(function() {
    "use strict";
    window.OrderFlowConfigurator = function() {
        this.currentStep = 1;
        this.totalSteps = 5;
        this.currentStep2Substep = null;
        this.totalStep2Substeps = null;
        this.isInStep2Substep = false;
        this.lastStep2Substep = null;
        this.currentSubStage = null;
        this.totalSubStages = 4;
        this.isInSubStage = false;
        this.isNavigating = false;
        this.isReorderSubmitting = false;
        this.isBuilding2ndClip = false;
        this.isPrescriptionOnlyFlow = false;
        this.isReorderMode = false;
        this.isFrameReorderMode = false;
        this.isOpticalRetailerReorder = false;
        this.isRedrillFlow = false;
        this.redrillVariantId = null;
        this.redrillHandle = null;
        this.redrillPrice = 0;
        this.isEditingConfig = false;
        this.editConfigId = null;
        this.editClipSequence = null;
        this._cartCache = null;
        this._cartCacheTime = 0;
        this._cartCacheTTL = 1e4;
        this._rateLimitCooldown = null;
        this._pricingUpdateTimeout = null;
        this._pricingUpdatePromise = null;
        this._saveStateTimeout = null;
        this.hasCompletedStep1_5 = false;
        this.hasVisitedStep1_5 = false;
        this.wasInStep1_5 = false;
        this.lastStepBeforeTwo = null;
        this.step1_5FrameChoice = null;
        this.originalStep1Header = null;
        this.configuration = {
            frameChoice: null,
            frameProduct: null,
            frameVariantId: null,
            frameVariantTitle: null,
            frameBrand: null,
            frameModel: null,
            requiresNativeLenses: false,
            nativeLensType: "single-vision",
            nativeLensFeature: "standard",
            nativeLensMaterial: "standard",
            readerPower: null,
            prescription: null,
            prescriptionSkipped: false,
            prescriptionSendLater: false,
            prescriptionUpload: null,
            prescriptionMethod: null,
            uploadPd: null,
            rxValuesStaging: null,
            rxCarriedToken: null,
            rxCarriedStatus: null,
            rxCertifiedAt: null,
            termsAcceptedAt: null,
            shipInAckAt: null,
            showPrescriptionError: false,
            isPrescriptionOnlyOrder: false,
            isFramelessRxOrder: false,
            orderForSomeoneElse: false,
            patientName: null,
            patientRelationship: null,
            clipType: null,
            clipOption: null,
            lensColor: null,
            magnification: null,
            lightSensitivityColor: null,
            lightSensitivityIntensity: null,
            bridgeColor: "MatteBlack",
            magnetColor: "Gunmetal",
            crystalColor: null,
            accessories: [],
            quantity: 1,
            source: null,
            orderSource: null
        };
        this.pricing = {
            frame: 0,
            nativeLenses: 0,
            clip: 0,
            hardware: 0,
            bridge: 0,
            magnet: 0,
            crystals: 0,
            secondClip: 0,
            accessories: 0,
            total: 0
        };
        this.nativeLensPricing = {
            lensType: {
                "single-vision": {
                    name: "Single Vision"
                },
                progressive: {
                    name: "Progressive"
                }
            },
            lensFeatures: {
                standard: {
                    name: "Standard"
                },
                "blue-light": {
                    name: "Blue Light"
                }
            },
            lensMaterials: {
                standard: {
                    name: "Standard"
                },
                "high-index-167": {
                    name: "High-Index 1.67"
                },
                "high-index-160": {
                    name: "High-Index 1.60"
                }
            }
        };
        this.clipTypes = {
            sun: {
                name: "Sun",
                get price() {
                    return window.chemistrie_prices?.clip_sun || 175;
                }
            },
            reader: {
                name: "Reader",
                get price() {
                    return window.chemistrie_prices?.clip_reader || 175;
                }
            },
            blueLight: {
                name: "Blue Light",
                get price() {
                    return window.chemistrie_prices?.clip_blue_light || 175;
                }
            },
            "3d": {
                name: "3D",
                get price() {
                    return window.chemistrie_prices?.clip_3d || 175;
                }
            },
            lightSensitivity: {
                name: "Light Sensitivity",
                get price() {
                    return window.chemistrie_prices?.clip_light_sensitivity || 175;
                }
            },
            migraine: {
                name: "Migraine",
                get price() {
                    return window.chemistrie_prices?.clip_migraine || 495;
                }
            },
            driving: {
                name: "Night Drive",
                get price() {
                    return window.chemistrie_prices?.clip_driving || 175;
                }
            }
        };
        this.therapeuticLensPricing = {
            "FL41-Light": {
                name: "FL-41 Light",
                get price() {
                    return window.chemistrie_prices?.therapeutic_fl41 || 175;
                }
            },
            "FL41-Medium": {
                name: "FL-41 Medium",
                get price() {
                    return window.chemistrie_prices?.therapeutic_fl41 || 175;
                }
            },
            Avulux: {
                name: "Avulux",
                get price() {
                    return window.chemistrie_prices?.therapeutic_avulux || 495;
                }
            }
        };
        this.accessories = {};
        this.initAccessoriesFromDOM();
        this.magnificationOptions = {
            reader: [ "+0.50", "+0.75", "+1.00", "+1.25", "+1.50", "+1.75", "+2.00", "+2.25", "+2.50" ],
            blueLight: [ "0.00", "+0.25", "+0.50", "+0.75", "+1.00", "+1.25", "+1.50", "+1.75", "+2.00" ]
        };
        this.currentMagIndex = 0;
        this.clipSubStageConfig = {
            sun: {
                stages: [ "lens", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "Lens Color", "Bridge", "Magnets", "Crystals" ]
            },
            lightSensitivity: {
                stages: [ "lens", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "FL-41 Tint", "Bridge", "Magnets", "Crystals" ]
            },
            migraine: {
                stages: [ "lens", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "Avulux Info", "Bridge", "Magnets", "Crystals" ]
            },
            reader: {
                stages: [ "magnification", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "Magnification", "Bridge", "Magnets", "Crystals" ]
            },
            blueLight: {
                stages: [ "magnification", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "Magnification", "Bridge", "Magnets", "Crystals" ]
            },
            "3d": {
                stages: [ "lens", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "3D Technology", "Bridge", "Magnets", "Crystals" ]
            },
            driving: {
                stages: [ "lens", "bridge", "magnet", "crystal" ],
                total: 4,
                names: [ "Driving Vision", "Bridge", "Magnets", "Crystals" ]
            }
        };
        this.step2SubstepConfig = {
            "own-frame-own-lenses": {
                stages: [ "frame-details" ],
                total: 1,
                names: [ "Frame Details" ]
            },
            "own-frame-new-lenses": {
                stages: [ "frame-details", "lens-type", "lens-features", "lens-material", "prescription" ],
                total: 5,
                names: [ "Frame Details", "Lens Type", "Lens Features", "Lens Material", "Prescription" ]
            },
            "new-frame-lenses": {
                stages: [ "lens-type", "lens-features", "lens-material", "prescription" ],
                total: 4,
                names: [ "Lens Type", "Lens Features", "Lens Material", "Prescription" ]
            }
        };
        this.lensTypeSubstepConfigs = {
            readers: {
                stages: [ "reader-power", "lens-features" ],
                names: [ "Select Power", "Lens Features" ],
                skipMaterial: true,
                skipPrescription: true
            },
            "non-rx": {
                stages: [ "lens-features" ],
                names: [ "Lens Features" ],
                skipMaterial: true,
                skipPrescription: true
            },
            "single-vision": {
                stages: [ "lens-features", "lens-material", "prescription" ],
                names: [ "Lens Features", "Lens Material", "Prescription" ],
                skipMaterial: false,
                skipPrescription: false
            },
            progressive: {
                stages: [ "lens-features", "lens-material", "prescription" ],
                names: [ "Lens Features", "Lens Material", "Prescription" ],
                skipMaterial: false,
                skipPrescription: false
            }
        };
        this.viewportPresets = {
            4: "full",
            5: "full"
        };
        this.substageViewports = {
            lens: "full",
            magnification: "full",
            bridge: "bridge",
            magnet: "magnet",
            crystal: "crystal"
        };
        this.lensTypeConfig = {
            "3d": {
                displayName: "Standard",
                category: "3d",
                lensImagePath: "Lens-3D.png",
                autoSelect: true
            },
            driving: {
                displayName: "Standard",
                category: "driving",
                lensImagePath: "Raen-Angle-Lens-Driving.png",
                autoSelect: true
            },
            blueLight: {
                displayName: "Blue Light Protection",
                category: "blueLight",
                lensImagePath: "Lens-BlueLight.png",
                autoSelect: false
            },
            reader: {
                displayName: "Reading Glasses",
                category: "reader",
                lensImagePath: "Lens-Reader.png",
                autoSelect: false
            },
            migraine: {
                displayName: "Avulux",
                category: "migraine",
                lensImagePath: "Raen-Angle-Lens-Avulux-Light.png",
                autoSelect: true
            }
        };
        this.therapeuticConfig = {
            fl41: {
                displayPrefix: "FL-41",
                colors: {
                    "FL41-Light": {
                        display: "Light",
                        hexColor: "#dfc8c5"
                    },
                    "FL41-Medium": {
                        display: "Medium",
                        hexColor: "#df978f"
                    }
                }
            },
            avulux: {
                displayPrefix: "Avulux",
                colors: {
                    Avulux: {
                        display: "Standard",
                        hexColor: "#b1b3a7"
                    }
                }
            }
        };
        this.lightSensitivityConfig = {
            fl41: {
                displayPrefix: "FL-41",
                colors: {
                    "FL41-Light": {
                        display: "Light",
                        hexColor: "#dfc8c5"
                    },
                    "FL41-Medium": {
                        display: "Medium",
                        hexColor: "#df978f"
                    }
                }
            }
        };
        this.migraineConfig = {
            avulux: {
                displayPrefix: "Avulux",
                colors: {
                    Avulux: {
                        display: "Standard",
                        hexColor: "#b1b3a7"
                    }
                }
            }
        };
        this.hardwareOptions = {
            bridge: [ "Gold", "Silver" ],
            magnet: [ "Gold", "Silver" ],
            crystal: [ "clear", "grey" ]
        };
        this.frameModel = "Raen-Angle";
        this.init();
        return this;
    };
    window.OrderFlowConfigurator.prototype = {
        formatPrice: function(amount) {
            const num = parseFloat(amount);
            if (isNaN(num)) return "$0";
            if (num % 1 === 0) {
                return `$${num}`;
            }
            return `$${num.toFixed(2)}`;
        },
        formatPdValue: function(pdData) {
            if (!pdData) return "--";
            if (typeof pdData === "object" && pdData.mode) {
                if (pdData.mode === "dual") {
                    return `L:${pdData.left || "--"} R:${pdData.right || "--"}`;
                } else {
                    return pdData.value || "--";
                }
            } else {
                return pdData;
            }
        },
        isPdDualMode: function(pdData) {
            return !!(pdData && typeof pdData === "object" && pdData.mode === "dual");
        },
        markPrescriptionFieldErrors: function(variant, fields) {
            const suffix = variant === "C" ? "C" : "";
            const fieldIds = [ `odSphere${suffix}`, `odCylinder${suffix}`, `odAxis${suffix}`, `odAdd${suffix}`, `osSphere${suffix}`, `osCylinder${suffix}`, `osAxis${suffix}`, `osAdd${suffix}` ];
            const pdFieldIds = fields.isDualMode ? variant === "C" ? [ "pdCLeft", "pdCRight", "pdLeft", "pdRight" ] : [ "pdLeft", "pdRight" ] : variant === "C" ? [ "pdC", "pd" ] : [ "pd" ];
            let hasEmptyFields = false;
            const emptyFieldNames = [];
            fieldIds.forEach(id => {
                const input = document.getElementById(id);
                if (!input) return;
                const value = input.value.trim();
                const inputField = input.closest(".input-field");
                if (value === "") {
                    hasEmptyFields = true;
                    emptyFieldNames.push(input.previousElementSibling?.textContent || id);
                    input.classList.add("rx-input-error");
                    if (inputField) inputField.classList.add("has-error");
                } else {
                    input.classList.remove("rx-input-error");
                    if (inputField) inputField.classList.remove("has-error");
                }
            });
            if (!fields.pdValid) {
                hasEmptyFields = true;
                emptyFieldNames.push("PD");
                pdFieldIds.forEach(id => {
                    const input = document.getElementById(id);
                    if (input && input.value.trim() === "") {
                        input.classList.add("rx-input-error");
                        const inputField = input.closest(".input-field");
                        if (inputField) inputField.classList.add("has-error");
                    }
                });
            } else {
                pdFieldIds.forEach(id => {
                    const input = document.getElementById(id);
                    if (input) {
                        input.classList.remove("rx-input-error");
                        const inputField = input.closest(".input-field");
                        if (inputField) inputField.classList.remove("has-error");
                    }
                });
            }
            const errorMsgId = variant === "C" ? "rxErrorMessageC" : "rxErrorMessage";
            let errorMsg = document.getElementById(errorMsgId);
            if (hasEmptyFields) {
                if (!errorMsg) {
                    const rxGrid = document.querySelector(variant === "C" ? '[data-step2-substep="prescription-c"] .rx-input-grid' : '[data-step2-substep="prescription"] .rx-input-grid');
                    if (rxGrid) {
                        errorMsg = document.createElement("div");
                        errorMsg.id = errorMsgId;
                        errorMsg.className = "rx-error-message";
                        rxGrid.insertAdjacentElement("beforebegin", errorMsg);
                    }
                }
                if (errorMsg) {
                    errorMsg.innerHTML = `<span class="error-icon">⚠️</span> Please fill in all prescription fields. Enter "0" if a value on your Rx is empty.`;
                    errorMsg.style.display = "block";
                }
            } else if (errorMsg) {
                errorMsg.style.display = "none";
            }
        },
        _readUploadPd: function() {
            const isDual = document.getElementById("dualPdToggleUpload")?.checked || false;
            if (isDual) {
                const left = document.getElementById("pdLeftUpload")?.value.trim() || "";
                const right = document.getElementById("pdRightUpload")?.value.trim() || "";
                return {
                    pdData: {
                        mode: "dual",
                        value: null,
                        left: left || null,
                        right: right || null
                    },
                    pdValid: !!(left && right)
                };
            }
            const single = document.getElementById("pdUpload")?.value.trim() || "";
            return {
                pdData: {
                    mode: "single",
                    value: single || null,
                    left: null,
                    right: null
                },
                pdValid: !!single
            };
        },
        _restoreUploadPdUI: function() {
            const pd = this.configuration.uploadPd;
            if (!pd) return;
            const toggle = document.getElementById("dualPdToggleUpload");
            const wrap = document.getElementById("pdToggleWrapperUpload");
            const single = document.getElementById("pdSingleWrapperUpload");
            const dualLeft = document.getElementById("pdDualLeftUpload");
            const dualRight = document.getElementById("pdDualRightUpload");
            const pdInput = document.getElementById("pdUpload");
            const leftInput = document.getElementById("pdLeftUpload");
            const rightInput = document.getElementById("pdRightUpload");
            if (pd.mode === "dual" && (pd.left || pd.right)) {
                if (toggle) toggle.checked = true;
                if (wrap) wrap.classList.add("dual-active");
                if (single) single.style.display = "none";
                if (dualLeft) dualLeft.style.display = "flex";
                if (dualRight) dualRight.style.display = "flex";
                if (leftInput) leftInput.value = pd.left || "";
                if (rightInput) rightInput.value = pd.right || "";
            } else {
                if (toggle) toggle.checked = false;
                if (wrap) wrap.classList.remove("dual-active");
                if (single) single.style.display = "flex";
                if (dualLeft) dualLeft.style.display = "none";
                if (dualRight) dualRight.style.display = "none";
                if (pdInput) pdInput.value = pd.value || "";
            }
        },
        _isRxCertTheOnlyBlocker: function() {
            const method = this.configuration.prescriptionMethod;
            if (this.configuration.rxCertifiedAt) return false;
            if (method === "upload") {
                const hasFile = !!(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token);
                return hasFile && this._readUploadPd().pdValid;
            }
            if (method === "manual") {
                const ids = [ "odSphere", "odCylinder", "odAxis", "odAdd", "osSphere", "osCylinder", "osAxis", "osAdd" ];
                const allFilled = ids.every(function(id) {
                    return (document.getElementById(id)?.value.trim() || "") !== "";
                });
                if (!allFilled) return false;
                const dual = document.getElementById("dualPdToggle")?.checked;
                if (dual) {
                    const l = document.getElementById("pdLeft")?.value.trim() || "";
                    const r = document.getElementById("pdRight")?.value.trim() || "";
                    return !!(l && r);
                }
                return !!(document.getElementById("pd")?.value.trim() || "");
            }
            return false;
        },
        _showRxCertWarning: function() {
            const method = this.configuration.prescriptionMethod;
            const rowId = method === "upload" ? "rxCertRowUpload" : "rxCertRowManual";
            const errorId = method === "upload" ? "rxCertUploadError" : "rxCertManualError";
            const row = document.getElementById(rowId);
            const error = document.getElementById(errorId);
            if (row) {
                row.classList.add("rx-cert-pulse");
                setTimeout(function() {
                    row.classList.remove("rx-cert-pulse");
                }, 6e3);
                row.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
            if (error) error.hidden = false;
        },
        _isUploadPdMissing: function() {
            if (this.configuration.prescriptionMethod !== "upload") return false;
            if (!(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token)) return false;
            return !this._readUploadPd().pdValid;
        },
        _showUploadPdWarning: function() {
            const isDual = document.getElementById("dualPdToggleUpload")?.checked || false;
            const ids = isDual ? [ "pdLeftUpload", "pdRightUpload" ] : [ "pdUpload" ];
            ids.forEach(function(id) {
                const input = document.getElementById(id);
                if (input && input.value.trim() === "") {
                    input.classList.add("rx-input-error");
                    const field = input.closest(".input-field");
                    if (field) field.classList.add("has-error");
                }
            });
            const error = document.getElementById("pdUploadError");
            if (error) {
                error.hidden = false;
                error.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        },
        showPrescriptionErrors: function(variant) {
            const fields = {
                odSphere: document.getElementById("odSphere")?.value.trim() || "",
                odCylinder: document.getElementById("odCylinder")?.value.trim() || "",
                odAxis: document.getElementById("odAxis")?.value.trim() || "",
                odAdd: document.getElementById("odAdd")?.value.trim() || "",
                osSphere: document.getElementById("osSphere")?.value.trim() || "",
                osCylinder: document.getElementById("osCylinder")?.value.trim() || "",
                osAxis: document.getElementById("osAxis")?.value.trim() || "",
                osAdd: document.getElementById("osAdd")?.value.trim() || ""
            };
            const dualPdToggle = document.getElementById("dualPdToggle");
            const isDualMode = dualPdToggle?.checked || false;
            let pdValid = false;
            if (isDualMode) {
                const pdLeft = document.getElementById("pdLeft")?.value.trim();
                const pdRight = document.getElementById("pdRight")?.value.trim();
                pdValid = !!(pdLeft && pdRight);
            } else {
                const pdSingle = document.getElementById("pd")?.value.trim();
                pdValid = !!pdSingle;
            }
            fields.pdValid = pdValid;
            fields.isDualMode = isDualMode;
            this.markPrescriptionFieldErrors("B", fields);
        },
        clearPrescriptionFieldError: function(input) {
            if (!input) return;
            input.classList.remove("rx-input-error");
            const inputField = input.closest(".input-field");
            if (inputField) inputField.classList.remove("has-error");
        },
        markInlineRxFieldErrors: function(fields) {
            const fieldIds = [ "odSphereReview", "odCylinderReview", "odAxisReview", "odAddReview", "osSphereReview", "osCylinderReview", "osAxisReview", "osAddReview" ];
            const pdFieldIds = fields.isDualMode ? [ "pdLeftReview", "pdRightReview" ] : [ "pdReview" ];
            let hasEmptyFields = false;
            const emptyFieldNames = [];
            fieldIds.forEach(id => {
                const input = document.getElementById(id);
                if (!input) return;
                const value = input.value.trim();
                const inputField = input.closest(".input-field");
                if (value === "") {
                    hasEmptyFields = true;
                    emptyFieldNames.push(input.previousElementSibling?.textContent || id);
                    input.classList.add("rx-input-error");
                    if (inputField) inputField.classList.add("has-error");
                } else {
                    input.classList.remove("rx-input-error");
                    if (inputField) inputField.classList.remove("has-error");
                }
            });
            if (!fields.pdValid) {
                hasEmptyFields = true;
                emptyFieldNames.push("PD");
                pdFieldIds.forEach(id => {
                    const input = document.getElementById(id);
                    if (input && input.value.trim() === "") {
                        input.classList.add("rx-input-error");
                        const inputField = input.closest(".input-field");
                        if (inputField) inputField.classList.add("has-error");
                    }
                });
            } else {
                pdFieldIds.forEach(id => {
                    const input = document.getElementById(id);
                    if (input) {
                        input.classList.remove("rx-input-error");
                        const inputField = input.closest(".input-field");
                        if (inputField) inputField.classList.remove("has-error");
                    }
                });
            }
            let errorMsg = document.getElementById("rxErrorMessageReview");
            if (hasEmptyFields) {
                if (!errorMsg) {
                    const rxGrid = document.querySelector("#inlineRxForm .rx-input-grid");
                    if (rxGrid) {
                        errorMsg = document.createElement("div");
                        errorMsg.id = "rxErrorMessageReview";
                        errorMsg.className = "rx-error-message";
                        rxGrid.insertAdjacentElement("beforebegin", errorMsg);
                    }
                }
                if (errorMsg) {
                    errorMsg.innerHTML = `<span class="error-icon">⚠️</span> Please fill in all prescription fields. Enter "0" if a value on your Rx is empty.`;
                    errorMsg.style.display = "block";
                }
            } else if (errorMsg) {
                errorMsg.style.display = "none";
            }
        },
        initAccessoriesFromDOM: function() {
            const accessoryItems = document.querySelectorAll(".accessory-item[data-accessory-key]");
            if (accessoryItems.length === 0) {
                if (window.chemistrie_products?.accessories) {
                    Object.entries(window.chemistrie_products.accessories).forEach(([key, data]) => {
                        this.accessories[key] = {
                            selected: false,
                            name: data.title || key,
                            price: data.price || 0,
                            variantId: data.variantId
                        };
                    });
                    console.log("[Accessories] Initialized from window.chemistrie_products:", Object.keys(this.accessories));
                } else {
                    console.log("[Accessories] No accessories configured");
                }
                return;
            }
            accessoryItems.forEach(item => {
                const key = item.dataset.accessoryKey;
                const checkbox = item.querySelector(".accessory-toggle");
                if (key && checkbox) {
                    this.accessories[key] = {
                        selected: false,
                        name: item.querySelector(".accessory-name")?.textContent || key,
                        price: parseInt(checkbox.dataset.price, 10) || 0,
                        variantId: checkbox.dataset.variantId
                    };
                }
            });
            console.log("[Accessories] Initialized from DOM:", Object.keys(this.accessories));
        },
        init: async function() {
            const self = this;
            window.addEventListener("pageshow", function(e) {
                if (e.persisted) {
                    self.isNavigating = false;
                }
            });
            const urlParams = this.parseURLParameters();
            const isFreshOrderEntry = urlParams.source === "header-extra" || urlParams.source === "eyeglasses-pdp" || urlParams.source === "reorder-email" || !!urlParams.resumeToken;
            if (isFreshOrderEntry) {
                try {
                    localStorage.removeItem("orderFlowState");
                } catch (e) {}
                try {
                    sessionStorage.removeItem("orderFlowEntry");
                } catch (e) {}
                console.log("[init] Fresh order entry (" + urlParams.source + ") — cleared saved state for a clean start");
            }
            this._entryScopeValid = function() {
                try {
                    const nav = performance.getEntriesByType("navigation")[0];
                    if (nav && nav.type) return nav.type === "reload" || nav.type === "back_forward";
                    if (performance.navigation) {
                        return performance.navigation.type === 1 || performance.navigation.type === 2;
                    }
                } catch (e) {}
                return false;
            }();
            if (!this._entryScopeValid) {
                try {
                    sessionStorage.removeItem("orderFlowEntry");
                } catch (e) {}
                console.log("[init] Fresh navigation — entry-scoped flags discarded");
            }
            this.loadState();
            this.isInitializing = true;
            let targetStep = this.currentStep;
            if (urlParams.resumeToken) {
                const resumedStep = await this._applyResumeToken(urlParams.resumeToken);
                if (resumedStep) {
                    targetStep = resumedStep;
                }
            }
            if (urlParams.startStep) {
                targetStep = urlParams.startStep;
            }
            if (urlParams.preselectClipType) {
                this.pendingClipPreselect = urlParams.preselectClipType;
                console.log("[init] Clip PDP pre-select queued:", this.pendingClipPreselect);
            }
            if (urlParams.frameHandle) {
                this.configuration.frameChoice = "new-frame-lenses";
                this.configuration.frameProduct = urlParams.frameHandle;
                if (urlParams.frameVariantId && !isNaN(urlParams.frameVariantId)) {
                    this.configuration.frameVariantId = urlParams.frameVariantId;
                    console.log("[init] Stored frame variant ID from URL:", urlParams.frameVariantId);
                } else {
                    this.configuration.frameVariantId = null;
                    this.configuration.frameVariantTitle = null;
                    console.log("[init] Cleared stale frameVariantId — no valid variant ID in URL for frame:", urlParams.frameHandle);
                }
                if (urlParams.frameVariantTitle) {
                    this.configuration.frameVariantTitle = urlParams.frameVariantTitle;
                    console.log("[init] Stored frame variant title from URL:", urlParams.frameVariantTitle);
                }
                if (urlParams.startStep && urlParams.startStep > 1) {
                    this.hasCompletedStep1_5 = true;
                }
            }
            if (urlParams.continue === "2ndclip") {
                console.log("[init] Smart continuation requested from thank you page");
                this.smartContinuationFromThankYou();
                window.history.replaceState({}, "", window.location.pathname);
            }
            if (urlParams.mode === "prescription-only") {
                this.isPrescriptionOnlyFlow = true;
                this.configuration.requiresNativeLenses = true;
                if (urlParams.frameHandle) {
                    console.log("[init] Prescription-only mode detected from PDP (Variant C)");
                    this.configuration.frameChoice = "new-frame-lenses";
                    this.configuration.isFramelessRxOrder = false;
                } else {
                    console.log("[init] Prescription-only mode detected from header (frameless, Variant B)");
                    this.configuration.frameChoice = "own-frame-new-lenses";
                    this.configuration.isFramelessRxOrder = true;
                    this.configuration.orderSource = "EXTRA - New Rx Lenses";
                }
            } else if (urlParams.frameHandle) {
                this.isPrescriptionOnlyFlow = false;
                this.configuration.isPrescriptionOnlyOrder = false;
                this.configuration.isFramelessRxOrder = false;
                this.configuration.requiresNativeLenses = true;
                console.log("[init] Cleared stale prescription-only flags for full-customize flow");
            }
            if (urlParams.source === "eyeglasses-pdp") {
                if (urlParams.mode === "prescription-only") {
                    this.configuration.orderSource = "Eyeglasses PDP - Prescription Only";
                } else {
                    this.configuration.orderSource = "Eyeglasses PDP - Full Customize";
                }
                console.log("[init] Order source set from PDP:", this.configuration.orderSource);
            } else if (urlParams.source === "order-flow") {
                this.configuration.orderSource = "Order Flow - Variant C";
                console.log("[init] Order source set from Order Flow return:", this.configuration.orderSource);
            }
            if (urlParams.opticalRetailerReorder) {
                this.startOpticalRetailerReorder(false);
                window.history.replaceState({}, document.title, window.location.pathname);
            }
            if (urlParams.mode === "reorder" && urlParams.reorder) {
                const rd = urlParams.reorder;
                console.log("[init] Reorder mode detected, restoring configuration from URL params:", rd);
                if (rd.clipType) {
                    this.configuration.frameChoice = rd.frameChoice || "own-frame-own-lenses";
                    this.configuration.frameBrand = rd.frameBrand || "";
                    this.configuration.frameModel = rd.frameModel || "";
                    this.configuration.frameProduct = rd.frameProduct || "";
                    if (rd.frameVariantId) {
                        this.configuration.frameVariantId = parseInt(rd.frameVariantId);
                    }
                    if (rd.frameVariantTitle) {
                        this.configuration.frameVariantTitle = rd.frameVariantTitle;
                    }
                    if (rd.nativeLensType) {
                        this.configuration.nativeLensType = rd.nativeLensType;
                        this.configuration.nativeLensFeature = rd.nativeLensFeature || "standard";
                        this.configuration.nativeLensMaterial = rd.nativeLensMaterial || "standard";
                        this.configuration.requiresNativeLenses = true;
                    }
                    this.configuration.clipType = rd.clipType;
                    this.configuration.lensCategory = null;
                    this.configuration.lensColor = null;
                    this.configuration.bridgeColor = "MatteBlack";
                    this.configuration.magnetColor = "Gunmetal";
                    this.configuration.crystalColor = null;
                    this.configuration.accessories = [];
                    this.configuration.quantity = 1;
                    this.configuration.orderSource = "Customer Reorder";
                    this.configuration.originalOrder = rd.originalOrderName || "";
                    this.isReorderMode = true;
                    this._clearStaleRxState({
                        includeRxData: true
                    });
                    targetStep = 4;
                    console.log("[init] Reorder config restored, will navigate to Step 4");
                    console.log("[init] clipType:", rd.clipType, "frameChoice:", rd.frameChoice, "originalOrder:", rd.originalOrderName);
                } else {
                    console.warn("[init] Reorder mode missing clipType param, falling back to Step 1");
                }
                window.history.replaceState({}, "", window.location.pathname);
            }
            if (urlParams.mode === "reorder-frame" && urlParams.reorder) {
                const rd = urlParams.reorder;
                console.log("[init] Frame-reorder mode detected, restoring frame config from URL params:", rd);
                this.configuration.frameChoice = rd.frameChoice || "own-frame-own-lenses";
                this.configuration.frameBrand = rd.frameBrand || "";
                this.configuration.frameModel = rd.frameModel || "";
                this.configuration.frameProduct = rd.frameProduct || "";
                if (rd.frameVariantId) {
                    this.configuration.frameVariantId = parseInt(rd.frameVariantId);
                }
                if (rd.frameVariantTitle) {
                    this.configuration.frameVariantTitle = rd.frameVariantTitle;
                }
                if (rd.nativeLensType) {
                    this.configuration.nativeLensType = rd.nativeLensType;
                    this.configuration.nativeLensFeature = rd.nativeLensFeature || "standard";
                    this.configuration.nativeLensMaterial = rd.nativeLensMaterial || "standard";
                    this.configuration.requiresNativeLenses = true;
                }
                this.configuration.clipType = null;
                this.configuration.lensCategory = null;
                this.configuration.lensColor = null;
                this.configuration.bridgeColor = "MatteBlack";
                this.configuration.magnetColor = "Gunmetal";
                this.configuration.crystalColor = null;
                this.configuration.accessories = [];
                this.configuration.quantity = 1;
                this.configuration.addSecondClip = false;
                this.configuration.orderSource = "Customer Reorder";
                this.configuration.originalOrder = rd.originalOrderName || "";
                this.isBuilding2ndClip = true;
                this.isFrameReorderMode = true;
                this._clearStaleRxState({
                    includeRxData: true
                });
                targetStep = 3;
                console.log("[init] Frame-reorder config restored, will navigate to Step 3");
                console.log("[init] frameChoice:", rd.frameChoice, "frameProduct:", rd.frameProduct);
                window.history.replaceState({}, "", window.location.pathname);
            }
            if (urlParams.mode === "redrill") {
                console.log("[init] Redrill mode detected from Redrill PDP");
                this.isRedrillFlow = true;
                this.configuration.frameChoice = "own-frame-own-lenses";
                this.configuration.requiresNativeLenses = false;
                this._clearStaleRxState({
                    includeRxData: true
                });
                if (urlParams.redrillVariantId) {
                    this.redrillVariantId = urlParams.redrillVariantId;
                }
                if (urlParams.redrillHandle) {
                    this.redrillHandle = urlParams.redrillHandle;
                }
                this.redrillPrice = urlParams.redrillPrice ? parseInt(urlParams.redrillPrice, 10) / 100 : 75;
                this.configuration.orderSource = "Redrill - Replacement Magnets";
                this.configuration.clipType = null;
                this.configuration.lensCategory = null;
                this.configuration.lensColor = null;
                this.configuration.bridgeColor = "MatteBlack";
                this.configuration.magnetColor = "Gunmetal";
                this.configuration.crystalColor = null;
                this.configuration.accessories = [];
                this.configuration.quantity = 1;
                this.configuration.addSecondClip = false;
                targetStep = 3;
                window.history.replaceState({}, "", window.location.pathname);
            }
            const jumpToStep = localStorage.getItem("jumpToStep");
            const isBuilding2ndClipFlag = localStorage.getItem("isBuilding2ndClip");
            const storedFrameData = localStorage.getItem("secondClipFrameData");
            if (jumpToStep === "3" && isBuilding2ndClipFlag === "true" && storedFrameData) {
                console.log('[init] Detected cart-triggered "Add Another Clip" navigation');
                try {
                    const frameData = JSON.parse(storedFrameData);
                    console.log("[init] Restoring frame data from cart:", frameData);
                    this.configuration.frameChoice = frameData.frameChoice;
                    this.configuration.frameProduct = frameData.frameProduct;
                    this.configuration.frameBrand = frameData.frameBrand;
                    this.configuration.frameModel = frameData.frameModel;
                    this.configuration.frameVariantId = frameData.frameVariantId || null;
                    this.configuration.frameVariantTitle = frameData.frameVariantTitle || null;
                    this.configuration.nativeLensType = frameData.nativeLensType;
                    this.configuration.nativeLensFeature = frameData.nativeLensFeature;
                    this.configuration.nativeLensMaterial = frameData.nativeLensMaterial;
                    this.configuration.prescription = frameData.prescription;
                    const carriedOrderSource = frameData.orderSource;
                    if (carriedOrderSource && carriedOrderSource.indexOf("Unknown") === -1) {
                        this.configuration.orderSource = carriedOrderSource;
                    } else {
                        this.configuration.orderSource = this.deriveOrderSourceFromFrameChoice(frameData.frameChoice);
                    }
                    if (frameData.originalOrder) {
                        this.configuration.originalOrder = frameData.originalOrder;
                    }
                    console.log("[init] Order source restored from cart:", this.configuration.orderSource);
                    if (frameData.prescriptionUpload && frameData.prescriptionUpload.token) {
                        this.configuration.prescriptionUpload = frameData.prescriptionUpload;
                    } else if (frameData.rxUploadToken && frameData.rxUploadFilename) {
                        this.configuration.prescriptionUpload = {
                            token: frameData.rxUploadToken,
                            fileName: frameData.rxUploadFilename
                        };
                    } else if (frameData.rxUploadToken) {
                        this.configuration.rxCarriedToken = frameData.rxUploadToken;
                        this.configuration.rxCarriedStatus = frameData.prescriptionStatus || null;
                    } else if (frameData.rxValuesStaging && frameData.rxValuesStaging.token) {
                        this.configuration.rxValuesStaging = frameData.rxValuesStaging;
                    }
                    this.configuration.clipType = null;
                    this.configuration.lensCategory = null;
                    this.configuration.lensColor = null;
                    this.configuration.bridgeColor = "MatteBlack";
                    this.configuration.magnetColor = "Gunmetal";
                    this.configuration.crystalColor = null;
                    this.configuration.accessories = [];
                    this.configuration.quantity = 1;
                    this.configuration.addSecondClip = false;
                    this.isBuilding2ndClip = true;
                    targetStep = 3;
                    console.log("[init] Frame data restored, will navigate to Step 3");
                    console.log("[init] Current step before navigation:", this.currentStep);
                    console.log("[init] Target step:", targetStep);
                    localStorage.removeItem("jumpToStep");
                    localStorage.removeItem("isBuilding2ndClip");
                } catch (error) {
                    console.error("[init] Error restoring frame data from cart:", error);
                    localStorage.removeItem("jumpToStep");
                    localStorage.removeItem("isBuilding2ndClip");
                    localStorage.removeItem("secondClipFrameData");
                }
            }
            const isEditingConfigFlag = localStorage.getItem("isEditingConfig");
            const editConfigIdStored = localStorage.getItem("editConfigId");
            const editConfigDataStored = localStorage.getItem("editConfigData");
            if (isEditingConfigFlag === "true" && editConfigIdStored && editConfigDataStored) {
                console.log('[init] Detected cart-triggered "Edit Config" navigation');
                try {
                    const editData = JSON.parse(editConfigDataStored);
                    console.log("[init] Restoring configuration data from cart:", editData);
                    this.isEditingConfig = true;
                    this.editConfigId = editConfigIdStored;
                    this.editClipSequence = localStorage.getItem("editClipSequence");
                    const normalizedClipType = editData.clipType ? editData.clipType.replace(/[\s-]+(.)/g, (_, c) => c.toUpperCase()).replace(/[\s-]+/g, "") : null;
                    const normalizeBridgeColor = value => {
                        if (!value) return "MatteBlack";
                        return value.replace(/\s+/g, "");
                    };
                    const normalizeMagnetColor = value => {
                        if (!value) return "Gunmetal";
                        return value.replace(/\s+/g, "");
                    };
                    const normalizeCrystalColor = value => {
                        if (!value || value === "None") return null;
                        return value.replace(/\s+/g, "");
                    };
                    Object.assign(this.configuration, {
                        frameChoice: editData.frameChoice,
                        frameProduct: editData.frameProduct,
                        frameBrand: editData.frameBrand,
                        frameModel: editData.frameModel,
                        frameVariantId: editData.frameVariantId ? parseInt(editData.frameVariantId) : null,
                        frameVariantTitle: editData.frameVariantTitle || null,
                        orderSource: editData.orderSource && editData.orderSource.indexOf("Unknown") === -1 ? editData.orderSource : this.deriveOrderSourceFromFrameChoice(editData.frameChoice),
                        nativeLensType: editData.nativeLensType,
                        nativeLensFeature: editData.nativeLensFeature,
                        nativeLensMaterial: editData.nativeLensMaterial,
                        prescription: editData.prescription,
                        uploadPd: editData.uploadPd || null,
                        clipType: normalizedClipType,
                        lensCategory: editData.lensCategory,
                        lensColor: editData.lensColor,
                        magnification: editData.magnification,
                        therapeuticType: editData.therapeuticType,
                        therapeuticIntensity: editData.therapeuticIntensity,
                        ...normalizedClipType === "lightSensitivity" && editData.therapeuticIntensity && {
                            lightSensitivityIntensity: this.capitalizeWords(editData.therapeuticIntensity),
                            lightSensitivityColor: "FL41-" + this.capitalizeWords(editData.therapeuticIntensity)
                        },
                        bridgeColor: normalizeBridgeColor(editData.bridgeFinish),
                        magnetColor: normalizeMagnetColor(editData.magnetFinish),
                        crystalColor: normalizeCrystalColor(editData.crystalAccent)
                    });
                    if (editData.rxUploadToken && editData.rxUploadFilename) {
                        this.configuration.prescriptionUpload = {
                            token: editData.rxUploadToken,
                            fileName: editData.rxUploadFilename
                        };
                        this.configuration.prescriptionMethod = "upload";
                    } else if (editData.rxUploadToken) {
                        this.configuration.rxCarriedToken = editData.rxUploadToken;
                        this.configuration.rxCarriedStatus = editData.prescriptionStatus || null;
                    }
                    if (editData.frameChoice === "own-frame-new-lenses" || editData.frameChoice === "new-frame-lenses") {
                        this.configuration.requiresNativeLenses = true;
                    }
                    const isEditPrescriptionOnly = localStorage.getItem("editPrescriptionOnly") === "true";
                    if (isEditPrescriptionOnly || editData.isPrescriptionOnly) {
                        this.isPrescriptionOnlyFlow = true;
                        this.configuration.isPrescriptionOnlyOrder = true;
                        console.log("[init] Prescription-only edit mode activated");
                    }
                    localStorage.removeItem("editPrescriptionOnly");
                    if (editData.therapeuticType && editData.therapeuticIntensity) {
                        const typeMap = {
                            fl41: "FL41",
                            chromagreen: "ChromaGreen"
                        };
                        const typeKey = typeMap[editData.therapeuticType] || editData.therapeuticType.toUpperCase();
                        const intensityKey = editData.therapeuticIntensity.charAt(0).toUpperCase() + editData.therapeuticIntensity.slice(1);
                        this.configuration.therapeuticColor = `${typeKey}-${intensityKey}`;
                        console.log("[init] Built therapeuticColor:", this.configuration.therapeuticColor);
                    }
                    targetStep = 5;
                    console.log("[init] Configuration restored, will navigate to Step 5 in edit mode");
                    console.log("[init] Edit Config ID:", this.editConfigId);
                    console.log("[init] Edit Clip Sequence:", this.editClipSequence);
                    localStorage.removeItem("isEditingConfig");
                    localStorage.removeItem("editConfigId");
                    localStorage.removeItem("editClipSequence");
                    localStorage.removeItem("editConfigData");
                    localStorage.removeItem("jumpToStep");
                } catch (error) {
                    console.error("[init] Error restoring configuration from cart:", error);
                    localStorage.removeItem("isEditingConfig");
                    localStorage.removeItem("editConfigId");
                    localStorage.removeItem("editClipSequence");
                    localStorage.removeItem("editConfigData");
                    localStorage.removeItem("jumpToStep");
                }
            }
            window.orderFlowConfigurator = this;
            this.setupEventListeners();
            this.setupStickyProgress();
            this.initializeResetModalHandlers();
            this.initializePDInfoModal();
            this.initializeReorderModal();
            this.initializeShipInAckModal();
            this.initializeSaveProgressModal();
            this.checkReorderSuccess();
            setTimeout(() => {
                this.attachCartButtonListeners();
            }, 500);
            console.log("[init] About to call goToStep with targetStep:", targetStep);
            await this.goToStep(targetStep);
            console.log("[init] Returned from goToStep, currentStep is now:", this.currentStep);
            this.isInitializing = false;
            this.updateNavigationButtons();
            this.updateProgressBar();
            await this.calculateTotalPrice();
            this.updateLensTypeCardPrices();
            if (urlParams.action === "opencart") {
                console.log("[init] Opening cart drawer from thank you page");
                setTimeout(() => {
                    this.refreshAndOpenCart();
                    window.history.replaceState({}, "", window.location.pathname);
                }, 500);
            }
        },
        parseURLParameters: function() {
            const params = new URLSearchParams(window.location.search);
            const dParam = params.get("d");
            if (dParam) {
                try {
                    let b64 = dParam.replace(/-/g, "+").replace(/_/g, "/");
                    while (b64.length % 4) b64 += "=";
                    const json = decodeURIComponent(escape(atob(b64)));
                    const payload = JSON.parse(json);
                    if (payload && typeof payload === "object") {
                        for (const key of Object.keys(payload)) {
                            if (params.get(key) == null) {
                                params.set(key, String(payload[key]));
                            }
                        }
                        console.log("[parseURLParameters] Decoded `d` payload:", payload);
                    }
                } catch (e) {
                    console.warn("[parseURLParameters] Failed to decode `d` payload, ignoring:", e.message);
                }
            }
            const result = {
                startStep: null,
                frameHandle: null,
                frameVariantId: null,
                frameVariantTitle: null,
                source: null,
                action: null,
                continue: null,
                preselectClipType: null
            };
            const startParam = params.get("start");
            if (startParam) {
                const stepMatch = startParam.match(/step(\d+)/i);
                if (stepMatch && stepMatch[1]) {
                    const stepNum = parseInt(stepMatch[1]);
                    if (stepNum >= 1 && stepNum <= this.totalSteps) {
                        result.startStep = stepNum;
                    }
                }
            }
            if (params.get("reorder") === "1" && startParam === "retail") {
                result.opticalRetailerReorder = true;
                result.startStep = 2;
            }
            const frameParam = params.get("frame");
            if (frameParam) {
                result.frameHandle = frameParam;
            }
            const variantParam = params.get("variant");
            if (variantParam) {
                result.frameVariantId = parseInt(variantParam);
            }
            const variantTitleParam = params.get("variantTitle");
            if (variantTitleParam) {
                result.frameVariantTitle = decodeURIComponent(variantTitleParam);
            }
            const sourceParam = params.get("source");
            if (sourceParam) {
                result.source = sourceParam;
                this.configuration.source = sourceParam;
            }
            const actionParam = params.get("action");
            if (actionParam) {
                result.action = actionParam;
            }
            const continueParam = params.get("continue");
            if (continueParam) {
                result.continue = continueParam;
            }
            const modeParam = params.get("mode");
            if (modeParam) {
                result.mode = modeParam;
            }
            if (!modeParam) {
                const preselectParam = params.get("clipType");
                if (preselectParam) {
                    result.preselectClipType = preselectParam;
                }
            }
            const resumeParam = params.get("resume");
            if (resumeParam) {
                result.resumeToken = resumeParam;
            }
            const redrillVariantParam = params.get("redrillVariant");
            if (redrillVariantParam) {
                result.redrillVariantId = redrillVariantParam;
            }
            const redrillHandleParam = params.get("redrillHandle");
            if (redrillHandleParam) {
                result.redrillHandle = redrillHandleParam;
            }
            const redrillPriceParam = params.get("redrillPrice");
            if (redrillPriceParam) {
                result.redrillPrice = redrillPriceParam;
            }
            if (modeParam === "reorder" || modeParam === "reorder-frame") {
                result.reorder = {
                    clipType: params.get("clipType"),
                    frameChoice: params.get("frameChoice"),
                    frameBrand: params.get("frameBrand"),
                    frameModel: params.get("frameModel"),
                    frameProduct: params.get("frameProduct"),
                    frameVariantId: params.get("frameVariantId"),
                    frameVariantTitle: params.get("frameVariantTitle"),
                    nativeLensType: params.get("nativeLensType"),
                    nativeLensFeature: params.get("nativeLensFeature"),
                    nativeLensMaterial: params.get("nativeLensMaterial"),
                    originalOrderName: params.get("originalOrderName")
                };
            }
            return result;
        },
        setupEventListeners: function() {
            const self = this;
            const prevBtn = document.getElementById("prevStepBtn");
            const nextBtn = document.getElementById("nextStepBtn");
            const addToCartBtn = document.getElementById("addToCartBtn");
            if (prevBtn) {
                prevBtn.addEventListener("click", () => self.previousStep());
            }
            if (nextBtn) {
                nextBtn.addEventListener("click", () => self.nextStep());
            }
            if (addToCartBtn) {
                addToCartBtn.addEventListener("click", () => self.addToCart());
            }
            const tcCheckbox = document.getElementById("tcAcceptCheckbox");
            const tcAcceptance = document.getElementById("tcAcceptance");
            const tcError = document.getElementById("tcAcceptError");
            if (tcCheckbox) {
                tcCheckbox.addEventListener("change", function() {
                    if (tcCheckbox.checked) {
                        self.configuration.termsAcceptedAt = (new Date).toISOString();
                        if (tcError) tcError.hidden = true;
                        if (tcAcceptance) tcAcceptance.classList.remove("tc-pulse");
                    } else {
                        self.configuration.termsAcceptedAt = null;
                    }
                    self.saveState();
                });
                if (self.configuration.termsAcceptedAt) {
                    tcCheckbox.checked = true;
                }
            }
            document.addEventListener("cart:partial-add-failure", e => {
                console.error("[Order Flow] Partial cart add failure:", e.detail);
                self.showCartLoadingOverlay(false);
                const addToCartBtn = document.getElementById("addToCartBtn");
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    addToCartBtn.textContent = "Add to Cart";
                }
                const message = e.detail.message || "Some items may not have been added to your cart.";
                self.showOrderFlowError(message);
            });
            document.addEventListener("cart:critical-add-failure", e => {
                console.error("[Order Flow] 🚨 CRITICAL cart add failure:", e.detail);
                self.showCartLoadingOverlay(false);
                const addToCartBtn = document.getElementById("addToCartBtn");
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    addToCartBtn.textContent = "Add to Cart";
                }
                const message = e.detail.message || "Required hardware could not be added. Please try again.";
                self.showOrderFlowError(message);
            });
            document.querySelectorAll(".progress-step").forEach(step => {
                step.addEventListener("click", e => {
                    const stepNum = parseInt(e.currentTarget.dataset.step);
                    if (self.canNavigateToStep(stepNum)) {
                        if (!self.requireShipInAck(stepNum)) return;
                        self.goToStep(stepNum);
                    }
                });
            });
            this.setupStep1Events();
            this.setupStep2Events();
            this.setupStep3Events();
            this.setupStep4Events();
            const nativeLensHeader = document.getElementById("nativeLensHeader");
            if (nativeLensHeader) {
                console.log("[setupEventListeners] Attaching click handler to nativeLensHeader");
                nativeLensHeader.addEventListener("click", async () => {
                    console.log("[nativeLensHeader] Click event fired!");
                    await self.toggleNativeLensBreakdown();
                });
            } else {
                console.warn("[setupEventListeners] nativeLensHeader element not found");
            }
            this.setupMagnificationPicker();
            this.setupPreviewTouchHandler();
        },
        setupPreviewTouchHandler: function() {
            if (window.innerWidth > 768) {
                return;
            }
            const configuratorView = document.querySelector(".configurator-view");
            const selectionSection = document.querySelector(".selection-section");
            if (!configuratorView) {
                console.log("[PullToRefreshHandler] Configurator view not found, skipping");
                return;
            }
            let touchStartY = 0;
            let touchStartElement = null;
            const handleTouchStart = e => {
                touchStartY = e.touches[0].clientY;
                touchStartElement = e.target;
            };
            const handleTouchMove = e => {
                const touchCurrentY = e.touches[0].clientY;
                const deltaY = touchCurrentY - touchStartY;
                if (deltaY <= 0) {
                    return;
                }
                const isInSelectionSection = selectionSection && (selectionSection.contains(touchStartElement) || touchStartElement === selectionSection);
                if (isInSelectionSection) {
                    if (selectionSection.scrollTop <= 0) {
                        e.preventDefault();
                    }
                } else {
                    e.preventDefault();
                }
            };
            const handleTouchEnd = () => {
                touchStartElement = null;
            };
            configuratorView.addEventListener("touchstart", handleTouchStart, {
                passive: true
            });
            configuratorView.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
            configuratorView.addEventListener("touchend", handleTouchEnd, {
                passive: true
            });
            console.log("[PullToRefreshHandler] Pull-to-refresh prevention enabled for entire configurator on mobile");
        },
        initializeCardAccordions: function() {
            const self = this;
            const cards = document.querySelectorAll("#step1 .frame-choice-card");
            console.log("[Accordion] Initializing for", cards.length, "cards");
            cards.forEach((card, index) => {
                const infoTrigger = card.querySelector(".info-icon-trigger");
                const detailsSection = card.querySelector(".frame-choice-card-details");
                if (!infoTrigger || !detailsSection) {
                    console.warn("[Accordion] Missing elements for card", index + 1);
                    return;
                }
                const expandCard = () => {
                    cards.forEach(otherCard => {
                        if (otherCard !== card && otherCard.classList.contains("expanded")) {
                            collapseCard(otherCard);
                        }
                    });
                    card.classList.add("expanded");
                    infoTrigger.setAttribute("aria-expanded", "true");
                    detailsSection.setAttribute("aria-hidden", "false");
                    console.log("[Accordion] Expanded card:", card.dataset.choice);
                    setTimeout(() => {
                        card.scrollIntoView({
                            behavior: "smooth",
                            block: "nearest"
                        });
                    }, 200);
                };
                const collapseCard = (targetCard = card) => {
                    const trigger = targetCard.querySelector(".info-icon-trigger");
                    const details = targetCard.querySelector(".frame-choice-card-details");
                    targetCard.classList.remove("expanded");
                    trigger.setAttribute("aria-expanded", "false");
                    details.setAttribute("aria-hidden", "true");
                    console.log("[Accordion] Collapsed card:", targetCard.dataset.choice);
                };
                infoTrigger.addEventListener("click", e => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (card.classList.contains("expanded")) {
                        collapseCard();
                    } else {
                        expandCard();
                    }
                });
                console.log("[Accordion] Initialized card", index + 1);
            });
        },
        setupStep1Events: function() {
            const self = this;
            const step1 = document.getElementById("step1");
            if (step1 && step1.dataset.eventsAttached === "true") {
                console.log("[setupStep1Events] Events already attached, skipping");
                return;
            }
            console.log("[setupStep1Events] Starting event attachment...");
            this.initializeCardAccordions();
            document.querySelectorAll("#step1 .frame-choice-card").forEach(card => {
                card.addEventListener("click", function(e) {
                    if (e.target.closest(".info-icon-trigger")) {
                        return;
                    }
                    const choice = this.dataset.choice;
                    console.log("[Step 1] Frame choice card clicked:", choice);
                    self.selectFrameChoice(choice);
                });
                card.addEventListener("keydown", function(e) {
                    if (e.key !== "Enter" && e.key !== " ") return;
                    if (e.target.closest(".info-icon-trigger")) return;
                    e.preventDefault();
                    self.selectFrameChoice(this.dataset.choice);
                });
            });
            if (step1) {
                step1.dataset.eventsAttached = "true";
                console.log("[setupStep1Events] All listeners attached successfully");
            }
        },
        setupStep2Events: function() {
            const self = this;
            const step2 = document.getElementById("step2");
            if (step2 && step2.dataset.eventsAttached === "true") {
                console.log("[setupStep2Events] Events already attached, skipping");
                return;
            }
            console.log("[setupStep2Events] Starting event attachment (delayed 100ms)...");
            setTimeout(() => {
                console.log("[setupStep2Events] Attaching events now...");
                const skipRxBtn = document.getElementById("skipRxBtn");
                if (skipRxBtn) {
                    console.log("[setupStep2Events] Found Skip Rx button (Variant C)");
                    skipRxBtn.addEventListener("click", function() {
                        console.log("[Skip Rx] Button clicked (Variant C)");
                        self.skipRxPrescription();
                    });
                }
                const skipRxBtnB = document.getElementById("skipRxBtnB");
                if (skipRxBtnB) {
                    console.log("[setupStep2Events] Found Skip & Add Later button (Variant B)");
                    skipRxBtnB.addEventListener("click", function() {
                        console.log("[Skip & Add Later] Button clicked (Variant B)");
                        self.skipRxPrescriptionVariantB();
                    });
                }
                const notSureBtns = document.querySelectorAll(".not-sure-btn");
                notSureBtns.forEach(btn => {
                    console.log(`[setupStep2Events] Found Not Sure button`);
                    btn.addEventListener("click", function() {
                        const frameChoice = self.configuration.frameChoice;
                        let variant;
                        if (frameChoice === "own-frame-own-lenses") {
                            variant = "A";
                        } else if (frameChoice === "own-frame-new-lenses") {
                            variant = "B";
                        }
                        console.log(`[Not Sure] Button clicked for Variant ${variant} (frameChoice: ${frameChoice})`);
                        self.handleNotSureFrameDetails(variant);
                    });
                });
                [ "frameBrand", "frameModel" ].forEach(id => {
                    const input = document.getElementById(id);
                    if (input) {
                        console.log(`[setupStep2Events] Found frame input: ${id}`);
                        input.addEventListener("input", () => {
                            console.log(`[Input Event] Field changed: ${id}, value: "${input.value}"`);
                            if (input.value !== "Unknown") {
                                const notSureBtns = document.querySelectorAll(".not-sure-btn");
                                notSureBtns.forEach(btn => btn.classList.remove("selected"));
                            }
                            self.validateStep2();
                            self.updateNavigationButtons();
                        });
                    } else {
                        console.warn(`[setupStep2Events] Frame input NOT found: ${id}`);
                    }
                });
                [ "odSphere", "odCylinder", "odAxis", "odAdd", "osSphere", "osCylinder", "osAxis", "osAdd", "pd", "pdLeft", "pdRight", "odSphereC", "odCylinderC", "odAxisC", "odAddC", "osSphereC", "osCylinderC", "osAxisC", "osAddC", "pdC", "pdCLeft", "pdCRight", "rxNotes" ].forEach(id => {
                    const input = document.getElementById(id);
                    if (input) {
                        console.log(`[setupStep2Events] Found Rx input: ${id}`);
                        input.addEventListener("input", () => {
                            console.log(`[Input Event] Rx field changed: ${id}, value: "${input.value}"`);
                            self.clearPrescriptionFieldError(input);
                            if (input.value.trim()) {
                                const skipBtn = document.getElementById("skipRxBtn");
                                const skipBtnB = document.getElementById("skipRxBtnB");
                                if (skipBtn) skipBtn.classList.remove("selected");
                                if (skipBtnB) skipBtnB.classList.remove("selected");
                                if (self.configuration.prescription === "skip") {
                                    self.configuration.prescription = null;
                                    self.configuration.prescriptionSkippedInVariantB = false;
                                    self.configuration.prescriptionSkipped = false;
                                }
                            }
                            self.validateStep2();
                            self.updateNavigationButtons();
                        });
                    } else {
                        console.warn(`[setupStep2Events] Rx input NOT found: ${id}`);
                    }
                });
                document.querySelectorAll("[data-lens-type]").forEach(card => {
                    card.addEventListener("click", function() {
                        const lensType = card.dataset.lensType;
                        console.log(`[Step 2] Lens type card clicked: ${lensType}`);
                        self.selectLensType(lensType);
                    });
                });
                document.querySelectorAll("[data-lens-feature]").forEach(card => {
                    card.addEventListener("click", function() {
                        const lensFeature = card.dataset.lensFeature;
                        console.log(`[Step 2] Lens feature card clicked: ${lensFeature}`);
                        self.selectLensFeature(lensFeature);
                    });
                });
                document.querySelectorAll("[data-lens-material]").forEach(card => {
                    card.addEventListener("click", function() {
                        const lensMaterial = card.dataset.lensMaterial;
                        console.log(`[Step 2] Lens material card clicked: ${lensMaterial}`);
                        self.selectLensMaterial(lensMaterial);
                    });
                });
                self.setupRxMethodChooser();
                self.setupOrderForSomeoneElseEvents();
                console.log("[setupStep2Events] Event attachment complete!");
                if (step2) {
                    step2.dataset.eventsAttached = "true";
                }
                console.log("[setupStep2Events] Running initial validation...");
                self.validateStep2();
                self.updateNavigationButtons();
            }, 100);
        },
        setupRxMethodChooser: function() {
            const self = this;
            const cards = document.querySelectorAll(".rx-method-card");
            const dropzone = document.getElementById("rxDropzone");
            const fileInput = document.getElementById("uploadPrescriptionInput");
            const deleteBtn = document.getElementById("rxDropzoneDelete");
            const ackBtn = document.getElementById("rxLaterAcknowledgeBtn");
            const uploadCard = document.querySelector('.rx-method-card[data-rx-method="upload"]');
            const endpoint = (window.chemistrie_rx_upload_endpoint || "").trim();
            if (uploadCard && !endpoint) {
                uploadCard.style.display = "none";
            }
            cards.forEach(function(card) {
                if (!card.dataset.rxMethod) return;
                card.addEventListener("click", function() {
                    self.selectRxMethod(card.dataset.rxMethod);
                });
                card.addEventListener("keydown", function(e) {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        self.selectRxMethod(card.dataset.rxMethod);
                    }
                });
            });
            if (self.configuration.prescriptionMethod) {
                self.selectRxMethod(self.configuration.prescriptionMethod, {
                    skipSave: true
                });
            }
            if (self.configuration.prescriptionUpload && self.configuration.prescriptionUpload.token) {
                self._renderDropzoneFile(self.configuration.prescriptionUpload);
            }
            self._restoreUploadPdUI();
            if (self.configuration.prescriptionSendLater && ackBtn) {
                ackBtn.classList.add("acknowledged");
            }
            if (dropzone && fileInput && endpoint) {
                dropzone.addEventListener("keydown", function(e) {
                    if ((e.key === "Enter" || e.key === " ") && !dropzone.classList.contains("has-file")) {
                        e.preventDefault();
                        fileInput.click();
                    }
                });
                if (deleteBtn) {
                    deleteBtn.addEventListener("click", function(e) {
                        e.stopPropagation();
                        const token = self.configuration.prescriptionUpload && self.configuration.prescriptionUpload.token;
                        self.configuration.prescriptionUpload = null;
                        self._clearDropzoneFile();
                        self._setUploadStatus("", null);
                        self.saveState();
                        if (typeof self.updateNavigationButtons === "function") {
                            self.updateNavigationButtons();
                        }
                        if (token && endpoint) {
                            fetch(endpoint, {
                                method: "DELETE",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    token: token
                                }),
                                keepalive: true
                            }).catch(function(err) {
                                console.warn("[Rx Delete] Server-side release failed (file will expire via cron):", err);
                            });
                        }
                    });
                }
                dropzone.addEventListener("dragover", function(e) {
                    e.preventDefault();
                    dropzone.classList.add("is-dragover");
                });
                dropzone.addEventListener("dragleave", function() {
                    dropzone.classList.remove("is-dragover");
                });
                dropzone.addEventListener("drop", function(e) {
                    e.preventDefault();
                    dropzone.classList.remove("is-dragover");
                    const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
                    if (file) self._handleRxFileSelected(file);
                });
                fileInput.addEventListener("change", function(e) {
                    const file = e.target.files && e.target.files[0];
                    if (file) self._handleRxFileSelected(file);
                    e.target.value = "";
                });
            }
            if (ackBtn) {
                ackBtn.addEventListener("click", function() {
                    self.configuration.prescriptionSendLater = true;
                    ackBtn.classList.add("acknowledged");
                    self.saveState();
                    if (typeof self.updateNavigationButtons === "function") {
                        self.updateNavigationButtons();
                    }
                });
            }
            const rxNotesManual = document.getElementById("rxNotes");
            const rxNotesUpload = document.getElementById("rxNotesUpload");
            if (rxNotesManual && rxNotesUpload) {
                rxNotesManual.addEventListener("input", function() {
                    if (rxNotesUpload.value !== rxNotesManual.value) rxNotesUpload.value = rxNotesManual.value;
                });
                rxNotesUpload.addEventListener("input", function() {
                    if (rxNotesManual.value !== rxNotesUpload.value) rxNotesManual.value = rxNotesUpload.value;
                });
            }
            document.querySelectorAll(".rx-cert-checkbox").forEach(function(box) {
                box.addEventListener("change", function() {
                    if (box.checked) {
                        self.configuration.rxCertifiedAt = (new Date).toISOString();
                        document.querySelectorAll(".rx-cert-row").forEach(function(r) {
                            r.classList.remove("rx-cert-pulse");
                        });
                        document.querySelectorAll(".rx-cert-row__error").forEach(function(e) {
                            e.hidden = true;
                        });
                    } else {
                        self.configuration.rxCertifiedAt = null;
                    }
                    document.querySelectorAll(".rx-cert-checkbox").forEach(function(other) {
                        if (other !== box) other.checked = box.checked;
                    });
                    self.saveState();
                    if (typeof self.updateNavigationButtons === "function") {
                        self.updateNavigationButtons();
                    }
                });
            });
            const rxFieldIds = [ "odSphere", "odCylinder", "odAxis", "odAdd", "osSphere", "osCylinder", "osAxis", "osAdd", "pd", "pdLeft", "pdRight", "dualPdToggle", "pdUpload", "pdLeftUpload", "pdRightUpload", "dualPdToggleUpload", "rxNotes", "rxNotesUpload" ];
            rxFieldIds.forEach(function(id) {
                const el = document.getElementById(id);
                if (!el) return;
                const evt = el.tagName === "TEXTAREA" || el.type === "text" || el.type === "number" ? "input" : "change";
                el.addEventListener(evt, function() {
                    if (self.configuration.rxCertifiedAt) {
                        self.configuration.rxCertifiedAt = null;
                        document.querySelectorAll(".rx-cert-checkbox").forEach(function(b) {
                            b.checked = false;
                        });
                        self.saveState();
                        if (typeof self.updateNavigationButtons === "function") {
                            self.updateNavigationButtons();
                        }
                    }
                });
            });
            [ "pdUpload", "pdLeftUpload", "pdRightUpload" ].forEach(function(id) {
                const el = document.getElementById(id);
                if (!el) return;
                el.addEventListener("input", function() {
                    if (el.value.trim() !== "") {
                        el.classList.remove("rx-input-error");
                        const field = el.closest(".input-field");
                        if (field) field.classList.remove("has-error");
                    }
                    const err = document.getElementById("pdUploadError");
                    if (err && self._readUploadPd().pdValid) err.hidden = true;
                });
            });
            const rxFileInput = document.getElementById("uploadPrescriptionInput");
            if (rxFileInput) {
                rxFileInput.addEventListener("change", function() {
                    if (self.configuration.rxCertifiedAt) {
                        self.configuration.rxCertifiedAt = null;
                        document.querySelectorAll(".rx-cert-checkbox").forEach(function(b) {
                            b.checked = false;
                        });
                        self.saveState();
                        if (typeof self.updateNavigationButtons === "function") {
                            self.updateNavigationButtons();
                        }
                    }
                });
            }
            if (self.configuration.rxCertifiedAt) {
                document.querySelectorAll(".rx-cert-checkbox").forEach(function(b) {
                    b.checked = true;
                });
            }
        },
        selectRxMethod: function(method, opts) {
            opts = opts || {};
            const previousMethod = this.configuration.prescriptionMethod;
            if (previousMethod === "later" && method !== "later") {
                this.configuration.prescriptionSendLater = false;
                const ackBtn = document.getElementById("rxLaterAcknowledgeBtn");
                if (ackBtn) ackBtn.classList.remove("acknowledged");
            }
            if (previousMethod && method !== previousMethod && this.configuration.rxCertifiedAt) {
                this.configuration.rxCertifiedAt = null;
                document.querySelectorAll(".rx-cert-checkbox").forEach(function(b) {
                    b.checked = false;
                });
            }
            this.configuration.prescriptionMethod = method;
            document.querySelectorAll(".rx-method-card").forEach(function(card) {
                const isSelected = card.dataset.rxMethod === method;
                card.classList.toggle("selected", isSelected);
                card.setAttribute("aria-pressed", isSelected ? "true" : "false");
            });
            document.querySelectorAll(".rx-method-content").forEach(function(panel) {
                panel.hidden = panel.dataset.rxMethodContent !== method;
            });
            if (!opts.skipSave && method && method !== previousMethod) {
                const activePanel = document.querySelector('.rx-method-content[data-rx-method-content="' + method + '"]');
                if (activePanel) {
                    requestAnimationFrame(function() {
                        const targetY = activePanel.getBoundingClientRect().top + window.scrollY;
                        const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
                        if (prefersReduced) {
                            window.scrollTo(0, targetY);
                            return;
                        }
                        const startY = window.scrollY;
                        const distance = targetY - startY;
                        const duration = 1200;
                        const startTime = performance.now();
                        function ease(t) {
                            return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
                        }
                        function step(now) {
                            const elapsed = now - startTime;
                            const t = Math.min(elapsed / duration, 1);
                            window.scrollTo(0, startY + distance * ease(t));
                            if (t < 1) requestAnimationFrame(step);
                        }
                        requestAnimationFrame(step);
                    });
                }
            }
            if (!opts.skipSave) this.saveState();
            if (typeof this.updateNavigationButtons === "function") {
                this.updateNavigationButtons();
            }
        },
        _handleRxFileSelected: async function(file) {
            const ALLOWED_TYPES = [ "application/pdf", "image/jpeg", "image/png", "image/webp" ];
            const MAX_BYTES = 10 * 1024 * 1024;
            const dropzone = document.getElementById("rxDropzone");
            const endpoint = (window.chemistrie_rx_upload_endpoint || "").trim();
            const self = this;
            if (!endpoint) {
                self._setUploadStatus("Upload is currently unavailable. Please enter your Rx manually.", "error");
                return;
            }
            if (!ALLOWED_TYPES.includes(file.type)) {
                self._setUploadStatus("Unsupported file type. Please upload a PDF, JPG, PNG, or WebP.", "error");
                return;
            }
            if (file.size > MAX_BYTES) {
                self._setUploadStatus("File is too large. Maximum size is 10 MB.", "error");
                return;
            }
            if (dropzone) dropzone.classList.add("is-uploading");
            self._setUploadStatus("Uploading…", null);
            try {
                const fileData = await self._fileToBase64(file);
                const rxRide = self._buildUploadRxRideAlong();
                const ridePatient = self._buildRxPatientPayload();
                if (ridePatient) rxRide.patient = ridePatient;
                const response = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        fileData: fileData,
                        fileName: file.name,
                        fileType: file.type,
                        fileSize: file.size,
                        pd: rxRide.pd,
                        notes: rxRide.notes,
                        patient: rxRide.patient
                    })
                });
                if (!response.ok) {
                    const errBody = await response.text().catch(function() {
                        return "";
                    });
                    if (response.status === 400) {
                        let fields = null;
                        try {
                            const errJson = JSON.parse(errBody);
                            if (Array.isArray(errJson.fields) && errJson.fields.length) fields = errJson.fields;
                        } catch (e) {}
                        if (fields) {
                            self.configuration.prescriptionUpload = null;
                            self._clearDropzoneFile();
                            self._setUploadStatus("Your PD or notes contain characters we can’t accept. Please retype them using plain numbers, then re-attach your file.", "error");
                            return;
                        }
                    }
                    throw new Error("Upload failed (" + response.status + "): " + errBody.slice(0, 120));
                }
                const data = await response.json();
                if (!data || !data.token) throw new Error("Server response missing token");
                self.configuration.prescriptionUpload = {
                    token: data.token,
                    fileName: file.name,
                    fileType: file.type,
                    fileSize: file.size,
                    uploadedAt: (new Date).toISOString(),
                    rxDataFingerprint: Object.keys(rxRide).length ? JSON.stringify(rxRide) : null
                };
                self._renderDropzoneFile(self.configuration.prescriptionUpload);
                self._setUploadStatus("", null);
                self.saveState();
                if (typeof self.updateNavigationButtons === "function") {
                    self.updateNavigationButtons();
                }
            } catch (err) {
                console.error("[Rx Upload] Failed:", err);
                self.configuration.prescriptionUpload = null;
                self._clearDropzoneFile();
                self._setUploadStatus("Upload failed. Please try again or fill in the prescription manually.", "error");
            } finally {
                if (dropzone) dropzone.classList.remove("is-uploading");
            }
        },
        _renderDropzoneFile: function(upload) {
            const dz = document.getElementById("rxDropzone");
            if (!dz || !upload) return;
            dz.classList.add("has-file");
            const uploadedRow = dz.querySelector(".rx-dropzone__uploaded");
            const filenameEl = dz.querySelector(".rx-dropzone__filename");
            const sizeEl = dz.querySelector(".rx-dropzone__size");
            if (uploadedRow) uploadedRow.hidden = false;
            if (filenameEl) filenameEl.textContent = upload.fileName || "";
            if (sizeEl) sizeEl.textContent = upload.fileSize ? "(" + this._formatBytes(upload.fileSize) + ")" : "";
        },
        _clearDropzoneFile: function() {
            const dz = document.getElementById("rxDropzone");
            if (!dz) return;
            dz.classList.remove("has-file", "is-uploading");
            const uploadedRow = dz.querySelector(".rx-dropzone__uploaded");
            if (uploadedRow) uploadedRow.hidden = true;
        },
        _setUploadStatus: function(text, kind) {
            const statusEl = document.getElementById("uploadRxStatus");
            if (!statusEl) return;
            statusEl.textContent = text || "";
            statusEl.classList.remove("error", "success");
            if (kind) statusEl.classList.add(kind);
            statusEl.hidden = !text;
        },
        _fileToBase64: function(file) {
            return new Promise(function(resolve, reject) {
                const reader = new FileReader;
                reader.onload = function() {
                    const result = reader.result || "";
                    const comma = String(result).indexOf(",");
                    resolve(comma >= 0 ? String(result).slice(comma + 1) : String(result));
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
                reader.readAsDataURL(file);
            });
        },
        _formatBytes: function(b) {
            if (b < 1024) return b + " B";
            if (b < 1024 * 1024) return (b / 1024).toFixed(1) + " KB";
            return (b / 1024 / 1024).toFixed(1) + " MB";
        },
        setupOrderForSomeoneElseEvents: function() {
            const self = this;
            const triggerBtn = document.getElementById("orderForSomeoneElseBtn");
            const overlay = document.getElementById("orderForSomeoneModalOverlay");
            const closeBtn = document.getElementById("orderForSomeoneModalClose");
            const step1 = document.getElementById("orderForSomeoneStep1");
            const step2 = document.getElementById("orderForSomeoneStep2");
            const confirmation = document.getElementById("orderForSomeoneConfirmation");
            const backBtn = document.getElementById("orderForSomeoneBack");
            const confirmBtn = document.getElementById("orderForSomeoneConfirm");
            const doneBtn = document.getElementById("orderForSomeoneDone");
            const patientNameInput = document.getElementById("patientName");
            const patientRelationshipSelect = document.getElementById("patientRelationship");
            const confirmationText = document.getElementById("orderForSomeoneConfirmationText");
            if (!triggerBtn || !overlay) {
                console.log("[setupOrderForSomeoneElseEvents] Modal elements not found, skipping");
                return;
            }
            if (triggerBtn.dataset.eventsAttached === "true") {
                console.log("[setupOrderForSomeoneElseEvents] Events already attached, skipping");
                return;
            }
            console.log("[setupOrderForSomeoneElseEvents] Attaching events...");
            const resetModal = () => {
                step1.style.display = "block";
                step2.style.display = "none";
                confirmation.style.display = "none";
                document.querySelectorAll(".order-for-someone-modal__option").forEach(opt => {
                    opt.classList.remove("selected");
                });
                if (patientNameInput) patientNameInput.value = "";
                if (patientRelationshipSelect) patientRelationshipSelect.value = "";
                if (confirmBtn) confirmBtn.disabled = true;
            };
            const validateForm = () => {
                const nameValid = patientNameInput && patientNameInput.value.trim().length > 0;
                const relationshipValid = patientRelationshipSelect && patientRelationshipSelect.value !== "";
                if (confirmBtn) {
                    confirmBtn.disabled = !(nameValid && relationshipValid);
                }
            };
            triggerBtn.addEventListener("click", () => {
                console.log("[OrderForSomeone] Opening modal");
                resetModal();
                if (self.configuration.orderForSomeoneElse && self.configuration.patientName) {
                    patientNameInput.value = self.configuration.patientName;
                    patientRelationshipSelect.value = self.configuration.patientRelationship || "";
                    step1.style.display = "none";
                    step2.style.display = "block";
                    validateForm();
                }
                overlay.style.display = "flex";
                document.body.style.overflow = "hidden";
            });
            const closeModal = () => {
                overlay.style.display = "none";
                document.body.style.overflow = "";
            };
            closeBtn.addEventListener("click", closeModal);
            overlay.addEventListener("click", e => {
                if (e.target === overlay) closeModal();
            });
            document.querySelectorAll(".order-for-someone-modal__option").forEach(option => {
                option.addEventListener("click", () => {
                    const answer = option.dataset.answer;
                    console.log("[OrderForSomeone] Selected:", answer);
                    document.querySelectorAll(".order-for-someone-modal__option").forEach(opt => {
                        opt.classList.remove("selected");
                    });
                    option.classList.add("selected");
                    if (answer === "yes") {
                        setTimeout(() => {
                            step1.style.display = "none";
                            step2.style.display = "block";
                            if (patientNameInput) patientNameInput.focus();
                        }, 200);
                    } else {
                        self.configuration.orderForSomeoneElse = false;
                        self.configuration.patientName = null;
                        self.configuration.patientRelationship = null;
                        self.saveState();
                        triggerBtn.classList.remove("active");
                        self.removePatientInfoIndicator();
                        console.log("[OrderForSomeone] Cleared - order is for purchaser");
                        setTimeout(closeModal, 200);
                    }
                });
            });
            if (backBtn) {
                backBtn.addEventListener("click", () => {
                    step2.style.display = "none";
                    step1.style.display = "block";
                });
            }
            if (patientNameInput) {
                patientNameInput.addEventListener("input", validateForm);
            }
            if (patientRelationshipSelect) {
                patientRelationshipSelect.addEventListener("change", validateForm);
            }
            if (confirmBtn) {
                confirmBtn.addEventListener("click", () => {
                    const name = patientNameInput.value.trim();
                    const relationship = patientRelationshipSelect.value;
                    if (!name || !relationship) return;
                    self.configuration.orderForSomeoneElse = true;
                    self.configuration.patientName = name;
                    self.configuration.patientRelationship = relationship;
                    self.saveState();
                    console.log("[OrderForSomeone] Saved patient info:", {
                        name: name,
                        relationship: relationship
                    });
                    triggerBtn.classList.add("active");
                    self.showPatientInfoIndicator(name, relationship);
                    step2.style.display = "none";
                    confirmation.style.display = "block";
                    const strongEl = confirmationText.querySelector("strong");
                    if (strongEl) {
                        strongEl.textContent = `${name} (${relationship})`;
                    }
                });
            }
            if (doneBtn) {
                doneBtn.addEventListener("click", closeModal);
            }
            triggerBtn.dataset.eventsAttached = "true";
            console.log("[setupOrderForSomeoneElseEvents] Events attached successfully");
        },
        showPatientInfoIndicator: function(name, relationship) {
            this.removePatientInfoIndicator();
            const orderBtn = document.getElementById("orderForSomeoneElseBtn");
            if (!orderBtn) return;
            const indicator = document.createElement("div");
            indicator.className = "patient-info-indicator";
            indicator.id = "patientInfoIndicator";
            indicator.innerHTML = `\n                <span class="patient-info-indicator__text">Order for: <strong></strong></span>\n                <button type="button" class="patient-info-indicator__edit" id="patientInfoEdit">Edit</button>\n            `;
            indicator.querySelector(".patient-info-indicator__text strong").textContent = name;
            orderBtn.insertAdjacentElement("afterend", indicator);
            const editBtn = document.getElementById("patientInfoEdit");
            if (editBtn) {
                editBtn.addEventListener("click", () => {
                    const triggerBtn = document.getElementById("orderForSomeoneElseBtn");
                    if (triggerBtn) triggerBtn.click();
                });
            }
        },
        removePatientInfoIndicator: function() {
            const existing = document.getElementById("patientInfoIndicator");
            if (existing) existing.remove();
        },
        showStep2Variant: function() {
            const frameChoice = this.configuration.frameChoice;
            document.querySelectorAll(".step2-variant").forEach(variant => {
                variant.style.display = "none";
            });
            const titleEl = document.getElementById("step2Title");
            const descriptionEl = document.getElementById("step2Description");
            let variantId = "";
            let title = "";
            let description = "";
            switch (frameChoice) {
              case "own-frame-own-lenses":
                variantId = "step2VariantA";
                title = "Let's Get to Know Your Frames";
                description = "";
                break;

              case "own-frame-new-lenses":
                variantId = "step2VariantB";
                title = "Let's Get to Know Your Frames & Rx";
                description = "";
                break;

              case "new-frame-lenses":
                variantId = "step2VariantC";
                title = "Your Prescription";
                description = "We'll pair your prescription with a Chemistrie-compatible frame";
                break;

              default:
                console.warn("No frameChoice selected - showing default variant");
                variantId = "step2VariantC";
                title = "Tell Us About Your Prescription";
                description = "We need a few details to get started";
            }
            if (titleEl) titleEl.textContent = title;
            if (descriptionEl) descriptionEl.textContent = description;
            if (variantId === "step2VariantC" && this.configuration.frameProduct) {
                this.showSelectedFrameNotice();
            } else {
                this.hideSelectedFrameNotice();
                if (variantId === "step2VariantA" || variantId === "step2VariantB") {
                    this.configuration.frameProduct = null;
                }
            }
            this.setupStep2Events();
        },
        showSelectedFrameNotice: async function() {
            const noticeEl = document.getElementById("selectedFrameNotice");
            const frameNameEl = document.getElementById("selectedFrameName");
            if (noticeEl && frameNameEl && this.configuration.frameProduct) {
                const frameHandle = this.configuration.frameProduct;
                let frameData = window.chemistrie_products?.frames?.[frameHandle];
                if (!frameData) {
                    frameData = await this.fetchFrameData(frameHandle);
                }
                let frameName = frameData?.title || this.capitalizeWords(frameHandle.replace(/-/g, " "));
                if (this.configuration.frameVariantTitle) {
                    let variantDisplay = this.configuration.frameVariantTitle;
                    variantDisplay = variantDisplay.replace(/^Option\d*[-_]?/i, "");
                    variantDisplay = variantDisplay.charAt(0).toUpperCase() + variantDisplay.slice(1);
                    frameName += ` - ${variantDisplay}`;
                }
                frameNameEl.textContent = frameName;
                noticeEl.style.display = "block";
                console.log(`Showing frame notice for: ${frameName} (${frameHandle})`);
            }
        },
        hideSelectedFrameNotice: function() {
            const noticeEl = document.getElementById("selectedFrameNotice");
            if (noticeEl) {
                noticeEl.style.display = "none";
                console.log("Hiding frame notice - switching to variant without frame selection");
            }
        },
        skipRxPrescription: function() {
            this.configuration.prescription = "skip";
            [ "odSphereC", "odCylinderC", "odAxisC", "odAddC", "osSphereC", "osCylinderC", "osAxisC", "osAddC", "pdC", "rxNotes" ].forEach(id => {
                const input = document.getElementById(id);
                if (input) input.value = "";
            });
            this.updateNavigationButtons();
            this.saveState();
        },
        skipRxPrescriptionVariantB: function() {
            this.configuration.prescription = "skip";
            this.configuration.prescriptionSkippedInVariantB = true;
            console.log("[skipRxPrescriptionVariantB] Prescription marked as skip - will show inline fields in Step 5");
            [ "odSphere", "odCylinder", "odAxis", "odAdd", "osSphere", "osCylinder", "osAxis", "osAdd", "pd", "rxNotes" ].forEach(id => {
                const input = document.getElementById(id);
                if (input) input.value = "";
            });
            const skipBtn = document.getElementById("skipRxBtnB");
            if (skipBtn) {
                skipBtn.classList.add("selected");
            }
            this.updateNavigationButtons();
            this.saveState();
            console.log("[skipRxPrescriptionVariantB] Configuration updated:", {
                prescription: this.configuration.prescription,
                prescriptionSkippedInVariantB: this.configuration.prescriptionSkippedInVariantB
            });
        },
        handleNotSureFrameDetails: function(variant) {
            console.log(`[handleNotSureFrameDetails] Prefilling frame details for Variant ${variant}`);
            this.configuration.frameDetailsUnknown = true;
            const brandInputId = "frameBrand";
            const modelInputId = "frameModel";
            const brandInput = document.getElementById(brandInputId);
            const modelInput = document.getElementById(modelInputId);
            if (brandInput && modelInput) {
                brandInput.value = "Unknown";
                modelInput.value = "Unknown";
                console.log(`[handleNotSureFrameDetails] Prefilled ${brandInputId} and ${modelInputId} with "Unknown"`);
                this.configuration.frameBrand = "Unknown";
                this.configuration.frameModel = "Unknown";
                const notSureBtns = document.querySelectorAll(".not-sure-btn");
                notSureBtns.forEach(btn => {
                    btn.classList.add("selected");
                });
                this.validateStep2();
                this.updateNavigationButtons();
                this.saveState();
                console.log("[handleNotSureFrameDetails] Configuration updated:", {
                    frameBrand: this.configuration.frameBrand,
                    frameModel: this.configuration.frameModel,
                    frameDetailsUnknown: this.configuration.frameDetailsUnknown
                });
            } else {
                console.error(`[handleNotSureFrameDetails] Could not find inputs for Variant ${variant}`);
            }
        },
        showFrameWarningModal: function(pendingFrameChoice) {
            const modal = document.getElementById("frameWarningModal");
            const frameNameEl = document.getElementById("previousFrameName");
            const cancelBtn = document.getElementById("frameWarningCancel");
            const continueBtn = document.getElementById("frameWarningContinue");
            if (!modal || !frameNameEl || !cancelBtn || !continueBtn) {
                console.error("[Frame Warning Modal] Elements not found");
                return;
            }
            const frameName = this.configuration.frameProduct.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
            frameNameEl.textContent = frameName;
            modal.style.display = "flex";
            console.log("[Frame Warning Modal] Showing modal - frame:", frameName);
            const self = this;
            const handleCancel = () => {
                modal.style.display = "none";
                console.log("[Frame Warning] User canceled - keeping current frame selection");
                cancelBtn.removeEventListener("click", handleCancel);
                continueBtn.removeEventListener("click", handleContinue);
                modal.removeEventListener("click", handleOverlayClick);
            };
            const handleContinue = () => {
                modal.style.display = "none";
                console.log("[Frame Warning] User confirmed - clearing frameProduct and proceeding");
                self.configuration.frameProduct = null;
                self.applyFrameChoice(pendingFrameChoice);
                cancelBtn.removeEventListener("click", handleCancel);
                continueBtn.removeEventListener("click", handleContinue);
                modal.removeEventListener("click", handleOverlayClick);
            };
            const handleOverlayClick = e => {
                if (e.target === modal) {
                    handleCancel();
                }
            };
            cancelBtn.addEventListener("click", handleCancel);
            continueBtn.addEventListener("click", handleContinue);
            modal.addEventListener("click", handleOverlayClick);
        },
        showEditWarningModal: function() {
            const modal = document.getElementById("editWarningModal");
            const cancelBtn = document.getElementById("editWarningCancel");
            const continueBtn = document.getElementById("editWarningContinue");
            if (!modal || !cancelBtn || !continueBtn) {
                console.error("[Edit Warning Modal] Elements not found");
                return;
            }
            modal.style.display = "flex";
            console.log("[Edit Warning Modal] Showing modal");
            const self = this;
            const handleCancel = () => {
                modal.style.display = "none";
                console.log("[Edit Warning] User chose to stay — keeping edit mode");
                cancelBtn.removeEventListener("click", handleCancel);
                continueBtn.removeEventListener("click", handleContinue);
            };
            const handleContinue = () => {
                modal.style.display = "none";
                console.log("[Edit Warning] User chose to start over — clearing edit mode");
                self.isEditingConfig = false;
                self.editConfigId = null;
                self.editClipSequence = null;
                self.isPrescriptionOnlyFlow = false;
                self.configuration.isPrescriptionOnlyOrder = false;
                self.resetConfiguration();
                self.goToStep(1);
                cancelBtn.removeEventListener("click", handleCancel);
                continueBtn.removeEventListener("click", handleContinue);
            };
            cancelBtn.addEventListener("click", handleCancel);
            continueBtn.addEventListener("click", handleContinue);
            modal.addEventListener("click", e => {
                if (e.target === modal) {
                    handleCancel();
                }
            });
        },
        deriveOrderSourceFromFrameChoice: function(frameChoice) {
            if (frameChoice === "own-frame-own-lenses") return "Order Flow - Variant A";
            if (frameChoice === "own-frame-new-lenses") return "Order Flow - Variant B";
            if (frameChoice === "new-frame-lenses") return "Order Flow - Variant C";
            return null;
        },
        applyFrameChoice: function(frameChoice) {
            console.log("[applyFrameChoice] Applying frame choice:", frameChoice);
            if (!this.isOpticalRetailerReorder && (!this.configuration.orderSource || !this.configuration.orderSource.includes("PDP"))) {
                if (frameChoice === "own-frame-own-lenses") {
                    this.configuration.orderSource = "Order Flow - Variant A";
                } else if (frameChoice === "own-frame-new-lenses") {
                    this.configuration.orderSource = "Order Flow - Variant B";
                } else if (frameChoice === "new-frame-lenses") {
                    this.configuration.orderSource = "Order Flow - Variant C";
                }
                console.log("[applyFrameChoice] Order source set:", this.configuration.orderSource);
                this.saveState();
            }
            if (this.configuration.frameChoice === frameChoice) {
                console.log("[applyFrameChoice] Same choice re-selected, skipping DOM update");
                document.querySelectorAll("#step1 .frame-choice-card.flipped").forEach(card => {
                    card.classList.remove("flipped");
                    card.setAttribute("aria-expanded", "false");
                });
                return;
            }
            const previousChoice = this.configuration.frameChoice;
            const isFrameVariantA = frameChoice === "own-frame-own-lenses";
            const isFrameVariantB = frameChoice === "own-frame-new-lenses";
            const wasFrameVariantA = previousChoice === "own-frame-own-lenses";
            const wasFrameVariantB = previousChoice === "own-frame-new-lenses";
            if ((wasFrameVariantA || wasFrameVariantB) && (isFrameVariantA || isFrameVariantB) && frameChoice !== previousChoice) {
                console.log("[applyFrameChoice] Clearing frame details when switching between Variant A and B");
                this.configuration.frameBrand = null;
                this.configuration.frameModel = null;
                this.configuration.frameDetailsUnknown = false;
                const frameBrandInput = document.getElementById("frameBrand");
                const frameModelInput = document.getElementById("frameModel");
                if (frameBrandInput) frameBrandInput.value = "";
                if (frameModelInput) frameModelInput.value = "";
                const notSureBtns = document.querySelectorAll(".not-sure-btn");
                notSureBtns.forEach(btn => btn.classList.remove("selected"));
            }
            this.configuration.frameChoice = frameChoice;
            if (frameChoice === "own-frame-own-lenses") {
                this._clearStaleRxState();
            }
            try {
                document.dispatchEvent(new CustomEvent("configurator:variant_chosen", {
                    detail: {
                        variant: frameChoice
                    }
                }));
            } catch (e) {}
            if (!this.isOpticalRetailerReorder && (!this.configuration.orderSource || !this.configuration.orderSource.includes("PDP"))) {
                if (frameChoice === "own-frame-own-lenses") {
                    this.configuration.orderSource = "Order Flow - Variant A";
                } else if (frameChoice === "own-frame-new-lenses") {
                    this.configuration.orderSource = "Order Flow - Variant B";
                } else if (frameChoice === "new-frame-lenses") {
                    this.configuration.orderSource = "Order Flow - Variant C";
                }
                console.log("[applyFrameChoice] Order source set:", this.configuration.orderSource);
            }
            document.querySelectorAll("#step1 .frame-choice-card").forEach(card => {
                card.classList.remove("selected");
                card.setAttribute("aria-pressed", "false");
                card.classList.remove("flipped");
                card.setAttribute("aria-expanded", "false");
            });
            const selectedCard = document.querySelector(`#step1 [data-choice="${frameChoice}"]`);
            if (selectedCard) {
                selectedCard.classList.add("selected");
                selectedCard.setAttribute("aria-pressed", "true");
            }
            this.updateNavigationButtons();
            this.saveState();
            this.updateLensTypeCardPrices();
            console.log("[applyFrameChoice] Frame choice applied successfully");
        },
        saveInlineRxData: function() {
            console.log("[saveInlineRxData] Saving prescription data from Step 5 inline form");
            const odSphere = document.getElementById("odSphereReview")?.value.trim();
            const odCylinder = document.getElementById("odCylinderReview")?.value.trim();
            const odAxis = document.getElementById("odAxisReview")?.value.trim();
            const odAdd = document.getElementById("odAddReview")?.value.trim();
            const osSphere = document.getElementById("osSphereReview")?.value.trim();
            const osCylinder = document.getElementById("osCylinderReview")?.value.trim();
            const osAxis = document.getElementById("osAxisReview")?.value.trim();
            const osAdd = document.getElementById("osAddReview")?.value.trim();
            const dualPdToggleReview = document.getElementById("dualPdToggleReview");
            const isDualModeReview = dualPdToggleReview?.checked || false;
            let pdDataReview;
            let pdValidReview = false;
            if (isDualModeReview) {
                const pdLeftRev = document.getElementById("pdLeftReview")?.value.trim();
                const pdRightRev = document.getElementById("pdRightReview")?.value.trim();
                pdDataReview = {
                    mode: "dual",
                    value: null,
                    left: pdLeftRev || null,
                    right: pdRightRev || null
                };
                pdValidReview = !!(pdLeftRev && pdRightRev);
                console.log("[saveInlineRxData] PD Mode: DUAL | Left:", pdLeftRev, "Right:", pdRightRev);
            } else {
                const pdSingleRev = document.getElementById("pdReview")?.value.trim();
                pdDataReview = {
                    mode: "single",
                    value: pdSingleRev || null,
                    left: null,
                    right: null
                };
                pdValidReview = !!pdSingleRev;
                console.log("[saveInlineRxData] PD Mode: SINGLE | Value:", pdSingleRev);
            }
            const allOdFieldsFilled = odSphere !== "" && odCylinder !== "" && odAxis !== "" && odAdd !== "";
            const allOsFieldsFilled = osSphere !== "" && osCylinder !== "" && osAxis !== "" && osAdd !== "";
            if (!allOdFieldsFilled || !allOsFieldsFilled || !pdValidReview) {
                this.markInlineRxFieldErrors({
                    odSphere: odSphere,
                    odCylinder: odCylinder,
                    odAxis: odAxis,
                    odAdd: odAdd,
                    osSphere: osSphere,
                    osCylinder: osCylinder,
                    osAxis: osAxis,
                    osAdd: osAdd,
                    pdValid: pdValidReview,
                    isDualMode: isDualModeReview
                });
                console.log("[saveInlineRxData] ❌ Validation failed - all fields are required (can be 0)");
                return false;
            }
            const rxNotesReview = document.getElementById("rxNotesReview")?.value.trim() || "";
            this.configuration.prescription = {
                od: {
                    sphere: odSphere,
                    cylinder: odCylinder,
                    axis: odAxis,
                    add: odAdd
                },
                os: {
                    sphere: osSphere,
                    cylinder: osCylinder,
                    axis: osAxis,
                    add: osAdd
                },
                pd: pdDataReview,
                notes: rxNotesReview
            };
            this.configuration.prescriptionSkippedInVariantB = false;
            const inlineRxForm = document.getElementById("inlineRxForm");
            const addPrescriptionSection = document.getElementById("addPrescriptionSection");
            const expandRxBtn = document.getElementById("expandRxBtn");
            if (inlineRxForm) {
                inlineRxForm.style.display = "none";
            }
            if (expandRxBtn) {
                expandRxBtn.textContent = "Click to Edit";
            }
            const prescriptionStatus = document.querySelector(".prescription-status");
            if (prescriptionStatus) {
                prescriptionStatus.innerHTML = 'Prescription Saved ✅ - <button type="button" class="expand-rx-btn" id="expandRxBtn">Click to Edit</button>';
                const newExpandBtn = document.getElementById("expandRxBtn");
                if (newExpandBtn && inlineRxForm) {
                    newExpandBtn.addEventListener("click", function() {
                        const isVisible = inlineRxForm.style.display === "block";
                        inlineRxForm.style.display = isVisible ? "none" : "block";
                        newExpandBtn.textContent = isVisible ? "Click to Edit" : "Click to Hide";
                    });
                }
            }
            if (addPrescriptionSection) {
                addPrescriptionSection.style.background = "#E8F5E9";
                addPrescriptionSection.style.borderColor = "#4CAF50";
            }
            this.saveState();
            this.updateNavigationButtons();
            this.hidePrescriptionErrorBanner();
            console.log("[saveInlineRxData] ✅ Prescription saved:", this.configuration.prescription);
            return true;
        },
        setupSendLaterModal: function() {
            const sendLaterBtn = document.getElementById("sendLaterBtn");
            const prescriptionLaterDialog = document.getElementById("prescriptionLaterDialog");
            const prescriptionLaterOverlay = document.getElementById("prescriptionLaterOverlay");
            const prescriptionLaterClose = document.getElementById("prescriptionLaterClose");
            const addPrescriptionNowBtn = document.getElementById("addPrescriptionNowBtn");
            const iUnderstandBtn = document.getElementById("iUnderstandBtn");
            const expandRxBtn = document.getElementById("expandRxBtn");
            const inlineRxForm = document.getElementById("inlineRxForm");
            console.log("[setupSendLaterModal] Setting up Send Later modal event listeners");
            if (sendLaterBtn && prescriptionLaterDialog) {
                sendLaterBtn.addEventListener("click", () => {
                    prescriptionLaterDialog.classList.add("is-active");
                    console.log("[setupSendLaterModal] Modal opened");
                });
            }
            if (prescriptionLaterClose && prescriptionLaterDialog) {
                prescriptionLaterClose.addEventListener("click", () => {
                    prescriptionLaterDialog.classList.remove("is-active");
                    console.log("[setupSendLaterModal] Modal closed via X button");
                });
            }
            if (prescriptionLaterOverlay && prescriptionLaterDialog) {
                prescriptionLaterOverlay.addEventListener("click", () => {
                    prescriptionLaterDialog.classList.remove("is-active");
                    console.log("[setupSendLaterModal] Modal closed via overlay click");
                });
            }
            if (addPrescriptionNowBtn && expandRxBtn && inlineRxForm && prescriptionLaterDialog) {
                addPrescriptionNowBtn.addEventListener("click", () => {
                    prescriptionLaterDialog.classList.remove("is-active");
                    inlineRxForm.style.display = "block";
                    expandRxBtn.textContent = "Click to Hide";
                    const addPrescriptionSection = document.getElementById("addPrescriptionSection");
                    if (addPrescriptionSection) {
                        addPrescriptionSection.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                    }
                    console.log("[setupSendLaterModal] Prescription form expanded, modal closed");
                });
            }
            if (iUnderstandBtn && prescriptionLaterDialog) {
                const self = this;
                iUnderstandBtn.addEventListener("click", () => {
                    self.configuration.prescriptionSendLater = true;
                    self.saveState();
                    prescriptionLaterDialog.classList.remove("is-active");
                    self.hidePrescriptionErrorBanner();
                    const inlineRxForm = document.getElementById("inlineRxForm");
                    const expandRxBtn = document.getElementById("expandRxBtn");
                    if (inlineRxForm) {
                        inlineRxForm.style.display = "none";
                    }
                    if (expandRxBtn) {
                        expandRxBtn.textContent = "Click to Add";
                    }
                    console.log("[setupSendLaterModal] User acknowledged prescription will be sent later");
                    console.log("[setupSendLaterModal] prescriptionSendLater flag set to true");
                    console.log("[setupSendLaterModal] Prescription form collapsed to normal state");
                });
            }
        },
        showPrescriptionErrorBanner: function() {
            const errorBanner = document.getElementById("prescriptionErrorBanner");
            if (errorBanner) {
                errorBanner.style.display = "flex";
                const closeBtn = document.getElementById("prescriptionErrorClose");
                if (closeBtn && !closeBtn.dataset.handlerAttached) {
                    closeBtn.addEventListener("click", () => {
                        this.hidePrescriptionErrorBanner();
                    });
                    closeBtn.dataset.handlerAttached = "true";
                }
                console.log("[showPrescriptionErrorBanner] Error banner displayed");
            }
        },
        hidePrescriptionErrorBanner: function() {
            const errorBanner = document.getElementById("prescriptionErrorBanner");
            if (errorBanner) {
                errorBanner.style.display = "none";
            }
            this.showPrescriptionError = false;
            console.log("[hidePrescriptionErrorBanner] Error banner hidden");
        },
        showOrderFlowError: function(message) {
            const existing = document.getElementById("orderFlowErrorBanner");
            if (existing) existing.remove();
            const banner = document.createElement("div");
            banner.id = "orderFlowErrorBanner";
            banner.style.cssText = "display:flex;align-items:flex-start;gap:10px;padding:14px 16px;margin:12px 0;background:#FEF2F2;border:1px solid #EF4444;border-radius:8px;color:#991B1B;font-size:14px;line-height:1.5;";
            const icon = document.createElement("span");
            icon.textContent = "⚠";
            icon.style.cssText = "flex-shrink:0;font-size:18px;";
            const text = document.createElement("span");
            text.textContent = message;
            text.style.flex = "1";
            const closeBtn = document.createElement("button");
            closeBtn.textContent = "✕";
            closeBtn.style.cssText = "background:none;border:none;color:#991B1B;cursor:pointer;font-size:16px;padding:0;flex-shrink:0;";
            closeBtn.addEventListener("click", () => banner.remove());
            banner.appendChild(icon);
            banner.appendChild(text);
            banner.appendChild(closeBtn);
            const addToCartBtn = document.getElementById("addToCartBtn");
            if (addToCartBtn && addToCartBtn.parentNode) {
                addToCartBtn.parentNode.insertBefore(banner, addToCartBtn);
            } else {
                const activeStep = document.querySelector('.step-content.active, .step-content[style*="display: block"]');
                if (activeStep) {
                    activeStep.insertBefore(banner, activeStep.firstChild);
                }
            }
            setTimeout(() => {
                if (banner.parentNode) banner.remove();
            }, 15e3);
            console.log("[showOrderFlowError] Error banner displayed:", message);
        },
        populateInlinePrescriptionForm: function() {
            if (!this.configuration.prescription || this.configuration.prescription === "skip") {
                console.log("[Step 5] No prescription data to populate");
                return;
            }
            const rx = this.configuration.prescription;
            console.log("[Step 5] Populating inline prescription form with saved data");
            const odSphere = document.getElementById("odSphereReview");
            const odCylinder = document.getElementById("odCylinderReview");
            const odAxis = document.getElementById("odAxisReview");
            const odAdd = document.getElementById("odAddReview");
            const osSphere = document.getElementById("osSphereReview");
            const osCylinder = document.getElementById("osCylinderReview");
            const osAxis = document.getElementById("osAxisReview");
            const osAdd = document.getElementById("osAddReview");
            const pdSingleReview = document.getElementById("pdReview");
            const pdLeftReview = document.getElementById("pdLeftReview");
            const pdRightReview = document.getElementById("pdRightReview");
            const dualPdToggleReview = document.getElementById("dualPdToggleReview");
            const pdToggleWrapperReview = document.getElementById("pdToggleWrapperReview");
            const pdSingleWrapperReview = document.getElementById("pdSingleWrapperReview");
            const pdDualLeftReview = document.getElementById("pdDualLeftReview");
            const pdDualRightReview = document.getElementById("pdDualRightReview");
            if (odSphere && rx.od) odSphere.value = rx.od.sphere || "";
            if (odCylinder && rx.od) odCylinder.value = rx.od.cylinder || "";
            if (odAxis && rx.od) odAxis.value = rx.od.axis || "";
            if (odAdd && rx.od) odAdd.value = rx.od.add || "";
            if (osSphere && rx.os) osSphere.value = rx.os.sphere || "";
            if (osCylinder && rx.os) osCylinder.value = rx.os.cylinder || "";
            if (osAxis && rx.os) osAxis.value = rx.os.axis || "";
            if (osAdd && rx.os) osAdd.value = rx.os.add || "";
            if (rx.pd) {
                if (typeof rx.pd === "object" && rx.pd.mode) {
                    if (rx.pd.mode === "dual") {
                        if (dualPdToggleReview) dualPdToggleReview.checked = true;
                        if (pdToggleWrapperReview) pdToggleWrapperReview.classList.add("dual-active");
                        if (pdSingleWrapperReview) pdSingleWrapperReview.style.display = "none";
                        if (pdDualLeftReview) pdDualLeftReview.style.display = "flex";
                        if (pdDualRightReview) pdDualRightReview.style.display = "flex";
                        if (pdLeftReview) pdLeftReview.value = rx.pd.left || "";
                        if (pdRightReview) pdRightReview.value = rx.pd.right || "";
                        console.log("[Step 5] PD populated in DUAL mode - Left:", rx.pd.left, "Right:", rx.pd.right);
                    } else {
                        if (dualPdToggleReview) dualPdToggleReview.checked = false;
                        if (pdToggleWrapperReview) pdToggleWrapperReview.classList.remove("dual-active");
                        if (pdSingleWrapperReview) pdSingleWrapperReview.style.display = "flex";
                        if (pdDualLeftReview) pdDualLeftReview.style.display = "none";
                        if (pdDualRightReview) pdDualRightReview.style.display = "none";
                        if (pdSingleReview) pdSingleReview.value = rx.pd.value || "";
                        console.log("[Step 5] PD populated in SINGLE mode - Value:", rx.pd.value);
                    }
                } else {
                    if (dualPdToggleReview) dualPdToggleReview.checked = false;
                    if (pdToggleWrapperReview) pdToggleWrapperReview.classList.remove("dual-active");
                    if (pdSingleWrapperReview) pdSingleWrapperReview.style.display = "flex";
                    if (pdDualLeftReview) pdDualLeftReview.style.display = "none";
                    if (pdDualRightReview) pdDualRightReview.style.display = "none";
                    if (pdSingleReview) pdSingleReview.value = rx.pd;
                    console.log("[Step 5] PD populated in SINGLE mode (legacy format) - Value:", rx.pd);
                }
            }
            const rxNotesReviewField = document.getElementById("rxNotesReview");
            if (rxNotesReviewField) {
                rxNotesReviewField.value = rx.notes || "";
            }
            console.log("[Step 5] Prescription form populated successfully");
        },
        validateStep2: function() {
            const frameChoice = this.configuration.frameChoice;
            let isValid = false;
            console.log("[Step 2 Validation] Frame choice:", frameChoice);
            switch (frameChoice) {
              case "own-frame-own-lenses":
                const brandA = document.getElementById("frameBrand")?.value.trim();
                const modelA = document.getElementById("frameModel")?.value.trim();
                console.log("[Variant A] Brand:", brandA, "Model:", modelA);
                isValid = !!(brandA && modelA);
                if (isValid) {
                    this.configuration.frameBrand = brandA;
                    this.configuration.frameModel = modelA;
                    console.log("[Variant A] ✅ Valid - data saved");
                } else {
                    console.log("[Variant A] ❌ Invalid - missing brand or model");
                }
                break;

              case "own-frame-new-lenses":
                const brandB = document.getElementById("frameBrand")?.value.trim();
                const modelB = document.getElementById("frameModel")?.value.trim();
                if (this.configuration.prescription === "skip") {
                    isValid = !!(brandB && modelB);
                    if (isValid) {
                        this.configuration.frameBrand = brandB;
                        this.configuration.frameModel = modelB;
                        console.log("[Variant B] ✅ Valid - frame fields filled, Rx skipped (add later in Step 5)");
                    } else {
                        console.log("[Variant B] ❌ Invalid - missing frame fields (Rx skipped)");
                    }
                } else {
                    const odSphere = document.getElementById("odSphere")?.value.trim();
                    const odCylinder = document.getElementById("odCylinder")?.value.trim();
                    const odAxis = document.getElementById("odAxis")?.value.trim();
                    const odAdd = document.getElementById("odAdd")?.value.trim();
                    const osSphere = document.getElementById("osSphere")?.value.trim();
                    const osCylinder = document.getElementById("osCylinder")?.value.trim();
                    const osAxis = document.getElementById("osAxis")?.value.trim();
                    const osAdd = document.getElementById("osAdd")?.value.trim();
                    const dualPdToggle = document.getElementById("dualPdToggle");
                    const isDualMode = dualPdToggle?.checked || false;
                    let pdData;
                    let pdValid = false;
                    if (isDualMode) {
                        const pdLeft = document.getElementById("pdLeft")?.value.trim();
                        const pdRight = document.getElementById("pdRight")?.value.trim();
                        pdData = {
                            mode: "dual",
                            value: null,
                            left: pdLeft || null,
                            right: pdRight || null
                        };
                        pdValid = !!(pdLeft && pdRight);
                        console.log("[Variant B] PD Mode: DUAL | Left:", pdLeft, "Right:", pdRight);
                    } else {
                        const pdSingle = document.getElementById("pd")?.value.trim();
                        pdData = {
                            mode: "single",
                            value: pdSingle || null,
                            left: null,
                            right: null
                        };
                        pdValid = !!pdSingle;
                        console.log("[Variant B] PD Mode: SINGLE | Value:", pdSingle);
                    }
                    console.log("[Variant B] Brand:", brandB, "Model:", modelB);
                    console.log("[Variant B] OD - Sphere:", odSphere, "Cyl:", odCylinder, "Axis:", odAxis, "Add:", odAdd);
                    console.log("[Variant B] OS - Sphere:", osSphere, "Cyl:", osCylinder, "Axis:", osAxis, "Add:", osAdd);
                    const allOdFieldsFilled = odSphere !== "" && odCylinder !== "" && odAxis !== "" && odAdd !== "";
                    const allOsFieldsFilled = osSphere !== "" && osCylinder !== "" && osAxis !== "" && osAdd !== "";
                    isValid = !!(brandB && modelB && allOdFieldsFilled && allOsFieldsFilled && pdValid);
                    if (isValid) {
                        const rxNotes = document.getElementById("rxNotes")?.value.trim() || "";
                        this.configuration.frameBrand = brandB;
                        this.configuration.frameModel = modelB;
                        this.configuration.prescription = {
                            od: {
                                sphere: odSphere,
                                cylinder: odCylinder,
                                axis: odAxis,
                                add: odAdd
                            },
                            os: {
                                sphere: osSphere,
                                cylinder: osCylinder,
                                axis: osAxis,
                                add: osAdd
                            },
                            pd: pdData,
                            notes: rxNotes
                        };
                        console.log("[Variant B] ✅ Valid - frame and Rx data saved (PD mode:", pdData.mode + ")");
                    } else {
                        console.log("[Variant B] ❌ Invalid - missing frame or Rx fields (all fields required, can be 0)");
                    }
                }
                break;

              case "new-frame-lenses":
                if (this.configuration.prescription === "skip") {
                    isValid = true;
                    console.log("[Variant C] ✅ Valid - prescription skipped");
                } else {
                    const odSphereC = document.getElementById("odSphereC")?.value.trim();
                    const odCylinderC = document.getElementById("odCylinderC")?.value.trim();
                    const odAxisC = document.getElementById("odAxisC")?.value.trim();
                    const odAddC = document.getElementById("odAddC")?.value.trim();
                    const osSphereC = document.getElementById("osSphereC")?.value.trim();
                    const osCylinderC = document.getElementById("osCylinderC")?.value.trim();
                    const osAxisC = document.getElementById("osAxisC")?.value.trim();
                    const osAddC = document.getElementById("osAddC")?.value.trim();
                    const dualPdToggleC = document.getElementById("dualPdToggle");
                    const isDualModeC = dualPdToggleC?.checked || false;
                    let pdDataC;
                    let pdValidC = false;
                    if (isDualModeC) {
                        const pdLeftC = document.getElementById("pdCLeft")?.value.trim() || document.getElementById("pdLeft")?.value.trim();
                        const pdRightC = document.getElementById("pdCRight")?.value.trim() || document.getElementById("pdRight")?.value.trim();
                        pdDataC = {
                            mode: "dual",
                            value: null,
                            left: pdLeftC || null,
                            right: pdRightC || null
                        };
                        pdValidC = !!(pdLeftC && pdRightC);
                        console.log("[Variant C] PD Mode: DUAL | Left:", pdLeftC, "Right:", pdRightC);
                    } else {
                        const pdSingleC = document.getElementById("pdC")?.value.trim() || document.getElementById("pd")?.value.trim();
                        pdDataC = {
                            mode: "single",
                            value: pdSingleC || null,
                            left: null,
                            right: null
                        };
                        pdValidC = !!pdSingleC;
                        console.log("[Variant C] PD Mode: SINGLE | Value:", pdSingleC);
                    }
                    console.log("[Variant C] OD - Sphere:", odSphereC, "Cyl:", odCylinderC, "Axis:", odAxisC, "Add:", odAddC);
                    console.log("[Variant C] OS - Sphere:", osSphereC, "Cyl:", osCylinderC, "Axis:", osAxisC, "Add:", osAddC);
                    const allOdFieldsFilledC = odSphereC !== "" && odCylinderC !== "" && odAxisC !== "" && odAddC !== "";
                    const allOsFieldsFilledC = osSphereC !== "" && osCylinderC !== "" && osAxisC !== "" && osAddC !== "";
                    isValid = !!(allOdFieldsFilledC && allOsFieldsFilledC && pdValidC);
                    if (isValid) {
                        const rxNotesC = document.getElementById("rxNotes")?.value.trim() || "";
                        this.configuration.prescription = {
                            od: {
                                sphere: odSphereC,
                                cylinder: odCylinderC,
                                axis: odAxisC,
                                add: odAddC
                            },
                            os: {
                                sphere: osSphereC,
                                cylinder: osCylinderC,
                                axis: osAxisC,
                                add: osAddC
                            },
                            pd: pdDataC,
                            notes: rxNotesC
                        };
                        console.log("[Variant C] ✅ Valid - Rx data saved (PD mode:", pdDataC.mode + ")");
                    } else {
                        console.log("[Variant C] ❌ Invalid - missing required Rx fields (all fields required, can be 0)");
                    }
                }
                break;

              default:
                console.log("[Step 2 Validation] ⚠️ Unknown frame choice:", frameChoice);
            }
            console.log("[Step 2 Validation] Final result:", isValid ? "✅ VALID" : "❌ INVALID");
            this.saveState();
            return isValid;
        },
        setupStep3Events: function() {
            const self = this;
            document.querySelectorAll("#step3 .lens-card").forEach(card => {
                card.addEventListener("click", async function() {
                    if (this.classList.contains("disabled")) {
                        return;
                    }
                    const clipType = this.dataset.clipType;
                    await self.selectClipCard(clipType);
                });
            });
        },
        setupMagnificationPicker: function() {
            const self = this;
            const upArrow = document.getElementById("magArrowUp");
            if (upArrow) {
                upArrow.addEventListener("click", () => self.incrementMagnification());
            }
            const downArrow = document.getElementById("magArrowDown");
            if (downArrow) {
                downArrow.addEventListener("click", () => self.decrementMagnification());
            }
            const picker = document.querySelector(".magnification-picker");
            if (picker) {
                picker.addEventListener("keydown", e => {
                    if (e.key === "ArrowUp") {
                        e.preventDefault();
                        self.incrementMagnification();
                    } else if (e.key === "ArrowDown") {
                        e.preventDefault();
                        self.decrementMagnification();
                    }
                });
                picker.setAttribute("tabindex", "0");
            }
            const magContainer = document.getElementById("step4ReaderOptions");
            if (magContainer) {
                magContainer.addEventListener("wheel", e => {
                    e.preventDefault();
                    if (e.deltaY < 0) {
                        self.incrementMagnification();
                    } else if (e.deltaY > 0) {
                        self.decrementMagnification();
                    }
                }, {
                    passive: false
                });
            }
            this.setupMagnificationTouch();
        },
        setupMagnificationTouch: function() {
            const self = this;
            const picker = document.querySelector(".magnification-picker");
            if (!picker) return;
            let startY = 0;
            let currentY = 0;
            let isDragging = false;
            picker.addEventListener("touchstart", e => {
                startY = e.touches[0].clientY;
                isDragging = true;
            }, {
                passive: true
            });
            picker.addEventListener("touchmove", e => {
                if (!isDragging) return;
                currentY = e.touches[0].clientY;
                const deltaY = startY - currentY;
                if (Math.abs(deltaY) > 30) {
                    if (deltaY > 0) {
                        self.incrementMagnification();
                    } else {
                        self.decrementMagnification();
                    }
                    startY = currentY;
                }
            }, {
                passive: true
            });
            picker.addEventListener("touchend", () => {
                isDragging = false;
            }, {
                passive: true
            });
        },
        initializeMagnificationPicker: function(clipType) {
            const options = clipType === "reader" ? this.magnificationOptions.reader : this.magnificationOptions.blueLight;
            if (this.configuration.magnification) {
                const savedIndex = options.indexOf(this.configuration.magnification);
                this.currentMagIndex = savedIndex >= 0 ? savedIndex : 0;
            } else {
                this.currentMagIndex = 0;
            }
            this.updateMagnificationDisplay();
            const rangeLabel = document.getElementById("magRangeLabel");
            if (rangeLabel && clipType === "blueLight") {
                rangeLabel.textContent = "Range: 0.00 (Plano) to +2.00";
            } else if (rangeLabel) {
                rangeLabel.textContent = "Range: +0.50 to +2.50";
            }
            this.configuration.magnification = options[this.currentMagIndex];
            this.configuration.lensColor = options[this.currentMagIndex];
            this.configuration.lensCategory = clipType;
            this.saveState();
            this.updateNavigationButtons();
        },
        incrementMagnification: function() {
            const clipType = this.configuration.clipType;
            const options = clipType === "reader" ? this.magnificationOptions.reader : this.magnificationOptions.blueLight;
            if (this.currentMagIndex < options.length - 1) {
                this.currentMagIndex++;
                this.updateMagnificationDisplay();
                const selectedMag = options[this.currentMagIndex];
                this.configuration.magnification = selectedMag;
                this.configuration.lensColor = selectedMag;
                this.configuration.lensCategory = clipType;
                this.saveState();
                this.updateNavigationButtons();
            }
        },
        decrementMagnification: function() {
            const clipType = this.configuration.clipType;
            const options = clipType === "reader" ? this.magnificationOptions.reader : this.magnificationOptions.blueLight;
            if (this.currentMagIndex > 0) {
                this.currentMagIndex--;
                this.updateMagnificationDisplay();
                const selectedMag = options[this.currentMagIndex];
                this.configuration.magnification = selectedMag;
                this.configuration.lensColor = selectedMag;
                this.configuration.lensCategory = clipType;
                this.saveState();
                this.updateNavigationButtons();
            }
        },
        updateMagnificationDisplay: function() {
            const clipType = this.configuration.clipType;
            const options = clipType === "reader" ? this.magnificationOptions.reader : this.magnificationOptions.blueLight;
            const valueEl = document.getElementById("magValue");
            const upArrow = document.getElementById("magArrowUp");
            const downArrow = document.getElementById("magArrowDown");
            if (valueEl) {
                valueEl.classList.add("changing");
                valueEl.textContent = options[this.currentMagIndex];
                setTimeout(() => {
                    valueEl.classList.remove("changing");
                }, 300);
            }
            if (upArrow) {
                upArrow.disabled = this.currentMagIndex >= options.length - 1;
            }
            if (downArrow) {
                downArrow.disabled = this.currentMagIndex <= 0;
            }
        },
        setupStep4Events: function() {
            const self = this;
            document.querySelectorAll("#step4SunOptions .category-tab").forEach(tab => {
                tab.addEventListener("click", function() {
                    const category = this.dataset.category;
                    self.selectColorCategory(category);
                });
            });
            document.addEventListener("click", function(e) {
                if (e.target.closest("#step4LensColorGrid .lens-puck-container")) {
                    const colorEl = e.target.closest(".lens-puck-container");
                    const colorValue = colorEl.dataset.color;
                    self.selectLensColor(colorValue);
                }
            });
            document.addEventListener("click", function(e) {
                if (e.target.closest("#step4MagnificationGrid .mag-option")) {
                    const magEl = e.target.closest(".mag-option");
                    const magValue = magEl.dataset.magnification;
                    self.selectMagnification(magValue);
                }
            });
            document.addEventListener("click", function(e) {
                if (e.target.closest("#step4 .option-card")) {
                    const optionEl = e.target.closest(".option-card");
                    const optionValue = optionEl.dataset.option;
                    self.selectClipOption(optionValue);
                }
            });
        },
        showDetailsPanel: function(stepId, content) {
            const detailsArea = document.querySelector(`#${stepId} .details-area`);
            const mainArea = document.querySelector(`#${stepId} .main-area`);
            const stepContent = document.querySelector(`#${stepId} .step-content`);
            if (detailsArea && mainArea && stepContent) {
                detailsArea.innerHTML = content;
                detailsArea.classList.add("active");
                mainArea.classList.add("has-details");
                stepContent.classList.add("show-details");
            }
        },
        setupSubChoiceEvents: function() {
            const self = this;
            document.querySelectorAll("#step1Details .sub-choice-card, #step1SubOptionsContainer .sub-choice-card").forEach(card => {
                card.addEventListener("click", function() {
                    const subChoice = this.dataset.subChoice;
                    self.selectFrameSubChoice(subChoice);
                });
            });
        },
        selectFrameChoice: function(choice) {
            if ((choice === "own-frame-own-lenses" || choice === "own-frame-new-lenses") && this.configuration.frameProduct) {
                console.log("[selectFrameChoice] Detected frame switch - showing warning modal");
                this.showFrameWarningModal(choice);
                return;
            }
            this.applyFrameChoice(choice);
        },
        updateStep1Header: function(choice) {
            const headerTitle = document.querySelector("#step1 .step-header-container h2");
            const headerDescription = document.querySelector("#step1 .step-header-container p");
            if (!this.originalStep1Header && headerTitle && headerDescription) {
                this.originalStep1Header = {
                    title: headerTitle.textContent,
                    description: headerDescription.textContent
                };
            }
            if (headerTitle && headerDescription) {
                if (choice === "own-frame") {
                    headerTitle.textContent = "Using Your Own Frame";
                    headerDescription.textContent = "Using your own frames is a great choice—they already fit you perfectly and match your style.";
                } else if (choice === "new-frame-lenses") {
                    headerTitle.textContent = "Selecting a Chemistrie Frame";
                    headerDescription.textContent = "Choosing a Chemistrie frame ensures perfect compatibility with our clip system.";
                }
            }
        },
        restoreStep1Header: function() {
            if (this.originalStep1Header) {
                const headerTitle = document.querySelector("#step1 .step-header-container h2");
                const headerDescription = document.querySelector("#step1 .step-header-container p");
                if (headerTitle && headerDescription) {
                    headerTitle.textContent = this.originalStep1Header.title;
                    headerDescription.textContent = this.originalStep1Header.description;
                }
            }
        },
        showStep1SubContent: function(choice) {
            this.updateStep1Header(choice);
            this.currentSubStep = 1.5;
            this.isInSubStep = true;
            this.hasVisitedStep1_5 = true;
            this.step1_5FrameChoice = choice;
            const step1MainContent = document.querySelector("#step1 .step-content.dynamic-split");
            if (step1MainContent) {
                step1MainContent.style.display = "none";
            } else {
                console.warn("Main content not found");
            }
            const subContent = document.getElementById("step1SubContent");
            const subOptionsContainer = document.getElementById("step1SubOptionsContainer");
            if (choice === "own-frame") {
                subOptionsContainer.innerHTML = `\n                    <div class="sub-choice-cards">\n                        <div class="sub-choice-card" data-sub-choice="existing-lenses">\n                            <div class="choice-icon">🔄</div>\n                            <h4>Use My Existing Lenses</h4>\n                            <p>Keep your current prescription lenses</p>\n                            <div class="choice-benefits">\n                                <span>✓ Keep your current prescription</span>\n                                <span>✓ Cost-effective option</span>\n                                <span>✓ Fast turnaround</span>\n                            </div>\n                        </div>\n                        <div class="sub-choice-card" data-sub-choice="new-lenses">\n                            <div class="choice-icon">✨</div>\n                            <h4>Get New Lenses</h4>\n                            <p>Upgrade to new prescription lenses</p>\n                            <div class="choice-benefits">\n                                <span>✓ Latest lens technology</span>\n                                <span>✓ Perfect fit guarantee</span>\n                                <span>✓ Multiple coating options</span>\n                            </div>\n                        </div>\n                    </div>\n                `;
            } else if (choice === "new-frame-lenses") {
                subOptionsContainer.innerHTML = `\n                    <div class="frame-selection-preview">\n                        <div class="frame-placeholder">\n                            <div class="frame-icon">👓</div>\n                            <h3>Frame Collection</h3>\n                            <p>Premium frames optimized for Chemistrie clips</p>\n                            <p><em>Frame catalog coming soon</em></p>\n                            <div class="coming-soon-note">\n                                <span>• Multiple styles available</span>\n                                <span>• Professional fitting included</span>\n                                <span>• Perfect Chemistrie compatibility</span>\n                            </div>\n                        </div>\n                    </div>\n                `;
                this.configuration.useExistingLenses = false;
            }
            if (subContent) {
                subContent.style.display = "block";
                subContent.classList.add("active");
            } else {
                console.error("Sub-content element not found");
            }
            this.setupSubChoiceEvents();
        },
        hideStep1SubContent: function(moveDirection = "none") {
            const subContent = document.getElementById("step1SubContent");
            if (subContent) {
                subContent.classList.remove("active");
                setTimeout(() => {
                    subContent.style.display = "none";
                }, 400);
            }
            const step1MainContent = document.querySelector("#step1 .step-content.dynamic-split");
            if (step1MainContent) {
                step1MainContent.style.display = "flex";
            }
            this.restoreStep1Header();
            if (moveDirection === "forward") {
                this.wasInStep1_5 = true;
                this.previousSubStep = 1.5;
                this.currentSubStep = null;
                this.isInSubStep = false;
            } else if (moveDirection === "back") {
                this.currentSubStep = null;
                this.isInSubStep = false;
            } else {
                this.currentSubStep = null;
                this.isInSubStep = false;
            }
        },
        selectFrameSubChoice: function(subChoice) {
            this.configuration.useExistingLenses = subChoice === "existing-lenses";
            this.hasCompletedStep1_5 = true;
            document.querySelectorAll(".sub-choice-card").forEach(card => {
                card.classList.remove("selected");
            });
            document.querySelector(`[data-sub-choice="${subChoice}"]`).classList.add("selected");
            this.updateNavigationButtons();
            this.saveState();
        },
        showPrescriptionOnlyOverlay: function() {
            const overlay = document.getElementById("prescriptionOnlyOverlay");
            if (!overlay) return;
            console.log("[showPrescriptionOnlyOverlay] Displaying overlay");
            overlay.style.display = "flex";
            if (typeof gsap !== "undefined") {
                gsap.fromTo(overlay, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                });
                gsap.fromTo(overlay.querySelector(".prescription-only-overlay__content"), {
                    y: 20,
                    opacity: 0
                }, {
                    y: 0,
                    opacity: 1,
                    duration: .3,
                    delay: .1,
                    ease: "power2.out"
                });
            }
            this.setupPrescriptionOnlyOverlayEvents();
        },
        hidePrescriptionOnlyOverlay: function() {
            const overlay = document.getElementById("prescriptionOnlyOverlay");
            if (!overlay) return;
            console.log("[hidePrescriptionOnlyOverlay] Hiding overlay");
            if (typeof gsap !== "undefined") {
                gsap.to(overlay, {
                    opacity: 0,
                    duration: .2,
                    ease: "power2.in",
                    onComplete: () => {
                        overlay.style.display = "none";
                    }
                });
            } else {
                overlay.style.display = "none";
            }
            this.isPrescriptionOnlyFlow = false;
            this.configuration.isPrescriptionOnlyOrder = false;
            this.configuration.isFramelessRxOrder = false;
        },
        skipClipsToReview: function() {
            console.log("[skipClipsToReview] Skipping clips, going to Step 5");
            this.configuration.isPrescriptionOnlyOrder = true;
            this.configuration.clipType = null;
            this.configuration.lensColor = null;
            this.configuration.lensCategory = null;
            this.configuration.magnification = null;
            this.configuration.bridgeColor = null;
            this.configuration.magnetColor = null;
            this.configuration.crystalColor = null;
            const overlay = document.getElementById("prescriptionOnlyOverlay");
            if (overlay) overlay.style.display = "none";
            this.isPrescriptionOnlyFlow = false;
            this.saveState();
            this.goToStep(5);
        },
        addRxLensesToCart: async function() {
            console.log("[addRxLensesToCart] Adding frameless Rx lenses to cart (no clip)");
            const lensType = this.configuration.nativeLensType;
            if (!lensType) {
                this.showOrderFlowError("Please choose a lens type before continuing.");
                return;
            }
            const lensFeature = this.configuration.nativeLensFeature;
            const lensMaterial = this.configuration.nativeLensMaterial;
            const lensTotal = this.getNativeLensPrice(lensType, lensFeature, lensMaterial);
            if (!lensTotal || lensTotal <= 0) {
                console.error("[addRxLensesToCart] Lens price resolved to 0 — aborting to avoid a free line item");
                this.showOrderFlowError("Sorry, we could not price those lenses. Please try again.");
                return;
            }
            const lensVariantId = this.getLensUpgradeVariantId(lensTotal, lensType);
            if (!lensVariantId) {
                console.error("[addRxLensesToCart] No lens-upgrade-addon variant for price:", lensTotal);
                this.showOrderFlowError("Sorry, we could not price those lenses. Please try again.");
                return;
            }
            try {
                await this._ensureRxStaged();
            } catch (rxErr) {
                this._handleRxStagingFailure(rxErr);
                return;
            }
            const lensDescription = this.buildPrescriptionLensSummary(lensType, lensFeature, lensMaterial, this.configuration.readerPower);
            const configurationId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
            const lensItem = {
                id: lensVariantId,
                quantity: 1,
                properties: {
                    "_Configuration ID": configurationId,
                    "_Order Type": "New Rx Lenses",
                    "_Item Type": "Prescription Lenses (Parent)",
                    "_Frame Choice Key": "own-frame-new-lenses",
                    "_Order Source": this.configuration.orderSource || "EXTRA - New Rx Lenses",
                    "Prescription Lenses": lensDescription,
                    "_Native Lens Type": lensType,
                    "_Native Lens Feature": lensFeature || "standard",
                    "_Native Lens Material": lensMaterial || "standard"
                }
            };
            if (this.configuration.frameDetailsUnknown) {
                lensItem.properties["For Frame"] = "Customer to provide frame details";
            } else {
                if (this.configuration.frameBrand) lensItem.properties["Frame Brand"] = this.configuration.frameBrand;
                if (this.configuration.frameModel) lensItem.properties["Frame Model"] = this.configuration.frameModel;
            }
            if (lensType === "readers" && this.configuration.readerPower) {
                lensItem.properties["_Reader Power"] = this.configuration.readerPower;
            }
            const framelessRxToken = this._getRxTokenForCart();
            if (!lensItem.properties["_Rx Upload Token"] && framelessRxToken) {
                lensItem.properties["_Rx Upload Token"] = framelessRxToken;
            }
            const overlay = document.getElementById("prescriptionOnlyOverlay");
            if (overlay) overlay.style.display = "none";
            this.isPrescriptionOnlyFlow = false;
            this.showCartLoadingOverlay(true, "Adding your lenses to cart...");
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        items: [ lensItem ],
                        sections: "cart-drawer-items,cart-header-dropdown"
                    })
                });
                if (!response.ok) throw new Error("cart/add.js returned " + response.status);
                console.log("[addRxLensesToCart] Lenses added to cart");
                this.configuration.isFramelessRxOrder = false;
                this.saveState();
                window.location.href = "/?open-cart=true";
            } catch (err) {
                console.error("[addRxLensesToCart] Error adding to cart:", err);
                this.showCartLoadingOverlay(false);
                this.showOrderFlowError("Sorry, we could not add your lenses to the cart. Please try again.");
            }
        },
        setupPrescriptionOnlyOverlayEvents: function() {
            const self = this;
            const addClipBtn = document.getElementById("prescriptionOnlyAddClipBtn");
            if (addClipBtn) {
                addClipBtn.onclick = function() {
                    self.hidePrescriptionOnlyOverlay();
                };
            }
            const skipBtn = document.getElementById("prescriptionOnlySkipBtn");
            if (skipBtn) {
                if (self.configuration.isFramelessRxOrder) {
                    skipBtn.textContent = "No Thanks, Add to Cart";
                }
                skipBtn.onclick = function() {
                    if (self.configuration.isFramelessRxOrder) {
                        self.addRxLensesToCart();
                    } else {
                        self.skipClipsToReview();
                    }
                };
            }
        },
        selectLensType: async function(lensType) {
            this.configuration.nativeLensType = lensType;
            if (lensType !== "readers") {
                this.configuration.readerPower = null;
            }
            this.updateStep2SubstepsForLensType(lensType);
            document.querySelectorAll("[data-lens-type]").forEach(card => {
                card.classList.remove("selected");
            });
            const selectedCard = document.querySelector(`[data-lens-type="${lensType}"]`);
            if (selectedCard) {
                selectedCard.classList.add("selected");
                console.log(`[Step 2] Selected lens type: ${lensType}`);
            }
            this.updateNavigationButtons();
            this.saveState();
            await this.calculateTotalPrice();
        },
        updateStep2SubstepsForLensType: function(lensType) {
            const frameChoice = this.configuration.frameChoice;
            if (!frameChoice || frameChoice === "own-frame-own-lenses") return;
            const lensConfig = this.lensTypeSubstepConfigs[lensType];
            if (!lensConfig) {
                console.error("[updateStep2SubstepsForLensType] Unknown lens type:", lensType);
                return;
            }
            let baseStages = [];
            let baseNames = [];
            if (frameChoice === "own-frame-new-lenses") {
                baseStages.push("frame-details");
                baseNames.push("Frame Details");
            }
            baseStages.push("lens-type");
            baseNames.push("Lens Type");
            baseStages = baseStages.concat(lensConfig.stages);
            baseNames = baseNames.concat(lensConfig.names);
            this.step2SubstepConfig[frameChoice] = {
                stages: baseStages,
                total: baseStages.length,
                names: baseNames,
                skipMaterial: lensConfig.skipMaterial,
                skipPrescription: lensConfig.skipPrescription
            };
            console.log(`[updateStep2SubstepsForLensType] Updated substeps for ${lensType}:`, this.step2SubstepConfig[frameChoice]);
        },
        selectLensFeature: async function(lensFeature) {
            this.configuration.nativeLensFeature = lensFeature;
            document.querySelectorAll("[data-lens-feature]").forEach(card => {
                card.classList.remove("selected");
            });
            const selectedCard = document.querySelector(`[data-lens-feature="${lensFeature}"]`);
            if (selectedCard) {
                selectedCard.classList.add("selected");
                console.log(`[Step 2] Selected lens feature: ${lensFeature}`);
            }
            this.updateNavigationButtons();
            this.saveState();
            await this.calculateTotalPrice();
        },
        selectLensMaterial: async function(lensMaterial) {
            this.configuration.nativeLensMaterial = lensMaterial;
            document.querySelectorAll("[data-lens-material]").forEach(card => {
                card.classList.remove("selected");
            });
            const selectedCard = document.querySelector(`[data-lens-material="${lensMaterial}"]`);
            if (selectedCard) {
                selectedCard.classList.add("selected");
                console.log(`[Step 2] Selected lens material: ${lensMaterial}`);
            }
            this.updateNavigationButtons();
            this.saveState();
            await this.calculateTotalPrice();
        },
        initializeReaderPowerPicker: function() {
            const self = this;
            if (!this.configuration.readerPower) {
                this.configuration.readerPower = "+1.00";
            }
            const upBtn = document.getElementById("readerPowerArrowUp");
            const downBtn = document.getElementById("readerPowerArrowDown");
            const valueDisplay = document.getElementById("readerPowerValue");
            const displayContainer = document.getElementById("readerPowerDisplay");
            const dropdown = document.getElementById("readerPowerDropdown");
            if (!upBtn || !downBtn || !valueDisplay) {
                console.warn("[initializeReaderPowerPicker] Power picker elements not found");
                return;
            }
            valueDisplay.textContent = this.configuration.readerPower;
            if (dropdown) {
                this.populateReaderPowerDropdown(dropdown);
            }
            const newUpBtn = upBtn.cloneNode(true);
            const newDownBtn = downBtn.cloneNode(true);
            upBtn.parentNode.replaceChild(newUpBtn, upBtn);
            downBtn.parentNode.replaceChild(newDownBtn, downBtn);
            newUpBtn.addEventListener("click", function() {
                self.adjustReaderPower(.25);
            });
            newDownBtn.addEventListener("click", function() {
                self.adjustReaderPower(-.25);
            });
            if (displayContainer && dropdown) {
                const newDisplayContainer = displayContainer.cloneNode(true);
                displayContainer.parentNode.replaceChild(newDisplayContainer, displayContainer);
                const freshDropdown = document.getElementById("readerPowerDropdown");
                const freshDisplayContainer = document.getElementById("readerPowerDisplay");
                this.populateReaderPowerDropdown(freshDropdown);
                freshDisplayContainer.addEventListener("click", function(e) {
                    if (e.target.classList.contains("mag-dropdown-option")) {
                        return;
                    }
                    freshDisplayContainer.classList.toggle("open");
                });
                freshDropdown.addEventListener("click", function(e) {
                    if (e.target.classList.contains("mag-dropdown-option")) {
                        const value = e.target.dataset.value;
                        self.setReaderPower(value);
                        freshDisplayContainer.classList.remove("open");
                    }
                });
                document.addEventListener("click", function(e) {
                    if (!freshDisplayContainer.contains(e.target)) {
                        freshDisplayContainer.classList.remove("open");
                    }
                });
            }
            console.log("[initializeReaderPowerPicker] Initialized with value:", this.configuration.readerPower);
        },
        populateReaderPowerDropdown: function(dropdown) {
            if (!dropdown) return;
            dropdown.innerHTML = "";
            const minPower = .25;
            const maxPower = 4;
            const step = .25;
            for (let power = minPower; power <= maxPower; power += step) {
                power = Math.round(power * 100) / 100;
                const value = "+" + power.toFixed(2);
                const option = document.createElement("div");
                option.className = "mag-dropdown-option";
                option.dataset.value = value;
                option.textContent = value;
                if (value === this.configuration.readerPower) {
                    option.classList.add("selected");
                }
                dropdown.appendChild(option);
            }
        },
        setReaderPower: function(value) {
            this.configuration.readerPower = value;
            const valueDisplay = document.getElementById("readerPowerValue");
            if (valueDisplay) {
                valueDisplay.textContent = value;
            }
            const dropdown = document.getElementById("readerPowerDropdown");
            if (dropdown) {
                dropdown.querySelectorAll(".mag-dropdown-option").forEach(opt => {
                    opt.classList.toggle("selected", opt.dataset.value === value);
                });
            }
            console.log("[setReaderPower] New value:", value);
            this.saveState();
            this.calculateTotalPrice();
        },
        adjustReaderPower: function(delta) {
            const minPower = .25;
            const maxPower = 4;
            let current = parseFloat(this.configuration.readerPower?.replace("+", "") || "1.00");
            current += delta;
            current = Math.max(minPower, Math.min(maxPower, current));
            current = Math.round(current * 100) / 100;
            this.configuration.readerPower = "+" + current.toFixed(2);
            const valueDisplay = document.getElementById("readerPowerValue");
            if (valueDisplay) {
                valueDisplay.textContent = this.configuration.readerPower;
            }
            const dropdown = document.getElementById("readerPowerDropdown");
            if (dropdown) {
                dropdown.querySelectorAll(".mag-dropdown-option").forEach(opt => {
                    opt.classList.toggle("selected", opt.dataset.value === this.configuration.readerPower);
                });
            }
            console.log("[adjustReaderPower] New value:", this.configuration.readerPower);
            this.saveState();
            this.calculateTotalPrice();
        },
        updateStep3ClipPrices: async function() {
            console.log("[updateStep3ClipPrices] Checking for existing clips in cart...");
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel);
            const hasClipForSameFrame = existingClips.length >= 1;
            const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isRedrillFlow;
            console.log("[updateStep3ClipPrices] Cart check:", {
                existingClipsCount: existingClips.length,
                isBuilding2ndClip: this.isBuilding2ndClip,
                shouldApplyDiscount: shouldApplyDiscount
            });
            const priceElements = document.querySelectorAll("#step3 .lens-card-price");
            priceElements.forEach(priceEl => {
                const card = priceEl.closest(".lens-card");
                if (!card) return;
                const clipType = card.dataset.clipType;
                const normalizedClipType = clipType ? clipType.replace(/-([a-z])/g, g => g[1].toUpperCase()) : null;
                if (!normalizedClipType || !this.clipTypes[normalizedClipType]) {
                    console.warn("[updateStep3ClipPrices] Unknown clip type:", clipType);
                    return;
                }
                const fullPrice = this.clipTypes[normalizedClipType].price || 0;
                const applyDiscount = shouldApplyDiscount && normalizedClipType !== "migraine";
                const displayPrice = applyDiscount ? fullPrice - 80 : fullPrice;
                const priceText = priceEl.textContent.trim();
                const isStartingAt = priceText.toLowerCase().includes("starting at");
                if (isStartingAt) {
                    priceEl.textContent = `Starting at $${displayPrice}`;
                } else {
                    priceEl.textContent = `$${displayPrice}`;
                }
                console.log(`[updateStep3ClipPrices] Updated ${clipType}: $${fullPrice} → $${displayPrice}`);
            });
        },
        selectClipCard: async function(clipType, opts) {
            opts = opts || {};
            if (this.isPrescriptionOnlyFlow) {
                const psoOverlay = document.getElementById("prescriptionOnlyOverlay");
                if (psoOverlay && psoOverlay.style.display !== "none") return;
            }
            if (!opts.preselect) {
                this.exitClipFocusMode();
            }
            const normalizedClipType = clipType.replace(/-([a-z])/g, g => g[1].toUpperCase());
            this.configuration.lensColor = null;
            this.configuration.lensCategory = null;
            this.configuration.magnification = null;
            this.configuration.magnificationValue = null;
            this.configuration.therapeuticColor = null;
            this.configuration.therapeuticType = null;
            this.configuration.clipType = normalizedClipType;
            try {
                document.dispatchEvent(new CustomEvent("configurator:clip_type_chosen", {
                    detail: {
                        clipType: normalizedClipType,
                        preselect: !!opts.preselect
                    }
                }));
            } catch (e) {}
            document.querySelectorAll("#step3 .lens-card").forEach(card => {
                card.classList.remove("selected");
            });
            document.querySelector(`#step3 [data-clip-type="${clipType}"]`).classList.add("selected");
            await this.calculateTotalPrice();
            this.updateOrderSummary();
            this.updateNavigationButtons();
            this.saveState();
        },
        applyClipPreselect: async function(clipType) {
            this.pendingClipPreselect = null;
            const normalizedClipType = String(clipType).replace(/-([a-z])/g, g => g[1].toUpperCase());
            if (!this.clipTypes[normalizedClipType]) {
                console.warn("[applyClipPreselect] Unknown clip type, ignoring:", clipType);
                return;
            }
            if (this.isPrescriptionOnlyFlow) {
                console.log("[applyClipPreselect] Prescription-only flow — skipping pre-select");
                return;
            }
            let clipAttr = normalizedClipType;
            let card = document.querySelector(`#step3 [data-clip-type="${clipAttr}"]`);
            if (!card) {
                clipAttr = normalizedClipType.replace(/[A-Z]/g, c => "-" + c.toLowerCase());
                card = document.querySelector(`#step3 [data-clip-type="${clipAttr}"]`);
            }
            if (!card) {
                console.warn("[applyClipPreselect] No Step 3 card for clip type:", clipType);
                return;
            }
            this.clipFocusMode = true;
            const rail = document.getElementById("step3ClipRail");
            if (rail) rail.classList.add("step3-rail--focus");
            await this.selectClipCard(clipAttr, {
                preselect: true
            });
            try {
                const url = new URL(window.location.href);
                url.searchParams.delete("clipType");
                window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
            } catch (e) {}
            console.log("[applyClipPreselect] Pre-selected clip from Clip PDP:", normalizedClipType);
        },
        exitClipFocusMode: function() {
            if (!this.clipFocusMode) return;
            this.clipFocusMode = false;
            const rail = document.getElementById("step3ClipRail");
            if (rail) rail.classList.remove("step3-rail--focus");
        },
        initializeStep4: function() {
            let clipType = this.configuration.clipType;
            if (!clipType) {
                const params = new URLSearchParams(window.location.search);
                const urlClipType = params.get("clipType");
                if (urlClipType && params.get("mode") === "reorder") {
                    console.log("[initializeStep4] clipType was null, restored from URL:", urlClipType);
                    clipType = urlClipType;
                    this.configuration.clipType = urlClipType;
                }
            }
            if (!clipType) {
                console.warn("[initializeStep4] No clip type available, cannot initialize Step 4");
                return;
            }
            this.initializeSharedImageLayering();
            const onFirstSubStage = !this.isInSubStage || this.currentSubStage === 1;
            const substage1Panel = document.querySelector('.selection-panel[data-substage="1"]');
            if (onFirstSubStage && substage1Panel && substage1Panel.style.display === "none") {
                console.log("[initializeStep4] Substage 1 panel was hidden, showing it");
                substage1Panel.style.display = "block";
            }
            this.showClipOptionsPanel(clipType);
            if (clipType === "sun") {
                this.initializeSunOptions();
            } else if (clipType === "reader") {} else if (clipType === "blueLight") {
                this.initializeBlueLightOptions();
            } else if (clipType === "3d") {
                this.initialize3DOptions();
            } else if (clipType === "lightSensitivity") {
                this.initializeLightSensitivityOptions();
            } else if (clipType === "migraine") {
                this.initializeMigraineOptions();
            } else if (clipType === "driving") {
                this.initializeDrivingOptions();
            }
        },
        showClipOptionsPanel: function(clipType) {
            if (!clipType) {
                console.warn("[showClipOptionsPanel] clipType is null, skipping");
                return;
            }
            document.querySelectorAll(".clip-options").forEach(panel => {
                panel.classList.add("hidden");
                panel.classList.remove("active");
                panel.style.display = "none";
            });
            const formatClipType = (() => {
                if (clipType === "3d") return "3D";
                return clipType.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join("");
            })();
            const panelId = `step4${formatClipType}Options`;
            const panel = document.getElementById(panelId);
            if (panel) {
                panel.classList.remove("hidden");
                panel.classList.add("active");
                panel.style.display = "block";
            }
        },
        initializeSunOptions: function() {
            if (!this.configuration.lensCategory) {
                this.configuration.lensCategory = "solid";
            }
            const currentCategory = this.configuration.lensCategory;
            document.querySelectorAll("#step4SunOptions .category-tab").forEach(tab => {
                tab.classList.remove("active");
            });
            const activeTab = document.querySelector(`#step4SunOptions [data-category="${currentCategory}"]`);
            if (activeTab) {
                activeTab.classList.add("active");
            }
            if (!this.configuration.lensColor) {
                const colorNameEl = document.getElementById("step4ColorName");
                const colorDescEl = document.getElementById("step4ColorDescription");
                if (colorNameEl) colorNameEl.style.display = "none";
                if (colorDescEl) colorDescEl.style.display = "none";
            }
            const sunLensSubtitle = document.getElementById("sunLensSubtitle");
            if (sunLensSubtitle) {
                const noARCoatingColors = [ "Grey", "Brown", "G15", "Amber" ];
                const currentColor = this.configuration.lensColor;
                if (currentCategory === "non-polarized") {
                    sunLensSubtitle.textContent = "100% UV protection with quality tints for everyday wear";
                } else if (currentCategory === "solid" && currentColor && noARCoatingColors.includes(currentColor)) {
                    sunLensSubtitle.textContent = "100% UV protection and fully polarized";
                } else {
                    sunLensSubtitle.textContent = "100% UV protection, fully polarized, and back-side anti-reflective coating included";
                }
            }
            this.loadColorGrid(currentCategory);
            if (this.configuration.lensColor) {
                let attempts = 0;
                const maxAttempts = 5;
                const getDelay = attempt => Math.min(150 * Math.pow(2, attempt), 3e3);
                const tryRestore = () => {
                    attempts++;
                    const grid = document.getElementById("step4LensColorGrid");
                    if (!grid || grid.children.length === 0) {
                        if (attempts < maxAttempts) {
                            const delay = getDelay(attempts);
                            console.log(`Grid not ready, attempt ${attempts}/${maxAttempts}, retrying in ${delay}ms...`);
                            setTimeout(tryRestore, delay);
                            return;
                        } else {
                            console.error("Grid failed to load after", maxAttempts, "attempts");
                            return;
                        }
                    }
                    const colorContainer = document.querySelector(`#step4LensColorGrid [data-color="${this.configuration.lensColor}"]`);
                    if (colorContainer) {
                        document.querySelectorAll("#step4LensColorGrid .lens-puck-container").forEach(container => {
                            container.classList.remove("selected");
                        });
                        colorContainer.classList.add("selected");
                        const colorName = colorContainer.title || this.configuration.lensColor;
                        const formattedColorName = this.formatColorName(colorName);
                        const colorNameEl = document.getElementById("step4ColorName");
                        const colorDescEl = document.getElementById("step4ColorDescription");
                        if (colorNameEl) {
                            colorNameEl.style.display = "block";
                            colorNameEl.textContent = formattedColorName;
                        }
                        if (colorDescEl) {
                            colorDescEl.style.display = "block";
                            colorDescEl.textContent = this.getLensDescription(currentCategory, colorName);
                        }
                        console.log("Successfully restored lens selection:", this.configuration.lensColor, "in category:", currentCategory);
                        this.synchronizeCanvasWithConfiguration();
                    } else {
                        console.warn("Could not restore lens selection:", this.configuration.lensColor, "in category:", currentCategory);
                        const availableColors = Array.from(document.querySelectorAll("#step4LensColorGrid [data-color]")).map(el => el.dataset.color);
                        console.log("Available colors in", currentCategory, "category:", availableColors);
                        const looseKey = value => String(value).replace(/^NP /, "").replace(/[\s-]/g, "").toLowerCase();
                        const savedKey = looseKey(this.configuration.lensColor);
                        const inThisCategory = availableColors.some(value => looseKey(value) === savedKey);
                        if (!inThisCategory) {
                            console.warn("Clearing lens color", this.configuration.lensColor, "- not offered in category", currentCategory);
                            this.configuration.lensColor = null;
                            if (this.sharedImageLayering) {
                                this.sharedImageLayering.removeLayer("lens");
                            }
                            this.updateNavigationButtons();
                            this.saveState();
                        }
                    }
                };
                setTimeout(tryRestore, 150);
            }
        },
        synchronizeCanvasWithConfiguration: function() {
            var self = this;
            if (this._syncDebounceTimer) {
                clearTimeout(this._syncDebounceTimer);
            }
            this._syncDebounceTimer = setTimeout(function() {
                self._doSynchronizeCanvas();
            }, 250);
        },
        _doSynchronizeCanvas: function() {
            console.log("Synchronizing canvas with current configuration...");
            if (!this.sharedImageLayering) {
                console.warn("Canvas not initialized, triggering initialization...");
                this.initializeImageLayering();
                if (!this._syncRetryCount) this._syncRetryCount = 0;
                this._syncRetryCount++;
                if (this._syncRetryCount < 3) {
                    var self = this;
                    setTimeout(function() {
                        self._doSynchronizeCanvas();
                    }, 200);
                } else {
                    console.error("Canvas initialization failed after 3 retries");
                    this._syncRetryCount = 0;
                }
                return;
            }
            this._syncRetryCount = 0;
            setTimeout(() => {
                const clipType = this.configuration.clipType;
                if (this.configuration.lensColor && this.configuration.lensCategory) {
                    console.log("Syncing lens layer:", this.configuration.lensColor, "in", this.configuration.lensCategory);
                    this.updateCanvasPreview("lens", this.configuration.lensColor);
                } else if (clipType === "lightSensitivity") {
                    this.configuration.lensCategory = "fl41";
                    if (!this.configuration.lightSensitivityColor && this.configuration.lightSensitivityIntensity) {
                        const intensityKey = this.configuration.lightSensitivityIntensity.charAt(0).toUpperCase() + this.configuration.lightSensitivityIntensity.slice(1);
                        this.configuration.lightSensitivityColor = `FL41-${intensityKey}`;
                    }
                    const lsColor = this.configuration.lightSensitivityColor || "FL41-Light";
                    console.log("Syncing lens layer:", lsColor, "in lightSensitivity");
                    this.updateCanvasPreview("lens", lsColor);
                } else if (clipType === "migraine") {
                    this.configuration.lensCategory = "migraine";
                    console.log("Syncing lens layer: Avulux-Light in migraine");
                    this.updateCanvasPreview("lens", "Avulux-Light");
                } else if (clipType && clipType !== "sun") {
                    this.configuration.lensCategory = clipType;
                    console.log("Syncing lens layer: Standard in", clipType);
                    this.updateCanvasPreview("lens", "Standard");
                }
            }, 50);
            setTimeout(() => {
                if (this.configuration.bridgeColor) {
                    console.log("Syncing bridge layer:", this.configuration.bridgeColor);
                    this.updateCanvasPreview("bridge", this.configuration.bridgeColor);
                }
            }, 100);
            setTimeout(() => {
                if (this.configuration.magnetColor) {
                    console.log("Syncing magnet layer:", this.configuration.magnetColor);
                    this.updateCanvasPreview("magnet", this.configuration.magnetColor);
                }
            }, 150);
            setTimeout(() => {
                if (this.configuration.crystalColor && this.configuration.crystalColor !== null && this.configuration.crystalColor !== "null") {
                    console.log("Syncing crystal layer:", this.configuration.crystalColor);
                    this.updateCanvasPreview("crystal", this.configuration.crystalColor);
                }
            }, 200);
            console.log("Canvas synchronization triggered");
        },
        getLensDescription: function(category, colorName) {
            const baseDescriptions = {
                gradient: "Premium polarized gradient lens with smooth light-to-dark transition. Provides 100% UV protection with reduced glare and enhanced visual comfort.",
                mirror: "Reflective polarized lens with mirror coating for maximum sun protection. Blocks intense light while providing superior clarity and 100% UV protection.",
                solid: "Classic polarized lens with uniform tint in premium color. Delivers consistent protection with 100% UV blocking and reduced eye strain."
            };
            const categoryDesc = baseDescriptions[category] || "Premium polarized lens with 100% UV protection and enhanced visual clarity.";
            return categoryDesc;
        },
        initializeReaderOptions: function() {
            const magnifications = [ "+0.50", "+0.75", "+1.00", "+1.25", "+1.50", "+1.75", "+2.00", "+2.25", "+2.50" ];
            const grid = document.getElementById("step4MagnificationGrid");
            grid.innerHTML = magnifications.map(mag => `<div class="mag-option" data-magnification="${mag}">\n                    <span class="mag-value">${mag}</span>\n                    <span class="mag-label">Magnification</span>\n                </div>`).join("");
        },
        initializeBlueLightOptions: function() {
            if (!this.configuration.magnification) {
                this.configuration.magnification = "0.00";
            }
            this.currentBlueLightMagIndex = this.magnificationOptions.blueLight.indexOf(this.configuration.magnification);
            if (this.currentBlueLightMagIndex === -1) {
                this.currentBlueLightMagIndex = 0;
            }
            this.updateBlueLightMagnificationDisplay();
            const upArrow = document.getElementById("blueLightMagArrowUp");
            const downArrow = document.getElementById("blueLightMagArrowDown");
            const planoBtn = document.getElementById("blueLightPlanoBtn");
            if (upArrow) {
                upArrow.addEventListener("click", () => this.incrementBlueLightMagnification());
            }
            if (downArrow) {
                downArrow.addEventListener("click", () => this.decrementBlueLightMagnification());
            }
            if (planoBtn) {
                planoBtn.addEventListener("click", () => this.selectBlueLightPlano());
            }
            if (this.sharedImageLayering) {
                const lensImagePath = "Raen-Angle-Lens-BlueLight.png";
                const assetUrl = this.getAssetUrl(lensImagePath);
                this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
            }
            this.updateNavigationButtons();
        },
        updateBlueLightMagnificationDisplay: function() {
            const magValue = this.magnificationOptions.blueLight[this.currentBlueLightMagIndex];
            const magDisplay = document.getElementById("blueLightMagValue");
            const planoBtn = document.getElementById("blueLightPlanoBtn");
            if (magDisplay) {
                magDisplay.textContent = magValue;
            }
            if (planoBtn && magValue !== "Plano") {
                planoBtn.classList.remove("selected");
            }
        },
        incrementBlueLightMagnification: function() {
            const options = this.magnificationOptions.blueLight;
            if (this.currentBlueLightMagIndex < options.length - 1) {
                this.currentBlueLightMagIndex++;
                this.updateBlueLightMagnificationDisplay();
                const selectedMag = options[this.currentBlueLightMagIndex];
                this.configuration.magnification = selectedMag;
                this.configuration.lensColor = selectedMag;
                this.configuration.lensCategory = "blueLight";
                this.saveState();
            }
        },
        decrementBlueLightMagnification: function() {
            const options = this.magnificationOptions.blueLight;
            if (this.currentBlueLightMagIndex > 0) {
                this.currentBlueLightMagIndex--;
                this.updateBlueLightMagnificationDisplay();
                const selectedMag = options[this.currentBlueLightMagIndex];
                this.configuration.magnification = selectedMag;
                this.configuration.lensColor = selectedMag;
                this.configuration.lensCategory = "blueLight";
                this.saveState();
            }
        },
        selectBlueLightPlano: function() {
            const planoBtn = document.getElementById("blueLightPlanoBtn");
            planoBtn.classList.add("selected");
            this.configuration.magnification = "Plano";
            this.configuration.lensColor = "Plano";
            this.configuration.lensCategory = "blueLight";
            const magDisplay = document.getElementById("blueLightMagValue");
            if (magDisplay) {
                magDisplay.textContent = "Plano";
            }
            this.saveState();
            this.updateNavigationButtons();
        },
        initialize3DOptions: function() {
            const config = this.lensTypeConfig["3d"];
            const puckWrapper = document.querySelector("#step43DOptions .lens-puck-wrapper");
            const displayName = puckWrapper ? puckWrapper.dataset.display : "Standard";
            this.configuration.lensColor = displayName;
            this.configuration.lensCategory = config.category;
            if (puckWrapper) {
                const puckContainer = puckWrapper.querySelector(".lens-puck-container");
                if (puckContainer) {
                    puckContainer.classList.add("selected");
                }
            }
            if (this.sharedImageLayering) {
                const lensImagePath = `${this.frameModel}-${config.lensImagePath}`;
                const assetUrl = this.getAssetUrl(lensImagePath);
                this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
            }
            this.saveState();
            this.updateNavigationButtons();
        },
        initializeDrivingOptions: function() {
            const config = this.lensTypeConfig["driving"];
            const puckWrapper = document.querySelector("#step4DrivingOptions .lens-puck-wrapper");
            const displayName = puckWrapper ? puckWrapper.dataset.display : "Standard";
            this.configuration.lensColor = displayName;
            this.configuration.lensCategory = config.category;
            if (puckWrapper) {
                const puckContainer = puckWrapper.querySelector(".lens-puck-container");
                if (puckContainer) {
                    puckContainer.classList.add("selected");
                }
            }
            if (this.sharedImageLayering) {
                const lensImagePath = `${this.frameModel}-Lens-Driving.png`;
                const assetUrl = this.getAssetUrl(lensImagePath);
                this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
            }
            this.saveState();
            this.updateNavigationButtons();
        },
        initializeLightSensitivityOptions: function() {
            document.querySelectorAll("#step4LightSensitivityColorGrid .lens-puck-wrapper").forEach(puck => {
                puck.addEventListener("click", e => {
                    const puckEl = e.currentTarget;
                    const color = puckEl.dataset.color;
                    const displayName = puckEl.dataset.display;
                    this.selectLightSensitivityColor(color, displayName);
                });
            });
            document.querySelectorAll("#step4LightSensitivityColorGrid .lens-puck-wrapper").forEach(puck => {
                const color = puck.dataset.color;
                if (this.lightSensitivityConfig.fl41 && this.lightSensitivityConfig.fl41.colors[color]) {
                    const hexColor = this.lightSensitivityConfig.fl41.colors[color].hexColor;
                    const puckColor = puck.querySelector(".puck-color");
                    if (puckColor) {
                        puckColor.style.backgroundColor = hexColor;
                    }
                }
            });
            if (this.configuration.lightSensitivityColor) {
                setTimeout(() => {
                    const selectedPuck = document.querySelector(`#step4LightSensitivityColorGrid .lens-puck-wrapper[data-color="${this.configuration.lightSensitivityColor}"]`);
                    if (selectedPuck) {
                        selectedPuck.click();
                    }
                }, 100);
            }
            this.updateLightSensitivityPuckPrices();
        },
        selectLightSensitivityColor: function(color, displayName) {
            document.querySelectorAll("#step4LightSensitivityColorGrid .lens-puck-wrapper").forEach(puck => {
                puck.classList.remove("selected");
                const container = puck.querySelector(".lens-puck-container");
                if (container) container.classList.remove("selected");
            });
            const selectedPuck = document.querySelector(`#step4LightSensitivityColorGrid .lens-puck-wrapper[data-color="${color}"]`);
            if (selectedPuck) {
                selectedPuck.classList.add("selected");
                const container = selectedPuck.querySelector(".lens-puck-container");
                if (container) container.classList.add("selected");
            }
            const intensity = color.includes("-") ? color.split("-")[1] : color;
            this.configuration.lightSensitivityColor = color;
            this.configuration.lightSensitivityIntensity = intensity;
            this.configuration.lensColor = displayName;
            this.configuration.lensCategory = "fl41";
            if (this.sharedImageLayering) {
                const lensImagePath = `${this.frameModel}-Lens-${color}.png`;
                const assetUrl = this.getAssetUrl(lensImagePath);
                this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
            }
            this.saveState();
            this.updateNavigationButtons();
            console.log("[selectLightSensitivityColor]", {
                color: color,
                displayName: displayName,
                intensity: intensity
            });
        },
        updateLightSensitivityPuckPrices: async function() {
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel);
            const hasClipForSameFrame = existingClips.length >= 1;
            const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isRedrillFlow;
            const multiClipDiscount = 80;
            document.querySelectorAll("#step4LightSensitivityColorGrid .lens-puck-wrapper").forEach(puck => {
                const color = puck.dataset.color;
                const priceEl = puck.querySelector(".lens-puck-price");
                if (!priceEl) return;
                const lensOption = this.therapeuticLensPricing[color];
                const fullPrice = lensOption ? lensOption.price : parseInt(puck.dataset.price) || 175;
                const displayPrice = shouldApplyDiscount ? fullPrice - multiClipDiscount : fullPrice;
                priceEl.textContent = `$${displayPrice}`;
                puck.dataset.price = displayPrice;
                console.log(`[updateLightSensitivityPuckPrices] ${color}: $${fullPrice} → $${displayPrice}${shouldApplyDiscount ? " (discounted)" : ""}`);
            });
        },
        initializeMigraineOptions: function() {
            const config = this.lensTypeConfig["migraine"];
            const puckWrapper = document.querySelector("#step4MigraineOptions .lens-puck-wrapper");
            const displayName = puckWrapper ? puckWrapper.dataset.display : "Avulux";
            this.configuration.lensColor = displayName;
            this.configuration.lensCategory = "migraine";
            if (puckWrapper) {
                const puckContainer = puckWrapper.querySelector(".lens-puck-container");
                if (puckContainer) {
                    puckContainer.classList.add("selected");
                }
            }
            if (this.sharedImageLayering) {
                const lensImagePath = `${this.frameModel}-Lens-Avulux-Light.png`;
                const assetUrl = this.getAssetUrl(lensImagePath);
                this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
            }
            this.saveState();
            this.updateNavigationButtons();
        },
        initializeTherapeuticOptions: function() {
            if (!this.configuration.therapeuticType) {
                this.configuration.therapeuticType = "fl41";
            }
            const currentCategory = this.configuration.therapeuticType;
            this.switchTherapeuticTab(currentCategory);
            document.querySelectorAll("#step4TherapeuticOptions .category-tab").forEach(tab => {
                tab.addEventListener("click", e => {
                    const category = e.currentTarget.dataset.category;
                    this.switchTherapeuticTab(category);
                });
            });
            document.querySelectorAll("#step4TherapeuticOptions .lens-puck-wrapper").forEach(puck => {
                puck.addEventListener("click", e => {
                    const puckEl = e.currentTarget;
                    const color = puckEl.dataset.color;
                    const displayName = puckEl.dataset.display;
                    const category = puckEl.dataset.category;
                    this.selectTherapeuticColor(color, displayName, category);
                });
            });
            document.querySelectorAll("#step4TherapeuticOptions .lens-puck-wrapper").forEach(puck => {
                const color = puck.dataset.color;
                const category = puck.dataset.category;
                if (this.therapeuticConfig[category] && this.therapeuticConfig[category].colors[color]) {
                    const hexColor = this.therapeuticConfig[category].colors[color].hexColor;
                    const puckColor = puck.querySelector(".puck-color");
                    if (puckColor) {
                        puckColor.style.backgroundColor = hexColor;
                    }
                }
            });
            if (this.configuration.lensColor) {
                setTimeout(() => {
                    const selectedPuck = document.querySelector(`#step4TherapeuticOptions .lens-puck-wrapper[data-display="${this.configuration.lensColor}"]`);
                    if (selectedPuck) {
                        selectedPuck.click();
                    }
                }, 100);
            }
            this.updateTherapeuticPuckPrices();
        },
        updateTherapeuticPuckPrices: async function() {
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel);
            const hasClipForSameFrame = existingClips.length >= 1;
            const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isRedrillFlow;
            const multiClipDiscount = 80;
            console.log("[updateTherapeuticPuckPrices] Discount check:", {
                isBuilding2ndClip: this.isBuilding2ndClip,
                existingClipsCount: existingClips.length,
                shouldApplyDiscount: shouldApplyDiscount
            });
            document.querySelectorAll("#step4TherapeuticColorGrid .lens-puck-wrapper").forEach(puck => {
                const category = puck.dataset.category;
                const color = puck.dataset.color;
                const priceEl = puck.querySelector(".lens-puck-price");
                if (!priceEl) return;
                const lensOption = this.therapeuticLensPricing[color];
                const fullPrice = lensOption ? lensOption.price : parseInt(puck.dataset.price) || 175;
                const isAvulux = category === "avulux";
                const canApplyDiscount = shouldApplyDiscount && !isAvulux;
                const displayPrice = canApplyDiscount ? fullPrice - multiClipDiscount : fullPrice;
                priceEl.textContent = `$${displayPrice}`;
                puck.dataset.price = displayPrice;
                console.log(`[updateTherapeuticPuckPrices] ${color}: $${fullPrice} → $${displayPrice}${canApplyDiscount ? " (discounted)" : ""}`);
            });
        },
        switchTherapeuticTab: function(category) {
            document.querySelectorAll("#step4TherapeuticOptions .category-tab").forEach(tab => {
                if (tab.dataset.category === category) {
                    tab.classList.add("active");
                } else {
                    tab.classList.remove("active");
                }
            });
            document.querySelectorAll("#step4TherapeuticOptions .lens-puck-wrapper").forEach(puck => {
                if (puck.dataset.category === category) {
                    puck.style.display = "flex";
                } else {
                    puck.style.display = "none";
                }
            });
            document.querySelectorAll("#step4TherapeuticOptions .category-description").forEach(desc => {
                desc.classList.remove("active");
                desc.style.display = "none";
            });
            const activeDescription = document.querySelector(`#step4TherapeuticOptions .category-description[data-category="${category}"]`);
            if (activeDescription) {
                activeDescription.classList.add("active");
                activeDescription.style.display = "block";
            }
            this.configuration.therapeuticType = category;
            this.saveState();
        },
        selectTherapeuticColor: function(color, displayName, category) {
            document.querySelectorAll("#step4TherapeuticOptions .lens-puck-wrapper").forEach(puck => {
                puck.classList.remove("selected");
            });
            const selectedPuck = document.querySelector(`#step4TherapeuticOptions .lens-puck-wrapper[data-color="${color}"]`);
            if (selectedPuck) {
                selectedPuck.classList.add("selected");
            }
            this.configuration.lensColor = displayName;
            this.configuration.therapeuticColor = color;
            this.configuration.lensCategory = "therapeutic";
            this.configuration.therapeuticType = category;
            const colorParts = color.split("-");
            const intensity = colorParts.length > 1 ? colorParts[1] : null;
            this.configuration.therapeuticIntensity = intensity;
            if (this.sharedImageLayering) {
                const frameModel = "Raen-Angle";
                const lensImagePath = `${frameModel}-Lens-${color}.png`;
                const assetUrl = this.getAssetUrl(lensImagePath);
                this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
            }
            this.saveState();
            this.updateNavigationButtons();
        },
        initializeStep5: async function() {
            const step5Container = document.getElementById("step5") || document.getElementById("reviewPanel");
            if (step5Container && step5Container.dataset.listenersAttached === "true") {
                console.log("[initializeStep5] Event listeners already attached, skipping to prevent duplicates");
            }
            const addPrescriptionSection = document.getElementById("addPrescriptionSection");
            const expandRxBtn = document.getElementById("expandRxBtn");
            const inlineRxForm = document.getElementById("inlineRxForm");
            const saveRxBtn = document.getElementById("saveRxBtn");
            const frameChoice = this.configuration.frameChoice;
            const isVariantWithPrescription = frameChoice === "own-frame-new-lenses" || frameChoice === "new-frame-lenses";
            if (this.configuration.prescriptionSkippedInVariantB === true && this.configuration.prescription === "skip" && isVariantWithPrescription && !this.isReorderMode) {
                if (addPrescriptionSection) {
                    addPrescriptionSection.style.display = "block";
                    addPrescriptionSection.classList.add("add-prescription-section--alert");
                    addPrescriptionSection.classList.remove("add-prescription-section--uploaded");
                    console.log("[Step 5] Showing prescription section - Rx was skipped in Variant B or C");
                }
                const listenersAlreadyAttached = step5Container && step5Container.dataset.listenersAttached === "true";
                if (!listenersAlreadyAttached) {
                    if (expandRxBtn && inlineRxForm) {
                        expandRxBtn.addEventListener("click", function() {
                            const isVisible = inlineRxForm.style.display === "block";
                            inlineRxForm.style.display = isVisible ? "none" : "block";
                            expandRxBtn.textContent = isVisible ? "Click to Add" : "Click to Hide";
                        });
                    }
                    if (saveRxBtn) {
                        const self = this;
                        saveRxBtn.addEventListener("click", function() {
                            self.saveInlineRxData();
                        });
                    }
                    const inlineRxInputIds = [ "odSphereReview", "odCylinderReview", "odAxisReview", "odAddReview", "osSphereReview", "osCylinderReview", "osAxisReview", "osAddReview", "pdReview", "pdLeftReview", "pdRightReview", "rxNotesReview" ];
                    const self = this;
                    inlineRxInputIds.forEach(id => {
                        const input = document.getElementById(id);
                        if (input) {
                            input.addEventListener("input", function() {
                                self.clearPrescriptionFieldError(input);
                            });
                        }
                    });
                    this.setupSendLaterModal();
                    if (step5Container) {
                        step5Container.dataset.listenersAttached = "true";
                    }
                }
            } else if (this.configuration.prescription && this.configuration.prescription !== "skip") {
                if (addPrescriptionSection) {
                    addPrescriptionSection.style.display = "block";
                    addPrescriptionSection.classList.add("add-prescription-section--uploaded");
                    addPrescriptionSection.classList.remove("add-prescription-section--alert");
                    const prescriptionStatus = document.querySelector(".prescription-status");
                    const rx = this.configuration.prescription;
                    if (prescriptionStatus && rx && rx.od && rx.os) {
                        prescriptionStatus.innerHTML = `Prescription Provided ✅ - <button type="button" class="expand-rx-btn" id="expandRxBtn">Click to View</button>`;
                        const expandBtn = document.getElementById("expandRxBtn");
                        const inlineRxForm = document.getElementById("inlineRxForm");
                        if (expandBtn && inlineRxForm) {
                            expandBtn.addEventListener("click", function() {
                                const isVisible = inlineRxForm.style.display === "block";
                                inlineRxForm.style.display = isVisible ? "none" : "block";
                                expandBtn.textContent = isVisible ? "Click to View" : "Click to Hide";
                            });
                        }
                        console.log("[Step 5] Updated prescription status to show filled data");
                        this.populateInlinePrescriptionForm();
                    }
                }
            } else {
                if (addPrescriptionSection) {
                    addPrescriptionSection.style.display = "none";
                }
            }
            this.initializeSharedImageLayering();
            if (this.sharedImageLayering) {
                setTimeout(() => {
                    this.synchronizeCanvasWithConfiguration();
                }, 100);
            }
            if (typeof this.loadBridgeColors === "function") {
                this.loadBridgeColors();
            }
            if (!this.configuration.bridgeColor) {
                const bridgeNameEl = document.getElementById("bridgeColorName");
                const bridgeDescEl = document.getElementById("bridgeColorDescription");
                if (bridgeNameEl) bridgeNameEl.style.display = "none";
                if (bridgeDescEl) bridgeDescEl.style.display = "none";
            } else {
                const bridgeNameEl = document.getElementById("bridgeColorName");
                const bridgeDescEl = document.getElementById("bridgeColorDescription");
                if (bridgeNameEl) bridgeNameEl.style.display = "block";
                if (bridgeDescEl) bridgeDescEl.style.display = "block";
                const bridgeGrid = document.getElementById("bridgeColorGrid");
                if (bridgeGrid && bridgeGrid.children.length > 0) {
                    this.selectBridgeColor(this.configuration.bridgeColor);
                }
            }
            await this.loadCompleteConfiguration();
            this.setupCompactAccessories();
            await this.setupSecondClipCTA();
            const secondClipSection = document.querySelector(".second-clip-toggle-section");
            if (this.isReorderMode && secondClipSection) {
                secondClipSection.classList.add("reorder-hidden");
                console.log('[initializeStep5] Reorder mode - hiding "Add Another Clip" toggle via .reorder-hidden class');
            } else if (secondClipSection) {
                console.log("[initializeStep5] Second clip toggle section found:", {
                    display: window.getComputedStyle(secondClipSection).display,
                    visibility: window.getComputedStyle(secondClipSection).visibility,
                    offsetTop: secondClipSection.offsetTop,
                    frameChoice: this.configuration.frameChoice
                });
            } else {
                console.warn("[initializeStep5] Second clip toggle section NOT FOUND in DOM!");
            }
            await this.updatePricingSummaryDebounced(300);
            console.log("[initializeStep5] Queued debounced pricing summary update");
            if (this.isEditingConfig) {
                console.log("[initializeStep5] Edit mode active, setting up edit UI");
                this.setupEditModeUI();
            }
        },
        loadBridgeColors: function() {
            const bridgeColors = [ {
                name: "Matte Black",
                value: "MatteBlack",
                description: "Classic matte black finish"
            }, {
                name: "Gold",
                value: "Gold",
                description: "Premium gold finish"
            }, {
                name: "Silver",
                value: "Silver",
                description: "Polished silver finish"
            }, {
                name: "Gunmetal",
                value: "Gunmetal",
                description: "Dark gunmetal finish"
            }, {
                name: "Bronze",
                value: "Bronze",
                description: "Warm bronze finish"
            } ];
            const grid = document.getElementById("bridgeColorGrid");
            if (!grid) return;
            grid.innerHTML = bridgeColors.map(color => {
                const assetFilename = `Customizer-Accessory-Bridge-${color.value}.webp`;
                const assetUrl = this.getAssetUrl(assetFilename);
                return `<div class="hardware-card bridge-card"\n                      data-color="${color.value}"\n                      title="${color.name}">\n                    <div class="hardware-image-wrapper">\n                        <img src="${assetUrl}" alt="${color.name} Bridge" class="hardware-image">\n                    </div>\n                    <span class="hardware-name">${color.name.toUpperCase()}</span>\n                </div>`;
            }).join("");
            document.querySelectorAll("#bridgeColorGrid .hardware-card").forEach(card => {
                card.addEventListener("click", () => {
                    this.selectBridgeColor(card.dataset.color);
                });
            });
        },
        selectBridgeColor: function(colorValue) {
            this.configuration.bridgeColor = colorValue;
            const variantKey = colorValue.toLowerCase().replace(/\s+/g, "");
            const variantPrice = window.chemistrie_products?.accessories?.bridge?.variants?.[variantKey]?.price || 0;
            this.pricing.bridge = variantPrice;
            document.querySelectorAll("#bridgeColorGrid .hardware-card").forEach(card => {
                card.classList.remove("selected");
            });
            const selectedCard = document.querySelector(`#bridgeColorGrid [data-color="${colorValue}"]`);
            if (selectedCard) {
                selectedCard.classList.add("selected");
            }
            const bridgeColorNames = {
                MatteBlack: "Matte Black",
                Gold: "Gold",
                Silver: "Silver",
                Gunmetal: "Gunmetal",
                Bronze: "Bronze"
            };
            const colorName = bridgeColorNames[colorValue] || colorValue;
            const nameEl = document.getElementById("bridgeColorName");
            const descEl = document.getElementById("bridgeColorDescription");
            if (nameEl) {
                nameEl.style.display = "block";
                nameEl.textContent = colorName;
            }
            if (descEl) {
                descEl.style.display = "block";
                descEl.textContent = "Premium magnetic bridge component that securely connects your clips to your glasses";
            }
            if (this.sharedImageLayering) {
                this.synchronizeCanvasWithConfiguration();
            }
            this.updateNavigationButtons();
            this.saveStateDebounced();
            this.calculateTotalPrice();
        },
        loadMagnetColors: function() {
            const magnetColors = [ {
                name: "Gunmetal",
                value: "Gunmetal",
                description: "Dark gunmetal finish"
            }, {
                name: "Gold",
                value: "Gold",
                description: "Premium gold finish"
            }, {
                name: "Silver",
                value: "Silver",
                description: "Polished silver finish"
            } ];
            const grid = document.getElementById("magnetColorGrid");
            if (!grid) return;
            grid.innerHTML = magnetColors.map(color => {
                const assetFilename = `Customizer-Accessory-Magnet-${color.value}.webp`;
                const assetUrl = this.getAssetUrl(assetFilename);
                return `<div class="hardware-card magnet-card"\n                      data-color="${color.value}"\n                      title="${color.name}">\n                    <div class="hardware-image-wrapper">\n                        <img src="${assetUrl}" alt="${color.name} Magnet" class="hardware-image">\n                    </div>\n                    <span class="hardware-name">${color.name.toUpperCase()}</span>\n                </div>`;
            }).join("");
            document.querySelectorAll("#magnetColorGrid .hardware-card").forEach(card => {
                card.addEventListener("click", () => {
                    this.selectMagnetColor(card.dataset.color);
                });
            });
        },
        selectMagnetColor: function(colorValue) {
            this.configuration.magnetColor = colorValue;
            const variantKey = colorValue.toLowerCase().replace(/\s+/g, "");
            const variantPrice = window.chemistrie_products?.accessories?.magnet?.variants?.[variantKey]?.price || 0;
            this.pricing.magnet = variantPrice;
            document.querySelectorAll("#magnetColorGrid .hardware-card").forEach(card => {
                card.classList.remove("selected");
            });
            document.querySelector(`#magnetColorGrid [data-color="${colorValue}"]`).classList.add("selected");
            if (this.sharedImageLayering) {
                this.updateCanvasPreview("magnet", colorValue);
            }
            this.updateNavigationButtons();
            this.saveStateDebounced();
            this.calculateTotalPrice();
        },
        loadCrystalOptions: function() {
            const crystalColors = [ {
                name: "None",
                value: null,
                description: "No crystal accent"
            }, {
                name: "Diamond",
                value: "Diamond",
                description: "Clear crystal accent"
            }, {
                name: "Emerald",
                value: "Emerald",
                description: "Green crystal accent"
            }, {
                name: "Amethyst",
                value: "Amethyst",
                description: "Purple crystal accent"
            }, {
                name: "Aquamarine",
                value: "Aquamarine",
                description: "Blue crystal accent"
            }, {
                name: "Cobalt",
                value: "Cobalt",
                description: "Deep blue crystal"
            }, {
                name: "Crystal Gold",
                value: "CrystalGold",
                description: "Gold crystal accent"
            }, {
                name: "Fire Opal",
                value: "FireOpal",
                description: "Orange-red crystal"
            }, {
                name: "Hematite",
                value: "Hematite",
                description: "Dark metallic crystal"
            }, {
                name: "Hyacinth",
                value: "Hyacinth",
                description: "Orange crystal"
            }, {
                name: "Olivine",
                value: "Olivine",
                description: "Olive green crystal"
            }, {
                name: "Rose",
                value: "Rose",
                description: "Pink crystal accent"
            }, {
                name: "Topaz",
                value: "Topaz",
                description: "Golden yellow crystal"
            } ];
            const grid = document.getElementById("crystalGrid");
            if (!grid) return;
            grid.innerHTML = crystalColors.map(crystal => {
                if (crystal.value === null) {
                    return `<div class="crystal-wrapper" data-color="${crystal.value}" title="${crystal.name}">\n                        <div class="crystal-none-option">\n                            <span class="none-icon">✕</span>\n                        </div>\n                        <div class="crystal-label">${crystal.name.toUpperCase()}</div>\n                    </div>`;
                } else {
                    const assetFilename = `Customizer-Accessory-Crystal-${crystal.value}.webp`;
                    const assetUrl = this.getAssetUrl(assetFilename);
                    const variantKey = crystal.value.toLowerCase().replace(/\s+/g, "");
                    const variantPrice = window.chemistrie_products?.accessories?.crystal?.variants?.[variantKey]?.price || 15;
                    return `<div class="crystal-wrapper" data-color="${crystal.value}" title="${crystal.name}">\n                        <div class="crystal-image-wrapper">\n                            <img src="${assetUrl}" alt="${crystal.name} Crystal" class="crystal-image">\n                        </div>\n                        <div class="crystal-label">${crystal.name.toUpperCase()}</div>\n                        <div class="crystal-price">+${this.formatPrice(variantPrice)}</div>\n                    </div>`;
                }
            }).join("");
            document.querySelectorAll("#crystalGrid .crystal-wrapper").forEach(wrapper => {
                wrapper.addEventListener("click", async () => {
                    await this.selectCrystalColor(wrapper.dataset.color);
                });
            });
            if (!this.configuration.crystalColor) {
                const noneWrapper = grid.querySelector('[data-color="null"]');
                if (noneWrapper) {
                    noneWrapper.classList.add("selected");
                    const noneOption = noneWrapper.querySelector(".crystal-none-option");
                    if (noneOption) {
                        noneOption.classList.add("selected");
                        this.configuration.crystalColor = null;
                        this.pricing.crystals = 0;
                    }
                }
            }
        },
        selectCrystalColor: async function(colorValue) {
            if (!colorValue || colorValue === "null") {
                this.configuration.crystalColor = null;
                this.pricing.crystals = 0;
                console.log("[selectCrystalColor] Crystal set to None, pricing.crystals = 0");
            } else {
                this.configuration.crystalColor = colorValue;
                const variantKey = colorValue.toLowerCase().replace(/\s+/g, "");
                const variantPrice = window.chemistrie_products?.accessories?.crystal?.variants?.[variantKey]?.price || 15;
                this.pricing.crystals = variantPrice;
                console.log("[selectCrystalColor] Crystal selected:", {
                    color: colorValue,
                    variantKey: variantKey,
                    price: variantPrice,
                    "pricing.crystals": this.pricing.crystals
                });
            }
            document.querySelectorAll("#crystalGrid .crystal-wrapper").forEach(wrapper => {
                wrapper.classList.remove("selected");
            });
            document.querySelectorAll("#crystalGrid .crystal-none-option, #crystalGrid .crystal-image-wrapper").forEach(element => {
                element.classList.remove("selected");
            });
            const selectedWrapper = document.querySelector(`#crystalGrid .crystal-wrapper[data-color="${colorValue || "null"}"]`);
            if (selectedWrapper) {
                selectedWrapper.classList.add("selected");
                const targetElement = selectedWrapper.querySelector(".crystal-none-option, .crystal-image-wrapper");
                if (targetElement) {
                    targetElement.classList.add("selected");
                }
            }
            if (this.sharedImageLayering) {
                if (!colorValue || colorValue === "null") {
                    this.sharedImageLayering.removeLayer("crystal");
                } else {
                    this.updateCanvasPreview("crystal", colorValue);
                }
            }
            await this.calculateTotalPrice();
            this.updateNavigationButtons();
            this.saveStateDebounced();
        },
        initializeSharedImageLayering: function() {
            if (this.sharedImageLayering) {
                console.log("Shared image layering already initialized");
                return;
            }
            const canvasId = "sharedPreviewCanvas";
            const canvas = document.getElementById(canvasId);
            if (!canvas) {
                console.error(`Shared canvas ${canvasId} not found`);
                return;
            }
            console.log("Initializing shared image layering...");
            if (window.SunClipImageLayering) {
                this.sharedImageLayering = new window.SunClipImageLayering(canvasId);
                const self = this;
                setTimeout(function() {
                    self.setupSharedPreviewControls();
                }, 200);
                const frameModel = "Raen-Angle";
                const frameImagePath = `${frameModel}-Frame.png`;
                const assetUrl = this.getAssetUrl(frameImagePath);
                this.sharedImageLayering.loadBaseImage(assetUrl);
                this.loadPreviousLayers();
                console.log("Shared image layering initialized successfully");
            }
        },
        clearCurrentStepLayering: function() {
            if (this.sharedImageLayering) {
                if (this.sharedImageLayering.ctx) {
                    this.sharedImageLayering.ctx.clearRect(0, 0, this.sharedImageLayering.canvas.width, this.sharedImageLayering.canvas.height);
                }
                this.sharedImageLayering = null;
            }
        },
        loadPreviousLayers: function() {
            if (!this.sharedImageLayering) return;
            var isValidValue = function(val) {
                return val && val !== "null" && val !== "undefined" && val !== "" && val !== null && val !== undefined;
            };
            if (isValidValue(this.configuration.lensColor) && isValidValue(this.configuration.lensCategory)) {
                const category = this.configuration.lensCategory;
                const capitalizedCategory = category === "3d" ? "3D" : category.charAt(0).toUpperCase() + category.slice(1);
                const frameModel = "Raen-Angle";
                let lensImagePath;
                if (category === "blueLight" || category === "reader" || category === "3d") {
                    lensImagePath = `${frameModel}-Lens-${capitalizedCategory}.png`;
                } else if (category === "driving") {
                    lensImagePath = `${frameModel}-Lens-Driving.png`;
                } else if (category === "fl41" || category === "lightSensitivity") {
                    const lsColor = this.configuration.lightSensitivityColor || "FL41-Light";
                    if (!isValidValue(lsColor)) {
                        console.log("Skipping light sensitivity lens layer - no valid color");
                    } else {
                        lensImagePath = `${frameModel}-Lens-${lsColor}.png`;
                    }
                } else if (category === "migraine") {
                    lensImagePath = `${frameModel}-Lens-Avulux-Light.png`;
                } else {
                    lensImagePath = `${frameModel}-Lens-${capitalizedCategory}-${this.configuration.lensColor}.png`;
                }
                if (lensImagePath) {
                    const assetUrl = this.getAssetUrl(lensImagePath);
                    this.sharedImageLayering.updateLayer("lens", assetUrl, 1);
                }
            }
            if (isValidValue(this.configuration.bridgeColor)) {
                const frameModel = "Raen-Angle";
                const bridgeImagePath = `${frameModel}-Bridge-${this.configuration.bridgeColor}.png`;
                const assetUrl = this.getAssetUrl(bridgeImagePath);
                this.sharedImageLayering.updateLayer("bridge", assetUrl, 2);
            }
            if (isValidValue(this.configuration.magnetColor)) {
                const frameModel = "Raen-Angle";
                const magnetImagePath = `${frameModel}-Magnet-${this.configuration.magnetColor}.png`;
                const assetUrl = this.getAssetUrl(magnetImagePath);
                this.sharedImageLayering.updateLayer("magnet", assetUrl, 3);
            }
            if (isValidValue(this.configuration.crystalColor)) {
                const frameModel = "Raen-Angle";
                const crystalImagePath = `${frameModel}-Crystal-${this.configuration.crystalColor}.png`;
                const assetUrl = this.getAssetUrl(crystalImagePath);
                this.sharedImageLayering.updateLayer("crystal", assetUrl, 4);
            }
            this.sharedImageLayering.render();
        },
        initializeReviewCanvas: function() {
            const canvasId = "sharedPreviewCanvas";
            const canvas = document.getElementById(canvasId);
            if (!canvas) {
                console.error(`Canvas ${canvasId} not found`);
                return;
            }
            if (window.SunClipImageLayering) {
                this.reviewCanvasLayering = new window.SunClipImageLayering(canvasId);
                this.loadCompleteFramePreview();
            }
        },
        loadCompleteConfiguration: async function() {
            await this.updateSummaryDisplay();
            await this.updatePricingSummary();
        },
        formatLensColorForDisplay: function(lensColor) {
            if (!lensColor) return "-";
            if (lensColor.match(/^[+\-]?\d+\.\d+$/) || lensColor === "0.00") {
                return lensColor;
            }
            if (lensColor === "Plano" || lensColor === "Standard") {
                return lensColor;
            }
            return lensColor.replace(/([A-Z])/g, " $1").trim();
        },
        getLensColorDisplayName: function(lensColor, lensCategory) {
            if (!lensColor) return "-";
            if (lensCategory === "non-polarized") {
                if (lensColor === "G15") {
                    return "NP G-15";
                }
                return "NP " + lensColor;
            }
            return this.formatLensColorForDisplay(lensColor);
        },
        updateSummaryDisplay: async function() {
            console.log("[Review Summary] Updating display with configuration:", this.configuration);
            if (this.isReorderMode) {
                const hideIds = [ "summaryNativeLenses", "nativeLensTypeItem", "readerPowerItem", "nativeLensFeatureItem", "nativeLensMaterialItem", "prescriptionSummaryItem" ];
                hideIds.forEach(id => {
                    const el = document.getElementById(id);
                    if (el) {
                        const target = el.classList.contains("summary-item") ? el : el.closest(".summary-item");
                        if (target) target.style.display = "none";
                    }
                });
                console.log("[Review Summary] Reorder mode - hidden lens/prescription summary rows");
            }
            const frameEl = document.getElementById("summaryFrame");
            if (frameEl) {
                if (this.configuration.frameChoice === "own-frame-own-lenses" || this.configuration.frameChoice === "own-frame-new-lenses") {
                    frameEl.textContent = "Use my existing frame";
                } else {
                    const frameHandle = this.configuration.frameProduct;
                    let frameData = window.chemistrie_products?.frames?.[frameHandle];
                    if (!frameData && frameHandle) {
                        console.log("[updateSummaryDisplay] Frame data not loaded, fetching...");
                        frameData = await this.fetchFrameData(frameHandle);
                    }
                    let displayText = "";
                    if (frameData && frameData.title) {
                        displayText = frameData.title;
                    } else {
                        displayText = frameHandle ? this.capitalizeWords(frameHandle.replace(/-/g, " ")) : "Frame";
                    }
                    if (this.configuration.frameVariantTitle) {
                        let variantDisplay = this.configuration.frameVariantTitle;
                        variantDisplay = variantDisplay.replace(/^Option\d*[-_]?/i, "");
                        variantDisplay = variantDisplay.charAt(0).toUpperCase() + variantDisplay.slice(1);
                        displayText += ` - ${variantDisplay}`;
                    }
                    frameEl.textContent = displayText;
                }
                console.log("[Review Summary] Updated frame:", frameEl.textContent);
            } else {
                console.warn("[Review Summary] summaryFrame element not found");
            }
            const lensesEl = document.getElementById("summaryNativeLenses");
            if (lensesEl) {
                if (this.configuration.frameChoice === "own-frame-own-lenses") {
                    lensesEl.textContent = "Own Lenses";
                } else if (this.configuration.frameChoice === "own-frame-new-lenses" || this.configuration.frameChoice === "new-frame-lenses") {
                    lensesEl.textContent = "New Lenses";
                } else {
                    lensesEl.textContent = "Frame Only";
                }
                console.log("[Review Summary] Updated native lenses:", lensesEl.textContent);
            } else {
                console.warn("[Review Summary] summaryNativeLenses element not found");
            }
            const frameChoice = this.configuration.frameChoice;
            const frameBrandItem = document.getElementById("frameBrandItem");
            const frameModelItem = document.getElementById("frameModelItem");
            const frameBrandEl = document.getElementById("summaryFrameBrand");
            const frameModelEl = document.getElementById("summaryFrameModel");
            if (frameChoice === "own-frame-own-lenses" || frameChoice === "own-frame-new-lenses") {
                if (frameBrandItem && frameBrandEl) {
                    frameBrandItem.style.display = "flex";
                    frameBrandEl.textContent = this.configuration.frameBrand || "Not Provided";
                    console.log("[Review Summary] Updated frame brand:", frameBrandEl.textContent);
                }
                if (frameModelItem && frameModelEl) {
                    frameModelItem.style.display = "flex";
                    frameModelEl.textContent = this.configuration.frameModel || "Not Provided";
                    console.log("[Review Summary] Updated frame model:", frameModelEl.textContent);
                }
            } else {
                if (frameBrandItem) frameBrandItem.style.display = "none";
                if (frameModelItem) frameModelItem.style.display = "none";
            }
            const nativeLensTypeItem = document.getElementById("nativeLensTypeItem");
            const nativeLensTypeEl = document.getElementById("summaryNativeLensType");
            if (frameChoice === "own-frame-new-lenses" || frameChoice === "new-frame-lenses") {
                if (nativeLensTypeItem && nativeLensTypeEl) {
                    nativeLensTypeItem.style.display = "flex";
                    const typeNames = {
                        "single-vision": "Single Vision",
                        progressive: "Progressive",
                        readers: "Readers",
                        "non-rx": "Non-Rx"
                    };
                    nativeLensTypeEl.textContent = typeNames[this.configuration.nativeLensType] || "Single Vision";
                    console.log("[Review Summary] Updated native lens type:", nativeLensTypeEl.textContent);
                }
            } else {
                if (nativeLensTypeItem) nativeLensTypeItem.style.display = "none";
            }
            const readerPowerItem = document.getElementById("readerPowerItem");
            const readerPowerEl = document.getElementById("summaryReaderPower");
            if ((frameChoice === "own-frame-new-lenses" || frameChoice === "new-frame-lenses") && this.configuration.nativeLensType === "readers") {
                if (readerPowerItem && readerPowerEl) {
                    readerPowerItem.style.display = "flex";
                    readerPowerEl.textContent = this.configuration.readerPower || "+1.00";
                    console.log("[Review Summary] Updated reader power:", readerPowerEl.textContent);
                }
            } else {
                if (readerPowerItem) readerPowerItem.style.display = "none";
            }
            const nativeLensFeatureItem = document.getElementById("nativeLensFeatureItem");
            const nativeLensFeatureEl = document.getElementById("summaryNativeLensFeature");
            if (frameChoice === "own-frame-new-lenses" || frameChoice === "new-frame-lenses") {
                if (nativeLensFeatureItem && nativeLensFeatureEl) {
                    nativeLensFeatureItem.style.display = "flex";
                    let blueLightPriceLabel = "";
                    if (this.configuration.nativeLensFeature === "blue-light") {
                        const withBL = this.getNativeLensPrice(this.configuration.nativeLensType || "single-vision", "blue-light", this.configuration.nativeLensMaterial || "standard");
                        const withoutBL = this.getNativeLensPrice(this.configuration.nativeLensType || "single-vision", "standard", this.configuration.nativeLensMaterial || "standard");
                        const blUpgrade = withBL - withoutBL;
                        blueLightPriceLabel = blUpgrade > 0 ? ` (+${this.formatPrice(blUpgrade)})` : "";
                    }
                    const featureNames = {
                        standard: "Standard (Anti-Reflective)",
                        "blue-light": `Blue Light Filter${blueLightPriceLabel}`
                    };
                    nativeLensFeatureEl.textContent = featureNames[this.configuration.nativeLensFeature] || "Standard";
                    console.log("[Review Summary] Updated native lens feature:", nativeLensFeatureEl.textContent);
                }
            } else {
                if (nativeLensFeatureItem) nativeLensFeatureItem.style.display = "none";
            }
            const nativeLensMaterialItem = document.getElementById("nativeLensMaterialItem");
            const nativeLensMaterialEl = document.getElementById("summaryNativeLensMaterial");
            const lensTypeForMaterial = this.configuration.nativeLensType;
            const skipMaterialDisplay = lensTypeForMaterial === "readers" || lensTypeForMaterial === "non-rx";
            if ((frameChoice === "own-frame-new-lenses" || frameChoice === "new-frame-lenses") && !skipMaterialDisplay) {
                if (nativeLensMaterialItem && nativeLensMaterialEl) {
                    nativeLensMaterialItem.style.display = "flex";
                    const baseMatPrice = this.getNativeLensPrice(this.configuration.nativeLensType || "single-vision", "standard", "standard");
                    const hi167Price = this.getNativeLensPrice(this.configuration.nativeLensType || "single-vision", "standard", "high-index-167") - baseMatPrice;
                    const hi160Price = this.getNativeLensPrice(this.configuration.nativeLensType || "single-vision", "standard", "high-index-160") - baseMatPrice;
                    const materialNames = {
                        standard: "Standard Lens (Polycarbonate)",
                        "high-index-167": `Thinnest Lens (High-Index 1.67)${hi167Price > 0 ? ` (+${this.formatPrice(hi167Price)})` : ""}`,
                        "high-index-160": `Thinner Lens (High-Index 1.60)${hi160Price > 0 ? ` (+${this.formatPrice(hi160Price)})` : ""}`
                    };
                    nativeLensMaterialEl.textContent = materialNames[this.configuration.nativeLensMaterial] || "Standard Lens (Polycarbonate)";
                    console.log("[Review Summary] Updated native lens material:", nativeLensMaterialEl.textContent);
                }
            } else {
                if (nativeLensMaterialItem) nativeLensMaterialItem.style.display = "none";
            }
            const prescriptionSummaryItem = document.getElementById("prescriptionSummaryItem");
            const prescriptionSummaryEl = document.getElementById("summaryPrescription");
            const skipPrescriptionDisplay = this.configuration.nativeLensType === "readers" || this.configuration.nativeLensType === "non-rx";
            if ((frameChoice === "own-frame-new-lenses" || frameChoice === "new-frame-lenses") && !skipPrescriptionDisplay) {
                if (prescriptionSummaryItem && prescriptionSummaryEl) {
                    prescriptionSummaryItem.style.display = "flex";
                    const rxUpload = this.configuration.prescriptionUpload;
                    const sentLater = this.configuration.prescriptionSendLater === true;
                    if (rxUpload && rxUpload.token) {
                        const fileLabel = rxUpload.fileName || "prescription file";
                        const rxNotes = this.configuration.prescription && typeof this.configuration.prescription === "object" ? this.configuration.prescription.notes : null;
                        const notesSuffix = rxNotes ? ` | Notes: ${rxNotes}` : "";
                        prescriptionSummaryEl.textContent = `Uploaded: ${fileLabel}${notesSuffix}`;
                        prescriptionSummaryEl.style.fontStyle = "normal";
                        prescriptionSummaryEl.style.color = "";
                    } else if (sentLater) {
                        prescriptionSummaryEl.textContent = "Email Rx Later";
                        prescriptionSummaryEl.style.fontStyle = "normal";
                        prescriptionSummaryEl.style.color = "";
                    } else if (this.configuration.prescription && this.configuration.prescription !== "skip" && typeof this.configuration.prescription === "object" && this.configuration.prescription.od && this.configuration.prescription.os) {
                        const rx = this.configuration.prescription;
                        let pdDisplay = "--";
                        if (rx.pd) {
                            if (typeof rx.pd === "object" && rx.pd.mode) {
                                if (rx.pd.mode === "dual") {
                                    pdDisplay = `L:${rx.pd.left || "--"} R:${rx.pd.right || "--"}`;
                                } else {
                                    pdDisplay = rx.pd.value || "--";
                                }
                            } else {
                                pdDisplay = rx.pd;
                            }
                        }
                        const formatEye = (eye, data) => {
                            if (!data) return `${eye}: --`;
                            const parts = [];
                            if (data.sphere) parts.push(data.sphere);
                            if (data.cylinder) parts.push(data.cylinder);
                            if (data.axis) parts.push(`x${data.axis}`);
                            if (data.add) parts.push(`Add:${data.add}`);
                            return parts.length > 0 ? `${eye}: ${parts.join(" ")}` : `${eye}: --`;
                        };
                        const odSummary = formatEye("OD", rx.od);
                        const osSummary = formatEye("OS", rx.os);
                        const notesSuffix = rx.notes ? ` | Notes: ${rx.notes}` : "";
                        prescriptionSummaryEl.textContent = `${odSummary} | ${osSummary} | PD: ${pdDisplay}${notesSuffix}`;
                        prescriptionSummaryEl.style.fontStyle = "normal";
                        prescriptionSummaryEl.style.color = "";
                    } else if (this.configuration.prescriptionSkipped || this.configuration.prescription === "skip") {
                        prescriptionSummaryEl.textContent = "To Be Provided";
                        prescriptionSummaryEl.style.fontStyle = "italic";
                        prescriptionSummaryEl.style.color = "#999";
                    } else {
                        prescriptionSummaryEl.textContent = "Not Provided";
                        prescriptionSummaryEl.style.fontStyle = "italic";
                        prescriptionSummaryEl.style.color = "#999";
                    }
                    console.log("[Review Summary] Updated prescription:", prescriptionSummaryEl.textContent);
                }
            } else {
                if (prescriptionSummaryItem) prescriptionSummaryItem.style.display = "none";
            }
            const orderForSummaryItem = document.getElementById("orderForSummaryItem");
            const orderForSummaryEl = document.getElementById("summaryOrderFor");
            if (this.configuration.orderForSomeoneElse && this.configuration.patientName) {
                if (orderForSummaryItem && orderForSummaryEl) {
                    orderForSummaryItem.style.display = "flex";
                    orderForSummaryEl.textContent = this.configuration.patientName;
                    console.log("[Review Summary] Updated Order For:", this.configuration.patientName);
                }
            } else {
                if (orderForSummaryItem) orderForSummaryItem.style.display = "none";
            }
            const clipEl = document.getElementById("summaryClipType");
            if (clipEl) {
                if (this.configuration.clipType) {
                    clipEl.textContent = this.getClipTypeLabel();
                } else {
                    clipEl.textContent = "-";
                }
                console.log("[Review Summary] Updated clip type:", clipEl.textContent);
            } else {
                console.warn("[Review Summary] summaryClipType element not found");
            }
            const lensColorEl = document.getElementById("summaryLensColor");
            const lensColorLabel = document.getElementById("summaryLensColorLabel");
            if (lensColorLabel) {
                if (this.configuration.clipType === "reader" || this.configuration.clipType === "blueLight") {
                    lensColorLabel.textContent = "Magnification:";
                } else {
                    lensColorLabel.textContent = "Lens Color:";
                }
            }
            if (lensColorEl) {
                let summaryValue;
                if (this.configuration.clipType === "reader" || this.configuration.clipType === "blueLight") {
                    summaryValue = this.configuration.magnification || "-";
                } else if (this.configuration.clipType === "lightSensitivity") {
                    const fl41Intensity = this.configuration.lightSensitivityIntensity || this.configuration.therapeuticIntensity;
                    summaryValue = fl41Intensity ? "FL-41 " + this.capitalizeWords(fl41Intensity) : "-";
                } else if (this.configuration.clipType === "migraine") {
                    summaryValue = "Avulux";
                } else {
                    summaryValue = this.getLensColorDisplayName(this.configuration.lensColor, this.configuration.lensCategory);
                }
                lensColorEl.textContent = summaryValue;
                console.log("[Review Summary] Updated lens color:", lensColorEl.textContent);
            } else {
                console.warn("[Review Summary] summaryLensColor element not found");
            }
            const bridgeEl = document.getElementById("summaryBridgeColor");
            if (bridgeEl) {
                const bridgeNames = {
                    MatteBlack: "Matte Black",
                    Gold: "Gold",
                    Silver: "Silver",
                    Gunmetal: "Gunmetal",
                    Bronze: "Bronze"
                };
                bridgeEl.textContent = bridgeNames[this.configuration.bridgeColor] || this.configuration.bridgeColor || "-";
                console.log("[Review Summary] Updated bridge:", bridgeEl.textContent);
            } else {
                console.warn("[Review Summary] summaryBridgeColor element not found");
            }
            const magnetEl = document.getElementById("summaryMagnetColor");
            if (magnetEl) {
                const magnetNames = {
                    Gunmetal: "Gunmetal",
                    Gold: "Gold",
                    Silver: "Silver"
                };
                magnetEl.textContent = magnetNames[this.configuration.magnetColor] || this.configuration.magnetColor || "-";
                console.log("[Review Summary] Updated magnet:", magnetEl.textContent);
            } else {
                console.warn("[Review Summary] summaryMagnetColor element not found");
            }
            const crystalEl = document.getElementById("summaryCrystalColor");
            const crystalItem = document.getElementById("crystalSummaryItem");
            if (crystalEl && crystalItem) {
                if (this.configuration.crystalColor && this.configuration.crystalColor !== null) {
                    crystalEl.textContent = this.configuration.crystalColor;
                    crystalItem.style.display = "flex";
                } else {
                    crystalItem.style.display = "none";
                }
                console.log("[Review Summary] Updated crystal:", this.configuration.crystalColor || "None");
            } else {
                console.warn("[Review Summary] summaryCrystalColor or crystalSummaryItem element not found");
            }
        },
        setupStep5Collapsibles: function() {
            if (window.innerWidth > 768) {
                console.log("[Step 5 Collapsibles] Skipping - not mobile viewport");
                return;
            }
            console.log("[Step 5 Collapsibles] Setting up collapsible sections");
            const collapsibleSections = document.querySelectorAll("#reviewContentContainer .summary-section, " + "#reviewContentContainer .pricing-section, " + "#reviewContentContainer .second-clip-toggle-section, " + "#reviewContentContainer .accessories-section");
            collapsibleSections.forEach((section, index) => {
                if (section.querySelector(".section-header-collapsible")) {
                    console.log("[Step 5 Collapsibles] Section already transformed, skipping");
                    return;
                }
                const header = section.querySelector("h3");
                if (!header) {
                    console.log("[Step 5 Collapsibles] No h3 found in section, skipping");
                    return;
                }
                const headerText = header.textContent;
                const contentElements = [];
                Array.from(section.children).forEach(child => {
                    if (child !== header) {
                        contentElements.push(child.outerHTML);
                    }
                });
                const isExpanded = index === 0;
                section.innerHTML = `\n                    <div class="section-header-collapsible">\n                        <span>${headerText}</span>\n                        <span class="collapse-icon">${isExpanded ? "▼" : "▶"}</span>\n                    </div>\n                    <div class="section-content-collapsible ${isExpanded ? "expanded" : ""}">\n                        <h3 style="display:none;">${headerText}</h3>\n                        ${contentElements.join("")}\n                    </div>\n                `;
                const headerEl = section.querySelector(".section-header-collapsible");
                headerEl.addEventListener("click", function() {
                    const contentEl = section.querySelector(".section-content-collapsible");
                    const iconEl = section.querySelector(".collapse-icon");
                    contentEl.classList.toggle("expanded");
                    iconEl.textContent = contentEl.classList.contains("expanded") ? "▼" : "▶";
                });
                console.log("[Step 5 Collapsibles] Transformed section:", headerText);
            });
        },
        loadCompleteFramePreview: function() {
            if (!this.reviewCanvasLayering) return;
            const frameModel = "Raen-Angle";
            const frameImagePath = `${frameModel}-Frame.png`;
            const assetUrl = this.getAssetUrl(frameImagePath);
            this.reviewCanvasLayering.loadBaseImage(assetUrl);
            if (this.configuration.lensColor && this.configuration.lensCategory) {
                const category = this.configuration.lensCategory;
                const capitalizedCategory = category === "3d" ? "3D" : category.charAt(0).toUpperCase() + category.slice(1);
                let lensImagePath;
                if (category === "blueLight" || category === "reader" || category === "3d") {
                    lensImagePath = `${frameModel}-Lens-${capitalizedCategory}.png`;
                } else if (category === "driving") {
                    lensImagePath = `${frameModel}-Lens-Driving.png`;
                } else if (category === "fl41" || category === "lightSensitivity") {
                    const lsColor = this.configuration.lightSensitivityColor || "FL41-Light";
                    lensImagePath = `${frameModel}-Lens-${lsColor}.png`;
                } else if (category === "migraine") {
                    lensImagePath = `${frameModel}-Lens-Avulux-Light.png`;
                } else {
                    lensImagePath = `${frameModel}-Lens-${capitalizedCategory}-${this.configuration.lensColor}.png`;
                }
                const lensAssetUrl = this.getAssetUrl(lensImagePath);
                this.reviewCanvasLayering.updateLayer("lens", lensAssetUrl, 1);
            }
            if (this.configuration.bridgeColor) {
                const bridgeImagePath = `${frameModel}-Bridge-${this.configuration.bridgeColor}.png`;
                const bridgeAssetUrl = this.getAssetUrl(bridgeImagePath);
                this.reviewCanvasLayering.updateLayer("bridge", bridgeAssetUrl, 2);
            }
            if (this.configuration.magnetColor) {
                const magnetImagePath = `${frameModel}-Magnet-${this.configuration.magnetColor}.png`;
                const magnetAssetUrl = this.getAssetUrl(magnetImagePath);
                this.reviewCanvasLayering.updateLayer("magnet", magnetAssetUrl, 3);
            }
            if (this.configuration.crystalColor) {
                const crystalImagePath = `${frameModel}-Crystal-${this.configuration.crystalColor}.png`;
                const crystalAssetUrl = this.getAssetUrl(crystalImagePath);
                this.reviewCanvasLayering.updateLayer("crystal", crystalAssetUrl, 4);
            }
            this.reviewCanvasLayering.render();
        },
        updateClipTypeLineItem: async function() {
            console.log("[CODE VERSION] updateClipTypeLineItem - Fixed $80 discount version (2025-11-13)");
            const clipTypeItem = document.getElementById("clipTypeLineItem");
            const clipTypeDesc = document.getElementById("clipTypeDescription");
            const clipTypePrice = document.getElementById("clipTypePrice");
            const discountLineItem = document.getElementById("clipDiscountLineItem");
            const discountPrice = document.getElementById("clipDiscountPrice");
            if (this.configuration.clipType) {
                const clipConfig = this.clipTypes[this.configuration.clipType];
                if (clipConfig) {
                    let actualClipPrice = clipConfig.price;
                    if (this.configuration.clipType === "lightSensitivity" && this.configuration.lightSensitivityColor) {
                        const lensOption = this.therapeuticLensPricing[this.configuration.lightSensitivityColor];
                        if (lensOption) {
                            actualClipPrice = lensOption.price;
                        }
                    } else if (this.configuration.clipType === "migraine") {
                        actualClipPrice = window.chemistrie_prices?.clip_migraine || 495;
                    }
                    if (this.configuration.clipType === "lightSensitivity" && this.configuration.lightSensitivityColor) {
                        const lensOption = this.therapeuticLensPricing[this.configuration.lightSensitivityColor];
                        if (lensOption) {
                            if (clipTypeDesc) clipTypeDesc.textContent = `${clipConfig.name} - ${lensOption.name}`;
                            if (clipTypePrice) clipTypePrice.textContent = this.formatPrice(actualClipPrice);
                        } else {
                            if (clipTypeDesc) clipTypeDesc.textContent = `${clipConfig.name} Clip`;
                            if (clipTypePrice) clipTypePrice.textContent = this.formatPrice(actualClipPrice);
                        }
                    } else if (this.configuration.clipType === "migraine") {
                        if (clipTypeDesc) clipTypeDesc.textContent = `${clipConfig.name} - Avulux`;
                        if (clipTypePrice) clipTypePrice.textContent = this.formatPrice(actualClipPrice);
                    } else {
                        if (clipTypeDesc) clipTypeDesc.textContent = `${clipConfig.name} Clip`;
                        if (clipTypePrice) clipTypePrice.textContent = this.formatPrice(actualClipPrice);
                    }
                    if (clipTypeItem) clipTypeItem.style.display = "flex";
                    const excludeIdForDiscount = this.isEditingConfig ? this.editConfigId : null;
                    const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeIdForDiscount);
                    const hasClipForSameFrame = existingClips.length >= 1;
                    if (this.isBuilding2ndClip && existingClips.length === 0 && !this.isFrameReorderMode && !this.isOpticalRetailerReorder) {
                        const secondClipStartTime = this._secondClipStartTime || 0;
                        const timeSinceStart = Date.now() - secondClipStartTime;
                        const isAtReviewStep = this.currentStep === 5;
                        const gracePeriodElapsed = timeSinceStart > 3e4;
                        if (isAtReviewStep && gracePeriodElapsed) {
                            console.warn("[updateClipTypeLineItem] Cart empty after grace period - resetting stale flag");
                            this.isBuilding2ndClip = false;
                            this._secondClipStartTime = null;
                            this.saveState();
                        } else {
                            console.log("[updateClipTypeLineItem] Keeping flag - within grace period or building 2nd clip");
                        }
                    }
                    const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isReorderMode || this.isOpticalRetailerReorder || this.isRedrillFlow;
                    console.log("[Discount Visibility Debug]", {
                        shouldApplyDiscount: shouldApplyDiscount,
                        isBuilding2ndClip: this.isBuilding2ndClip,
                        hasClipForSameFrame: hasClipForSameFrame,
                        isReorderMode: this.isReorderMode,
                        existingClipsCount: existingClips.length,
                        discountLineItemExists: !!discountLineItem,
                        discountPriceExists: !!discountPrice,
                        clipFullPrice: actualClipPrice,
                        discountAmount: 80,
                        elementDisplay: discountLineItem?.style.display
                    });
                    const isAvulux = this.configuration.clipType === "migraine";
                    const canApplyDiscount = shouldApplyDiscount && !isAvulux;
                    if (canApplyDiscount) {
                        const discountAmount = 80;
                        if (discountPrice) discountPrice.textContent = "-" + this.formatPrice(discountAmount);
                        if (discountLineItem) {
                            discountLineItem.style.display = "flex";
                            console.log("[updateClipTypeLineItem] ✅ Discount line item VISIBLE - 2nd clip discount:", discountAmount);
                        } else {
                            console.error("[updateClipTypeLineItem] ❌ discountLineItem element NOT FOUND in DOM");
                        }
                    } else {
                        if (discountLineItem) {
                            discountLineItem.style.display = "none";
                            const reason = isAvulux ? "Avulux excluded from discount" : "1st clip or different frame";
                            console.log("[updateClipTypeLineItem] ❌ Discount line item HIDDEN -", reason);
                        }
                    }
                }
            } else {
                if (clipTypeItem) clipTypeItem.style.display = "none";
                if (discountLineItem) discountLineItem.style.display = "none";
            }
        },
        updateAccessoriesLineItems: function() {
            const container = document.getElementById("accessoryLineItems");
            if (!container) {
                console.warn("[updateAccessoriesLineItems] Container #accessoryLineItems not found");
                return;
            }
            container.innerHTML = "";
            if (!this.configuration.accessories || this.configuration.accessories.length === 0) {
                return;
            }
            this.configuration.accessories.forEach(accessory => {
                const accessoryData = this.accessories[accessory.type];
                const price = accessoryData?.price || accessory.price || 0;
                const name = accessoryData?.name || accessory.name || accessory.type;
                const lineItem = document.createElement("div");
                lineItem.className = "price-item";
                lineItem.id = `${accessory.type}LineItem`;
                const labelEl = document.createElement("span");
                labelEl.className = "label";
                labelEl.textContent = name;
                const valueEl = document.createElement("span");
                valueEl.className = "value";
                valueEl.textContent = this.formatPrice(price / 100);
                lineItem.appendChild(labelEl);
                lineItem.appendChild(valueEl);
                container.appendChild(lineItem);
            });
            console.log("[updateAccessoriesLineItems] Updated with", this.configuration.accessories.length, "accessories");
        },
        getLabLensMaterialLabel: function(material) {
            if (material === "high-index-167") return "High-Index Lens (1.67)";
            if (material === "high-index-160") return "High-Index Lens (1.60)";
            return "";
        },
        buildPrescriptionLensSummary: function(lensType, lensFeature, lensMaterial, readerPower) {
            let base;
            if (lensType === "progressive") base = "Progressive Lenses"; else if (lensType === "readers") base = "Reader Lenses"; else if (lensType === "non-rx") base = "Non-Rx Lenses"; else base = "Single Vision Lenses";
            if (lensType === "readers" && readerPower) base += " " + readerPower;
            const upgrades = [];
            const skipMaterial = lensType === "readers" || lensType === "non-rx";
            const materialLabel = skipMaterial ? "" : this.getLabLensMaterialLabel(lensMaterial);
            if (materialLabel) upgrades.push(materialLabel);
            if (lensFeature === "blue-light") upgrades.push("Blue Light filter");
            if (upgrades.length === 0) return base;
            return base + ", w/ " + upgrades.join(" + ") + " upgrade";
        },
        getNativeLensBreakdown: async function() {
            const breakdown = {
                total: 0,
                prescriptionType: {
                    price: 0,
                    label: ""
                },
                lensMaterial: {
                    price: 0,
                    label: ""
                },
                blueLight: {
                    price: 0,
                    label: ""
                }
            };
            if (!this.configuration.nativeLensType) return breakdown;
            const excludeIdForLens = this.isEditingConfig ? this.editConfigId : null;
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeIdForLens);
            const hasClipForSameFrame = existingClips.length >= 1;
            const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isRedrillFlow;
            if (shouldApplyDiscount) {
                breakdown.total = 0;
                breakdown.prescriptionType.price = 0;
                breakdown.prescriptionType.label = "Prescription Lens - FREE (Multi-Clip)";
                console.log("[getNativeLensBreakdown] 2nd clip detected - Prescription Lens FREE");
                return breakdown;
            }
            const isIncludedFlow = this.configuration.isPrescriptionOnlyOrder === true || this.configuration.frameChoice === "new-frame-lenses";
            if (isIncludedFlow) {
                console.log("[getNativeLensBreakdown] Included flow - Base lens type INCLUDED with frame");
                let upgradeTotal = 0;
                const lensType = this.configuration.nativeLensType;
                const skipMaterialUpgrade = lensType === "readers" || lensType === "non-rx";
                if (!skipMaterialUpgrade && this.configuration.nativeLensMaterial && this.configuration.nativeLensMaterial !== "standard") {
                    const basePrice = this.getNativeLensPrice("single-vision", "standard", "standard");
                    const materialPrice = this.getNativeLensPrice("single-vision", "standard", this.configuration.nativeLensMaterial);
                    breakdown.lensMaterial.price = materialPrice - basePrice;
                    if (this.configuration.nativeLensMaterial === "high-index-160") {
                        breakdown.lensMaterial.label = "Thinner Lens (1.60)";
                    } else if (this.configuration.nativeLensMaterial === "high-index-167") {
                        breakdown.lensMaterial.label = "Thinnest Lens (1.67)";
                    }
                    upgradeTotal += breakdown.lensMaterial.price;
                }
                if (this.configuration.nativeLensFeature === "blue-light") {
                    const withBlueLight = this.getNativeLensPrice(lensType, "blue-light", this.configuration.nativeLensMaterial || "standard");
                    const withoutBlueLight = this.getNativeLensPrice(lensType, "standard", this.configuration.nativeLensMaterial || "standard");
                    breakdown.blueLight.price = withBlueLight - withoutBlueLight;
                    breakdown.blueLight.label = "Blue Light Protection";
                    upgradeTotal += breakdown.blueLight.price;
                }
                if (lensType === "progressive") {
                    const progressiveBase = this.getNativeLensPrice("progressive", "standard", "standard");
                    const singleVisionBase = this.getNativeLensPrice("single-vision", "standard", "standard");
                    breakdown.prescriptionType.price = progressiveBase - singleVisionBase;
                    breakdown.prescriptionType.label = "Progressive Lenses";
                    upgradeTotal += breakdown.prescriptionType.price;
                } else if (lensType === "readers") {
                    breakdown.prescriptionType.price = 0;
                    const readerPower = this.configuration.readerPower || "+1.00";
                    breakdown.prescriptionType.label = `Readers ${readerPower} (Included)`;
                } else if (lensType === "non-rx") {
                    breakdown.prescriptionType.price = 0;
                    breakdown.prescriptionType.label = "Non-Rx Lenses (Included)";
                } else {
                    breakdown.prescriptionType.price = 0;
                    breakdown.prescriptionType.label = "Single Vision Lenses (Included)";
                }
                breakdown.total = upgradeTotal;
                console.log("[getNativeLensBreakdown] Included flow breakdown:", {
                    frameChoice: this.configuration.frameChoice,
                    isPrescriptionOnlyOrder: this.configuration.isPrescriptionOnlyOrder,
                    lensType: lensType,
                    breakdown: breakdown
                });
                return breakdown;
            }
            const fullPrice = this.getNativeLensPrice(this.configuration.nativeLensType, this.configuration.nativeLensFeature, this.configuration.nativeLensMaterial);
            breakdown.total = fullPrice;
            console.log("[getNativeLensBreakdown] Configuration:", {
                type: this.configuration.nativeLensType,
                feature: this.configuration.nativeLensFeature,
                material: this.configuration.nativeLensMaterial,
                fullPrice: fullPrice
            });
            const basePrice = this.getNativeLensPrice(this.configuration.nativeLensType, "standard", "standard");
            if (this.configuration.nativeLensType === "progressive") {
                breakdown.prescriptionType.price = basePrice;
                breakdown.prescriptionType.label = "Progressive Lenses";
                console.log("[getNativeLensBreakdown] Progressive full price:", {
                    basePrice: basePrice,
                    price: breakdown.prescriptionType.price
                });
            } else if (this.configuration.nativeLensType === "single-vision") {
                breakdown.prescriptionType.price = basePrice;
                breakdown.prescriptionType.label = "Single Vision Lenses";
                console.log("[getNativeLensBreakdown] Single Vision base:", {
                    basePrice: basePrice,
                    label: breakdown.prescriptionType.label
                });
            } else if (this.configuration.nativeLensType === "readers") {
                breakdown.prescriptionType.price = basePrice;
                const readerPower = this.configuration.readerPower || "+1.00";
                breakdown.prescriptionType.label = `Reader Lenses ${readerPower}`;
                console.log("[getNativeLensBreakdown] Readers base:", {
                    basePrice: basePrice,
                    readerPower: readerPower,
                    label: breakdown.prescriptionType.label
                });
            } else if (this.configuration.nativeLensType === "non-rx") {
                breakdown.prescriptionType.price = basePrice;
                breakdown.prescriptionType.label = "Non-Rx Lenses";
                console.log("[getNativeLensBreakdown] Non-Rx base:", {
                    basePrice: basePrice,
                    label: breakdown.prescriptionType.label
                });
            }
            const skipMaterial = this.configuration.nativeLensType === "readers" || this.configuration.nativeLensType === "non-rx";
            if (!skipMaterial && this.configuration.nativeLensMaterial && this.configuration.nativeLensMaterial !== "standard") {
                const materialUpgradePrice = this.getNativeLensPrice(this.configuration.nativeLensType, "standard", this.configuration.nativeLensMaterial);
                breakdown.lensMaterial.price = materialUpgradePrice - basePrice;
                if (this.configuration.nativeLensMaterial === "high-index-160") {
                    breakdown.lensMaterial.label = "Thinner Lens (1.60)";
                } else if (this.configuration.nativeLensMaterial === "high-index-167") {
                    breakdown.lensMaterial.label = "Thinnest Lens (1.67)";
                }
                console.log("[getNativeLensBreakdown] Material upgrade:", {
                    basePrice: basePrice,
                    materialUpgradePrice: materialUpgradePrice,
                    upgrade: breakdown.lensMaterial.price,
                    material: this.configuration.nativeLensMaterial
                });
            }
            if (this.configuration.nativeLensFeature === "blue-light") {
                const withBlueLight = this.getNativeLensPrice(this.configuration.nativeLensType, "blue-light", this.configuration.nativeLensMaterial || "standard");
                const withoutBlueLight = this.getNativeLensPrice(this.configuration.nativeLensType, "standard", this.configuration.nativeLensMaterial || "standard");
                breakdown.blueLight.price = withBlueLight - withoutBlueLight;
                breakdown.blueLight.label = "Blue Light Protection";
                console.log("[getNativeLensBreakdown] Blue Light upgrade:", {
                    withBlueLight: withBlueLight,
                    withoutBlueLight: withoutBlueLight,
                    upgrade: breakdown.blueLight.price
                });
            }
            console.log("[getNativeLensBreakdown] Final breakdown:", breakdown);
            return breakdown;
        },
        updateNativeLensLineItem: async function() {
            console.log("[updateNativeLensLineItem] ========== FUNCTION CALLED ==========");
            const lineItem = document.getElementById("nativeLensLineItem");
            const priceElement = document.getElementById("nativeLensPrice");
            const prescriptionSubitem = document.getElementById("prescriptionTypeSubitem");
            const prescriptionLabel = document.getElementById("prescriptionTypeLabel");
            const prescriptionPrice = document.getElementById("prescriptionTypePrice");
            const materialSubitem = document.getElementById("lensMaterialSubitem");
            const materialLabel = document.getElementById("lensMaterialLabel");
            const materialPrice = document.getElementById("lensMaterialPrice");
            const blueLightSubitem = document.getElementById("blueLightSubitem");
            const blueLightPrice = document.getElementById("blueLightPrice");
            const frameChoice = this.configuration.frameChoice;
            const isVariantA = frameChoice === "own-frame-own-lenses";
            if (isVariantA) {
                if (lineItem) lineItem.style.display = "none";
                console.log("[updateNativeLensLineItem] Variant A detected - hiding Native Lens Upgrades");
                return;
            }
            if (this.isReorderMode) {
                if (lineItem) lineItem.style.display = "none";
                console.log("[updateNativeLensLineItem] Reorder mode - hiding Native Lens (customer already has lenses)");
                return;
            }
            const breakdown = await this.getNativeLensBreakdown();
            if (breakdown.total === 0 && !isVariantA) {
                if (lineItem) lineItem.style.display = "none";
                console.log("[updateNativeLensLineItem] 2nd clip detected - hiding Native Lens (FREE)");
                return;
            }
            const hasUpgrades = breakdown.prescriptionType.price > 0 || breakdown.lensMaterial.price > 0 || breakdown.blueLight.price > 0;
            const isPrescriptionOnlyOrder = this.configuration.isPrescriptionOnlyOrder === true;
            const isIncludedFlow = isPrescriptionOnlyOrder || this.configuration.frameChoice === "new-frame-lenses";
            if (lineItem) lineItem.style.display = "flex";
            const isExpanded = lineItem && lineItem.classList.contains("expanded");
            console.log("[updateNativeLensLineItem] State check:", {
                isExpanded: isExpanded,
                hasUpgrades: hasUpgrades,
                breakdown: {
                    total: breakdown.total,
                    prescription: breakdown.prescriptionType.price,
                    material: breakdown.lensMaterial.price,
                    blueLight: breakdown.blueLight.price
                },
                currentVisibility: {
                    prescription: prescriptionSubitem ? prescriptionSubitem.style.display : "null",
                    material: materialSubitem ? materialSubitem.style.display : "null",
                    blueLight: blueLightSubitem ? blueLightSubitem.style.display : "null"
                }
            });
            if (hasUpgrades) {
                if (priceElement) priceElement.textContent = "+" + this.formatPrice(breakdown.total);
                if (!isExpanded) {
                    console.log("[updateNativeLensLineItem] Dropdown is COLLAPSED - updating subitem visibility");
                    if (breakdown.prescriptionType.price > 0) {
                        if (prescriptionSubitem) {
                            prescriptionSubitem.style.display = "flex";
                            console.log("[updateNativeLensLineItem] Set prescription to: flex");
                        }
                    } else if (isIncludedFlow && this.configuration.nativeLensType === "single-vision") {
                        if (prescriptionSubitem) {
                            prescriptionSubitem.style.display = "flex";
                            console.log("[updateNativeLensLineItem] Included flow Single Vision - showing as Included");
                        }
                    } else {
                        if (prescriptionSubitem) {
                            prescriptionSubitem.style.display = "none";
                            console.log("[updateNativeLensLineItem] Set prescription to: none");
                        }
                    }
                    if (breakdown.lensMaterial.price > 0) {
                        if (materialSubitem) {
                            materialSubitem.style.display = "flex";
                            console.log("[updateNativeLensLineItem] Set material to: flex");
                        }
                    } else {
                        if (materialSubitem) {
                            materialSubitem.style.display = "none";
                            console.log("[updateNativeLensLineItem] Set material to: none");
                        }
                    }
                    if (breakdown.blueLight.price > 0) {
                        if (blueLightSubitem) {
                            blueLightSubitem.style.display = "flex";
                            console.log("[updateNativeLensLineItem] Set blueLight to: flex");
                        }
                    } else {
                        if (blueLightSubitem) {
                            blueLightSubitem.style.display = "none";
                            console.log("[updateNativeLensLineItem] Set blueLight to: none");
                        }
                    }
                } else {
                    console.log("[updateNativeLensLineItem] Dropdown is EXPANDED - preserving current subitem visibility");
                }
                if (breakdown.prescriptionType.price > 0) {
                    if (prescriptionLabel) prescriptionLabel.textContent = breakdown.prescriptionType.label;
                    if (prescriptionPrice) prescriptionPrice.textContent = "+" + this.formatPrice(breakdown.prescriptionType.price);
                } else if (isIncludedFlow && this.configuration.nativeLensType === "single-vision") {
                    if (prescriptionLabel) prescriptionLabel.textContent = "Single Vision Lenses";
                    if (prescriptionPrice) prescriptionPrice.textContent = "Included";
                }
                if (breakdown.lensMaterial.price > 0) {
                    if (materialLabel) materialLabel.textContent = breakdown.lensMaterial.label;
                    if (materialPrice) materialPrice.textContent = "+" + this.formatPrice(breakdown.lensMaterial.price);
                }
                if (breakdown.blueLight.price > 0) {
                    if (blueLightPrice) blueLightPrice.textContent = "+" + this.formatPrice(breakdown.blueLight.price);
                }
            } else {
                if (priceElement) {
                    if (isIncludedFlow && this.configuration.nativeLensType === "single-vision") {
                        priceElement.textContent = "Included";
                    } else if (breakdown.total > 0) {
                        priceElement.textContent = "+" + this.formatPrice(breakdown.total);
                    } else {
                        priceElement.textContent = "+$0";
                    }
                }
                if (!isExpanded) {
                    if (isIncludedFlow && this.configuration.nativeLensType === "single-vision") {
                        console.log("[updateNativeLensLineItem] Included flow Single Vision - showing Included");
                        if (prescriptionSubitem) {
                            prescriptionSubitem.style.display = "flex";
                            if (prescriptionLabel) prescriptionLabel.textContent = "Single Vision Lenses";
                            if (prescriptionPrice) prescriptionPrice.textContent = "Included";
                        }
                        if (materialSubitem) materialSubitem.style.display = "none";
                        if (blueLightSubitem) blueLightSubitem.style.display = "none";
                    } else {
                        console.log("[updateNativeLensLineItem] No upgrades & dropdown COLLAPSED - hiding all subitems");
                        if (prescriptionSubitem) prescriptionSubitem.style.display = "none";
                        if (materialSubitem) materialSubitem.style.display = "none";
                        if (blueLightSubitem) blueLightSubitem.style.display = "none";
                    }
                } else {
                    console.log("[updateNativeLensLineItem] No upgrades but dropdown EXPANDED - preserving current visibility");
                }
            }
            console.log("[updateNativeLensLineItem] Final visibility state:", {
                prescription: prescriptionSubitem ? prescriptionSubitem.style.display : "null",
                material: materialSubitem ? materialSubitem.style.display : "null",
                blueLight: blueLightSubitem ? blueLightSubitem.style.display : "null"
            });
            console.log("[updateNativeLensLineItem] ========== FUNCTION COMPLETE ==========");
        },
        reorderNativeLensLineItem: function() {
            const nativeLensItem = document.getElementById("nativeLensLineItem");
            const frameItem = document.getElementById("frameLineItem");
            const clipTypeItem = document.getElementById("clipTypeLineItem");
            if (!nativeLensItem) return;
            const isVariantC = this.configuration.frameChoice === "new-frame-lenses";
            if (isVariantC && frameItem) {
                frameItem.after(nativeLensItem);
            } else if (clipTypeItem) {
                clipTypeItem.after(nativeLensItem);
            }
        },
        updateCrystalLineItem: function() {
            const lineItem = document.getElementById("crystalLineItem");
            const label = document.getElementById("crystalLabel");
            const price = document.getElementById("crystalPrice");
            if (this.configuration.crystalColor) {
                const crystalName = this.capitalizeWords(this.configuration.crystalColor);
                if (label) label.textContent = `Crystal Accent (${crystalName})`;
                if (price) price.textContent = "+" + this.formatPrice(this.pricing.crystals);
                if (lineItem) lineItem.style.display = "flex";
            } else {
                if (lineItem) lineItem.style.display = "none";
            }
        },
        toggleNativeLensBreakdown: async function() {
            console.log("[toggleNativeLensBreakdown] Function called");
            const lineItem = document.getElementById("nativeLensLineItem");
            const breakdown = document.getElementById("nativeLensBreakdown");
            const prescriptionSubitem = document.getElementById("prescriptionTypeSubitem");
            const materialSubitem = document.getElementById("lensMaterialSubitem");
            const blueLightSubitem = document.getElementById("blueLightSubitem");
            if (!lineItem || !breakdown) {
                console.warn("[toggleNativeLensBreakdown] Elements not found:", {
                    lineItem: !!lineItem,
                    breakdown: !!breakdown
                });
                return;
            }
            const isExpanded = lineItem.classList.contains("expanded");
            console.log("[toggleNativeLensBreakdown] Current state:", {
                isExpanded: isExpanded,
                breakdownDisplay: breakdown.style.display,
                subitems: {
                    prescription: prescriptionSubitem ? prescriptionSubitem.style.display : "not found",
                    material: materialSubitem ? materialSubitem.style.display : "not found",
                    blueLight: blueLightSubitem ? blueLightSubitem.style.display : "not found"
                }
            });
            if (isExpanded) {
                console.log("[toggleNativeLensBreakdown] Collapsing...");
                console.log("[toggleNativeLensBreakdown] Subitem visibility BEFORE collapse:", {
                    prescription: prescriptionSubitem ? prescriptionSubitem.style.display : "null",
                    material: materialSubitem ? materialSubitem.style.display : "null",
                    blueLight: blueLightSubitem ? blueLightSubitem.style.display : "null"
                });
                breakdown.style.height = breakdown.scrollHeight + "px";
                void breakdown.offsetHeight;
                if (window.gsap) {
                    gsap.to(breakdown, {
                        height: 0,
                        duration: .3,
                        ease: "power2.in",
                        onComplete: () => {
                            breakdown.style.display = "none";
                            breakdown.style.height = "";
                            console.log("[toggleNativeLensBreakdown] GSAP onComplete - subitem visibility AFTER setting parent to none:", {
                                prescription: prescriptionSubitem ? prescriptionSubitem.style.display : "null",
                                material: materialSubitem ? materialSubitem.style.display : "null",
                                blueLight: blueLightSubitem ? blueLightSubitem.style.display : "null"
                            });
                        }
                    });
                } else {
                    breakdown.style.display = "none";
                    breakdown.style.height = "";
                }
                lineItem.classList.remove("expanded");
            } else {
                console.log("[toggleNativeLensBreakdown] Expanding...");
                const lensBreakdown = await this.getNativeLensBreakdown();
                console.log("[toggleNativeLensBreakdown] Lens breakdown:", {
                    total: lensBreakdown.total,
                    prescription: lensBreakdown.prescriptionType.price,
                    material: lensBreakdown.lensMaterial.price,
                    blueLight: lensBreakdown.blueLight.price
                });
                breakdown.style.height = "0px";
                breakdown.style.display = "block";
                if (lensBreakdown.prescriptionType.price > 0 && prescriptionSubitem) {
                    prescriptionSubitem.style.display = "flex";
                    console.log("[toggleNativeLensBreakdown] Showing prescription subitem");
                }
                if (lensBreakdown.lensMaterial.price > 0 && materialSubitem) {
                    materialSubitem.style.display = "flex";
                    console.log("[toggleNativeLensBreakdown] Showing material subitem");
                }
                if (lensBreakdown.blueLight.price > 0 && blueLightSubitem) {
                    blueLightSubitem.style.display = "flex";
                    console.log("[toggleNativeLensBreakdown] Showing blueLight subitem");
                }
                void breakdown.offsetHeight;
                const naturalHeight = breakdown.scrollHeight;
                console.log("[toggleNativeLensBreakdown] Measured natural height:", naturalHeight);
                if (window.gsap) {
                    gsap.to(breakdown, {
                        height: naturalHeight,
                        duration: .3,
                        ease: "power2.out",
                        onComplete: () => {
                            breakdown.style.height = "auto";
                            console.log("[toggleNativeLensBreakdown] GSAP expand complete - final subitem visibility:", {
                                prescription: prescriptionSubitem ? window.getComputedStyle(prescriptionSubitem).display : "null",
                                material: materialSubitem ? window.getComputedStyle(materialSubitem).display : "null",
                                blueLight: blueLightSubitem ? window.getComputedStyle(blueLightSubitem).display : "null"
                            });
                        }
                    });
                } else {
                    breakdown.style.height = "auto";
                }
                lineItem.classList.add("expanded");
            }
        },
        updatePricingSummary: async function() {
            await Promise.all([ this.updateFrameLineItem(), this.updateClipTypeLineItem(), this.updateNativeLensLineItem() ]);
            this.reorderNativeLensLineItem();
            this.updateCrystalLineItem();
            this.updateBridgeLineItem();
            this.updateMagnetLineItem();
            this.updateAccessoriesLineItems();
            const totalPrice = await this.calculateTotalPrice();
            const totalElement = document.getElementById("totalPrice");
            if (totalElement) totalElement.textContent = this.formatPrice(totalPrice);
            await this.updateNavTotalCalculator(totalPrice);
        },
        updatePricingSummaryDebounced: function(delay = 300) {
            const self = this;
            if (this._pricingUpdateTimeout) {
                clearTimeout(this._pricingUpdateTimeout);
            }
            return new Promise(resolve => {
                this._pricingUpdateTimeout = setTimeout(async () => {
                    console.log("[updatePricingSummaryDebounced] Executing debounced update");
                    await self.updatePricingSummary();
                    resolve();
                }, delay);
            });
        },
        updateNavTotalCalculator: async function(total) {
            const navCalculator = document.getElementById("navTotalCalculator");
            const navTotalPrice = document.getElementById("navTotalPrice");
            if (!navCalculator || !navTotalPrice) return;
            const currentStep = this.currentStep;
            const hasValidTotal = !isNaN(total);
            if (currentStep >= 2 && hasValidTotal) {
                navCalculator.style.display = "flex";
                const isVariantC = this.configuration.frameChoice === "new-frame-lenses";
                const isPrescriptionOnly = this.configuration.isPrescriptionOnlyOrder === true;
                const isIncludedFlow = isVariantC || isPrescriptionOnly;
                const isInStep2 = currentStep === 2;
                let displayTotal = total;
                if (isIncludedFlow && isInStep2) {
                    const lensBreakdown = await this.getNativeLensBreakdown();
                    let framePrice = 0;
                    if (this.configuration.frameChoice === "new-frame-lenses" && this.configuration.frameProduct) {
                        const excludeId = this.isEditingConfig ? this.editConfigId : null;
                        const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeId);
                        const is2ndClip = this.isBuilding2ndClip || existingClips.length >= 1;
                        if (!is2ndClip) {
                            let frameData = window.chemistrie_products?.frames?.[this.configuration.frameProduct];
                            if (!frameData) {
                                frameData = await this.fetchFrameData(this.configuration.frameProduct);
                            }
                            if (frameData && frameData.price) {
                                framePrice = frameData.price / 100;
                            } else {
                                framePrice = 95;
                            }
                        }
                    }
                    displayTotal = framePrice + lensBreakdown.total;
                    console.log("[Nav Calculator] Variant C Step 2 - Frame + Lens upgrades:", {
                        framePrice: framePrice,
                        lensUpgrades: lensBreakdown.total,
                        displayTotal: displayTotal
                    });
                }
                navTotalPrice.textContent = this.formatPrice(displayTotal);
                const isBuilding2ndClip = this.isBuilding2ndClip;
                const hasNativeLenses = this.configuration.nativeLensType;
                const existingIndicator = navCalculator.querySelector(".second-clip-indicator");
                if (existingIndicator) {
                    existingIndicator.remove();
                }
                if (isBuilding2ndClip && isInStep2 && hasNativeLenses && total > 0) {
                    const indicator = document.createElement("span");
                    indicator.className = "second-clip-indicator";
                    indicator.textContent = "*";
                    indicator.title = "Preview pricing - Additional clip lens upgrades are FREE";
                    indicator.style.cssText = `\n                        color: #C62828;\n                        font-size: 12px;\n                        margin-left: 4px;\n                        cursor: help;\n                        vertical-align: super;\n                    `;
                    navTotalPrice.appendChild(indicator);
                    console.log("[Nav Calculator] Added 2nd clip preview indicator");
                }
            } else {
                navCalculator.style.display = "none";
            }
        },
        updateFrameLineItem: async function() {
            const frameItem = document.getElementById("frameLineItem");
            const frameDesc = document.getElementById("frameDescription");
            const framePrice = document.getElementById("framePrice");
            const isVariantC = this.configuration.frameChoice === "new-frame-lenses";
            const excludeIdFrame = this.isEditingConfig ? this.editConfigId : null;
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeIdFrame);
            const hasClipForSameFrame = existingClips.length >= 1;
            const isBuilding2ndClip = this.isBuilding2ndClip || hasClipForSameFrame || this.isReorderMode;
            if (isVariantC && this.configuration.frameProduct && !isBuilding2ndClip) {
                const frameHandle = this.configuration.frameProduct;
                let frameData = window.chemistrie_products?.frames?.[frameHandle];
                if (!frameData) {
                    console.log("[updateFrameLineItem] Frame data not loaded, fetching...");
                    frameData = await this.fetchFrameData(frameHandle);
                }
                if (frameData) {
                    const frameName = frameData.title || this.capitalizeWords(frameHandle.replace(/-/g, " "));
                    frameDesc.textContent = frameName;
                    const framePriceValue = frameData.price / 100;
                    framePrice.textContent = this.formatPrice(framePriceValue);
                    frameItem.style.display = "flex";
                    console.log("[updateFrameLineItem] Displaying frame:", {
                        handle: frameHandle,
                        name: frameName,
                        price: framePriceValue
                    });
                } else {
                    console.warn("[updateFrameLineItem] Frame data not found for:", frameHandle);
                    frameItem.style.display = "none";
                }
            } else {
                frameItem.style.display = "none";
                if (isBuilding2ndClip && isVariantC) {
                    console.log("[updateFrameLineItem] Hiding frame - 2nd clip (customer already has frame)");
                }
            }
        },
        updateLensLineItem: async function() {
            const lensItem = document.getElementById("lensLineItem");
            const lensDesc = document.getElementById("lensDescription");
            const lensPrice = document.getElementById("lensPrice");
            let price = 0;
            if (this.configuration.clipType && this.clipTypes[this.configuration.clipType]) {
                const clipType = this.clipTypes[this.configuration.clipType];
                const category = this.configuration.lensCategory || "";
                const color = this.configuration.lensColor || "";
                let description = `${clipType.name} Clip`;
                if (category && color) {
                    description += ` - ${category.charAt(0).toUpperCase() + category.slice(1)} ${color}`;
                }
                const excludeIdClip = this.isEditingConfig ? this.editConfigId : null;
                const existingClipsForDiscount = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeIdClip);
                const hasClipForSameFrame = existingClipsForDiscount.length >= 1;
                const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isRedrillFlow;
                let fullPrice = clipType.price;
                if (this.configuration.clipType === "lightSensitivity" && this.configuration.lightSensitivityColor) {
                    const lensOption = this.therapeuticLensPricing[this.configuration.lightSensitivityColor];
                    fullPrice = lensOption ? lensOption.price : 175;
                } else if (this.configuration.clipType === "migraine") {
                    fullPrice = window.chemistrie_prices?.clip_migraine || 495;
                }
                const isAvulux = this.configuration.clipType === "migraine";
                const canApplyDiscount = shouldApplyDiscount && !isAvulux;
                price = canApplyDiscount ? fullPrice - 80 : fullPrice;
                lensDesc.textContent = description;
                lensPrice.textContent = this.formatPrice(price);
                lensItem.style.display = "flex";
                console.log("[updateLensLineItem] Clip price display:", {
                    fullPrice: fullPrice,
                    discountApplies: shouldApplyDiscount,
                    displayPrice: price
                });
            } else {
                lensItem.style.display = "none";
            }
            return price;
        },
        updateCrystalLineItem: function() {
            const crystalItem = document.getElementById("crystalLineItem");
            const crystalDesc = document.getElementById("crystalDescription");
            const crystalPrice = document.getElementById("crystalPrice");
            let price = 0;
            if (this.configuration.crystalColor && this.configuration.crystalColor !== "null") {
                price = this.pricing.crystals || 0;
                console.log("[updateCrystalLineItem] Displaying crystal:", {
                    color: this.configuration.crystalColor,
                    "pricing.crystals": this.pricing.crystals,
                    displayPrice: price
                });
                crystalDesc.textContent = `${this.configuration.crystalColor} Crystal`;
                crystalPrice.textContent = `+$${price.toFixed(2)}`;
                crystalItem.style.display = "flex";
            } else {
                console.log("[updateCrystalLineItem] No crystal selected - hiding line item");
                crystalItem.style.display = "none";
            }
            return price;
        },
        updateBridgeLineItem: function() {
            const bridgeItem = document.getElementById("bridgeLineItem");
            if (bridgeItem) {
                bridgeItem.style.display = "none";
            }
            return 0;
        },
        updateMagnetLineItem: function() {
            const magnetItem = document.getElementById("magnetLineItem");
            if (magnetItem) {
                magnetItem.style.display = "none";
            }
            return 0;
        },
        updateSecondClipLineItem: function() {
            console.log("updateSecondClipLineItem called");
            const addonsSection = document.getElementById("addonsSection");
            const secondClipItem = document.getElementById("secondClipLineItem");
            const secondClipDesc = document.getElementById("secondClipDescription");
            const secondClipPrice = document.getElementById("secondClipPrice");
            console.log("Found second clip elements:", {
                addonsSection: !!addonsSection,
                secondClipItem: !!secondClipItem,
                secondClipDesc: !!secondClipDesc,
                secondClipPrice: !!secondClipPrice
            });
            let price = 0;
            if (this.configuration.addSecondClip && this.configuration.secondClip) {
                const clipType = this.configuration.secondClip.type;
                if (this.clipTypes[clipType]) {
                    price = 95;
                    if (secondClipDesc) secondClipDesc.textContent = `Second ${this.clipTypes[clipType].name} Clip`;
                    if (secondClipPrice) secondClipPrice.textContent = `$${price}`;
                    if (secondClipItem) secondClipItem.style.display = "flex";
                    if (addonsSection) addonsSection.style.display = "block";
                } else {
                    if (secondClipItem) secondClipItem.style.display = "none";
                    if (addonsSection) addonsSection.style.display = "none";
                }
            } else {
                if (secondClipItem) secondClipItem.style.display = "none";
                if (addonsSection) addonsSection.style.display = "none";
            }
            console.log("Second clip price:", price);
            return price;
        },
        updateSecondClipToggleText: async function() {
            const toggleTitle = document.getElementById("secondClipToggleTitle");
            const toggleDesc = document.getElementById("secondClipToggleDesc");
            if (!toggleTitle || !toggleDesc) return;
            const excludeIdToggle = this.isEditingConfig ? this.editConfigId : null;
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeIdToggle);
            console.log("[updateSecondClipToggleText] Frame matching config:", {
                frameProduct: this.configuration.frameProduct,
                frameBrand: this.configuration.frameBrand,
                frameModel: this.configuration.frameModel,
                existingClipsRawCount: existingClips.length,
                existingClipsSummary: existingClips.map(c => ({
                    title: c.product_title,
                    frameProduct: c.properties?.["_Frame Product ID"],
                    frameBrand: c.properties?.["_Frame Brand"],
                    frameModel: c.properties?.["_Frame Model"]
                }))
            });
            let currentClipNumber = existingClips.length + 1;
            if (this.isBuilding2ndClip) {
                currentClipNumber = existingClips.length + 1;
            }
            const toggleOffersClipNumber = currentClipNumber + 1;
            const defaultClipPrice = window.chemistrie_prices?.clip_sun || 175;
            const multiClipDiscount = 80;
            const discountedClipPrice = defaultClipPrice - multiClipDiscount;
            toggleTitle.textContent = "Add Another Clip";
            toggleDesc.textContent = `Multi-Clip Discount (+${this.formatPrice(discountedClipPrice)})`;
            console.log("[updateSecondClipToggleText] Toggle calculation:", {
                existingClipsCount: existingClips.length,
                isBuilding2ndClip: this.isBuilding2ndClip,
                currentClipBeingBuilt: currentClipNumber,
                toggleOffersClip: toggleOffersClipNumber,
                displayText: toggleTitle.textContent
            });
        },
        setupSecondClipCTA: async function() {
            const secondClipToggle = document.getElementById("secondClipToggle");
            if (secondClipToggle) {
                secondClipToggle.addEventListener("change", async e => {
                    this.configuration.addSecondClip = e.target.checked;
                    this.updateAddToCartButtonText();
                    await this.updatePricingSummary();
                    this.saveState();
                });
                secondClipToggle.checked = false;
                this.configuration.addSecondClip = false;
                this.saveState();
                await this.updateSecondClipToggleText();
                console.log("[setupSecondClipCTA] Toggle initialized:", {
                    checked: secondClipToggle.checked,
                    configValue: this.configuration.addSecondClip
                });
            }
        },
        updateAddToCartButtonText: function() {
            const addToCartBtn = document.getElementById("addToCartBtn");
            if (!addToCartBtn) return;
            if (this.configuration.addSecondClip) {
                const isMobile = window.innerWidth <= 768;
                addToCartBtn.textContent = isMobile ? "Add to Cart +" : "Add to Cart + Additional Clip";
            } else {
                addToCartBtn.textContent = "Add to Cart";
            }
        },
        handleAddAnotherClipFromCart: async function(event) {
            console.log("[handleAddAnotherClipFromCart] Button clicked");
            const button = event.target.closest(".cart-item-group__add-another");
            if (!button) {
                console.error("[handleAddAnotherClipFromCart] Button not found");
                return;
            }
            const configId = button.dataset.configId;
            const frameBrand = button.dataset.frameBrand;
            const frameModel = button.dataset.frameModel;
            const frameProduct = button.dataset.frameProduct;
            console.log("[handleAddAnotherClipFromCart] Extracted button data:", {
                configId: configId,
                frameBrand: frameBrand,
                frameModel: frameModel,
                frameProduct: frameProduct
            });
            try {
                const response = await fetch("/cart.js", {
                    credentials: "same-origin"
                });
                const cartData = await response.json();
                console.log("[handleAddAnotherClipFromCart] Cart fetched:", cartData.items.length, "items");
                const inThisConfig = item => item.properties["_Config ID"] === configId || item.properties["_Configuration ID"] === configId;
                let firstClip = cartData.items.find(item => {
                    if (!inThisConfig(item)) return false;
                    const clipSequence = item.properties["_Clip Sequence"];
                    return !clipSequence || clipSequence === "1" || parseInt(clipSequence) === 1;
                });
                if (!firstClip) {
                    firstClip = cartData.items.filter(inThisConfig).sort((a, b) => parseInt(a.properties["_Clip Sequence"] || "999", 10) - parseInt(b.properties["_Clip Sequence"] || "999", 10))[0];
                }
                if (!firstClip) {
                    console.error("[handleAddAnotherClipFromCart] First clip not found in cart for config:", configId);
                    console.error("[handleAddAnotherClipFromCart] Available cart items:", cartData.items.map(i => ({
                        title: i.title,
                        configId: i.properties["_Config ID"] || i.properties["_Configuration ID"],
                        sequence: i.properties["_Clip Sequence"]
                    })));
                    alert("Error: Could not find clip configuration. Please try again.");
                    return;
                }
                console.log("[handleAddAnotherClipFromCart] First clip found:", firstClip.title);
                console.log("[handleAddAnotherClipFromCart] First clip properties:", firstClip.properties);
                let prescriptionData = null;
                const prescriptionProp = firstClip.properties["_Prescription"];
                if (prescriptionProp && prescriptionProp !== "skip") {
                    try {
                        prescriptionData = JSON.parse(prescriptionProp);
                        console.log("[handleAddAnotherClipFromCart] Parsed prescription data:", prescriptionData);
                    } catch (e) {
                        console.warn("[handleAddAnotherClipFromCart] Could not parse prescription JSON, using raw value:", prescriptionProp);
                        prescriptionData = prescriptionProp;
                    }
                }
                const frameData = {
                    frameChoice: firstClip.properties["_Frame Choice Key"] || firstClip.properties["_Frame Choice"] || "own-frame-own-lenses",
                    frameProduct: frameProduct || "",
                    frameBrand: frameBrand || "",
                    frameModel: frameModel || "",
                    nativeLensType: firstClip.properties["_Native Lens Type"] || "single-vision",
                    nativeLensFeature: firstClip.properties["_Native Lens Feature"] || "standard",
                    nativeLensMaterial: firstClip.properties["_Native Lens Material"] || "standard",
                    prescription: prescriptionData,
                    orderSource: firstClip.properties["_Order Source"] || null,
                    originalOrder: firstClip.properties["_Original Order"] || null
                };
                console.log("[handleAddAnotherClipFromCart] Frame data prepared:", frameData);
                localStorage.setItem("secondClipFrameData", JSON.stringify(frameData));
                localStorage.setItem("isBuilding2ndClip", "true");
                localStorage.setItem("jumpToStep", "3");
                console.log("[handleAddAnotherClipFromCart] Data stored to localStorage, navigating to order flow...");
                window.location.href = "/pages/order-flow";
            } catch (error) {
                console.error("[handleAddAnotherClipFromCart] Error:", error);
                alert("Error loading clip data. Please try again.");
            }
        },
        attachCartButtonListeners: function() {
            if (window.cartAddAnotherClipHandler) {
                console.log("[attachCartButtonListeners] Global cart handler present — standing down to avoid a duplicate-binding race");
                return;
            }
            console.log("[attachCartButtonListeners] Attaching listeners to cart buttons");
            const addAnotherButtons = document.querySelectorAll(".cart-item-group__add-another");
            console.log("[attachCartButtonListeners] Found", addAnotherButtons.length, "buttons");
            addAnotherButtons.forEach((button, index) => {
                button.removeEventListener("click", this.handleAddAnotherClipFromCart.bind(this));
                button.addEventListener("click", this.handleAddAnotherClipFromCart.bind(this));
                console.log("[attachCartButtonListeners] Listener attached to button", index + 1);
            });
            const cartDrawer = document.querySelector(".cart-drawer-items");
            if (cartDrawer && !this._cartObserver) {
                console.log("[attachCartButtonListeners] Setting up MutationObserver for cart drawer");
                this._cartObserver = new MutationObserver(mutations => {
                    const hasChanges = mutations.some(mutation => mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
                    if (hasChanges) {
                        console.log("[attachCartButtonListeners] Cart updated, reattaching listeners");
                        setTimeout(() => this.attachCartButtonListeners(), 100);
                    }
                });
                this._cartObserver.observe(cartDrawer, {
                    childList: true,
                    subtree: true
                });
            }
        },
        setupCompactAccessories: function() {
            console.log("=== DIAGNOSTIC: Setting up compact accessories ===");
            console.log("🔍 Product data available:", !!window.chemistrie_products);
            console.log("🔍 Accessories data available:", !!window.chemistrie_products?.accessories);
            if (window.chemistrie_products?.accessories) {
                console.log("🔍 Accessories structure:", window.chemistrie_products.accessories);
                console.log("🔍 Accessory types available:", Object.keys(window.chemistrie_products.accessories));
            } else {
                console.error("❌ CRITICAL: window.chemistrie_products.accessories is not loaded!");
            }
            const accessoryToggles = document.querySelectorAll("#reviewAccessories .accessory-toggle");
            console.log("🔍 Found accessory toggles:", accessoryToggles.length);
            accessoryToggles.forEach((toggle, index) => {
                console.log(`🔍 Toggle ${index + 1}:`, {
                    type: toggle.dataset.accessory,
                    checked: toggle.checked,
                    element: toggle
                });
            });
            accessoryToggles.forEach(toggle => {
                toggle.addEventListener("change", async e => {
                    const accessoryType = e.target.dataset.accessory;
                    console.log("🔍 Accessory toggle changed:", accessoryType, e.target.checked);
                    await this.toggleAccessory(accessoryType, e.target.checked);
                });
            });
            console.log("🔍 Current accessories configuration:", this.configuration.accessories);
            this.configuration.accessories.forEach(accessory => {
                const accessoryType = typeof accessory === "string" ? accessory : accessory.type;
                let toggle = document.querySelector(`[data-accessory="${accessoryType}"]`);
                if (!toggle && accessoryType === "cleaning") {
                    toggle = document.querySelector(`[data-accessory="cleaning_kit"]`);
                    console.log(`🛡️ Mapped legacy "cleaning" to "cleaning_kit" toggle`);
                }
                console.log(`🔍 Initializing toggle for ${accessoryType}:`, toggle ? "found" : "NOT FOUND");
                if (toggle) toggle.checked = true;
            });
            console.log("=== DIAGNOSTIC: Setup complete ===");
        },
        selectColorCategory: function(category) {
            if (this.configuration.lensCategory !== category) {
                this.configuration.lensColor = null;
                if (this.sharedImageLayering) {
                    this.sharedImageLayering.removeLayer("lens");
                }
            }
            this.configuration.lensCategory = category;
            document.querySelectorAll("#step4SunOptions .category-tab").forEach(tab => {
                tab.classList.remove("active");
            });
            document.querySelector(`#step4SunOptions [data-category="${category}"]`).classList.add("active");
            document.querySelectorAll("#step4SunOptions .category-description").forEach(desc => {
                desc.classList.remove("active");
                desc.style.display = "none";
            });
            const activeDescription = document.querySelector(`#step4SunOptions .category-description[data-category="${category}"]`);
            if (activeDescription) {
                activeDescription.classList.add("active");
                activeDescription.style.display = "block";
            }
            const sunLensSubtitle = document.getElementById("sunLensSubtitle");
            if (sunLensSubtitle) {
                const noARCoatingColors = [ "Grey", "Brown", "G15", "Amber" ];
                const currentColor = this.configuration.lensColor;
                if (category === "non-polarized") {
                    sunLensSubtitle.textContent = "100% UV protection with quality tints for everyday wear";
                } else if (category === "solid" && currentColor && noARCoatingColors.includes(currentColor)) {
                    sunLensSubtitle.textContent = "100% UV protection and fully polarized";
                } else {
                    sunLensSubtitle.textContent = "100% UV protection, fully polarized, and back-side anti-reflective coating included";
                }
            }
            this.loadColorGrid(category);
            this.updateNavigationButtons();
            this.saveState();
        },
        loadColorGrid: function(category) {
            const colors = {
                gradient: [ {
                    name: "VioletRose",
                    value: "VioletRose",
                    description: "Elegant violet to rose transition"
                }, {
                    name: "VioletGrey",
                    value: "VioletGrey",
                    description: "Sophisticated violet to grey blend"
                }, {
                    name: "Rouge",
                    value: "Rouge",
                    description: "Deep red gradient"
                }, {
                    name: "MediumBrown",
                    value: "MediumBrown",
                    description: "Warm brown transition"
                }, {
                    name: "DarkGrey",
                    value: "DarkGrey",
                    description: "Classic dark grey gradient"
                }, {
                    name: "DarkBrown",
                    value: "DarkBrown",
                    description: "Rich brown gradient"
                }, {
                    name: "CrimsonGrey",
                    value: "CrimsonGrey",
                    description: "Bold crimson gradient"
                }, {
                    name: "Amber",
                    value: "Amber",
                    description: "Warm amber transition"
                } ],
                mirror: [ {
                    name: "SkyBlue",
                    value: "SkyBlue",
                    description: "Brilliant sky blue mirror"
                }, {
                    name: "Silver",
                    value: "Silver",
                    description: "Classic silver mirror"
                }, {
                    name: "Orange",
                    value: "Orange",
                    description: "Vibrant orange mirror"
                }, {
                    name: "Morado",
                    value: "Morado",
                    description: "Purple mirror finish"
                }, {
                    name: "Green",
                    value: "Green",
                    description: "Emerald green mirror"
                }, {
                    name: "Gold",
                    value: "Gold",
                    description: "Luxurious gold mirror"
                }, {
                    name: "Caliente",
                    value: "Caliente",
                    description: "Hot red mirror"
                }, {
                    name: "Blue",
                    value: "Blue",
                    description: "Deep blue mirror"
                } ],
                solid: [ {
                    name: "Grey",
                    value: "Grey",
                    description: "Neutral grey lens"
                }, {
                    name: "Brown",
                    value: "Brown",
                    description: "Warm brown lens"
                }, {
                    name: "G15",
                    value: "G15",
                    description: "Classic G-15 green"
                }, {
                    name: "Yellow",
                    value: "Yellow",
                    description: "Bright yellow lens"
                }, {
                    name: "Rose",
                    value: "Rose",
                    description: "Rose colored lens"
                }, {
                    name: "Bronze",
                    value: "Bronze",
                    description: "Bronze tinted lens"
                }, {
                    name: "Blue",
                    value: "Blue",
                    description: "Blue tinted lens"
                }, {
                    name: "Amber",
                    value: "Amber",
                    description: "Amber colored lens"
                } ],
                "non-polarized": [ {
                    name: "NP Grey",
                    value: "Grey",
                    description: "Neutral grey lens without polarization"
                }, {
                    name: "NP Brown",
                    value: "Brown",
                    description: "Warm brown lens without polarization"
                }, {
                    name: "NP G-15",
                    value: "G15",
                    description: "Classic G-15 green without polarization"
                } ]
            };
            const grid = document.getElementById("step4LensColorGrid");
            const categoryColors = colors[category] || [];
            grid.innerHTML = categoryColors.map(color => {
                const categoryForSvg = category === "non-polarized" ? "Solid" : category.charAt(0).toUpperCase() + category.slice(1);
                const svgFileName = `ColorWheel-LensPucks-${categoryForSvg}-${color.value}.svg`;
                const svgUrl = this.getAssetUrl(svgFileName);
                const displayLabel = category === "non-polarized" ? color.name : this.formatColorName(color.name);
                return `<div class="lens-puck-wrapper">\n                          <div class="lens-puck-container"\n                               data-color="${color.value}"\n                               data-category="${category}"\n                               title="${color.name}">\n                            <img src="${svgUrl}"\n                                 alt="${color.name} lens"\n                                 class="lens-puck-image"\n                                 onerror="this.style.display='none';">\n                          </div>\n                          <span class="lens-puck-label">${displayLabel}</span>\n                        </div>`;
            }).join("");
        },
        selectLensColor: function(colorValue) {
            this.configuration.lensColor = colorValue;
            document.querySelectorAll("#step4LensColorGrid .lens-puck-container").forEach(container => {
                container.classList.remove("selected");
            });
            document.querySelector(`#step4LensColorGrid [data-color="${colorValue}"]`).classList.add("selected");
            const colorEl = document.querySelector(`#step4LensColorGrid [data-color="${colorValue}"]`);
            if (colorEl) {
                const colorName = colorEl.title || colorValue;
                const formattedColorName = this.formatColorName(colorName);
                const category = colorEl.dataset.category;
                const colorNameEl = document.getElementById("step4ColorName");
                const colorDescEl = document.getElementById("step4ColorDescription");
                if (colorNameEl) {
                    colorNameEl.style.display = "block";
                    colorNameEl.textContent = formattedColorName;
                }
                if (colorDescEl) {
                    colorDescEl.style.display = "block";
                    colorDescEl.textContent = this.getLensDescription(category, colorName);
                }
                if (category) {
                    this.configuration.lensCategory = category;
                }
                const sunLensSubtitle = document.getElementById("sunLensSubtitle");
                if (sunLensSubtitle) {
                    const noARCoatingColors = [ "Grey", "Brown", "G15", "Amber" ];
                    if (category === "solid" && noARCoatingColors.includes(colorValue)) {
                        sunLensSubtitle.textContent = "100% UV protection and fully polarized";
                    } else if (category === "non-polarized") {
                        sunLensSubtitle.textContent = "100% UV protection with quality tints for everyday wear";
                    } else {
                        sunLensSubtitle.textContent = "100% UV protection, fully polarized, and back-side anti-reflective coating included";
                    }
                }
            }
            if (!this.configuration.bridgeColor) {
                this.configuration.bridgeColor = "MatteBlack";
            }
            if (!this.configuration.magnetColor) {
                this.configuration.magnetColor = "Gunmetal";
            }
            if (this.sharedImageLayering) {
                this.updateCanvasPreview("lens", colorValue);
                if (this.configuration.bridgeColor) {
                    this.updateCanvasPreview("bridge", this.configuration.bridgeColor);
                }
                if (this.configuration.magnetColor) {
                    this.updateCanvasPreview("magnet", this.configuration.magnetColor);
                }
            }
            this.updateNavigationButtons();
            this.saveStateDebounced();
        },
        selectMagnification: function(magValue) {
            this.configuration.magnification = magValue;
            document.querySelectorAll("#step4MagnificationGrid .mag-option").forEach(option => {
                option.classList.remove("selected");
            });
            document.querySelector(`#step4MagnificationGrid [data-magnification="${magValue}"]`).classList.add("selected");
            this.updateNavigationButtons();
            this.saveStateDebounced();
        },
        selectClipOption: function(optionValue) {
            this.configuration.clipOption = optionValue;
            document.querySelectorAll("#step4 .option-card").forEach(card => {
                card.classList.remove("active");
            });
            document.querySelector(`#step4 [data-option="${optionValue}"]`).classList.add("active");
            this.updateNavigationButtons();
            this.saveState();
        },
        selectSecondClipChoice: async function(choice) {
            this.configuration.addSecondClip = choice === "yes";
            document.querySelectorAll("#step5 .choice-card").forEach(card => {
                card.classList.remove("selected");
            });
            document.querySelector(`#step5 [data-choice="${choice}"]`).classList.add("selected");
            const secondClipConfig = document.getElementById("secondClipConfigurator");
            if (choice === "yes") {
                secondClipConfig.classList.remove("hidden");
            } else {
                secondClipConfig.classList.add("hidden");
                this.configuration.secondClip = null;
            }
            await this.calculateTotalPrice();
            this.updateNavigationButtons();
            this.saveState();
        },
        toggleAccessory: async function(accessoryType, selected) {
            console.log("toggleAccessory called:", accessoryType, selected, "Current step:", this.currentStep);
            const accessory = this.accessories[accessoryType];
            console.log("Accessory details:", accessory);
            if (selected) {
                if (!this.configuration.accessories.find(a => a.type === accessoryType)) {
                    this.configuration.accessories.push({
                        type: accessoryType,
                        name: accessory.name,
                        price: accessory.price
                    });
                    console.log("Added accessory:", accessoryType, "New array:", this.configuration.accessories);
                }
            } else {
                this.configuration.accessories = this.configuration.accessories.filter(a => a.type !== accessoryType);
                console.log("Removed accessory:", accessoryType, "New array:", this.configuration.accessories);
            }
            const card = document.querySelector(`[data-accessory="${accessoryType}"]`);
            if (card && card.classList.contains("accessory-card")) {
                if (selected) {
                    card.classList.add("selected");
                } else {
                    card.classList.remove("selected");
                }
            }
            const totalPrice = await this.calculateTotalPrice();
            console.log("Total price after accessory toggle:", totalPrice);
            if (this.currentStep === 5) {
                console.log("Updating Step 5 pricing display...");
                this.updateClipTypeLineItem();
                this.updateAccessoriesLineItems();
                const totalElement = document.getElementById("totalPrice");
                if (totalElement) totalElement.textContent = `$${totalPrice}`;
                const finalPriceElement = document.getElementById("finalPrice");
                if (finalPriceElement) finalPriceElement.textContent = `$${totalPrice}`;
                this.updateNavTotalCalculator(totalPrice);
            } else {
                this.updateOrderSummary();
            }
            this.saveState();
        },
        nextStep: function() {
            if (this.isNavigating) {
                console.log("[nextStep] Navigation already in progress - ignoring call");
                return;
            }
            if (this.currentStep === 2 && this.isInStep2Substep) {
                this.nextStep2Substep();
                return;
            }
            if (this.currentStep === 4 && this.isInSubStage) {
                this.nextSubStage();
                return;
            }
            if (this.currentStep === 1 && this.configuration.frameChoice === "new-frame-lenses") {
                if (!this.configuration.frameProduct) {
                    console.log("Redirecting to Eyeglasses PLP for frame selection");
                    window.location.href = "/collections/eyeglasses?order_flow=true&variant=new-frame-lenses";
                    return;
                }
            }
            if (!this.requireShipInAck(this.currentStep + 1)) return;
            if (this.canProceedToNextStep()) {
                this.goToStep(this.currentStep + 1);
            }
        },
        SHIP_IN_ACK_ENABLED: false,
        requireShipInAck: function(targetStep) {
            if (!this.SHIP_IN_ACK_ENABLED) return true;
            if (this.currentStep !== 1 || targetStep <= 1) return true;
            const choice = this.configuration.frameChoice;
            if (choice !== "own-frame-own-lenses" && choice !== "own-frame-new-lenses") return true;
            if (this.configuration.shipInAckAt) return true;
            this._pendingShipInTarget = targetStep;
            this.showShipInAckModal(choice);
            return false;
        },
        previousStep: function() {
            if (this.isReorderMode && this.currentStep === 4 && (!this.isInSubStage || this.currentSubStage <= 1)) {
                console.log("[previousStep] Reorder mode — cannot go before Step 4");
                return;
            }
            if ((this.isFrameReorderMode || this.isRedrillFlow) && this.currentStep === 3) {
                console.log("[previousStep] Frame-reorder / redrill mode — cannot go before Step 3");
                return;
            }
            if (this.currentStep === 5 && this.configuration.isPrescriptionOnlyOrder === true) {
                console.log("[previousStep] Prescription-only order — skipping Steps 3-4, going to Step 2");
                this.goToStep(2);
                return;
            }
            if (this.currentStep === 2 && this.isInStep2Substep && this.currentStep2Substep > 1) {
                this.previousStep2Substep();
                return;
            }
            if (this.isEditingConfig && this.currentStep === 2 && (!this.isInStep2Substep || this.currentStep2Substep <= 1)) {
                console.log("[previousStep] Edit mode — showing warning before going to Step 1");
                this.showEditWarningModal();
                return;
            }
            if (this.currentStep === 4 && this.isInSubStage && this.currentSubStage > 1) {
                this.previousSubStage();
            } else if (this.currentStep > 1) {
                this.goToStep(this.currentStep - 1);
            }
        },
        initializeStep2Substeps: function() {
            const frameChoice = this.configuration.frameChoice;
            if (this.configuration.nativeLensType) {
                this.updateStep2SubstepsForLensType(this.configuration.nativeLensType);
            }
            const config = this.step2SubstepConfig[frameChoice];
            if (!config) {
                console.error(`No Step 2 substep config found for frame choice: ${frameChoice}`);
                return;
            }
            let startingSubstep = 1;
            if (this.lastStep2Substep && this.previousStepNumber === 3) {
                if (this.lastStep2Substep >= 1 && this.lastStep2Substep <= config.total) {
                    startingSubstep = this.lastStep2Substep;
                    console.log(`[Step 2] Restoring to last substep ${startingSubstep} (came from Step 3)`);
                } else {
                    console.warn(`[Step 2] Saved substep ${this.lastStep2Substep} out of range, starting at 1`);
                }
            } else if (this.currentStep2Substep && this.currentStep2Substep <= config.total) {
                startingSubstep = this.currentStep2Substep;
                console.log(`[Step 2] Restoring to substep ${startingSubstep} (page reload)`);
            } else if (this.previousStepNumber === 1) {
                console.log("[Step 2] Coming from Step 1, starting at substep 1");
            }
            this.currentStep2Substep = startingSubstep;
            this.totalStep2Substeps = config.total;
            this.isInStep2Substep = true;
            console.log(`[Step 2] Initialized substeps for variant '${frameChoice}': ${config.total} substeps`);
            this.updateStep2SubstepProgress();
            this.goToStep2Substep(startingSubstep);
        },
        goToStep2Substep: function(substepNumber) {
            const frameChoice = this.configuration.frameChoice;
            const config = this.step2SubstepConfig[frameChoice];
            if (!config || substepNumber < 1 || substepNumber > config.total) {
                console.warn(`[Step 2] Invalid substep number: ${substepNumber}`);
                return;
            }
            document.querySelectorAll(".step2-substep-panel").forEach(panel => {
                panel.style.display = "none";
            });
            const stageType = config.stages[substepNumber - 1];
            let panelToShow = null;
            if (stageType === "frame-details") {
                panelToShow = document.querySelector('[data-step2-substep="frame-details"]');
            } else if (stageType === "lens-type") {
                panelToShow = document.querySelector('[data-step2-substep="lens-type"]');
            } else if (stageType === "reader-power") {
                panelToShow = document.querySelector('[data-step2-substep="reader-power"]');
            } else if (stageType === "lens-features") {
                panelToShow = document.querySelector('[data-step2-substep="lens-features"]');
            } else if (stageType === "lens-material") {
                panelToShow = document.querySelector('[data-step2-substep="lens-material"]');
            } else if (stageType === "prescription") {
                panelToShow = document.querySelector('[data-step2-substep="prescription"]');
            }
            if (panelToShow) {
                panelToShow.style.display = "block";
                console.log(`[Step 2] Showing substep ${substepNumber}: ${stageType}`);
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
                const step2El = document.getElementById("step2");
                if (step2El) {
                    step2El.setAttribute("data-current-substep", stageType);
                }
                if (stageType === "reader-power") {
                    this.initializeReaderPowerPicker();
                }
                this.restoreStep2SubstepSelections(stageType);
            } else {
                console.warn(`[Step 2] Panel not found for stage type: ${stageType}`);
            }
            this.currentStep2Substep = substepNumber;
            try {
                document.dispatchEvent(new CustomEvent("configurator:substep", {
                    detail: {
                        substep: substepNumber,
                        stage: stageType,
                        variant: this.configuration.frameChoice
                    }
                }));
            } catch (e) {}
            this.updateStep2SubstepProgress();
            this.updateNavigationButtons();
            this.saveState();
        },
        nextStep2Substep: function() {
            const frameChoice = this.configuration.frameChoice;
            const config = this.step2SubstepConfig[frameChoice];
            if (!config) {
                console.error(`[Step 2] No config found for frame choice: ${frameChoice}`);
                return;
            }
            if (!this.isCurrentStep2SubstepValid()) {
                const currentStageType = config.stages[this.currentStep2Substep - 1];
                if (currentStageType === "prescription") {
                    if (this._isUploadPdMissing()) {
                        this._showUploadPdWarning();
                        console.log("[Step 2] Upload PD missing - surfacing PD warning");
                    } else if (this._isRxCertTheOnlyBlocker()) {
                        this._showRxCertWarning();
                        console.log("[Step 2] Prescription cert checkbox unchecked - surfacing cert warning");
                    } else if (!this.configuration.prescriptionSkipped && !this.configuration.prescriptionSkippedInVariantB) {
                        const variant = frameChoice === "new-frame-lenses" ? "C" : "B";
                        this.showPrescriptionErrors(variant);
                        console.log(`[Step 2] Prescription validation failed - showing errors for Variant ${variant}`);
                    }
                }
                return;
            }
            if (this.currentStep2Substep < config.total) {
                console.log(`[Step 2] Advancing to substep ${this.currentStep2Substep + 1}`);
                this.goToStep2Substep(this.currentStep2Substep + 1);
            } else {
                console.log("[Step 2] All substeps completed, advancing to Step 3");
                this.exitStep2Substeps();
                this.goToStep(3);
            }
        },
        previousStep2Substep: function() {
            if (this.currentStep2Substep > 1) {
                console.log(`[Step 2] Going back to substep ${this.currentStep2Substep - 1}`);
                this.goToStep2Substep(this.currentStep2Substep - 1);
            }
        },
        exitStep2Substeps: function() {
            console.log("[Step 2] Exiting substep system");
            if (this.currentStep2Substep) {
                this.lastStep2Substep = this.currentStep2Substep;
                console.log(`[Step 2] Saved last substep: ${this.lastStep2Substep}`);
            } else {
                console.log("[Step 2] Already exited substeps, keeping saved lastStep2Substep:", this.lastStep2Substep);
            }
            this.isInStep2Substep = false;
            this.currentStep2Substep = null;
            this.saveState();
        },
        updateStep2SubstepProgress: function() {
            const frameChoice = this.configuration.frameChoice;
            const config = this.step2SubstepConfig[frameChoice];
            if (!config) return;
            const stageName = config.names[this.currentStep2Substep - 1];
            const titleEl = document.getElementById("step2Title");
            if (titleEl && stageName) {
                titleEl.textContent = stageName;
                console.log(`[Step 2] Updated title to: ${stageName}`);
            }
        },
        restoreStep2SubstepSelections: function(stageType) {
            if (stageType === "frame-details") {
                const frameBrandInput = document.getElementById("frameBrand");
                const frameModelInput = document.getElementById("frameModel");
                if (frameBrandInput && this.configuration.frameBrand) {
                    frameBrandInput.value = this.configuration.frameBrand;
                }
                if (frameModelInput && this.configuration.frameModel) {
                    frameModelInput.value = this.configuration.frameModel;
                }
            } else if (stageType === "lens-type") {
                if (this.configuration.nativeLensType) {
                    this.selectLensType(this.configuration.nativeLensType);
                    console.log(`[Step 2] Restored lens type: ${this.configuration.nativeLensType}`);
                }
            } else if (stageType === "lens-features") {
                if (this.configuration.nativeLensFeature) {
                    this.selectLensFeature(this.configuration.nativeLensFeature);
                    console.log(`[Step 2] Restored lens feature: ${this.configuration.nativeLensFeature}`);
                }
            } else if (stageType === "lens-material") {
                if (this.configuration.nativeLensMaterial) {
                    this.selectLensMaterial(this.configuration.nativeLensMaterial);
                    console.log(`[Step 2] Restored lens material: ${this.configuration.nativeLensMaterial}`);
                }
            } else if (stageType === "prescription") {}
        },
        initializeSubStages: async function() {
            const clipType = this.configuration.clipType;
            const config = this.clipSubStageConfig[clipType];
            if (!config) {
                console.error(`No sub-stage config found for clip type: ${clipType}`);
                return;
            }
            let startingSubStage = 1;
            if (this.currentSubStage && this.currentSubStage <= config.total) {
                startingSubStage = this.currentSubStage;
                console.log(`[Step 4] Restoring to sub-stage ${startingSubStage} (page reload)`);
            }
            this.currentSubStage = startingSubStage;
            this.totalSubStages = config.total;
            this.isInSubStage = true;
            const progressEl = document.getElementById("substageProgress");
            if (progressEl) {
                progressEl.style.display = "flex";
            }
            this.updateSubStageProgress();
            await this.goToSubStage(startingSubStage);
        },
        goToSubStage: async function(subStageNumber) {
            const clipType = this.configuration.clipType;
            const config = this.clipSubStageConfig[clipType];
            if (!config || subStageNumber < 1 || subStageNumber > config.total) {
                return;
            }
            document.querySelectorAll(".selection-panel[data-substage]").forEach(panel => {
                panel.style.display = "none";
            });
            const stageType = config.stages[subStageNumber - 1];
            let panelToShow = null;
            if (stageType === "lens" || stageType === "magnification") {
                panelToShow = document.querySelector('.selection-panel[data-substage="1"]');
            } else if (stageType === "bridge") {
                panelToShow = document.querySelector('.selection-panel[data-substage="2"]');
            } else if (stageType === "magnet") {
                panelToShow = document.querySelector('.selection-panel[data-substage="3"]');
            } else if (stageType === "crystal") {
                panelToShow = document.querySelector('.selection-panel[data-substage="4"]');
            }
            if (panelToShow) {
                panelToShow.style.display = "block";
                if (stageType === "lens" || stageType === "magnification") {
                    const panelIds = [ "step4SunOptions", "step4LightSensitivityOptions", "step4MigraineOptions", "step4ReaderOptions", "step4BlueLightOptions", "step43DOptions", "step4DrivingOptions" ];
                    panelIds.forEach(id => {
                        const panel = document.getElementById(id);
                        if (panel) panel.style.display = "none";
                    });
                    this.showClipOptionsPanel(clipType);
                    if (clipType === "reader") {
                        this.initializeMagnificationPicker("reader");
                    } else if (clipType === "blueLight") {
                        this.initializeBlueLightOptions();
                    }
                } else if (stageType === "bridge") {
                    if (!document.querySelector("#bridgeColorGrid .hardware-card")) {
                        this.loadBridgeColors();
                    }
                    if (this.configuration.bridgeColor) {
                        this.selectBridgeColor(this.configuration.bridgeColor);
                    }
                } else if (stageType === "magnet") {
                    if (!document.querySelector("#magnetColorGrid .hardware-card")) {
                        this.loadMagnetColors();
                    }
                    if (this.configuration.magnetColor) {
                        this.selectMagnetColor(this.configuration.magnetColor);
                    }
                } else if (stageType === "crystal") {
                    if (!document.querySelector("#crystalGrid .crystal-wrapper")) {
                        this.loadCrystalOptions();
                    }
                    if (this.configuration.crystalColor) {
                        await this.selectCrystalColor(this.configuration.crystalColor);
                    }
                }
            }
            this.currentSubStage = subStageNumber;
            if (this.substageViewports[stageType] && this.sharedImageLayering && this.sharedImageLayering.setViewport) {
                const viewportName = this.substageViewports[stageType];
                console.log(`[Viewport] Applying substage viewport '${viewportName}' for ${stageType} (substage ${subStageNumber})`);
                this.sharedImageLayering.setViewport(viewportName);
            }
            if (window.innerWidth <= 768) {
                const selectionSection = document.querySelector(".selection-section");
                if (selectionSection) {
                    selectionSection.scrollTop = 0;
                }
            }
            this.updateSubStageProgress();
            this.updateNavigationButtons();
            this.saveState();
        },
        nextSubStage: async function() {
            const clipType = this.configuration.clipType;
            const config = this.clipSubStageConfig[clipType];
            if (this.currentSubStage < config.total) {
                await this.goToSubStage(this.currentSubStage + 1);
            } else {
                this.exitSubStages();
                if (this.isRedrillFlow) {
                    await this.addToCart();
                } else {
                    await this.goToStep(5);
                }
            }
        },
        previousSubStage: async function() {
            if (this.currentSubStage > 1) {
                await this.goToSubStage(this.currentSubStage - 1);
            }
        },
        exitSubStages: function() {
            this.isInSubStage = false;
            this.currentSubStage = null;
            const progressEl = document.getElementById("substageProgress");
            if (progressEl) {
                progressEl.style.display = "none";
            }
        },
        updateSubStageProgress: function() {
            const clipType = this.configuration.clipType;
            const config = this.clipSubStageConfig[clipType];
            if (!config) return;
            const counterEl = document.getElementById("substageCounter");
            if (counterEl) {
                counterEl.textContent = `${this.currentSubStage} of ${config.total}`;
            }
            const dotsContainer = document.getElementById("substageDots");
            if (dotsContainer) {
                dotsContainer.innerHTML = "";
                for (let i = 1; i <= config.total; i++) {
                    const dot = document.createElement("div");
                    dot.className = "substage-dot";
                    if (i < this.currentSubStage) {
                        dot.classList.add("completed");
                    } else if (i === this.currentSubStage) {
                        dot.classList.add("active");
                    }
                    dotsContainer.appendChild(dot);
                }
            }
            const stageName = config.names[this.currentSubStage - 1];
            const titleEl = document.getElementById("step4Title");
            if (titleEl && stageName) {
                titleEl.textContent = `Choose Your ${stageName}`;
            }
        },
        goToStep: async function(stepNumber) {
            if (stepNumber < 1 || stepNumber > this.totalSteps) return;
            this.isNavigating = true;
            try {
                this._syncMobileFullScreenMode(stepNumber);
                this.previousStepNumber = this.currentStep;
                this.handleStepVisibility(this.currentStep, stepNumber);
                this.currentStep = stepNumber;
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
                try {
                    document.dispatchEvent(new CustomEvent("configurator:step", {
                        detail: {
                            step: stepNumber,
                            prev: this.previousStepNumber,
                            variant: this.configuration.frameChoice,
                            lensType: this.configuration.nativeLensType,
                            clipType: this.configuration.clipType
                        }
                    }));
                } catch (e) {}
                if (stepNumber === 2) {
                    this.showStep2Variant();
                    this.initializeStep2Substeps();
                }
                if (this.previousStepNumber === 2 && stepNumber !== 2) {
                    this.exitStep2Substeps();
                }
                if (stepNumber === 3) {
                    if (this.pendingClipPreselect) {
                        await this.applyClipPreselect(this.pendingClipPreselect);
                    }
                    if (this.clipFocusMode && window.innerWidth < 769) {
                        const focusCard = document.querySelector("#step3ClipRail .lens-card.selected");
                        if (focusCard) focusCard.scrollIntoView({
                            block: "center"
                        });
                    }
                    await this.updateStep3ClipPrices();
                    if (this.isPrescriptionOnlyFlow) {
                        this.showPrescriptionOnlyOverlay();
                    }
                }
                if (stepNumber === 4) {
                    this.clearCurrentStepLayering();
                    this.initializeImageLayering();
                    await this.initializeSubStages();
                }
                if (this.previousStepNumber === 4 && stepNumber !== 4) {
                    this.exitSubStages();
                }
                this.updateProgressBar();
                this.updateNavigationButtons();
                const currentTotal = this.pricing.total || 0;
                await this.updateNavTotalCalculator(currentTotal);
                if (stepNumber >= 4 && stepNumber <= 5) {
                    this.applyStepViewport(stepNumber);
                }
                await this.initializeCurrentStep();
                if (window.innerWidth <= 768 && stepNumber >= 4) {
                    const selectionSection = document.querySelector(".selection-section");
                    if (selectionSection) {
                        selectionSection.scrollTop = 0;
                    }
                }
                if (stepNumber >= 4 && stepNumber <= 5) {
                    if (!this.sharedImageLayering) {
                        console.log("Canvas not initialized, initializing now for step", stepNumber);
                        this.initializeSharedImageLayering();
                    }
                    if (this.sharedImageLayering) {
                        setTimeout(() => {
                            this.synchronizeCanvasWithConfiguration();
                        }, 150);
                    } else {
                        console.warn("Canvas initialization failed for step", stepNumber);
                    }
                }
            } finally {
                setTimeout(() => {
                    this.isNavigating = false;
                }, 300);
            }
        },
        canNavigateToStep: function(stepNumber) {
            if (this.isReorderMode && stepNumber < 4) {
                console.log("[canNavigateToStep] Reorder mode — blocked navigation to Step", stepNumber);
                return false;
            }
            if ((this.isFrameReorderMode || this.isRedrillFlow) && stepNumber < 3) {
                console.log("[canNavigateToStep] Frame-reorder / redrill mode — blocked navigation to Step", stepNumber);
                return false;
            }
            if (this.isOpticalRetailerReorder && stepNumber < 2) {
                console.log("[canNavigateToStep] Optical-retailer reorder — blocked navigation to Step", stepNumber);
                return false;
            }
            if (stepNumber <= this.currentStep) return true;
            if (stepNumber > this.currentStep + 1) return false;
            return this.canProceedToNextStep();
        },
        handleStepVisibility: function(currentStep, newStep) {
            console.log("[handleStepVisibility] CALLED - currentStep:", currentStep, "newStep:", newStep);
            if (newStep === 5) {
                this.showPrescriptionError = false;
                this.hidePrescriptionErrorBanner();
                for (let i = 1; i <= 3; i++) {
                    const stepEl = document.getElementById(`step${i}`);
                    if (stepEl) stepEl.style.display = "none";
                }
                const configuratorWrapper = document.getElementById("configuratorWrapper");
                if (configuratorWrapper) {
                    configuratorWrapper.style.display = "block";
                }
                document.querySelectorAll(".selection-panel[data-substage]").forEach(panel => {
                    panel.style.display = "none";
                });
                const step5El = document.getElementById("step5");
                const reviewContainer = document.getElementById("reviewContentContainer");
                const reviewPanel = document.getElementById("reviewPanel");
                if (step5El && reviewContainer && reviewPanel) {
                    const fragment = document.createDocumentFragment();
                    while (step5El.firstChild) {
                        fragment.appendChild(step5El.firstChild);
                    }
                    reviewContainer.appendChild(fragment);
                    step5El.style.display = "none";
                    reviewPanel.style.display = "block";
                }
                if (this.sharedImageLayering && this.sharedImageLayering.setViewport) {
                    this.sharedImageLayering.setViewport("full");
                }
                const self = this;
                setTimeout(async () => {
                    console.log("[CODE VERSION] Step 5 - Fixed total calculation (2025-11-13)");
                    console.log("[Step 5] Populating review summary with configuration:", self.configuration);
                    await self.updateSummaryDisplay();
                    self.updatePricingSummaryDebounced(300);
                    self.setupStep5Collapsibles();
                }, 100);
                console.log("[Step Visibility] Showing Step 5 (Review) in configurator layout");
                return;
            }
            if (currentStep === 5) {
                const step5El = document.getElementById("step5");
                const reviewContainer = document.getElementById("reviewContentContainer");
                const reviewPanel = document.getElementById("reviewPanel");
                if (step5El && reviewContainer && reviewPanel) {
                    const fragment = document.createDocumentFragment();
                    while (reviewContainer.firstChild) {
                        fragment.appendChild(reviewContainer.firstChild);
                    }
                    step5El.appendChild(fragment);
                    reviewPanel.style.display = "none";
                }
            }
            const isCurrentConfigurator = currentStep >= 4 && currentStep <= 5;
            const isNewConfigurator = newStep >= 4 && newStep <= 5;
            if (currentStep === newStep && newStep <= 3 && !this.isInitializing) {
                console.log("[BUG #26 FIX TRIGGERED] Already on step", newStep, "- skipping ALL visibility changes to preserve event listeners");
                return;
            }
            if (currentStep === newStep) {
                for (let i = 1; i <= 3; i++) {
                    const stepEl = document.getElementById(`step${i}`);
                    if (stepEl) {
                        stepEl.style.display = "none";
                    }
                }
                const step1SubContent = document.getElementById("step1SubContent");
                if (step1SubContent) {
                    step1SubContent.style.display = "none";
                    step1SubContent.classList.remove("active");
                }
                const configuratorWrapper = document.getElementById("configuratorWrapper");
                if (newStep <= 3) {
                    if (configuratorWrapper) {
                        configuratorWrapper.style.display = "none";
                    }
                    const newStepEl = document.getElementById(`step${newStep}`);
                    if (newStepEl) {
                        newStepEl.style.display = "block";
                    }
                } else {
                    if (configuratorWrapper) {
                        configuratorWrapper.style.display = "block";
                        this.switchConfiguratorPanel(newStep);
                    }
                }
                return;
            }
            if (currentStep === 1 && newStep !== 1) {
                const step1SubContent = document.getElementById("step1SubContent");
                if (step1SubContent) {
                    step1SubContent.style.display = "none";
                    step1SubContent.classList.remove("active");
                }
                const step1MainContent = document.querySelector("#step1 .step-content.dynamic-split");
                if (step1MainContent) {
                    step1MainContent.style.display = "flex";
                }
            }
            for (let i = 1; i <= 3; i++) {
                if (i === newStep) continue;
                const stepEl = document.getElementById(`step${i}`);
                if (stepEl && stepEl.style.display !== "none") {
                    console.log("[handleStepVisibility] Hiding Step", i);
                    stepEl.style.display = "none";
                }
            }
            if (!isNewConfigurator) {
                const newStepEl = document.getElementById(`step${newStep}`);
                if (newStepEl) {
                    console.log("[handleStepVisibility] Showing Step", newStep);
                    newStepEl.style.display = "block";
                } else {
                    console.warn("[handleStepVisibility] Could not find element for Step", newStep);
                }
            }
            const configuratorWrapper = document.getElementById("configuratorWrapper");
            if (configuratorWrapper) {
                if (isNewConfigurator) {
                    configuratorWrapper.style.display = "block";
                    this.switchConfiguratorPanel(newStep);
                } else if (isCurrentConfigurator && !isNewConfigurator) {
                    configuratorWrapper.style.display = "none";
                }
            }
        },
        switchConfiguratorPanel: function(stepNumber) {
            if (stepNumber < 4 || stepNumber > 5) return;
            document.querySelectorAll(".configurator-view .selection-panel").forEach(panel => {
                panel.classList.remove("active");
                panel.style.display = "none";
            });
            const targetPanel = document.querySelector(`.configurator-view .selection-panel[data-step="${stepNumber}"]`);
            if (targetPanel) {
                targetPanel.classList.add("active");
                targetPanel.style.display = "block";
                console.log(`Switched to configurator panel for step ${stepNumber}`);
            } else if (stepNumber <= 3) {
                console.warn(`Panel for step ${stepNumber} not found`);
            }
        },
        canProceedToNextStep: function() {
            switch (this.currentStep) {
              case 1:
                return this.isStep1Valid();

              case 2:
                return this.isStep2Valid();

              case 3:
                return this.isStep3Valid();

              case 4:
                return this.isStep4Valid();

              case 5:
                return false;

              default:
                return false;
            }
        },
        isStep1Valid: function() {
            return this.configuration.frameChoice !== null;
        },
        isStep2Valid: function() {
            if (this.isInStep2Substep) {
                return this.isCurrentStep2SubstepValid();
            }
            const isValid = this.validateStep2();
            if (!isValid) {
                console.log("Step 2 validation failed - check frame/prescription data");
            }
            return isValid;
        },
        isCurrentStep2SubstepValid: function() {
            if (!this.isInStep2Substep || !this.currentStep2Substep) {
                return false;
            }
            const frameChoice = this.configuration.frameChoice;
            const config = this.step2SubstepConfig[frameChoice];
            if (!config) {
                console.error("[Step 2 Validation] No config found for frame choice:", frameChoice);
                return false;
            }
            const currentStageType = config.stages[this.currentStep2Substep - 1];
            console.log(`[Step 2 Validation] Validating substep ${this.currentStep2Substep}: ${currentStageType}`);
            switch (currentStageType) {
              case "frame-details":
                const brandInput = document.getElementById("frameBrand");
                const modelInput = document.getElementById("frameModel");
                const brand = brandInput?.value.trim();
                const model = modelInput?.value.trim();
                const isValid = !!(brand && model);
                if (isValid) {
                    this.configuration.frameBrand = brand;
                    this.configuration.frameModel = model;
                    console.log("[Frame Details] ✅ Valid - Brand:", brand, "Model:", model);
                } else {
                    console.log("[Frame Details] ❌ Invalid - Missing brand or model");
                }
                return isValid;

              case "lens-type":
                const hasLensType = !!this.configuration.nativeLensType;
                console.log("[Lens Type] Valid:", hasLensType, "Value:", this.configuration.nativeLensType);
                return hasLensType;

              case "reader-power":
                const hasReaderPower = !!this.configuration.readerPower;
                console.log("[Reader Power] Valid:", hasReaderPower, "Value:", this.configuration.readerPower);
                return hasReaderPower;

              case "lens-features":
                const hasLensFeature = !!this.configuration.nativeLensFeature;
                console.log("[Lens Features] Valid:", hasLensFeature, "Value:", this.configuration.nativeLensFeature);
                return hasLensFeature;

              case "lens-material":
                const hasLensMaterial = !!this.configuration.nativeLensMaterial;
                console.log("[Lens Material] Valid:", hasLensMaterial, "Value:", this.configuration.nativeLensMaterial);
                return hasLensMaterial;

              case "prescription":
                if (this.configuration.prescriptionMethod === "upload") {
                    if (!(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token)) {
                        console.log("[Prescription] ❌ Invalid - Upload method but no file staged");
                        return false;
                    }
                    const uploadPd = this._readUploadPd();
                    if (!uploadPd.pdValid) {
                        this.configuration.uploadPd = null;
                        console.log("[Prescription] ❌ Invalid - Upload method but PD not filled");
                        return false;
                    }
                    this.configuration.uploadPd = uploadPd.pdData;
                    if (!this.configuration.rxCertifiedAt) {
                        console.log("[Prescription] ❌ Invalid - File uploaded but cert checkbox unchecked");
                        return false;
                    }
                    console.log("[Prescription] ✅ Valid - File uploaded + PD + certified");
                    return true;
                }
                if (this.configuration.prescriptionMethod === "later") {
                    if (this.configuration.prescriptionSendLater) {
                        console.log('[Prescription] ✅ Valid - "I Understand" acknowledged (send later)');
                        return true;
                    }
                    console.log("[Prescription] ❌ Invalid - Later method not acknowledged");
                    return false;
                }
                if (this.configuration.prescriptionSkipped || this.configuration.prescriptionSkippedInVariantB) {
                    console.log("[Prescription] ✅ Valid - Skipped (legacy flag)");
                    return true;
                }
                const odSphere = document.getElementById("odSphere")?.value.trim() || "";
                const odCylinder = document.getElementById("odCylinder")?.value.trim() || "";
                const odAxis = document.getElementById("odAxis")?.value.trim() || "";
                const odAdd = document.getElementById("odAdd")?.value.trim() || "";
                const osSphere = document.getElementById("osSphere")?.value.trim() || "";
                const osCylinder = document.getElementById("osCylinder")?.value.trim() || "";
                const osAxis = document.getElementById("osAxis")?.value.trim() || "";
                const osAdd = document.getElementById("osAdd")?.value.trim() || "";
                const dualPdToggle = document.getElementById("dualPdToggle");
                const isDualMode = dualPdToggle?.checked || false;
                let pdData;
                let pdValid = false;
                if (isDualMode) {
                    const pdLeft = document.getElementById("pdLeft")?.value.trim();
                    const pdRight = document.getElementById("pdRight")?.value.trim();
                    pdData = {
                        mode: "dual",
                        value: null,
                        left: pdLeft || null,
                        right: pdRight || null
                    };
                    pdValid = !!(pdLeft && pdRight);
                } else {
                    const pdSingle = document.getElementById("pd")?.value.trim();
                    pdData = {
                        mode: "single",
                        value: pdSingle || null,
                        left: null,
                        right: null
                    };
                    pdValid = !!pdSingle;
                }
                const allOdFieldsFilled = odSphere !== "" && odCylinder !== "" && odAxis !== "" && odAdd !== "";
                const allOsFieldsFilled = osSphere !== "" && osCylinder !== "" && osAxis !== "" && osAdd !== "";
                const hasPrescription = allOdFieldsFilled && allOsFieldsFilled && pdValid;
                if (hasPrescription) {
                    const rxNotesGeneric = document.getElementById("rxNotes")?.value.trim() || "";
                    this.configuration.prescription = {
                        od: {
                            sphere: odSphere,
                            cylinder: odCylinder,
                            axis: odAxis,
                            add: odAdd
                        },
                        os: {
                            sphere: osSphere,
                            cylinder: osCylinder,
                            axis: osAxis,
                            add: osAdd
                        },
                        pd: pdData,
                        notes: rxNotesGeneric
                    };
                    this.configuration.prescriptionSkipped = false;
                    this.configuration.prescriptionSkippedInVariantB = false;
                    if (!this.configuration.rxCertifiedAt) {
                        console.log("[Prescription] ❌ Invalid - Fields filled but cert checkbox unchecked");
                        return false;
                    }
                    console.log("[Prescription] ✅ Valid - Filled + certified (PD mode:", pdData.mode + ")");
                } else {
                    console.log("[Prescription] ❌ Invalid - Not all fields filled (all required, can be 0)");
                }
                return hasPrescription;

              default:
                console.error(`[Step 2 Validation] Unknown substep type: ${currentStageType}`);
                return false;
            }
        },
        isStep3Valid: function() {
            const isValid = !!this.configuration.clipType;
            if (!isValid) {
                console.log("Step 3 validation failed - no clip type selected");
            }
            return isValid;
        },
        isStep4Valid: function() {
            if (this.isInSubStage) {
                return this.isCurrentSubStageValid();
            }
            const clipType = this.configuration.clipType;
            const hasBasicHardware = this.configuration.bridgeColor && this.configuration.magnetColor;
            if (!hasBasicHardware) {
                console.log("Step 4 validation failed - missing bridge or magnet selection");
                return false;
            }
            let isValid = false;
            switch (clipType) {
              case "sun":
                isValid = !!(this.configuration.lensCategory && this.configuration.lensColor);
                if (!isValid) {
                    console.log("Step 4 validation failed (Sun) - missing lens category or color");
                }
                break;

              case "reader":
                isValid = !!this.configuration.magnification;
                if (!isValid) {
                    console.log("Step 4 validation failed (Reader) - missing magnification");
                }
                break;

              case "blueLight":
                isValid = this.configuration.magnification !== null && this.configuration.magnification !== undefined;
                if (!isValid) {
                    console.log("Step 4 validation failed (Blue Light) - missing magnification");
                }
                break;

              case "lightSensitivity":
                isValid = !!this.configuration.lightSensitivityIntensity;
                if (!isValid) {
                    console.log("Step 4 validation failed (Light Sensitivity) - missing FL-41 intensity");
                }
                break;

              case "migraine":
              case "3d":
              case "driving":
                isValid = true;
                break;

              default:
                console.log(`Step 4 validation failed - unknown clip type: ${clipType}`);
                isValid = false;
            }
            return isValid;
        },
        isCurrentSubStageValid: function() {
            if (!this.isInSubStage || !this.currentSubStage) {
                return false;
            }
            const clipType = this.configuration.clipType;
            const config = this.clipSubStageConfig[clipType];
            if (!config) return false;
            const currentStageType = config.stages[this.currentSubStage - 1];
            switch (currentStageType) {
              case "lens":
                if (clipType === "sun") {
                    return !!(this.configuration.lensCategory && this.configuration.lensColor);
                } else if (clipType === "therapeutic") {
                    const therapType = this.configuration.therapeuticType;
                    const needsIntensity = therapType === "fl41";
                    return !!(therapType && (!needsIntensity || this.configuration.therapeuticIntensity));
                } else if (clipType === "lightSensitivity") {
                    return !!this.configuration.lightSensitivityIntensity;
                } else if (clipType === "migraine" || clipType === "3d" || clipType === "driving") {
                    return true;
                }
                return false;

              case "magnification":
                if (clipType === "reader") {
                    return !!this.configuration.magnification;
                } else if (clipType === "blueLight") {
                    return this.configuration.magnification !== null && this.configuration.magnification !== undefined;
                }
                return false;

              case "bridge":
                return !!this.configuration.bridgeColor;

              case "magnet":
                return !!this.configuration.magnetColor;

              case "crystal":
                return true;

              default:
                console.log(`Unknown substage type: ${currentStageType}`);
                return false;
            }
        },
        isStep5Valid: function() {
            return true;
        },
        initializeCurrentStep: async function() {
            switch (this.currentStep) {
              case 2:
                this.initializeStep2();
                break;

              case 4:
                this.initializeStep4();
                break;

              case 5:
                await this.initializeStep5();
                break;
            }
        },
        initializeStep2: function() {
            if (this.configuration.useExistingLenses === true) {
                this.setupIdentificationMode();
            } else {
                this.setupPurchaseMode();
            }
            const accordion = document.querySelector(".lens-type-accordion");
            if (accordion && accordion.children.length === 0) {
                this.renderNativeLensAccordion();
            }
        },
        setupIdentificationMode: function() {
            const headerH2 = document.querySelector("#step2 .step-header-container h2");
            const headerP = document.querySelector("#step2 .step-header-container p");
            if (headerH2) headerH2.textContent = "What Type of Lenses Are in Your Frame?";
            if (headerP) headerP.textContent = "Help us identify your current lenses to find compatible clip options";
            document.querySelectorAll("#step2 .choice-price").forEach(price => {
                price.style.display = "none";
            });
            const descriptions = {
                "frame-only": "My frame has no lenses (empty frame)",
                readers: "I have reading/magnification lenses",
                "blue-light": "I have blue light blocking lenses",
                sun: "I have tinted/sun lenses (non-prescription)",
                "clear-rx": "I have clear prescription lenses",
                "sun-rx": "I have prescription sun lenses"
            };
            Object.keys(descriptions).forEach(type => {
                const card = document.querySelector(`[data-lens-type="${type}"] p`);
                if (card) card.textContent = descriptions[type];
            });
            document.body.classList.add("identification-mode");
        },
        setupPurchaseMode: function() {
            document.querySelectorAll("#step2 .choice-price").forEach(price => {
                price.style.display = "block";
            });
            const descriptions = {
                "frame-only": "No prescription lenses, just the frame",
                readers: "Magnification lenses for reading",
                "blue-light": "Digital eye strain protection",
                sun: "UV protection with style",
                "clear-rx": "Prescription lenses",
                "sun-rx": "Prescription sun lenses"
            };
            Object.keys(descriptions).forEach(type => {
                const card = document.querySelector(`[data-lens-type="${type}"] p`);
                if (card) card.textContent = descriptions[type];
            });
            document.body.classList.remove("identification-mode");
        },
        renderNativeLensAccordion: function() {
            const accordion = document.querySelector(".lens-type-accordion");
            if (!accordion) return;
            const self = this;
            Object.entries(this.nativeLensTypes).forEach(([type, info]) => {
                const item = document.createElement("div");
                item.className = "lens-type-item";
                item.innerHTML = `\n                    <div class="lens-type-header" data-lens-type="${type}">\n                        <div class="lens-type-info">\n                            <h4>${info.name}</h4>\n                            <p>Professional quality lenses</p>\n                        </div>\n                        <div class="lens-type-price">+$${info.price}</div>\n                        <div class="expand-icon">▼</div>\n                    </div>\n                    <div class="lens-type-content">\n                        <p>Configure your ${info.name.toLowerCase()} options here.</p>\n                        <button class="select-lens-type" data-lens-type="${type}">\n                            Select ${info.name}\n                        </button>\n                    </div>\n                `;
                const selectBtn = item.querySelector(".select-lens-type");
                selectBtn.addEventListener("click", async () => {
                    await self.selectNativeLensType(type);
                });
                accordion.appendChild(item);
            });
            this.setupStep2Events();
        },
        selectNativeLensType: async function(type) {
            this.configuration.nativeLensType = type;
            this.pricing.nativeLenses = this.nativeLensTypes[type].price;
            document.querySelectorAll(".lens-type-item").forEach(item => {
                item.classList.remove("selected");
            });
            document.querySelector(`[data-lens-type="${type}"]`).closest(".lens-type-item").classList.add("selected");
            await this.calculateTotalPrice();
            this.updateNavigationButtons();
            this.saveState();
        },
        getNativeLensPrice: function(lensType, lensFeature, lensMaterial) {
            if (!lensType) return 0;
            let priceKey = "";
            if (lensType === "readers") {
                priceKey = "readers";
            } else if (lensType === "non-rx") {
                priceKey = "non_rx";
            } else if (lensType === "single-vision") {
                priceKey = "single_vision";
            } else if (lensType === "progressive") {
                priceKey = "progressive";
            }
            if (lensFeature === "blue-light") {
                priceKey += "_blue_light";
            }
            if (lensType === "single-vision" || lensType === "progressive") {
                if (lensMaterial === "high-index-160") {
                    priceKey += "_hi_160";
                } else if (lensMaterial === "high-index-167") {
                    priceKey += "_hi_167";
                }
            }
            if (this.configuration.frameChoice === "own-frame-new-lenses") {
                priceKey += "_variant_b";
                console.log("[getNativeLensPrice] Variant B pricing applied:", priceKey);
            }
            const price = window.chemistrie_prices?.[priceKey] || 0;
            console.log(`[Native Lens Price] ${lensType} + ${lensFeature} + ${lensMaterial} = ${priceKey} = $${price}`);
            return price;
        },
        calculateTotalPrice: async function() {
            console.log("[calculateTotalPrice] ========== START CALCULATION ==========");
            let total = 0;
            if (this.isRedrillFlow) {
                total += this.redrillPrice || 0;
                this.pricing.redrill = this.redrillPrice || 0;
            }
            if (this.configuration.isPrescriptionOnlyOrder) {
                console.log("[calculateTotalPrice] Prescription-only order - calculating without clips");
                const frameHandle = this.configuration.frameProduct;
                if (frameHandle) {
                    let frameData = window.chemistrie_products?.frames?.[frameHandle];
                    if (!frameData) {
                        frameData = await this.fetchFrameData(frameHandle);
                    }
                    if (frameData) {
                        const framePrice = frameData.price / 100;
                        total += framePrice;
                        this.pricing.frame = framePrice;
                        console.log("[calculateTotalPrice] Frame price:", framePrice);
                    }
                }
                const lensBreakdown = await this.getNativeLensBreakdown();
                const lensType = this.configuration.nativeLensType;
                let upgradePrice = 0;
                if (lensType === "single-vision") {
                    upgradePrice = lensBreakdown.lensMaterial.price + lensBreakdown.blueLight.price;
                } else if (lensType === "progressive") {
                    upgradePrice = lensBreakdown.prescriptionType.price + lensBreakdown.lensMaterial.price + lensBreakdown.blueLight.price;
                }
                total += upgradePrice;
                this.pricing.nativeLenses = upgradePrice;
                console.log("[calculateTotalPrice] Lens upgrade calculation:", {
                    lensType: lensType,
                    breakdown: lensBreakdown,
                    upgradePrice: upgradePrice,
                    note: "Single Vision is FREE with frame purchase"
                });
                this.pricing.clip = 0;
                this.pricing.hardware = 0;
                this.pricing.crystals = 0;
                this.pricing.secondClip = 0;
                const accessoriesTotal = this.configuration.accessories.reduce((sum, acc) => sum + (acc.price || 0) / 100, 0);
                total += accessoriesTotal;
                this.pricing.accessories = accessoriesTotal;
                console.log("[calculateTotalPrice] Prescription-only accessories:", accessoriesTotal);
                this.pricing.total = total;
                console.log("[calculateTotalPrice] Prescription-only total:", total);
                return total;
            }
            const excludeId = this.isEditingConfig ? this.editConfigId : null;
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel, excludeId);
            this._lastExistingClipsCheck = existingClips;
            let framePrice = 0;
            if (this.configuration.frameChoice === "new-frame-lenses" && this.configuration.frameProduct) {
                let frameData = window.chemistrie_products?.frames?.[this.configuration.frameProduct];
                if (!frameData) {
                    console.log("[calculateTotalPrice] Frame data not loaded, fetching...");
                    frameData = await this.fetchFrameData(this.configuration.frameProduct);
                }
                if (frameData && frameData.price) {
                    framePrice = frameData.price / 100;
                    console.log("[calculateTotalPrice] Frame price (Variant C):", {
                        frameHandle: this.configuration.frameProduct,
                        priceInCents: frameData.price,
                        priceInDollars: framePrice
                    });
                } else {
                    console.warn("[calculateTotalPrice] Frame data not found for:", this.configuration.frameProduct);
                    framePrice = 95;
                }
            } else {
                framePrice = 0;
            }
            const hasClipForSameFrame = existingClips.length >= 1;
            const shouldApplyDiscountForFrame = this.isBuilding2ndClip || hasClipForSameFrame || this.isReorderMode;
            if (!shouldApplyDiscountForFrame) {
                total += framePrice;
                console.log("[calculateTotalPrice] Frame price:", framePrice);
            } else {
                console.log("[calculateTotalPrice] Frame price: $0 (2nd clip - customer already has frame)");
            }
            if (this.configuration.nativeLensType && (this.configuration.frameChoice === "own-frame-new-lenses" || this.configuration.frameChoice === "new-frame-lenses")) {
                let nativeLensPrice = 0;
                const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isReorderMode;
                const isInStep2BeforeClipSelection = this.currentStep === 2 || this.currentStep === 1 && !this.configuration.clipType;
                if (shouldApplyDiscount && !isInStep2BeforeClipSelection) {
                    nativeLensPrice = 0;
                    console.log("[Price Calculation] Native Lens: $0 (2nd clip - customer already has lenses for this frame)");
                } else if (shouldApplyDiscount && isInStep2BeforeClipSelection) {
                    nativeLensPrice = this.getNativeLensPrice(this.configuration.nativeLensType, this.configuration.nativeLensFeature, this.configuration.nativeLensMaterial);
                    console.log("[Price Calculation] Native Lens (Step 2 preview):", nativeLensPrice, "(will be $0 at checkout for 2nd clip)");
                } else {
                    const isIncludedFlow = this.configuration.frameChoice === "new-frame-lenses";
                    if (isIncludedFlow) {
                        const lensBreakdown = await this.getNativeLensBreakdown();
                        nativeLensPrice = lensBreakdown.total;
                        console.log("[Price Calculation] Native Lens (Included flow):", nativeLensPrice, {
                            breakdown: lensBreakdown,
                            note: "Single Vision is FREE with frame purchase, only upgrades charged"
                        });
                    } else {
                        nativeLensPrice = this.getNativeLensPrice(this.configuration.nativeLensType, this.configuration.nativeLensFeature, this.configuration.nativeLensMaterial);
                        console.log("[Price Calculation] Native Lens:", nativeLensPrice);
                    }
                }
                total += nativeLensPrice;
            }
            if (this.isBuilding2ndClip && existingClips.length === 0 && !this.isFrameReorderMode && !this.isOpticalRetailerReorder) {
                console.warn("[calculateTotalPrice] isBuilding2ndClip is true but cart has no clips for this frame - resetting stale flag");
                this.isBuilding2ndClip = false;
                this._secondClipStartTime = null;
                this.saveState();
            }
            const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isReorderMode || this.isOpticalRetailerReorder || this.isRedrillFlow;
            let clipBasePrice = 0;
            if (this.configuration.clipType) {
                if (this.configuration.clipType === "lightSensitivity" && this.configuration.lightSensitivityColor) {
                    const lensOption = this.therapeuticLensPricing[this.configuration.lightSensitivityColor];
                    const fullPrice = lensOption ? lensOption.price : 175;
                    clipBasePrice = shouldApplyDiscount ? fullPrice - 80 : fullPrice;
                } else if (this.configuration.clipType === "migraine") {
                    const fullPrice = window.chemistrie_prices?.clip_migraine || 495;
                    clipBasePrice = fullPrice;
                } else {
                    const fullPrice = this.clipTypes[this.configuration.clipType]?.price || 0;
                    clipBasePrice = shouldApplyDiscount ? fullPrice - 80 : fullPrice;
                }
            }
            console.log("[Price Calculation] 2nd Clip Discount Check:", {
                frameProduct: this.configuration.frameProduct,
                frameBrand: this.configuration.frameBrand,
                frameModel: this.configuration.frameModel,
                existingClipsCount: existingClips.length,
                isBuilding2ndClip: this.isBuilding2ndClip,
                shouldApplyDiscount: shouldApplyDiscount,
                clipBasePrice: clipBasePrice,
                clipType: this.configuration.clipType,
                hasClipTypeSelected: !!this.configuration.clipType
            });
            total += clipBasePrice;
            this.pricing.clip = clipBasePrice;
            console.log("[calculateTotalPrice] After clip:", total, "(clipBasePrice:", clipBasePrice, ")");
            const hardwarePrice = this.pricing.hardware || 0;
            const bridgePrice = this.pricing.bridge || 0;
            const magnetPrice = this.pricing.magnet || 0;
            const crystalsPrice = this.pricing.crystals || 0;
            total += hardwarePrice;
            total += bridgePrice;
            total += magnetPrice;
            total += crystalsPrice;
            console.log("[calculateTotalPrice] After hardware+crystals+bridge+magnet:", total, "(hardware:", hardwarePrice, "bridge:", bridgePrice, "magnet:", magnetPrice, "crystals:", crystalsPrice, ")");
            if (this.configuration.addSecondClip && this.configuration.secondClip) {
                const secondClipPrice = this.clipTypes[this.configuration.secondClip.type]?.price || 0;
                total += secondClipPrice * .8;
            }
            const accessoriesTotal = this.configuration.accessories.reduce((sum, acc) => sum + (acc.price || 0) / 100, 0);
            total += accessoriesTotal;
            console.log("[calculateTotalPrice] After accessories:", total, "(accessories:", accessoriesTotal, ")");
            if (isNaN(total)) {
                console.error("[calculateTotalPrice] ❌ TOTAL IS NaN! Diagnostic info:", {
                    framePrice: framePrice,
                    clipBasePrice: clipBasePrice,
                    hardwarePrice: hardwarePrice,
                    crystalsPrice: crystalsPrice,
                    accessoriesTotal: accessoriesTotal,
                    pricingObject: JSON.stringify(this.pricing),
                    configClipType: this.configuration.clipType,
                    clipTypesAvailable: Object.keys(this.clipTypes || {}),
                    hasClipForSameFrame: existingClips.length >= 1,
                    shouldApplyDiscount: this.isBuilding2ndClip || existingClips.length >= 1
                });
                total = 0;
            }
            this.pricing.total = total;
            console.log("[calculateTotalPrice] ========== FINAL TOTAL:", total, "==========");
            await this.updateNavTotalCalculator(total);
            return total;
        },
        updateOrderSummary: function() {
            const summaryItems = document.getElementById("orderSummaryItems");
            const totalEl = document.getElementById("orderTotal");
            if (!summaryItems || !totalEl) return;
            summaryItems.innerHTML = "";
            if (this.configuration.frameChoice) {
                this.addSummaryItem(summaryItems, this.configuration.frameChoice === "own-frame" ? "Your Frame" : "Chemistrie Frame", this.pricing.frame);
            }
            if (this.configuration.nativeLensType) {
                this.addSummaryItem(summaryItems, this.nativeLensTypes[this.configuration.nativeLensType].name, this.pricing.nativeLenses);
            }
            if (this.configuration.clipType) {
                this.addSummaryItem(summaryItems, `${this.clipTypes[this.configuration.clipType].name} Clip`, this.clipTypes[this.configuration.clipType].price);
            }
            if (this.configuration.addSecondClip && this.configuration.secondClip) {
                const secondClipPrice = this.clipTypes[this.configuration.secondClip.type].price;
                this.addSummaryItem(summaryItems, `2nd ${this.clipTypes[this.configuration.secondClip.type].name} Clip (20% off)`, secondClipPrice * .8);
            }
            this.configuration.accessories.forEach(accessory => {
                this.addSummaryItem(summaryItems, accessory.name, (accessory.price || 0) / 100);
            });
            totalEl.textContent = this.formatPrice(this.pricing.total);
            this.updateNavTotalCalculator(this.pricing.total);
        },
        addSummaryItem: function(container, name, price) {
            const item = document.createElement("div");
            item.className = "summary-item";
            const nameEl = document.createElement("span");
            nameEl.className = "item-name";
            nameEl.textContent = name;
            const priceEl = document.createElement("span");
            priceEl.className = "item-price";
            priceEl.textContent = this.formatPrice(price);
            item.appendChild(nameEl);
            item.appendChild(priceEl);
            container.appendChild(item);
        },
        updateProgressBar: function() {
            document.querySelectorAll(".progress-step").forEach(step => {
                const stepNum = parseInt(step.dataset.step);
                step.classList.toggle("active", stepNum === this.currentStep);
                step.classList.toggle("completed", stepNum < this.currentStep);
                const lockReorder = this.isReorderMode && stepNum < 4;
                const lockFrameReorder = this.isFrameReorderMode && stepNum < 3;
                const lockOpticalRetailerReorder = this.isOpticalRetailerReorder && stepNum < 2;
                const lockRedrill = this.isRedrillFlow && stepNum < 3;
                if (lockReorder || lockFrameReorder || lockOpticalRetailerReorder || lockRedrill) {
                    step.style.pointerEvents = "none";
                    step.style.opacity = "0.5";
                } else {
                    step.style.pointerEvents = "";
                    step.style.opacity = "";
                }
            });
        },
        updateNavigationButtons: function() {
            const prevBtn = document.getElementById("prevStepBtn");
            const nextBtn = document.getElementById("nextStepBtn");
            const addToCartBtn = document.getElementById("addToCartBtn");
            const saveProgressBtn = document.getElementById("saveProgressBtn");
            if (prevBtn) {
                let showPrevious = this.currentStep > 1 || this.currentStep === 1 && this.isInSubStep && this.currentSubStep === 1.5;
                if (this.isReorderMode && this.currentStep === 4 && (!this.isInSubStage || this.currentSubStage <= 1)) {
                    showPrevious = false;
                }
                if ((this.isFrameReorderMode || this.isRedrillFlow) && this.currentStep === 3) {
                    showPrevious = false;
                }
                prevBtn.style.display = showPrevious ? "block" : "none";
            }
            const redrillSubStageTotal = (this.clipSubStageConfig[this.configuration.clipType] || {}).total || 4;
            const onLastRedrillSubStage = this.isRedrillFlow && this.currentStep === 4 && this.isInSubStage && this.currentSubStage >= redrillSubStageTotal;
            if (nextBtn) {
                if (this.currentStep === this.totalSteps || onLastRedrillSubStage) {
                    nextBtn.style.display = "none";
                } else {
                    nextBtn.style.display = "block";
                    let canProceed = this.canProceedToNextStep();
                    if (!canProceed && this.currentStep === 2 && this.isInStep2Substep) {
                        const cfg = this.step2SubstepConfig && this.step2SubstepConfig[this.configuration.frameChoice];
                        const onPrescriptionSubstep = cfg && cfg.stages && cfg.stages[this.currentStep2Substep - 1] === "prescription";
                        if (onPrescriptionSubstep && (typeof this._isRxCertTheOnlyBlocker === "function" && this._isRxCertTheOnlyBlocker() || typeof this._isUploadPdMissing === "function" && this._isUploadPdMissing())) {
                            canProceed = true;
                        }
                    }
                    nextBtn.disabled = !canProceed;
                }
            }
            if (addToCartBtn) {
                addToCartBtn.style.display = this.currentStep === this.totalSteps || onLastRedrillSubStage ? "block" : "none";
            }
            if (saveProgressBtn) {
                const substepCfg = this.step2SubstepConfig[this.configuration.frameChoice];
                const lensTypeIdx = substepCfg && substepCfg.stages ? substepCfg.stages.indexOf("lens-type") : -1;
                const reachedLensType = lensTypeIdx !== -1 && this.currentStep2Substep >= lensTypeIdx + 1;
                const showSave = this.currentStep > 2 || this.currentStep === 2 && this.isInStep2Substep && reachedLensType;
                saveProgressBtn.style.display = showSave ? "block" : "none";
            }
        },
        updateLensTypeCardPrices: function() {
            const frameChoice = this.configuration.frameChoice;
            const isVariantB = frameChoice === "own-frame-new-lenses";
            const isVariantC = frameChoice === "new-frame-lenses";
            const isPrescriptionOnly = this.configuration.isPrescriptionOnlyOrder;
            const isIncludedFlow = isVariantC || isPrescriptionOnly;
            let singleVisionPrice, progressivePrice, nonRxPrice, readersPrice;
            if (isVariantB) {
                singleVisionPrice = window.chemistrie_prices?.single_vision_variant_b || 75;
                progressivePrice = window.chemistrie_prices?.progressive_variant_b || 195;
                nonRxPrice = window.chemistrie_prices?.non_rx_variant_b || 75;
                readersPrice = window.chemistrie_prices?.readers_variant_b || 75;
            } else if (isIncludedFlow) {
                const fullProgressivePrice = window.chemistrie_prices?.progressive || 225;
                const fullSingleVisionPrice = window.chemistrie_prices?.single_vision || 95;
                singleVisionPrice = 0;
                progressivePrice = fullProgressivePrice - fullSingleVisionPrice;
                nonRxPrice = 0;
                readersPrice = 0;
            } else {
                singleVisionPrice = window.chemistrie_prices?.single_vision || 95;
                progressivePrice = window.chemistrie_prices?.progressive || 225;
                nonRxPrice = window.chemistrie_prices?.non_rx || 95;
                readersPrice = window.chemistrie_prices?.readers || 95;
            }
            const svCard = document.getElementById("singleVisionCardPrice");
            if (svCard) {
                if (isIncludedFlow && singleVisionPrice === 0) {
                    svCard.textContent = "Included";
                } else {
                    svCard.textContent = "$" + singleVisionPrice;
                }
            }
            const progCard = document.getElementById("progressiveCardPrice");
            if (progCard) {
                if (isIncludedFlow) {
                    progCard.textContent = "+$" + progressivePrice;
                } else {
                    progCard.textContent = "$" + progressivePrice;
                }
            }
            const nonRxCard = document.getElementById("nonRxCardPrice");
            if (nonRxCard) {
                if (isIncludedFlow && nonRxPrice === 0) {
                    nonRxCard.textContent = "Included";
                } else {
                    nonRxCard.textContent = "$" + nonRxPrice;
                }
            }
            const readersCard = document.getElementById("readersCardPrice");
            if (readersCard) {
                if (isIncludedFlow && readersPrice === 0) {
                    readersCard.textContent = "Included";
                } else {
                    readersCard.textContent = "$" + readersPrice;
                }
            }
            console.log("[updateLensTypeCardPrices] Updated prices:", {
                frameChoice: frameChoice,
                isVariantB: isVariantB,
                isIncludedFlow: isIncludedFlow,
                singleVisionPrice: isIncludedFlow && singleVisionPrice === 0 ? "Included" : "$" + singleVisionPrice,
                progressivePrice: isIncludedFlow ? "+$" + progressivePrice : "$" + progressivePrice,
                nonRxPrice: isIncludedFlow && nonRxPrice === 0 ? "Included" : "$" + nonRxPrice,
                readersPrice: isIncludedFlow && readersPrice === 0 ? "Included" : "$" + readersPrice
            });
        },
        storeOrderDataForThankYou: function() {
            try {
                const orderData = {
                    clipType: this.configuration.clipType || "Unknown",
                    frameChoice: this.configuration.frameChoice || "",
                    frameBrand: this.configuration.frameBrand || "",
                    frameModel: this.configuration.frameModel || "",
                    frameProduct: this.configuration.frameProduct || "",
                    lensType: this.configuration.lensType || "",
                    lensColor: this.configuration.lensColor || "",
                    upgrades: this.configuration.upgrades || [],
                    totalPrice: this.configuration.currentPrice || 0,
                    basePrice: this.configuration.basePrice || 0,
                    timestamp: Date.now(),
                    frameData: {
                        frameChoice: this.configuration.frameChoice,
                        frameProduct: this.configuration.frameProduct,
                        frameBrand: this.configuration.frameBrand,
                        frameModel: this.configuration.frameModel,
                        nativeLensType: this.configuration.nativeLensType,
                        nativeLensFeature: this.configuration.nativeLensFeature,
                        nativeLensMaterial: this.configuration.nativeLensMaterial,
                        prescription: this.configuration.prescription
                    }
                };
                localStorage.setItem("chemistrie_last_order", JSON.stringify(orderData));
                console.log("[storeOrderDataForThankYou] Order data stored for thank you page:", orderData);
            } catch (error) {
                console.error("[storeOrderDataForThankYou] Error storing order data:", error);
            }
        },
        smartContinuationFromThankYou: function() {
            try {
                this.configuration.addSecondClip = true;
                const lastOrderJson = localStorage.getItem("chemistrie_last_order");
                if (!lastOrderJson) {
                    console.warn("[smartContinuationFromThankYou] No previous order data found");
                    return;
                }
                const lastOrder = JSON.parse(lastOrderJson);
                console.log("[smartContinuationFromThankYou] Pre-populating from previous order:", lastOrder);
                if (lastOrder.frameData) {
                    const frameData = lastOrder.frameData;
                    if (frameData.frameChoice) {
                        this.configuration.frameChoice = frameData.frameChoice;
                        const frameChoiceRadio = document.querySelector(`input[name="frame-choice"][value="${frameData.frameChoice}"]`);
                        if (frameChoiceRadio) {
                            frameChoiceRadio.checked = true;
                            frameChoiceRadio.dispatchEvent(new Event("change", {
                                bubbles: true
                            }));
                        }
                    }
                    if (frameData.frameProduct) {
                        this.configuration.frameProduct = frameData.frameProduct;
                        const frameSelector = document.getElementById("frameSelector");
                        if (frameSelector) {
                            frameSelector.value = frameData.frameProduct;
                            frameSelector.dispatchEvent(new Event("change", {
                                bubbles: true
                            }));
                        }
                    }
                    if (frameData.frameBrand) this.configuration.frameBrand = frameData.frameBrand;
                    if (frameData.frameModel) this.configuration.frameModel = frameData.frameModel;
                    if (frameData.nativeLensType) this.configuration.nativeLensType = frameData.nativeLensType;
                    if (frameData.nativeLensFeature) this.configuration.nativeLensFeature = frameData.nativeLensFeature;
                    if (frameData.nativeLensMaterial) this.configuration.nativeLensMaterial = frameData.nativeLensMaterial;
                    if (frameData.prescription) this.configuration.prescription = frameData.prescription;
                }
                this.goToStep(1);
                this.updateNavigationButtons();
                this.updateProgressBar();
                const clipTypeSection = document.querySelector('[data-step="1"]');
                if (clipTypeSection) {
                    const existingBanner = clipTypeSection.querySelector(".smart-continuation-banner");
                    if (!existingBanner) {
                        const banner = document.createElement("div");
                        banner.className = "smart-continuation-banner";
                        banner.style.cssText = "background: #e8f5e9; border: 1px solid #4caf50; padding: 15px; margin-bottom: 20px; border-radius: 4px;";
                        banner.innerHTML = `\n                            <p style="margin: 0; font-size: 14px; color: #2e7d32;">\n                                <strong>Building Additional Clip:</strong> We've pre-filled your previous selections.\n                                You can change them or proceed to lens selection.\n                            </p>\n                        `;
                        clipTypeSection.insertBefore(banner, clipTypeSection.firstChild);
                    }
                }
                console.log("[smartContinuationFromThankYou] Smart continuation setup complete");
            } catch (error) {
                console.error("[smartContinuationFromThankYou] Error in smart continuation:", error);
            }
        },
        closeCartDrawer: function() {
            if (window.cartDrawer && typeof window.cartDrawer.closeDrawer === "function") {
                window.cartDrawer.closeDrawer();
                console.log("[closeCartDrawer] Cart drawer closed");
            } else {
                console.warn("[closeCartDrawer] Cart drawer not available");
            }
        },
        setupEditModeUI: function() {
            console.log("[setupEditModeUI] Setting up edit mode UI");
            const addToCartBtn = document.getElementById("addToCartBtn");
            if (addToCartBtn) {
                addToCartBtn.textContent = "Update Order";
                console.log('[setupEditModeUI] Changed button text to "Update Order"');
            }
            const footerActions = document.querySelector(".order-flow__footer-actions");
            if (footerActions && !document.getElementById("cancelEditBtn")) {
                const cancelBtn = document.createElement("button");
                cancelBtn.id = "cancelEditBtn";
                cancelBtn.type = "button";
                cancelBtn.className = "chemistrie-button chemistrie-button--secondary";
                cancelBtn.textContent = "Cancel";
                cancelBtn.style.marginRight = "10px";
                cancelBtn.addEventListener("click", () => this.cancelEdit());
                footerActions.insertBefore(cancelBtn, addToCartBtn);
                console.log("[setupEditModeUI] Added Cancel button");
            }
        },
        cancelEdit: function() {
            console.log("[cancelEdit] Canceling edit mode");
            this.isEditingConfig = false;
            this.editConfigId = null;
            this.editClipSequence = null;
            window.location.href = "/?open-cart=true";
        },
        updateExistingConfiguration: async function() {
            console.log("[updateExistingConfiguration] Starting configuration update");
            console.log("[updateExistingConfiguration] Config ID:", this.editConfigId);
            console.log("[updateExistingConfiguration] Clip Sequence:", this.editClipSequence);
            const addToCartBtn = document.getElementById("addToCartBtn");
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = "Updating...";
            }
            this.showCartLoadingOverlay(true, "Updating your order...");
            try {
                await this._ensureRxStaged();
            } catch (rxErr) {
                this.showCartLoadingOverlay(false);
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    addToCartBtn.textContent = "Update Order";
                }
                this._handleRxStagingFailure(rxErr);
                return;
            }
            window.__chemistrieCartTxnUntil = Date.now() + 3e4;
            const removedSnapshot = [];
            const addedLines = [];
            let rebuildCompleted = false;
            try {
                const cartResponse = await fetch("/cart.js", {
                    credentials: "same-origin"
                });
                if (!cartResponse.ok) {
                    throw new Error("Failed to fetch cart");
                }
                const cart = await cartResponse.json();
                console.log("[updateExistingConfiguration] Current cart fetched:", cart.items.length, "items");
                const isPrescriptionOnlyEdit = this.configuration.isPrescriptionOnlyOrder === true;
                const itemsToRemove = cart.items.filter(item => {
                    const configMatch = item.properties["_Configuration ID"] === this.editConfigId;
                    const parentMatch = item.properties["_Parent Config ID"] === this.editConfigId;
                    if (isPrescriptionOnlyEdit) {
                        return configMatch || parentMatch;
                    } else {
                        const seqMatch = item.properties["_Clip Sequence"] === this.editClipSequence;
                        return (configMatch || parentMatch) && seqMatch;
                    }
                });
                console.log("[updateExistingConfiguration] Items to remove:", itemsToRemove.length);
                itemsToRemove.forEach(item => {
                    console.log("  - ", item.title, "(key:", item.key + ")");
                });
                for (const item of itemsToRemove) {
                    console.log("[updateExistingConfiguration] Removing item:", item.title);
                    const removeResponse = await fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        credentials: "same-origin",
                        body: JSON.stringify({
                            id: item.key,
                            quantity: 0
                        })
                    });
                    if (!removeResponse.ok) {
                        const detail = await removeResponse.text().catch(() => "");
                        if (detail.indexOf("no valid id or line parameter") !== -1) {
                            console.warn("[updateExistingConfiguration] Line already gone, treating as removed:", item.title);
                        } else {
                            throw new Error(`Failed to remove item: ${item.title} — ${removeResponse.status} ${detail.slice(0, 200)}`);
                        }
                    }
                    removedSnapshot.push({
                        id: item.variant_id,
                        quantity: item.quantity,
                        properties: {
                            ...item.properties
                        }
                    });
                }
                console.log("[updateExistingConfiguration] All old items removed");
                let cartItems;
                if (isPrescriptionOnlyEdit) {
                    const prescriptionItems = await this.preparePrescriptionOnlyCartItems();
                    if (prescriptionItems.parent) {
                        prescriptionItems.parent.properties["_Configuration ID"] = this.editConfigId;
                        prescriptionItems.children.forEach(child => {
                            if (child.properties["_Parent Config ID"]) {
                                child.properties["_Parent Config ID"] = this.editConfigId;
                            }
                        });
                        cartItems = [ prescriptionItems.parent, ...prescriptionItems.children ];
                    } else {
                        cartItems = Array.isArray(prescriptionItems) ? prescriptionItems : [ prescriptionItems ];
                        if (cartItems[0]?.properties) {
                            cartItems[0].properties["_Configuration ID"] = this.editConfigId;
                        }
                    }
                } else {
                    cartItems = await this.prepareCartItemsForEdit();
                }
                console.log("[updateExistingConfiguration] Prepared", cartItems.length, "new items to add");
                for (const item of cartItems) {
                    console.log("[updateExistingConfiguration] Adding item:", item.product_title);
                    const addResponse = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        credentials: "same-origin",
                        body: JSON.stringify(item)
                    });
                    if (!addResponse.ok) {
                        const errorData = await addResponse.json();
                        throw new Error(`Failed to add item: ${errorData.description || "Unknown error"}`);
                    }
                    try {
                        const added = await addResponse.json();
                        if (added && added.key) {
                            addedLines.push({
                                key: added.key,
                                isParent: (item.properties && item.properties["_Item Type"] || "").indexOf("Parent") !== -1
                            });
                        }
                    } catch (parseError) {
                        console.warn("[updateExistingConfiguration] Could not read the added line key — it cannot be unwound if the rebuild fails:", parseError);
                    }
                }
                rebuildCompleted = true;
                console.log("[updateExistingConfiguration] All new items added");
                const isVariantCEdit = this.configuration.frameChoice === "new-frame-lenses" && parseInt(this.editClipSequence) === 1;
                if (isVariantCEdit) {
                    const updatedCartResponse = await fetch("/cart.js", {
                        credentials: "same-origin"
                    });
                    if (updatedCartResponse.ok) {
                        const updatedCart = await updatedCartResponse.json();
                        const frameParent = updatedCart.items.find(item => item.properties && item.properties["_Configuration ID"] === this.editConfigId && (item.properties["_Item Type"] || "").includes("FRAME"));
                        if (frameParent) {
                            const updatedProps = {
                                ...frameParent.properties
                            };
                            updatedProps["_Clip Type"] = this.getClipTypeLabel();
                            updatedProps["_Clip Type Key"] = this.configuration.clipType || "";
                            if (this.configuration.lensCategory) {
                                updatedProps["_Lens Category"] = this.capitalizeWords(this.configuration.lensCategory);
                            } else {
                                delete updatedProps["_Lens Category"];
                            }
                            updatedProps["_Lens Color"] = this.configuration.lensColor || "";
                            if (this.configuration.magnification) {
                                updatedProps["_Magnification"] = this.configuration.magnification;
                            } else {
                                delete updatedProps["_Magnification"];
                            }
                            updatedProps["_Bridge Finish"] = this.capitalizeWords(this.configuration.bridgeColor || "MatteBlack");
                            updatedProps["_Magnet Finish"] = this.capitalizeWords(this.configuration.magnetColor || "Gunmetal");
                            if (this.configuration.crystalColor) {
                                updatedProps["_Crystal Accent"] = this.capitalizeWords(this.configuration.crystalColor);
                            } else {
                                delete updatedProps["_Crystal Accent"];
                            }
                            const frameDisplayName = frameParent.properties["Frame"] || "";
                            const clipLabel = this.getClipTypeLabel();
                            const lensColor = this.configuration.lensColor ? this.capitalizeWords(this.configuration.lensColor.replace(/-/g, " ")) : "Standard";
                            updatedProps["Clip Configuration"] = `Frame: ${frameDisplayName} | Clip: ${clipLabel} | Color: ${lensColor}`;
                            await fetch("/cart/change.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                credentials: "same-origin",
                                body: JSON.stringify({
                                    id: frameParent.key,
                                    quantity: 1,
                                    properties: updatedProps
                                })
                            });
                            console.log("[updateExistingConfiguration] ✅ Updated frame parent clip metadata");
                        }
                    }
                }
                this.invalidateCartCache();
                this.showCartLoadingOverlay(false);
                this.unstickProgressBar();
                this.isEditingConfig = false;
                this.editConfigId = null;
                this.editClipSequence = null;
                this.resetConfiguration();
                console.log("[updateExistingConfiguration] Configuration update complete! Redirecting to homepage.");
                window.location.href = "/?open-cart=true";
            } catch (error) {
                console.error("[updateExistingConfiguration] Error updating configuration:", error);
                if (!rebuildCompleted && removedSnapshot.length > 0) {
                    try {
                        const unwindOrder = [ ...addedLines.filter(line => !line.isParent), ...addedLines.filter(line => line.isParent) ];
                        let unwound = 0;
                        for (const line of unwindOrder) {
                            const undoResponse = await fetch("/cart/change.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                credentials: "same-origin",
                                body: JSON.stringify({
                                    id: line.key,
                                    quantity: 0
                                })
                            });
                            if (undoResponse.ok) {
                                unwound++;
                            } else {
                                console.error("[updateExistingConfiguration] Could not unwind a partially-added line —", "it will be duplicated by the restore:", undoResponse.status, line.key);
                            }
                        }
                        if (unwindOrder.length > 0) {
                            console.warn("[updateExistingConfiguration] Unwound", unwound, "of", unwindOrder.length, "partially-added line(s) before restoring");
                        }
                        const restoreResponse = await fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            credentials: "same-origin",
                            body: JSON.stringify({
                                items: removedSnapshot
                            })
                        });
                        if (restoreResponse.ok) {
                            console.warn("[updateExistingConfiguration] Rebuild failed — original configuration restored");
                        } else {
                            console.error("[updateExistingConfiguration] Rollback failed:", restoreResponse.status);
                        }
                    } catch (rollbackError) {
                        console.error("[updateExistingConfiguration] Rollback failed:", rollbackError);
                    }
                }
                this.showCartLoadingOverlay(false);
                alert("Error updating configuration. Please try again.");
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    addToCartBtn.textContent = "Update Order";
                }
            } finally {
                window.__chemistrieCartTxnUntil = 0;
            }
        },
        prepareCartItemsForEdit: async function() {
            console.log("[prepareCartItemsForEdit] Preparing cart items with existing config ID:", this.editConfigId);
            const items = [];
            const configId = this.editConfigId;
            const clipTypeLabel = this.getClipTypeLabel();
            const frameLabel = this.configuration.frameBrand && this.configuration.frameModel ? `${this.configuration.frameBrand} ${this.configuration.frameModel}` : this.getFrameChoiceLabel();
            const configSummary = `${clipTypeLabel} for ${frameLabel}`;
            const shouldApplyDiscount = parseInt(this.editClipSequence) >= 2;
            console.log("[prepareCartItemsForEdit] Clip sequence:", this.editClipSequence, "Apply discount:", shouldApplyDiscount);
            const clipVariantId = this.getProductVariantId("lens", {
                clipType: this.configuration.clipType,
                category: this.configuration.lensCategory,
                color: this.configuration.lensColor,
                magnification: this.configuration.magnification,
                therapeuticType: this.configuration.therapeuticType,
                intensity: this.configuration.therapeuticIntensity
            }, shouldApplyDiscount);
            if (!clipVariantId) {
                console.error("[prepareCartItemsForEdit] Could not get clip variant ID");
                throw new Error("Variant lookup failed - clipVariantId is null");
            }
            const variantImageUrl = this.getVariantImageUrl({
                clipType: this.configuration.clipType,
                category: this.configuration.lensCategory,
                color: this.configuration.lensColor,
                intensity: this.configuration.therapeuticIntensity
            });
            const isVariantCFirstClip = this.configuration.frameChoice === "new-frame-lenses" && parseInt(this.editClipSequence) === 1;
            const editProperties = {
                "_Clip Sequence": this.editClipSequence,
                "_Order Source": this.configuration.orderSource || this.deriveOrderSourceFromFrameChoice(this.configuration.frameChoice) || "Order Flow - Unknown",
                "Clip Configuration": configSummary,
                "_Frame Choice": this.getFrameChoiceLabel(),
                "_Frame Choice Key": this.configuration.frameChoice,
                ...this.configuration.frameBrand && {
                    "_Frame Brand": this.configuration.frameBrand
                },
                ...this.configuration.frameModel && {
                    "_Frame Model": this.configuration.frameModel
                },
                ...this.configuration.frameProduct && {
                    "_Frame Product ID": this.configuration.frameProduct
                },
                "_Clip Type": clipTypeLabel,
                ...this.configuration.bridgeColor && {
                    "_Bridge Finish": this.capitalizeWords(this.configuration.bridgeColor)
                },
                ...this.configuration.magnetColor && {
                    "_Magnet Finish": this.capitalizeWords(this.configuration.magnetColor)
                },
                ...this.configuration.crystalColor && {
                    "_Crystal Accent": this.capitalizeWords(this.configuration.crystalColor)
                },
                ...this.configuration.clipType === "sun" && this.configuration.lensCategory && {
                    "_Lens Category": this.capitalizeWords(this.configuration.lensCategory)
                },
                ...this.configuration.clipType === "sun" && this.configuration.lensColor && {
                    "_Lens Color": this.getLensColorDisplayName(this.configuration.lensColor, this.configuration.lensCategory)
                },
                ...this.configuration.magnification && {
                    _Magnification: this.configuration.magnification
                },
                ...this.configuration.clipType === "lightSensitivity" && {
                    ...(this.configuration.lightSensitivityIntensity || this.configuration.therapeuticIntensity) && {
                        "_FL-41 Intensity": this.capitalizeWords(this.configuration.lightSensitivityIntensity || this.configuration.therapeuticIntensity)
                    }
                },
                ...this.configuration.clipType === "migraine" && {
                    "_Lens Type": "Avulux"
                }
            };
            if (isVariantCFirstClip) {
                editProperties["_Parent Config ID"] = configId;
                editProperties["_Item Type"] = "  ↳ Clip (Child)";
            } else {
                editProperties["_Configuration ID"] = configId;
                editProperties["_Item Type"] = "CLIP (Parent)";
            }
            if (variantImageUrl) {
                editProperties["_Variant Image"] = variantImageUrl;
            }
            const parentItem = {
                id: clipVariantId,
                quantity: this.configuration.quantity || 1,
                properties: editProperties,
                product_title: clipTypeLabel
            };
            if (this.configuration.requiresNativeLenses) {
                parentItem.properties["_Prescription Lens Type"] = this.configuration.nativeLensType || "single-vision";
                parentItem.properties["_Prescription Lens Feature"] = this.configuration.nativeLensFeature || "standard";
                if (this.configuration.nativeLensType !== "readers" && this.configuration.nativeLensType !== "non-rx") {
                    parentItem.properties["_Prescription Lens Material"] = this.configuration.nativeLensMaterial || "standard";
                }
                if (this.configuration.nativeLensType === "readers" && this.configuration.readerPower) {
                    parentItem.properties["_Reader Power"] = this.configuration.readerPower;
                }
                parentItem.properties["_Native Lens Type"] = this.configuration.nativeLensType || "single-vision";
                parentItem.properties["_Native Lens Feature"] = this.configuration.nativeLensFeature || "standard";
                if (this.configuration.nativeLensType !== "readers" && this.configuration.nativeLensType !== "non-rx") {
                    parentItem.properties["_Native Lens Material"] = this.configuration.nativeLensMaterial || "standard";
                }
            }
            const editRxUpload = this.configuration.prescriptionUpload;
            if (editRxUpload && editRxUpload.token && this._orderRequiresRx()) {
                parentItem.properties["_Prescription Status"] = "Uploaded - Pending verification";
                parentItem.properties["_Rx Upload Token"] = editRxUpload.token;
                if (editRxUpload.fileName) parentItem.properties["_Rx Upload Filename"] = editRxUpload.fileName;
            } else if (this.configuration.prescriptionSendLater === true && this._orderRequiresRx()) {
                parentItem.properties["_Prescription Status"] = "Pending - Customer will send later";
            } else if (this.configuration.prescription && this.configuration.prescription !== "skip" && this._orderRequiresRx()) {
                parentItem.properties["_Prescription Status"] = "Provided";
            } else if (this.configuration.rxCarriedToken && this.configuration.rxCarriedStatus) {
                parentItem.properties["_Prescription Status"] = this.configuration.rxCarriedStatus;
            }
            const editRxToken = this._getRxTokenForCart();
            if (!parentItem.properties["_Rx Upload Token"] && editRxToken && (this._orderRequiresRx() || editRxToken === this.configuration.rxCarriedToken)) {
                parentItem.properties["_Rx Upload Token"] = editRxToken;
            }
            const editCertMethod = this.configuration.prescriptionMethod;
            if ((editCertMethod === "manual" || editCertMethod === "upload") && this.configuration.rxCertifiedAt) {
                parentItem.properties["_Rx Certified At"] = this.configuration.rxCertifiedAt;
            }
            if (this.configuration.termsAcceptedAt) {
                parentItem.properties["_Terms Accepted At"] = this.configuration.termsAcceptedAt;
            }
            items.push(parentItem);
            if (this.configuration.requiresNativeLenses && !shouldApplyDiscount) {
                const lensBreakdown = await this.getNativeLensBreakdown();
                console.log("[prepareCartItemsForEdit] Lens breakdown:", lensBreakdown);
                if (lensBreakdown.total > 0) {
                    const lensUpgradeVariantId = this.getLensUpgradeVariantId(lensBreakdown.total, this.configuration.nativeLensType);
                    if (lensUpgradeVariantId) {
                        const upgradeDetails = [];
                        if (lensBreakdown.prescriptionType && lensBreakdown.prescriptionType.price > 0) {
                            upgradeDetails.push(lensBreakdown.prescriptionType.label);
                        }
                        if (lensBreakdown.lensMaterial && lensBreakdown.lensMaterial.price > 0) {
                            upgradeDetails.push(this.getLabLensMaterialLabel(this.configuration.nativeLensMaterial));
                        }
                        if (lensBreakdown.blueLight && lensBreakdown.blueLight.price > 0) {
                            upgradeDetails.push("Blue Light filter");
                        }
                        const lensEditProperties = {
                            "_Parent Config ID": configId,
                            "_Item Type": "  ↳ Prescription Lens (Child)",
                            _Is_Paid_Upgrade: lensBreakdown.total > 0 ? "true" : "false",
                            "For Frame": frameLabel,
                            "_Upgrade Details": upgradeDetails.join(" + "),
                            "_Prescription Type": this.configuration.nativeLensType,
                            "_Lens Feature": this.configuration.nativeLensFeature || "standard"
                        };
                        if (this.configuration.nativeLensType !== "readers" && this.configuration.nativeLensType !== "non-rx") {
                            lensEditProperties["_Lens Material"] = this.configuration.nativeLensMaterial || "standard";
                        }
                        if (this.configuration.nativeLensType === "readers" && this.configuration.readerPower) {
                            lensEditProperties["_Reader Power"] = this.configuration.readerPower;
                        }
                        const prescriptionLensItem = {
                            id: lensUpgradeVariantId,
                            quantity: this.configuration.quantity || 1,
                            properties: lensEditProperties,
                            product_title: "Prescription Lens Upgrade"
                        };
                        items.push(prescriptionLensItem);
                        console.log("[prepareCartItemsForEdit] Added lens upgrade item:", lensBreakdown.total);
                    } else {
                        console.warn("[prepareCartItemsForEdit] Could not find lens upgrade variant for price:", lensBreakdown.total);
                    }
                }
            } else if (this.configuration.requiresNativeLenses && shouldApplyDiscount) {
                console.log("[prepareCartItemsForEdit] ✅ SKIPPED Native Lens Upgrade - 2nd clip uses existing lenses");
            }
            if (this.configuration.crystalColor && this.pricing?.crystals > 0) {
                const crystalVariantId = this.getCrystalVariantId();
                if (crystalVariantId) {
                    items.push({
                        id: crystalVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configId,
                            "_Clip Sequence": this.editClipSequence,
                            "_Item Type": "  ↳ Crystal Accent (Child)"
                        }
                    });
                    console.log("[prepareCartItemsForEdit] Added crystal accent:", this.configuration.crystalColor);
                }
            }
            if (this.configuration.bridgeColor) {
                const bridgeVariantId = this.getBridgeVariantId();
                if (bridgeVariantId) {
                    items.push({
                        id: bridgeVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configId,
                            "_Clip Sequence": this.editClipSequence,
                            "_Item Type": "  ↳ Bridge Hardware (Child)"
                        }
                    });
                    console.log("[prepareCartItemsForEdit] Added bridge hardware:", this.configuration.bridgeColor);
                }
            }
            if (this.configuration.magnetColor) {
                const magnetVariantId = this.getMagnetVariantId();
                if (magnetVariantId) {
                    items.push({
                        id: magnetVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configId,
                            "_Clip Sequence": this.editClipSequence,
                            "_Item Type": "  ↳ Magnet Hardware (Child)"
                        }
                    });
                    console.log("[prepareCartItemsForEdit] Added magnet hardware:", this.configuration.magnetColor);
                }
            }
            console.log("[prepareCartItemsForEdit] Prepared", items.length, "items");
            return items;
        },
        addToCart: async function() {
            const sunVariants = window.chemistrie_products && window.chemistrie_products.sun_clips && window.chemistrie_products.sun_clips.variants;
            if (this.configuration.clipType === "sun" && sunVariants && sunVariants.length && !this.findSunClipVariant({}, false)) {
                console.warn("[addToCart] ❌ Blocked - sun lens pair is not a product:", this.configuration.lensCategory, this.configuration.lensColor);
                this.configuration.lensColor = null;
                this.saveState();
                await this.goToStep(4);
                this.showOrderFlowError("Please pick your lens color again to continue. We couldn't match your earlier choice to one of our lenses.");
                return;
            }
            if (this.isEditingConfig) {
                console.log("[addToCart] Edit mode detected, routing to updateExistingConfiguration()");
                return this.updateExistingConfiguration();
            }
            if (false && !this.configuration.termsAcceptedAt) {
                console.log("[addToCart] ❌ Blocked - Terms & Conditions not accepted");
                const tcAcceptance = document.getElementById("tcAcceptance");
                const tcError = document.getElementById("tcAcceptError");
                if (tcAcceptance) {
                    tcAcceptance.classList.add("tc-pulse");
                    setTimeout(() => tcAcceptance.classList.remove("tc-pulse"), 6e3);
                    tcAcceptance.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
                if (tcError) tcError.hidden = false;
                return;
            }
            const requiresPrescription = (this.configuration.frameChoice === "own-frame-new-lenses" || this.configuration.frameChoice === "new-frame-lenses") && !this.isBuilding2ndClip && !this.isReorderMode;
            if (requiresPrescription && this.configuration.prescription === "skip" && !this.configuration.prescriptionSendLater && !(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token)) {
                console.log("[addToCart] ❌ Blocked - prescription required for", this.configuration.frameChoice);
                this.showPrescriptionError = true;
                this.showPrescriptionErrorBanner();
                const addPrescriptionSection = document.getElementById("addPrescriptionSection");
                const inlineRxForm = document.getElementById("inlineRxForm");
                const expandRxBtn = document.getElementById("expandRxBtn");
                if (addPrescriptionSection) {
                    addPrescriptionSection.classList.add("prescription-section-pulse");
                    setTimeout(() => {
                        addPrescriptionSection.classList.remove("prescription-section-pulse");
                    }, 6e3);
                    addPrescriptionSection.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
                if (inlineRxForm && expandRxBtn) {
                    inlineRxForm.style.display = "block";
                    expandRxBtn.textContent = "Click to Hide";
                }
                return;
            }
            if (!this.validateFinalConfiguration()) {
                alert("Please complete all required selections before adding to cart.");
                return;
            }
            const addToCartBtn = document.getElementById("addToCartBtn");
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = "Adding to Cart...";
            }
            try {
                await this._ensureRxStaged();
            } catch (rxErr) {
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    this.updateAddToCartButtonText();
                }
                this._handleRxStagingFailure(rxErr);
                return;
            }
            this.showCartLoadingOverlay(true, "Adding items to cart...");
            let cartItems;
            try {
                cartItems = await this.prepareCartItems();
            } catch (prepError) {
                if (prepError.message && prepError.message.startsWith("HARDWARE_VARIANT_MISSING:")) {
                    const missingPart = prepError.message.split(":")[1];
                    console.error("[addToCart] ❌ Hardware variant lookup failed:", missingPart);
                    this.showCartLoadingOverlay(false);
                    const addToCartBtn = document.getElementById("addToCartBtn");
                    if (addToCartBtn) {
                        addToCartBtn.disabled = false;
                        addToCartBtn.textContent = "Add to Cart";
                    }
                    this.showOrderFlowError(`We couldn't load your ${missingPart} hardware options. Please go back to Step 4 and re-select your ${missingPart}.`);
                    return;
                }
                console.error("[addToCart] ❌ prepareCartItems failed:", prepError);
                this.showCartLoadingOverlay(false);
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    this.updateAddToCartButtonText();
                }
                this.showOrderFlowError("Sorry, something went wrong adding your configuration to the cart. Please try again.");
                return;
            }
            const isBuild2ndClipFlow = this.configuration.addSecondClip === true;
            this.addItemsToShopifyCart(cartItems).then(async () => {
                this.invalidateCartCache();
                try {
                    document.dispatchEvent(new CustomEvent("configurator:add_to_cart", {
                        detail: {
                            variant: this.configuration.frameChoice,
                            clipType: this.configuration.clipType,
                            isSecondClip: isBuild2ndClipFlow
                        }
                    }));
                } catch (e) {}
                if (isBuild2ndClipFlow) {
                    console.log("[Add to Cart] Build 2nd Clip flow - jumping to Step #3");
                    if (this.configuration.frameChoice === "own-frame-new-lenses") {
                        const odSphere = document.getElementById("odSphereReview")?.value.trim();
                        const osSphere = document.getElementById("osSphereReview")?.value.trim();
                        const dualPdToggleReview = document.getElementById("dualPdToggleReview");
                        const isDualModeReview = dualPdToggleReview?.checked || false;
                        let pdDataBuild2nd;
                        let pdValidBuild2nd = false;
                        if (isDualModeReview) {
                            const pdLeftRev = document.getElementById("pdLeftReview")?.value.trim();
                            const pdRightRev = document.getElementById("pdRightReview")?.value.trim();
                            pdDataBuild2nd = {
                                mode: "dual",
                                value: null,
                                left: pdLeftRev || null,
                                right: pdRightRev || null
                            };
                            pdValidBuild2nd = !!(pdLeftRev && pdRightRev);
                        } else {
                            const pdSingleRev = document.getElementById("pdReview")?.value.trim();
                            pdDataBuild2nd = {
                                mode: "single",
                                value: pdSingleRev || null,
                                left: null,
                                right: null
                            };
                            pdValidBuild2nd = !!pdSingleRev;
                        }
                        if (odSphere || osSphere || pdValidBuild2nd) {
                            const rxNotesBuild2nd = document.getElementById("rxNotesReview")?.value.trim() || "";
                            this.configuration.prescription = {
                                od: {
                                    sphere: document.getElementById("odSphereReview")?.value.trim() || "",
                                    cylinder: document.getElementById("odCylinderReview")?.value.trim() || "",
                                    axis: document.getElementById("odAxisReview")?.value.trim() || "",
                                    add: document.getElementById("odAddReview")?.value.trim() || ""
                                },
                                os: {
                                    sphere: document.getElementById("osSphereReview")?.value.trim() || "",
                                    cylinder: document.getElementById("osCylinderReview")?.value.trim() || "",
                                    axis: document.getElementById("osAxisReview")?.value.trim() || "",
                                    add: document.getElementById("osAddReview")?.value.trim() || ""
                                },
                                pd: pdDataBuild2nd,
                                notes: rxNotesBuild2nd
                            };
                            console.log("[Build 2nd Clip] Captured inline Rx data from Step #5 (PD mode:", pdDataBuild2nd.mode + ")");
                        }
                    }
                    const frameData = {
                        frameChoice: this.configuration.frameChoice,
                        frameProduct: this.configuration.frameProduct,
                        frameBrand: this.configuration.frameBrand,
                        frameModel: this.configuration.frameModel,
                        nativeLensType: this.configuration.nativeLensType,
                        nativeLensFeature: this.configuration.nativeLensFeature,
                        nativeLensMaterial: this.configuration.nativeLensMaterial,
                        prescription: this.configuration.prescription,
                        orderSource: this.configuration.orderSource || this.deriveOrderSourceFromFrameChoice(this.configuration.frameChoice),
                        rxValuesStaging: this.configuration.rxValuesStaging || null,
                        prescriptionUpload: this.configuration.prescriptionUpload || null
                    };
                    localStorage.setItem("secondClipFrameData", JSON.stringify(frameData));
                    this.configuration = {
                        ...this.configuration,
                        orderSource: frameData.orderSource,
                        isPrescriptionOnlyOrder: false,
                        isFramelessRxOrder: false,
                        clipType: null,
                        clipOption: null,
                        lensCategory: null,
                        magnification: null,
                        magnificationValue: null,
                        lightSensitivityColor: null,
                        lightSensitivityIntensity: null,
                        therapeuticType: null,
                        therapeuticColor: null,
                        therapeuticIntensity: null,
                        lensColor: null,
                        bridgeColor: "MatteBlack",
                        magnetColor: "Gunmetal",
                        crystalColor: null,
                        accessories: [],
                        quantity: 1,
                        secondClip: null,
                        addSecondClip: false
                    };
                    const secondClipToggle = document.getElementById("secondClipToggle");
                    if (secondClipToggle) {
                        secondClipToggle.checked = false;
                        console.log("[Build 2nd Clip] Toggle UI forced to OFF");
                    }
                    this.isBuilding2ndClip = true;
                    this._secondClipStartTime = Date.now();
                    this.saveState();
                    this.goToStep(3);
                    this.showCartLoadingOverlay(false);
                    if (addToCartBtn) {
                        addToCartBtn.disabled = false;
                        this.updateAddToCartButtonText();
                    }
                    await this.calculateTotalPrice();
                    this.refreshAndOpenCart();
                    console.log("[Build 2nd Clip] Cart drawer opened - user can close when ready");
                } else {
                    console.log("[Add to Cart] Normal flow - redirecting to homepage with cart drawer");
                    this.showCartLoadingOverlay(false);
                    this.unstickProgressBar();
                    this.resetConfiguration();
                    console.log("[Add to Cart] Redirecting to homepage with ?open-cart=true");
                    window.location.href = "/?open-cart=true";
                }
            }).catch(error => {
                console.error("Error adding to cart:", error);
                this.showCartLoadingOverlay(false);
                alert("Error adding items to cart. Please try again.");
                if (addToCartBtn) {
                    addToCartBtn.disabled = false;
                    this.updateAddToCartButtonText();
                }
            });
        },
        showCartSuccessModal: function() {
            return;
        },
        unstickProgressBar: function() {
            const progressSection = document.querySelector(".order-flow__progress-section");
            const spacer = document.getElementById("progress-spacer");
            if (progressSection) {
                progressSection.classList.remove("is-sticky");
            }
            if (spacer) {
                spacer.remove();
            }
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        refreshAndOpenCart: function() {
            if (window.cartDrawer && typeof window.cartDrawer.refreshCart === "function") {
                console.log("[refreshAndOpenCart] Calling refreshCart() to fetch section HTML");
                window.cartDrawer.refreshCart();
                setTimeout(() => {
                    if (typeof window.cartDrawer.openDrawer === "function") {
                        window.cartDrawer.openDrawer();
                    }
                }, 500);
            } else {
                console.warn("[refreshAndOpenCart] Cart drawer not available");
            }
        },
        showCartLoadingOverlay: function(show, message = "Adding to cart...") {
            let overlay = document.getElementById("cartLoadingOverlay");
            if (show) {
                if (!overlay) {
                    overlay = document.createElement("div");
                    overlay.id = "cartLoadingOverlay";
                    overlay.innerHTML = `\n                        <div class="cart-loading-overlay__content">\n                            <div class="cart-loading-overlay__spinner"></div>\n                            <div class="cart-loading-overlay__message">${message}</div>\n                        </div>\n                    `;
                    overlay.style.cssText = `\n                        position: fixed;\n                        top: 0;\n                        left: 0;\n                        right: 0;\n                        bottom: 0;\n                        background: rgba(255, 255, 255, 0.9);\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        z-index: 9999;\n                        opacity: 0;\n                        transition: opacity 0.2s ease;\n                    `;
                    document.body.appendChild(overlay);
                    const style = document.createElement("style");
                    style.id = "cartLoadingOverlayStyles";
                    style.textContent = `\n                        .cart-loading-overlay__content {\n                            text-align: center;\n                        }\n                        .cart-loading-overlay__spinner {\n                            width: 48px;\n                            height: 48px;\n                            border: 3px solid #e0e0e0;\n                            border-top-color: #333;\n                            border-radius: 50%;\n                            margin: 0 auto 16px;\n                            animation: cartSpinnerRotate 0.8s linear infinite;\n                        }\n                        .cart-loading-overlay__message {\n                            font-size: 16px;\n                            color: #333;\n                            font-family: var(--font-body-family, sans-serif);\n                        }\n                        @keyframes cartSpinnerRotate {\n                            from { transform: rotate(0deg); }\n                            to { transform: rotate(360deg); }\n                        }\n                    `;
                    document.head.appendChild(style);
                }
                const msgEl = overlay.querySelector(".cart-loading-overlay__message");
                if (msgEl) msgEl.textContent = message;
                overlay.style.display = "flex";
                requestAnimationFrame(() => {
                    overlay.style.opacity = "1";
                });
            } else {
                if (overlay) {
                    overlay.style.opacity = "0";
                    setTimeout(() => {
                        overlay.style.display = "none";
                    }, 200);
                }
            }
        },
        getCartCached: async function(forceRefresh = false) {
            const now = Date.now();
            const cacheValid = this._cartCache && now - this._cartCacheTime < this._cartCacheTTL;
            if (this._rateLimitCooldown && now < this._rateLimitCooldown) {
                console.log("[getCartCached] Rate limit cooldown active, using cached/empty cart");
                return this._cartCache || {
                    items: [],
                    item_count: 0,
                    total_price: 0
                };
            }
            if (!forceRefresh && cacheValid) {
                console.log("[getCartCached] Using cached cart (age: " + (now - this._cartCacheTime) + "ms)");
                return this._cartCache;
            }
            console.log("[getCartCached] Fetching fresh cart data");
            try {
                const response = await fetch("/cart.js", {
                    credentials: "same-origin"
                });
                if (response.status === 429) {
                    console.warn("[getCartCached] Rate limited (429) - entering 30s cooldown");
                    this._rateLimitCooldown = now + 3e4;
                    if (window.cartStateManager && typeof window.cartStateManager.setRateLimitCooldown === "function") {
                        window.cartStateManager.setRateLimitCooldown();
                    }
                    return this._cartCache || {
                        items: [],
                        item_count: 0,
                        total_price: 0
                    };
                }
                if (!response.ok) throw new Error("Failed to fetch cart");
                this._cartCache = await response.json();
                this._cartCacheTime = now;
                this._rateLimitCooldown = null;
                return this._cartCache;
            } catch (error) {
                console.warn("[getCartCached] Fetch error, using cached/empty cart:", error.message);
                return this._cartCache || {
                    items: [],
                    item_count: 0,
                    total_price: 0
                };
            }
        },
        invalidateCartCache: function() {
            this._cartCache = null;
            this._cartCacheTime = 0;
            console.log("[invalidateCartCache] Cart cache cleared");
        },
        getExistingClipsForFrame: async function(frameProduct, frameBrand, frameModel, excludeConfigId = null) {
            try {
                const cart = await this.getCartCached();
                return cart.items.filter(item => {
                    if (!item.properties) return false;
                    const itemConfigId = item.properties["_Configuration ID"] || item.properties["_Parent Config ID"];
                    if (excludeConfigId && itemConfigId === excludeConfigId) {
                        console.log("[getExistingClipsForFrame] Skipping item being edited:", excludeConfigId);
                        return false;
                    }
                    const itemType = item.properties["_Item Type"] || "";
                    const isClipItem = itemType.toLowerCase().includes("clip");
                    if (!isClipItem) {
                        return false;
                    }
                    if (frameProduct && item.properties["_Frame Product ID"] === frameProduct) {
                        console.log("[getExistingClipsForFrame] Variant C clip match found:", {
                            frameProduct: frameProduct,
                            itemFrameProduct: item.properties["_Frame Product ID"],
                            itemType: itemType
                        });
                        return true;
                    }
                    if (frameBrand && frameModel) {
                        const brandMatch = item.properties["_Frame Brand"] === frameBrand;
                        const modelMatch = item.properties["_Frame Model"] === frameModel;
                        if (brandMatch && modelMatch) {
                            console.log("[getExistingClipsForFrame] Variant A/B clip match found:", {
                                frameBrand: frameBrand,
                                frameModel: frameModel,
                                itemBrand: item.properties["_Frame Brand"],
                                itemModel: item.properties["_Frame Model"],
                                itemType: itemType
                            });
                            return true;
                        }
                    }
                    return false;
                });
            } catch (error) {
                console.error("[getExistingClipsForFrame] Error fetching cart:", error);
                return [];
            }
        },
        validateFinalConfiguration: function() {
            if (this.isReorderMode) {
                console.log("[validateFinalConfiguration] Reorder mode - validating clip fields only");
                const reorderFields = [ this.configuration.clipType, this.configuration.bridgeColor, this.configuration.magnetColor ];
                if (this.configuration.clipType === "sun") reorderFields.push(this.configuration.lensColor);
                if (this.configuration.clipType === "reader" || this.configuration.clipType === "blueLight") reorderFields.push(this.configuration.magnification);
                if (this.configuration.clipType === "lightSensitivity") reorderFields.push(this.configuration.lightSensitivityIntensity);
                return reorderFields.every(field => field !== null && field !== undefined);
            }
            if (this.configuration.isPrescriptionOnlyOrder === true) {
                console.log("[validateFinalConfiguration] Prescription-only order - skipping clip requirements");
                const requiredForPrescriptionOnly = [ this.configuration.frameChoice, this.configuration.nativeLensType ];
                return requiredForPrescriptionOnly.every(field => field !== null && field !== undefined);
            }
            const requiredFields = [ this.configuration.frameChoice, this.configuration.nativeLensType, this.configuration.clipType ];
            if (this.configuration.clipType === "sun") {
                requiredFields.push(this.configuration.lensColor);
            } else if (this.configuration.clipType === "reader" || this.configuration.clipType === "blueLight") {
                requiredFields.push(this.configuration.magnification);
            } else if (this.configuration.clipType === "lightSensitivity") {
                requiredFields.push(this.configuration.lightSensitivityIntensity);
            }
            if (!this.configuration.isPrescriptionOnlyOrder) {
                requiredFields.push(this.configuration.bridgeColor);
                requiredFields.push(this.configuration.magnetColor);
            }
            return requiredFields.every(field => field !== null && field !== undefined);
        },
        _formatPdProperty: function(pd) {
            if (!pd) return "";
            if (typeof pd === "object") {
                if (pd.mode === "dual" && pd.left && pd.right) return "L: " + pd.left + ", R: " + pd.right;
                return pd.value || "";
            }
            return pd;
        },
        _readUploadNotes: function() {
            return document.getElementById("rxNotes")?.value.trim() || document.getElementById("rxNotesUpload")?.value.trim() || "";
        },
        _resolveRxValuesEndpoint: function() {
            const explicit = (window.chemistrie_rx_values_endpoint || "").trim();
            if (explicit) return explicit;
            const uploadEndpoint = (window.chemistrie_rx_upload_endpoint || "").trim();
            if (uploadEndpoint && /\/stage\/?$/.test(uploadEndpoint)) {
                return uploadEndpoint.replace(/\/stage\/?$/, "/values");
            }
            return "";
        },
        _strings: function() {
            if (this._stringsCache) return this._stringsCache;
            const raw = window.chemistrie_save_progress_strings || {};
            const decoder = document.createElement("textarea");
            const out = {};
            for (const key of Object.keys(raw)) {
                const value = raw[key];
                if (typeof value !== "string" || value.indexOf("&") === -1) {
                    out[key] = value;
                    continue;
                }
                decoder.innerHTML = value;
                out[key] = decoder.value;
            }
            this._stringsCache = out;
            return out;
        },
        _resolveConfigurationsEndpoint: function() {
            const explicit = (window.chemistrie_configurations_endpoint || "").trim();
            if (explicit) return explicit;
            const rxValues = this._resolveRxValuesEndpoint();
            if (rxValues && /\/prescriptions\/values\/?$/.test(rxValues)) {
                return rxValues.replace(/\/prescriptions\/values\/?$/, "/configurations/save");
            }
            const upload = (window.chemistrie_rx_upload_endpoint || "").trim();
            if (upload && /\/prescriptions\/stage\/?$/.test(upload)) {
                return upload.replace(/\/prescriptions\/stage\/?$/, "/configurations/save");
            }
            return "";
        },
        buildSaveBlob: function() {
            const cfg = {
                ...this.configuration || {}
            };
            const source = this.configuration || {};
            delete cfg.saveProgressToken;
            cfg.hasRx = !!(source.prescription && source.prescription !== "skip" || source.prescriptionUpload && source.prescriptionUpload.token || source.rxValuesStaging && source.rxValuesStaging.token || source.rxCarriedToken);
            return {
                currentStep: this.currentStep,
                currentSubStep: this.currentSubStep,
                isInSubStep: this.isInSubStep,
                hasCompletedStep1_5: this.hasCompletedStep1_5,
                hasVisitedStep1_5: this.hasVisitedStep1_5,
                wasInStep1_5: this.wasInStep1_5,
                lastStepBeforeTwo: this.lastStepBeforeTwo,
                step1_5FrameChoice: this.step1_5FrameChoice,
                originalStep1Header: this.originalStep1Header,
                currentStep2Substep: this.currentStep2Substep,
                lastStep2Substep: this.lastStep2Substep,
                isInStep2Substep: this.isInStep2Substep,
                previousStepNumber: this.previousStepNumber,
                currentSubStage: this.currentSubStage,
                configuration: cfg,
                pricing: this.pricing
            };
        },
        _postSaveProgress: async function(email, marketingConsent) {
            const endpoint = this._resolveConfigurationsEndpoint();
            if (!endpoint) {
                console.error("[SaveProgress] No endpoint resolved — is the Rx endpoint configured?");
                return {
                    ok: false,
                    reason: "unconfigured"
                };
            }
            let response;
            try {
                response = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        email: email,
                        marketingConsent: !!marketingConsent,
                        token: this.configuration && this.configuration.saveProgressToken || undefined,
                        state: this.buildSaveBlob()
                    })
                });
            } catch (err) {
                console.error("[SaveProgress] Network error:", err);
                return {
                    ok: false,
                    reason: "network"
                };
            }
            let data = null;
            try {
                data = await response.json();
            } catch (e) {}
            if (!response.ok || !data || !data.token) {
                console.error("[SaveProgress] Save rejected:", response.status, data && data.error, data && data.fields ? data.fields.join(", ") : "");
                return {
                    ok: false,
                    reason: response.status === 400 ? "invalid" : "server"
                };
            }
            this.configuration = this.configuration || {};
            this.configuration.saveProgressToken = data.token;
            this.saveState();
            console.log("[SaveProgress] Saved. Token:", data.token, "· emailSent:", data.emailSent);
            return {
                ok: true,
                token: data.token,
                emailSent: !!data.emailSent
            };
        },
        _resolveConfigurationReadEndpoint: function(token) {
            const saveUrl = this._resolveConfigurationsEndpoint();
            if (!saveUrl) return "";
            return saveUrl.replace(/\/save\/?$/, "/" + encodeURIComponent(token));
        },
        _promptResumeEmail: function(endpoint) {
            const self = this;
            const modal = document.getElementById("resumeGateModal");
            const input = document.getElementById("resumeGateEmailInput");
            const submit = document.getElementById("resumeGateSubmit");
            const skip = document.getElementById("resumeGateSkip");
            const errorEl = document.getElementById("resumeGateError");
            if (!modal || !input || !submit || !skip) {
                console.error("[Resume] Gate markup missing — starting a normal session");
                return Promise.resolve(null);
            }
            const strings = self._strings();
            return new Promise(function(resolve) {
                let settled = false;
                function showError(message) {
                    if (errorEl) {
                        errorEl.textContent = message;
                        errorEl.style.display = "block";
                    }
                    input.classList.add("error");
                }
                function clearError() {
                    if (errorEl) {
                        errorEl.textContent = "";
                        errorEl.style.display = "none";
                    }
                    input.classList.remove("error");
                }
                function close(result) {
                    if (settled) return;
                    settled = true;
                    modal.style.display = "none";
                    document.body.classList.remove("save-progress-open");
                    document.documentElement.classList.remove("save-progress-open");
                    resolve(result);
                }
                async function attempt() {
                    const email = input.value.trim();
                    if (!email || !self.validateEmail(email)) {
                        showError(strings.resumeErrorEmail || "Please enter a valid email address");
                        input.focus();
                        return;
                    }
                    clearError();
                    const originalLabel = submit.textContent;
                    submit.disabled = true;
                    skip.disabled = true;
                    input.disabled = true;
                    submit.textContent = strings.resumeRestoring || "Restoring...";
                    let response = null;
                    let payload = null;
                    try {
                        const controller = new AbortController;
                        const timer = setTimeout(function() {
                            controller.abort();
                        }, 12e3);
                        response = await fetch(endpoint, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: email
                            }),
                            signal: controller.signal
                        });
                        clearTimeout(timer);
                        try {
                            payload = await response.json();
                        } catch (e) {}
                    } catch (err) {
                        console.warn("[Resume] Fetch failed:", err && err.name === "AbortError" ? "timed out" : err);
                    }
                    submit.disabled = false;
                    skip.disabled = false;
                    input.disabled = false;
                    submit.textContent = originalLabel;
                    if (!response) {
                        showError(strings.resumeErrorNetwork || "We could not reach our server. Check your connection and try again.");
                        return;
                    }
                    if (response.status === 403) {
                        showError(strings.resumeErrorMismatch || "That is not the email this build was saved with. Try another.");
                        input.select();
                        return;
                    }
                    if (response.status === 410) {
                        showError(strings.resumeErrorExpired || "This saved build has expired.");
                        setTimeout(function() {
                            close(null);
                        }, 2600);
                        return;
                    }
                    if (response.status === 423) {
                        showError(strings.resumeErrorLocked || "Too many tries. Please start a new order and save again.");
                        setTimeout(function() {
                            close(null);
                        }, 2600);
                        return;
                    }
                    if (!response.ok || !payload || !payload.state) {
                        showError(strings.resumeErrorGeneric || "We could not restore your build. Please try again.");
                        return;
                    }
                    close(payload.state);
                }
                submit.addEventListener("click", function(e) {
                    e.preventDefault();
                    attempt();
                });
                skip.addEventListener("click", function(e) {
                    e.preventDefault();
                    close(null);
                });
                input.addEventListener("keydown", function(e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        attempt();
                    }
                });
                input.addEventListener("input", clearError);
                modal.style.display = "flex";
                document.body.classList.add("save-progress-open");
                document.documentElement.classList.add("save-progress-open");
                input.focus();
            });
        },
        _applyResumeToken: async function(token) {
            try {
                if (window.history && window.history.replaceState) {
                    const url = new URL(window.location.href);
                    url.searchParams.delete("resume");
                    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
                }
            } catch (e) {}
            const endpoint = this._resolveConfigurationReadEndpoint(token);
            if (!endpoint) {
                console.error("[Resume] No endpoint resolved — falling through to normal init");
                return null;
            }
            const blob = await this._promptResumeEmail(endpoint);
            if (!blob) return null;
            this.configuration = {
                ...this.configuration,
                ...blob.configuration || {}
            };
            this.pricing = {
                ...this.pricing,
                ...blob.pricing || {}
            };
            this.configuration.saveProgressToken = token;
            this.configuration.orderSource = this.deriveOrderSourceFromFrameChoice(this.configuration.frameChoice);
            this.configuration.isPrescriptionOnlyOrder = false;
            this.configuration.isFramelessRxOrder = false;
            this.configuration.originalOrder = null;
            this.currentStep = blob.currentStep || 1;
            this.currentStep2Substep = blob.currentStep2Substep || null;
            this.isInStep2Substep = blob.isInStep2Substep || false;
            this.lastStep2Substep = blob.lastStep2Substep || null;
            this.currentSubStage = blob.currentSubStage || null;
            this.hasCompletedStep1_5 = blob.hasCompletedStep1_5 || false;
            this.hasVisitedStep1_5 = blob.hasVisitedStep1_5 || false;
            this.wasInStep1_5 = blob.wasInStep1_5 || false;
            this.lastStepBeforeTwo = blob.lastStepBeforeTwo || null;
            this.step1_5FrameChoice = blob.step1_5FrameChoice || null;
            this.originalStep1Header = blob.originalStep1Header || null;
            this.saveState();
            setTimeout(() => this.restoreUIState(), 100);
            console.log("[Resume] Applied saved build — step", this.currentStep, "· sub-step", this.currentStep2Substep, "· sub-stage", this.currentSubStage, "· orderSource", this.configuration.orderSource);
            try {
                document.dispatchEvent(new CustomEvent("configurator:resumed", {
                    detail: {
                        step: this.currentStep,
                        variant: this.configuration.frameChoice
                    }
                }));
            } catch (e) {}
            return this.currentStep;
        },
        showSaveProgressModal: function(opts) {
            const modal = document.getElementById("saveProgressModal");
            if (!modal) {
                console.error("[SaveProgress] Modal element not found");
                return;
            }
            this._saveProgressResetAfter = !!(opts && opts.resetAfterSave);
            this._showSaveProgressPanel("form");
            this._clearSaveProgressError();
            const input = document.getElementById("saveProgressEmailInput");
            if (input) input.value = "";
            const consent = document.getElementById("saveProgressMarketingOptIn");
            if (consent) consent.checked = false;
            this._saveProgressReturnFocus = document.activeElement;
            modal.style.display = "flex";
            document.body.classList.add("save-progress-open");
            document.documentElement.classList.add("save-progress-open");
            if (input) input.focus();
            try {
                document.dispatchEvent(new CustomEvent("configurator:save_progress_opened", {
                    detail: {
                        step: this.currentStep,
                        resetAfterSave: this._saveProgressResetAfter
                    }
                }));
            } catch (e) {}
        },
        hideSaveProgressModal: function() {
            const modal = document.getElementById("saveProgressModal");
            if (modal) modal.style.display = "none";
            document.body.classList.remove("save-progress-open");
            document.documentElement.classList.remove("save-progress-open");
            if (this._saveProgressReturnFocus && typeof this._saveProgressReturnFocus.focus === "function") {
                this._saveProgressReturnFocus.focus();
            }
            this._saveProgressReturnFocus = null;
        },
        _showSaveProgressPanel: function(which) {
            const form = document.getElementById("saveProgressFormPanel");
            const success = document.getElementById("saveProgressSuccessPanel");
            if (!form || !success) return;
            const showingForm = which === "form";
            form.style.display = showingForm ? "flex" : "none";
            success.style.display = showingForm ? "none" : "flex";
        },
        _showSaveProgressError: function(message) {
            const el = document.getElementById("saveProgressError");
            const input = document.getElementById("saveProgressEmailInput");
            if (el) {
                el.textContent = message;
                el.style.display = "block";
            }
            if (input) input.classList.add("error");
        },
        _clearSaveProgressError: function() {
            const el = document.getElementById("saveProgressError");
            const input = document.getElementById("saveProgressEmailInput");
            if (el) {
                el.textContent = "";
                el.style.display = "none";
            }
            if (input) input.classList.remove("error");
        },
        _submitSaveProgress: async function() {
            const input = document.getElementById("saveProgressEmailInput");
            const submit = document.getElementById("saveProgressSubmit");
            const consent = document.getElementById("saveProgressMarketingOptIn");
            const email = input ? input.value.trim() : "";
            if (!email || !this.validateEmail(email)) {
                this._showSaveProgressError(this._strings().saveProgressErrorEmail || "Please enter a valid email address");
                if (input) input.focus();
                return;
            }
            this._clearSaveProgressError();
            const originalLabel = submit ? submit.textContent : "";
            if (submit) {
                submit.disabled = true;
                submit.textContent = this._strings().saveProgressSaving || "Saving...";
            }
            if (input) input.disabled = true;
            if (consent) consent.disabled = true;
            const result = await this._postSaveProgress(email, consent ? consent.checked : false);
            if (submit) {
                submit.disabled = false;
                submit.textContent = originalLabel;
            }
            if (input) input.disabled = false;
            if (consent) consent.disabled = false;
            if (!result.ok) {
                const strings = this._strings();
                const message = result.reason === "network" ? strings.saveProgressErrorNetwork || "We could not reach our server. Check your connection and try again." : strings.saveProgressErrorGeneric || "We could not save your build. Please try again.";
                this._showSaveProgressError(message);
                return;
            }
            const body = document.getElementById("saveProgressSuccessBody");
            if (body) {
                const template = this._strings().saveProgressSuccessBody || "We sent your link to {{ email }}. It works for the next 30 days.";
                body.textContent = template.replace("{{ email }}", email);
            }
            this._showSaveProgressPanel("success");
            try {
                document.dispatchEvent(new CustomEvent("configurator:save_progress_saved", {
                    detail: {
                        step: this.currentStep,
                        resetAfterSave: this._saveProgressResetAfter
                    }
                }));
            } catch (e) {}
        },
        initializeSaveProgressModal: function() {
            const self = this;
            const footerBtn = document.getElementById("saveProgressBtn");
            if (footerBtn) {
                footerBtn.addEventListener("click", function(e) {
                    e.preventDefault();
                    self.showSaveProgressModal({
                        resetAfterSave: false
                    });
                });
            }
            const saveAndReset = document.getElementById("saveAndResetBtn");
            if (saveAndReset) {
                saveAndReset.addEventListener("click", function(e) {
                    e.preventDefault();
                    if (typeof self.hideResetModal === "function") self.hideResetModal();
                    self.showSaveProgressModal({
                        resetAfterSave: false
                    });
                });
            }
            [ "saveProgressClose", "saveProgressCancel" ].forEach(function(id) {
                const el = document.getElementById(id);
                if (el) el.addEventListener("click", function(e) {
                    e.preventDefault();
                    self.hideSaveProgressModal();
                });
            });
            const submit = document.getElementById("saveProgressSubmit");
            if (submit) {
                submit.addEventListener("click", function(e) {
                    e.preventDefault();
                    self._submitSaveProgress();
                });
            }
            const input = document.getElementById("saveProgressEmailInput");
            if (input) {
                input.addEventListener("keydown", function(e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        self._submitSaveProgress();
                    }
                });
                input.addEventListener("input", function() {
                    self._clearSaveProgressError();
                });
            }
            [ "saveProgressDone", "saveProgressSuccessClose" ].forEach(function(id) {
                const el = document.getElementById(id);
                if (el) el.addEventListener("click", function(e) {
                    e.preventDefault();
                    const shouldReset = self._saveProgressResetAfter;
                    self.hideSaveProgressModal();
                    if (shouldReset && typeof self.resetConfiguration === "function") {
                        self.resetConfiguration();
                    }
                });
            });
            const modal = document.getElementById("saveProgressModal");
            if (modal) {
                modal.addEventListener("click", function(e) {
                    if (e.target === modal) self.hideSaveProgressModal();
                });
            }
            document.addEventListener("keydown", function(e) {
                if (e.key !== "Escape") return;
                const m = document.getElementById("saveProgressModal");
                if (m && m.style.display !== "none") self.hideSaveProgressModal();
            });
        },
        _buildUploadRxRideAlong: function() {
            const out = {};
            const domPd = this._readUploadPd();
            const pdStr = this._formatPdProperty(domPd.pdValid ? domPd.pdData : this.configuration.uploadPd);
            if (pdStr) out.pd = pdStr;
            const notes = this._readUploadNotes();
            if (notes) out.notes = notes;
            return out;
        },
        _buildRxPatientPayload: function() {
            const cfg = this.configuration;
            if (cfg.orderForSomeoneElse && cfg.patientName) {
                return {
                    orderFor: "Different Person (See Patient Info)",
                    patientName: cfg.patientName,
                    relationship: cfg.patientRelationship || "Not specified"
                };
            }
            return null;
        },
        _buildRxValuesPayload: function() {
            const cfg = this.configuration;
            const payload = {};
            const hasUpload = !!(cfg.prescriptionUpload && cfg.prescriptionUpload.token);
            const rx = cfg.prescription;
            if (hasUpload) {
                Object.assign(payload, this._buildUploadRxRideAlong());
            } else if (rx && typeof rx === "object") {
                const eye = function(e) {
                    return {
                        sphere: e?.sphere || "",
                        cylinder: e?.cylinder || "",
                        axis: e?.axis || "",
                        add: e?.add || ""
                    };
                };
                const od = eye(rx.od);
                const os = eye(rx.os);
                if (Object.values(od).some(Boolean)) payload.od = od;
                if (Object.values(os).some(Boolean)) payload.os = os;
                const pdStr = this._formatPdProperty(rx.pd);
                if (pdStr) payload.pd = pdStr;
                if (rx.notes) payload.notes = String(rx.notes);
            }
            const patient = this._buildRxPatientPayload();
            if (patient) payload.patient = patient;
            return payload;
        },
        _postRxValues: async function(body) {
            const endpoint = this._resolveRxValuesEndpoint();
            const fail = function(kind, fields) {
                const err = new Error("Rx staging failed: " + kind + (fields ? " [" + fields.join(", ") + "]" : ""));
                err.rxStaging = {
                    kind: kind,
                    fields: fields || null
                };
                return err;
            };
            if (!endpoint) {
                console.error("[Rx Staging] No values endpoint configured (set rx_values_endpoint or rx_upload_endpoint in the section settings)");
                throw fail("no-endpoint");
            }
            const controller = new AbortController;
            const timeout = setTimeout(function() {
                controller.abort();
            }, 15e3);
            let response;
            try {
                response = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(body),
                    signal: controller.signal
                });
            } catch (netErr) {
                console.error("[Rx Staging] Network error:", netErr);
                throw fail("network");
            } finally {
                clearTimeout(timeout);
            }
            if (response.status === 400) {
                let fields = null;
                try {
                    const errBody = await response.json();
                    if (Array.isArray(errBody.fields) && errBody.fields.length) fields = errBody.fields;
                } catch (e) {}
                if (fields) throw fail("invalid-fields", fields);
                throw fail("network");
            }
            if (response.status === 404 && body.token) {
                throw fail("token-gone");
            }
            if (!response.ok) {
                console.error("[Rx Staging] Endpoint returned", response.status);
                throw fail("network");
            }
            const data = await response.json();
            if (!data || !data.token) throw fail("network");
            return data;
        },
        _ensureRxStaged: async function() {
            const cfg = this.configuration;
            const payload = this._buildRxValuesPayload();
            const hasPayload = Object.keys(payload).length > 0;
            const upload = cfg.prescriptionUpload;
            if (upload && upload.token) {
                if (!hasPayload) return upload.token;
                const fingerprint = JSON.stringify(payload);
                if (upload.rxDataFingerprint === fingerprint) return upload.token;
                if (this._rxUpdateModeUnsupported) return upload.token;
                const res = await this._postRxValues({
                    token: upload.token,
                    rx_data: payload
                });
                if (res.token && res.token !== upload.token) {
                    console.warn("[Rx Staging] Values endpoint does not support update mode — deploy the dashboard before removing raw Rx props. Keeping file token.");
                    this._rxUpdateModeUnsupported = true;
                    return upload.token;
                }
                upload.rxDataFingerprint = fingerprint;
                this.saveState();
                console.log("[Rx Staging] Synced PD/notes/patient onto upload staging row");
                return upload.token;
            }
            if (hasPayload) {
                const fingerprint = JSON.stringify(payload);
                if (cfg.rxValuesStaging && cfg.rxValuesStaging.fingerprint === fingerprint) {
                    return cfg.rxValuesStaging.token;
                }
                const res = await this._postRxValues({
                    rx_data: payload
                });
                cfg.rxValuesStaging = {
                    token: res.token,
                    fingerprint: fingerprint,
                    expiresAt: res.expiresAt || null
                };
                this.saveState();
                console.log("[Rx Staging] Typed Rx staged, token received");
                return res.token;
            }
            return cfg.rxCarriedToken || null;
        },
        _clearStaleRxState: function(opts) {
            opts = opts || {};
            const cfg = this.configuration;
            cfg.prescriptionSendLater = false;
            cfg.prescriptionMethod = null;
            cfg.rxCertifiedAt = null;
            cfg.prescriptionSkipped = false;
            cfg.prescriptionSkippedInVariantB = false;
            if (opts.includeRxData === true) {
                cfg.prescription = null;
                cfg.prescriptionUpload = null;
                cfg.uploadPd = null;
                cfg.rxValuesStaging = null;
                cfg.rxCarriedToken = null;
                cfg.rxCarriedStatus = null;
            }
            const ackBtn = document.getElementById("rxLaterAcknowledgeBtn");
            if (ackBtn) ackBtn.classList.remove("acknowledged");
            document.querySelectorAll(".rx-cert-checkbox").forEach(function(b) {
                b.checked = false;
            });
        },
        _orderRequiresRx: function() {
            const cfg = this.configuration;
            if (cfg.frameChoice === "own-frame-own-lenses") return false;
            if (cfg.frameChoice === "Own Frames + Own Lenses") return false;
            if (cfg.nativeLensType === "non-rx" || cfg.nativeLensType === "readers") return false;
            return true;
        },
        _getRxTokenForCart: function() {
            const cfg = this.configuration;
            if (cfg.prescriptionUpload && cfg.prescriptionUpload.token) return cfg.prescriptionUpload.token;
            if (cfg.rxValuesStaging && cfg.rxValuesStaging.token) return cfg.rxValuesStaging.token;
            return cfg.rxCarriedToken || null;
        },
        _handleRxStagingFailure: function(err) {
            const info = err && err.rxStaging || {
                kind: "network"
            };
            let message;
            if (info.kind === "invalid-fields") {
                const labels = {
                    "od.sphere": "OD Sphere",
                    "od.cylinder": "OD Cylinder",
                    "od.axis": "OD Axis",
                    "od.add": "OD Add",
                    "os.sphere": "OS Sphere",
                    "os.cylinder": "OS Cylinder",
                    "os.axis": "OS Axis",
                    "os.add": "OS Add",
                    od: "OD (right eye)",
                    os: "OS (left eye)",
                    pd: "PD",
                    notes: "Rx Notes",
                    patient: "Patient Info",
                    "patient.patientName": "Patient Name",
                    "patient.relationship": "Relationship",
                    "patient.orderFor": "Order For"
                };
                const named = (info.fields || []).map(function(f) {
                    return labels[f] || f;
                }).join(", ");
                message = "Some prescription fields contain characters we can’t accept" + (named ? " (" + named + ")" : "") + ". Please retype them using plain numbers (e.g. -2.00) and try again.";
            } else if (info.kind === "token-gone") {
                this.configuration.prescriptionUpload = null;
                this._clearDropzoneFile();
                this.saveState();
                message = "Your uploaded prescription file has expired. Please re-attach your prescription file, then try again.";
            } else {
                message = "We couldn’t securely save your prescription just now, so your order wasn’t added to the cart. " + "Please check your connection and try again — your details are still filled in.";
            }
            this.showOrderFlowError(message);
            console.error("[Rx Staging] Blocked add-to-cart:", info.kind, info.fields || "");
        },
        prepareCartItems: async function() {
            console.log("═══════════════════════════════════════════════════════════════");
            console.log("[prepareCartItems] === PREPARING CART ITEMS ===");
            console.log("[prepareCartItems] isPrescriptionOnlyOrder:", this.configuration.isPrescriptionOnlyOrder);
            console.log("[prepareCartItems] Full configuration:", JSON.stringify(this.configuration, null, 2));
            console.log("═══════════════════════════════════════════════════════════════");
            if (this.configuration.isPrescriptionOnlyOrder === true) {
                console.log("✅ [prepareCartItems] Prescription-only order detected - using preparePrescriptionOnlyCartItems()");
                return await this.preparePrescriptionOnlyCartItems();
            } else {
                console.log("ℹ️ [prepareCartItems] Standard order (with clips) - using regular prepareCartItems flow");
            }
            const items = [];
            const existingClipsForDiscount = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel);
            const hasClipForSameFrame = existingClipsForDiscount.length >= 1;
            if (this.isBuilding2ndClip && existingClipsForDiscount.length === 0 && !this.isFrameReorderMode && !this.isOpticalRetailerReorder) {
                console.warn("[prepareCartItems] isBuilding2ndClip is true but cart has no clips for this frame - resetting stale flag");
                this.isBuilding2ndClip = false;
                this._secondClipStartTime = null;
                this.saveState();
            }
            const shouldApplyDiscount = this.isBuilding2ndClip || hasClipForSameFrame || this.isReorderMode || this.isOpticalRetailerReorder || this.isRedrillFlow;
            console.log(`[prepareCartItems] Should apply 2nd clip discount: ${shouldApplyDiscount} (isBuilding2ndClip: ${this.isBuilding2ndClip}, existingClips: ${existingClipsForDiscount.length}, isReorderMode: ${this.isReorderMode}, isOpticalRetailerReorder: ${this.isOpticalRetailerReorder})`);
            const clipVariantId = this.getProductVariantId("lens", {
                clipType: this.configuration.clipType,
                category: this.configuration.lensCategory,
                color: this.configuration.lensColor,
                magnification: this.configuration.magnification,
                therapeuticType: this.configuration.therapeuticType,
                intensity: this.configuration.therapeuticIntensity
            }, shouldApplyDiscount);
            if (!clipVariantId) {
                console.error("[prepareCartItems] Could not get clip variant ID");
                console.error("[prepareCartItems] Configuration:", {
                    clipType: this.configuration.clipType,
                    category: this.configuration.lensCategory,
                    color: this.configuration.lensColor,
                    magnification: this.configuration.magnification,
                    therapeuticType: this.configuration.therapeuticType,
                    intensity: this.configuration.therapeuticIntensity
                });
                alert("We encountered an issue finding the selected product variant. Please try a different selection or contact support for assistance.");
                throw new Error("Variant lookup failed - clipVariantId is null");
            }
            let configId;
            const existingClips = await this.getExistingClipsForFrame(this.configuration.frameProduct, this.configuration.frameBrand, this.configuration.frameModel);
            const highestExistingSequence = existingClips.reduce((max, clip) => {
                const parsed = parseInt(clip.properties?.["_Clip Sequence"], 10);
                return Number.isFinite(parsed) && parsed > max ? parsed : max;
            }, 0);
            const clipSequence = Math.max(highestExistingSequence, existingClips.length) + 1;
            const isFirstClip = clipSequence === 1;
            if (existingClips.length > 0) {
                const firstClipConfigId = existingClips[0].properties["_Configuration ID"] || existingClips[0].properties["_Parent Config ID"];
                if (firstClipConfigId) {
                    configId = firstClipConfigId;
                    console.log(`[prepareCartItems] Clip #${clipSequence} for same frame - reusing config ID:`, configId);
                } else {
                    configId = this.generateConfigId();
                    console.warn("[prepareCartItems] Existing clip has no config ID - generating new");
                }
            } else {
                configId = this.generateConfigId();
                console.log(`[prepareCartItems] Clip #${clipSequence} (first for this frame) - generated new config ID:`, configId);
            }
            const clipTypeLabel = this.getClipTypeLabel();
            const frameLabel = this.configuration.frameBrand && this.configuration.frameModel ? `${this.configuration.frameBrand} ${this.configuration.frameModel}` : this.getFrameChoiceLabel();
            const configSummary = `${clipTypeLabel} for ${frameLabel}`;
            const properties = {
                "_Configuration ID": configId,
                "_Item Type": "CLIP (Parent)",
                "_Clip Sequence": String(clipSequence),
                "_Order Source": this.configuration.orderSource || this.deriveOrderSourceFromFrameChoice(this.configuration.frameChoice) || "Order Flow - Unknown",
                ...this.configuration.originalOrder ? {
                    "_Original Order": this.configuration.originalOrder
                } : {},
                "Clip Configuration": configSummary,
                "_Frame Choice": this.getFrameChoiceLabel(),
                "_Frame Choice Key": this.configuration.frameChoice
            };
            if (this.configuration.frameBrand) {
                properties["_Frame Brand"] = this.configuration.frameBrand;
            }
            if (this.configuration.frameModel) {
                properties["_Frame Model"] = this.configuration.frameModel;
            }
            const isNewLensFlow = this.configuration.frameChoice === "own-frame-new-lenses" || this.configuration.frameChoice === "new-frame-lenses";
            if (this.configuration.nativeLensType && isNewLensFlow) {
                properties["_Native Lens Type"] = this.configuration.nativeLensType;
            }
            if (this.configuration.nativeLensFeature && isNewLensFlow) {
                properties["_Native Lens Feature"] = this.configuration.nativeLensFeature;
            }
            if (this.configuration.nativeLensMaterial && isNewLensFlow && this.configuration.nativeLensType !== "readers" && this.configuration.nativeLensType !== "non-rx") {
                properties["_Native Lens Material"] = this.configuration.nativeLensMaterial;
            }
            if (this.configuration.readerPower && isNewLensFlow && this.configuration.nativeLensType === "readers") {
                properties["_Reader Power"] = this.configuration.readerPower;
            }
            properties["_Clip Type"] = this.getClipTypeLabel();
            if (this.configuration.clipType === "sun") {
                if (this.configuration.lensCategory) {
                    properties["_Lens Category"] = this.capitalizeWords(this.configuration.lensCategory);
                }
                if (this.configuration.lensColor) {
                    properties["_Lens Color"] = this.getLensColorDisplayName(this.configuration.lensColor, this.configuration.lensCategory);
                }
            }
            if ((this.configuration.clipType === "reader" || this.configuration.clipType === "blueLight") && this.configuration.magnification) {
                properties["_Magnification"] = this.configuration.magnification;
            }
            if (this.configuration.clipType === "lightSensitivity") {
                if (this.configuration.lightSensitivityIntensity) {
                    properties["_FL-41 Intensity"] = this.configuration.lightSensitivityIntensity;
                }
            }
            if (this.configuration.clipType === "migraine") {
                properties["_Lens Type"] = "Avulux";
            }
            if (this.configuration.bridgeColor) {
                properties["_Bridge Finish"] = this.capitalizeWords(this.configuration.bridgeColor);
            }
            if (this.configuration.magnetColor) {
                properties["_Magnet Finish"] = this.capitalizeWords(this.configuration.magnetColor);
            }
            if (this.configuration.crystalColor) {
                properties["_Crystal Accent"] = this.capitalizeWords(this.configuration.crystalColor);
            }
            let clipBasePrice;
            if (this.configuration.clipType === "lightSensitivity" && this.configuration.lightSensitivityColor) {
                const lensOption = this.therapeuticLensPricing[this.configuration.lightSensitivityColor];
                const fullPrice = lensOption ? lensOption.price : 175;
                clipBasePrice = shouldApplyDiscount ? fullPrice - 80 : fullPrice;
            } else if (this.configuration.clipType === "migraine") {
                const fullPrice = window.chemistrie_prices?.clip_migraine || 495;
                clipBasePrice = fullPrice;
            } else {
                const fullPrice = this.clipTypes[this.configuration.clipType]?.price || 0;
                clipBasePrice = shouldApplyDiscount ? fullPrice - 80 : fullPrice;
            }
            properties["_Base Clip Price"] = this.formatPrice(clipBasePrice);
            console.log("[prepareCartItems] 2nd Clip Discount Check:", {
                frameProduct: this.configuration.frameProduct,
                frameBrand: this.configuration.frameBrand,
                frameModel: this.configuration.frameModel,
                existingClipsCount: existingClips.length,
                isBuilding2ndClip: this.isBuilding2ndClip,
                shouldApplyDiscount: shouldApplyDiscount,
                clipBasePrice: clipBasePrice
            });
            if (this.configuration.nativeLensType && (this.configuration.frameChoice === "own-frame-new-lenses" || this.configuration.frameChoice === "new-frame-lenses")) {
                const lensBreakdown = await this.getNativeLensBreakdown();
                properties["_Native Lens Upgrades Total"] = this.formatPrice(lensBreakdown.total);
                if (lensBreakdown.prescriptionType.price > 0) {
                    properties["_Prescription Type Charge"] = `${lensBreakdown.prescriptionType.label} (+${this.formatPrice(lensBreakdown.prescriptionType.price)})`;
                }
                if (lensBreakdown.lensMaterial.price > 0) {
                    properties["_Lens Material Charge"] = `${this.getLabLensMaterialLabel(this.configuration.nativeLensMaterial)} (+${this.formatPrice(lensBreakdown.lensMaterial.price)})`;
                }
                if (lensBreakdown.blueLight.price > 0) {
                    properties["_Blue Light Feature"] = `Blue Light filter (+${this.formatPrice(lensBreakdown.blueLight.price)})`;
                }
            }
            if (this.pricing.crystals > 0) {
                properties["_Crystal Accent Price"] = "+" + this.formatPrice(this.pricing.crystals);
            }
            const accessoriesTotal = this.configuration.accessories.reduce((sum, acc) => {
                const accPrice = window.chemistrie_prices?.[acc.type] || 0;
                return sum + accPrice;
            }, 0);
            if (accessoriesTotal > 0) {
                properties["_Accessories Total"] = this.formatPrice(accessoriesTotal);
            }
            if (this.configuration.frameProduct) {
                properties["_Frame Product ID"] = this.configuration.frameProduct;
            }
            if (this.isReorderMode || this.isFrameReorderMode) {
                if (this.configuration.frameProduct) {
                    properties["_Frame Handle"] = this.configuration.frameProduct;
                }
                if (this.configuration.frameVariantId) {
                    properties["_Frame Variant ID"] = String(this.configuration.frameVariantId);
                }
                if (this.configuration.frameVariantTitle) {
                    properties["_Frame Color"] = this.configuration.frameVariantTitle;
                }
            }
            if (shouldApplyDiscount) {
                if (this.isRedrillFlow) {
                    properties["_Clip Number"] = "Redrill - Replacement Magnets (Multi-Clip Discount)";
                } else if (this.isOpticalRetailerReorder) {
                    properties["_Clip Number"] = "Reorder - Optical Retailer (Multi-Clip Discount)";
                } else if (this.isReorderMode || this.isFrameReorderMode) {
                    properties["_Clip Number"] = "Reorder (Multi-Clip Discount)";
                } else if (this.isBuilding2ndClip) {
                    properties["_Clip Number"] = "2nd (Build Flow)";
                } else {
                    properties["_Clip Number"] = `2nd (${existingClips.length} existing for same frame)`;
                }
            } else {
                properties["_Clip Number"] = "1st";
            }
            const totalConfigPrice = await this.calculateTotalPrice();
            properties["_Configuration Total"] = this.formatPrice(totalConfigPrice);
            properties["_Note"] = `Cart shows base variant price (${this.formatPrice(clipBasePrice)}). Total with all customization: ${this.formatPrice(totalConfigPrice)}`;
            const rxUpload = this.configuration.prescriptionUpload;
            if (rxUpload && rxUpload.token && this._orderRequiresRx()) {
                properties["_Prescription Status"] = "Uploaded - Pending verification";
                properties["_Rx Upload Token"] = rxUpload.token;
                if (rxUpload.fileName) properties["_Rx Upload Filename"] = rxUpload.fileName;
                console.log("[prepareCartItems] Added prescription upload token to cart properties");
            } else if (this.configuration.prescriptionSendLater === true && this._orderRequiresRx()) {
                properties["_Prescription Status"] = "Pending - Customer will send later";
                console.log('[prepareCartItems] Added prescription "send later" metadata to cart properties');
            } else if (this.configuration.prescription && this.configuration.prescription !== "skip" && this._orderRequiresRx()) {
                properties["_Prescription Status"] = "Provided";
            } else if (this.configuration.rxCarriedToken && this.configuration.rxCarriedStatus) {
                properties["_Prescription Status"] = this.configuration.rxCarriedStatus;
            }
            const stagedRxToken = this._getRxTokenForCart();
            if (!properties["_Rx Upload Token"] && stagedRxToken && (this._orderRequiresRx() || stagedRxToken === this.configuration.rxCarriedToken)) {
                properties["_Rx Upload Token"] = stagedRxToken;
            }
            const certMethod = this.configuration.prescriptionMethod;
            if ((certMethod === "manual" || certMethod === "upload") && this.configuration.rxCertifiedAt) {
                properties["_Rx Certified At"] = this.configuration.rxCertifiedAt;
            }
            if (this.configuration.termsAcceptedAt) {
                properties["_Terms Accepted At"] = this.configuration.termsAcceptedAt;
            }
            if (this.configuration.frameChoice === "new-frame-lenses" && this.configuration.frameProduct && !shouldApplyDiscount) {
                const frameVariantId = await this.getFrameVariantId();
                if (frameVariantId) {
                    let frameDisplayName = this.configuration.frameProduct.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
                    let variantColorDisplay = "";
                    if (this.configuration.frameVariantTitle) {
                        variantColorDisplay = this.configuration.frameVariantTitle.replace(/^Option\d*[-_]?/i, "").charAt(0).toUpperCase() + this.configuration.frameVariantTitle.replace(/^Option\d*[-_]?/i, "").slice(1);
                        frameDisplayName += ` - ${variantColorDisplay}`;
                    }
                    const frameSummaryColor = this.configuration.lensColor ? this.capitalizeWords(this.configuration.lensColor.replace(/-/g, " ")) : "Standard";
                    const frameConfigSummary = [ `Frame: ${frameDisplayName}`, `Clip: ${this.getClipTypeLabel()}`, `Color: ${frameSummaryColor}` ].join(" | ");
                    items.push({
                        id: frameVariantId,
                        quantity: 1,
                        properties: {
                            "_Configuration ID": configId,
                            "_Item Type": "FRAME (Parent)",
                            "_Order Source": this.configuration.orderSource || "Order Flow - Variant C",
                            Frame: frameDisplayName,
                            "_Frame Handle": this.configuration.frameProduct,
                            "_Frame Product ID": this.configuration.frameProduct,
                            "_Frame Choice": this.getFrameChoiceLabel(),
                            "_Frame Choice Key": this.configuration.frameChoice,
                            ...this.configuration.frameVariantId && {
                                "_Frame Variant ID": String(this.configuration.frameVariantId)
                            },
                            ...this.configuration.frameVariantTitle && {
                                "_Frame Color": variantColorDisplay || this.configuration.frameVariantTitle
                            },
                            "Clip Configuration": frameConfigSummary,
                            ...this.configuration.nativeLensType && {
                                "Prescription Lens": this.capitalizeWords(this.configuration.nativeLensType.replace(/-/g, " ")),
                                "_Native Lens Type": this.configuration.nativeLensType,
                                "_Native Lens Feature": this.configuration.nativeLensFeature || "standard",
                                "_Native Lens Material": this.configuration.nativeLensMaterial || "standard"
                            },
                            ...this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token && this._orderRequiresRx() && {
                                "_Prescription Status": "Uploaded - Pending verification",
                                "_Rx Upload Token": this.configuration.prescriptionUpload.token,
                                ...this.configuration.prescriptionUpload.fileName && {
                                    "_Rx Upload Filename": this.configuration.prescriptionUpload.fileName
                                }
                            },
                            ...!(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token) && this.configuration.prescriptionSendLater === true && this._orderRequiresRx() && {
                                "_Prescription Status": "Pending - Customer will send later"
                            },
                            ...!(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token) && this.configuration.prescription && this.configuration.prescription !== "skip" && !this.configuration.prescriptionSendLater && this._orderRequiresRx() && {
                                "_Prescription Status": "Provided"
                            },
                            ...!(this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token) && this._getRxTokenForCart() && (this._orderRequiresRx() || this._getRxTokenForCart() === this.configuration.rxCarriedToken) && {
                                "_Rx Upload Token": this._getRxTokenForCart()
                            },
                            ...(this.configuration.prescriptionMethod === "manual" || this.configuration.prescriptionMethod === "upload") && this.configuration.rxCertifiedAt && {
                                "_Rx Certified At": this.configuration.rxCertifiedAt
                            },
                            ...this.configuration.termsAcceptedAt && {
                                "_Terms Accepted At": this.configuration.termsAcceptedAt
                            },
                            "_Clip Type": this.getClipTypeLabel(),
                            "_Clip Type Key": this.configuration.clipType || "",
                            ...this.configuration.clipType === "sun" && this.configuration.lensCategory && {
                                "_Lens Category": this.capitalizeWords(this.configuration.lensCategory)
                            },
                            ...this.configuration.clipType === "sun" && this.configuration.lensColor && {
                                "_Lens Color": this.configuration.lensColor
                            },
                            ...this.configuration.magnification && {
                                _Magnification: this.configuration.magnification
                            },
                            ...this.configuration.therapeuticType && {
                                "_Therapeutic Type": this.configuration.therapeuticType
                            },
                            ...this.configuration.therapeuticIntensity && {
                                "_Therapeutic Intensity": this.configuration.therapeuticIntensity
                            },
                            "_Bridge Finish": this.capitalizeWords(this.configuration.bridgeColor || "MatteBlack"),
                            "_Magnet Finish": this.capitalizeWords(this.configuration.magnetColor || "Gunmetal"),
                            ...this.configuration.crystalColor && {
                                "_Crystal Accent": this.capitalizeWords(this.configuration.crystalColor)
                            }
                        }
                    });
                    console.log("[prepareCartItems] ✅ Added frame as parent (Variant C) with prescription:", {
                        frameProduct: this.configuration.frameProduct,
                        frameVariantId: frameVariantId,
                        configId: configId,
                        displayName: frameDisplayName
                    });
                } else {
                    console.error("[prepareCartItems] ❌ Could not find frame variant ID for:", this.configuration.frameProduct);
                    throw new Error(`Frame variant not found: ${this.configuration.frameProduct}`);
                }
            }
            const isVariantC = this.configuration.frameChoice === "new-frame-lenses";
            const frameWasAdded = isVariantC && !shouldApplyDiscount;
            const clipProperties = {
                ...properties
            };
            if (frameWasAdded) {
                delete clipProperties["_Configuration ID"];
                clipProperties["_Parent Config ID"] = configId;
                clipProperties["_Item Type"] = "  ↳ Clip (Child)";
                if (this.configuration.frameProduct) {
                    clipProperties["_Frame Product ID"] = this.configuration.frameProduct;
                }
            } else {
                clipProperties["_Item Type"] = "CLIP (Parent)";
                const isFirstClipOfVariantC2ndClipFlow = isVariantC && shouldApplyDiscount;
                if (!isFirstClipOfVariantC2ndClipFlow) {
                    const clipRxUpload = this.configuration.prescriptionUpload;
                    if (clipRxUpload && clipRxUpload.token && this._orderRequiresRx()) {
                        clipProperties["_Prescription Status"] = "Uploaded - Pending verification";
                        clipProperties["_Rx Upload Token"] = clipRxUpload.token;
                        if (clipRxUpload.fileName) clipProperties["_Rx Upload Filename"] = clipRxUpload.fileName;
                    } else if (this.configuration.prescriptionSendLater === true && this._orderRequiresRx()) {
                        clipProperties["_Prescription Status"] = "Pending - Customer will send later";
                    } else if (this.configuration.prescription && this.configuration.prescription !== "skip" && this._orderRequiresRx()) {
                        clipProperties["_Prescription Status"] = "Provided";
                    }
                    const clipCertMethod = this.configuration.prescriptionMethod;
                    if ((clipCertMethod === "manual" || clipCertMethod === "upload") && this.configuration.rxCertifiedAt) {
                        clipProperties["_Rx Certified At"] = this.configuration.rxCertifiedAt;
                    }
                    if (this.configuration.termsAcceptedAt) {
                        clipProperties["_Terms Accepted At"] = this.configuration.termsAcceptedAt;
                    }
                }
            }
            const variantImageUrl = this.getVariantImageUrl({
                clipType: this.configuration.clipType,
                category: this.configuration.lensCategory,
                color: this.configuration.lensColor,
                intensity: this.configuration.therapeuticIntensity
            });
            if (variantImageUrl) {
                clipProperties["_Variant Image"] = variantImageUrl;
            }
            items.push({
                id: clipVariantId,
                quantity: this.configuration.quantity || 1,
                properties: clipProperties
            });
            console.log("[prepareCartItems] Added clip item:", items[items.length - 1]);
            if (this.configuration.nativeLensType && !shouldApplyDiscount && (this.configuration.frameChoice === "own-frame-new-lenses" || this.configuration.frameChoice === "new-frame-lenses")) {
                const lensBreakdown = await this.getNativeLensBreakdown();
                const isVariantC = this.configuration.frameChoice === "new-frame-lenses";
                const shouldAddLensItem = lensBreakdown.total > 0 || isVariantC;
                if (shouldAddLensItem) {
                    const lensType = this.configuration.nativeLensType;
                    const lensUpgradeVariantId = this.getLensUpgradeVariantId(lensBreakdown.total, lensType);
                    if (lensUpgradeVariantId) {
                        const upgradeDetails = [];
                        if (isVariantC) {
                            if (lensType === "single-vision") {
                                upgradeDetails.push("Single Vision Lenses (Included)");
                            } else if (lensType === "readers") {
                                const readerPower = this.configuration.readerPower || "+1.00";
                                upgradeDetails.push(`Reader Lenses ${readerPower} (Included)`);
                            } else if (lensType === "non-rx") {
                                upgradeDetails.push("Non-Rx Lenses (Included)");
                            }
                        }
                        if (lensBreakdown.prescriptionType.price > 0) {
                            upgradeDetails.push(`${lensBreakdown.prescriptionType.label} (+${this.formatPrice(lensBreakdown.prescriptionType.price)})`);
                        }
                        if (lensBreakdown.lensMaterial.price > 0 && lensType !== "readers" && lensType !== "non-rx") {
                            upgradeDetails.push(`${this.getLabLensMaterialLabel(this.configuration.nativeLensMaterial)} (+${this.formatPrice(lensBreakdown.lensMaterial.price)})`);
                        }
                        if (lensBreakdown.blueLight.price > 0) {
                            upgradeDetails.push(`Blue Light filter (+${this.formatPrice(lensBreakdown.blueLight.price)})`);
                        }
                        const lensProperties = {
                            "_Parent Config ID": configId,
                            "_Item Type": "  ↳ Prescription Lens (Child)",
                            _Is_Paid_Upgrade: lensBreakdown.total > 0 ? "true" : "false",
                            "For Frame": frameLabel,
                            "_Upgrade Details": upgradeDetails.join(" + "),
                            "_Prescription Type": this.configuration.nativeLensType,
                            "_Lens Feature": this.configuration.nativeLensFeature || "standard"
                        };
                        if (this.configuration.nativeLensType !== "readers" && this.configuration.nativeLensType !== "non-rx") {
                            lensProperties["_Lens Material"] = this.configuration.nativeLensMaterial || "standard";
                        }
                        if (this.configuration.nativeLensType === "readers" && this.configuration.readerPower) {
                            lensProperties["_Reader Power"] = this.configuration.readerPower;
                        }
                        items.push({
                            id: lensUpgradeVariantId,
                            quantity: 1,
                            properties: lensProperties
                        });
                    } else {
                        console.warn("[prepareCartItems] Could not find lens upgrade variant for price:", lensBreakdown.total);
                    }
                }
            }
            if (this.configuration.crystalColor && this.pricing.crystals > 0) {
                const crystalVariantId = this.getCrystalVariantId();
                if (crystalVariantId) {
                    items.push({
                        id: crystalVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configId,
                            "_Clip Sequence": String(clipSequence),
                            "_Item Type": "  ↳ Crystal Accent (Child)",
                            "For Clip": configSummary
                        }
                    });
                    console.log("[prepareCartItems] Added crystal accent variant:", this.configuration.crystalColor, "ID:", crystalVariantId);
                } else {
                    console.warn("[prepareCartItems] Could not find crystal variant ID");
                }
            }
            console.log("[prepareCartItems] 🔍 BRIDGE CHECK:", {
                bridgeColor: this.configuration.bridgeColor,
                isPrescriptionOnlyOrder: this.configuration.isPrescriptionOnlyOrder,
                itemsCountBefore: items.length
            });
            if (this.configuration.bridgeColor && !this.configuration.isPrescriptionOnlyOrder) {
                const bridgeVariantId = this.getBridgeVariantId();
                console.log("[prepareCartItems] 🔍 Bridge variant lookup result:", bridgeVariantId);
                if (bridgeVariantId) {
                    const bridgeItem = {
                        id: bridgeVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configId,
                            "_Clip Sequence": String(clipSequence),
                            "_Item Type": "  ↳ Bridge Hardware (Child)",
                            "For Clip": configSummary
                        }
                    };
                    items.push(bridgeItem);
                    console.log("[prepareCartItems] ✅ Added bridge hardware variant:", this.configuration.bridgeColor, "ID:", bridgeVariantId);
                    console.log("[prepareCartItems] ✅ Bridge item added:", JSON.stringify(bridgeItem));
                    console.log("[prepareCartItems] ✅ Items count after bridge:", items.length);
                } else {
                    console.error("[prepareCartItems] ❌ CRITICAL: Could not find bridge variant ID for color:", this.configuration.bridgeColor);
                    console.error("[prepareCartItems] ❌ Available bridge variants:", window.chemistrie_products?.accessories?.bridge?.variants);
                    throw new Error("HARDWARE_VARIANT_MISSING:bridge");
                }
            } else if (this.configuration.bridgeColor && this.configuration.isPrescriptionOnlyOrder) {
                console.log("[prepareCartItems] ⚠️ Bridge hardware skipped - prescription-only order (hardware is only for clips)");
            } else if (!this.configuration.bridgeColor) {
                console.error("[prepareCartItems] ❌ Bridge hardware skipped - bridgeColor is falsy:", this.configuration.bridgeColor);
            }
            if (this.configuration.magnetColor && !this.configuration.isPrescriptionOnlyOrder) {
                const magnetVariantId = this.getMagnetVariantId();
                if (magnetVariantId) {
                    items.push({
                        id: magnetVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configId,
                            "_Clip Sequence": String(clipSequence),
                            "_Item Type": "  ↳ Magnet Hardware (Child)",
                            "For Clip": configSummary
                        }
                    });
                    console.log("[prepareCartItems] Added magnet hardware variant:", this.configuration.magnetColor, "ID:", magnetVariantId);
                } else {
                    console.error("[prepareCartItems] ❌ CRITICAL: Could not find magnet variant ID for color:", this.configuration.magnetColor);
                    throw new Error("HARDWARE_VARIANT_MISSING:magnet");
                }
            } else if (this.configuration.magnetColor && this.configuration.isPrescriptionOnlyOrder) {
                console.log("[prepareCartItems] ⚠️ Magnet hardware skipped - prescription-only order (hardware is only for clips)");
            }
            if (this.isRedrillFlow && this.redrillVariantId) {
                items.push({
                    id: this.redrillVariantId,
                    quantity: 1,
                    properties: {
                        "_Parent Config ID": configId,
                        "_Clip Sequence": String(clipSequence),
                        "_Item Type": "Redrill / Replacement Magnets",
                        "_Order Source": "Redrill - Replacement Magnets",
                        "For Clip": configSummary
                    }
                });
                console.log("[prepareCartItems] Added redrill magnets line item, variant ID:", this.redrillVariantId);
            }
            console.log("🔍 [prepareCartItems] Processing accessories...");
            console.log("🔍 [prepareCartItems] Accessories in configuration:", this.configuration.accessories);
            if (this.configuration.accessories && this.configuration.accessories.length > 0) {
                console.log(`🔍 [prepareCartItems] Found ${this.configuration.accessories.length} accessories to add`);
                this.configuration.accessories.forEach((accessory, index) => {
                    console.log(`🔍 [prepareCartItems] Processing accessory ${index + 1}:`, accessory);
                    const accessoryVariantId = this.getAccessoryVariantId(accessory.type);
                    if (accessoryVariantId) {
                        const accessoryData = this.accessories[accessory.type];
                        const windowAccessoryData = window.chemistrie_products?.accessories?.[accessory.type];
                        const accessoryName = accessoryData?.name || windowAccessoryData?.title || this.capitalizeWords(accessory.type.replace(/_/g, " "));
                        const accessoryItem = {
                            id: accessoryVariantId,
                            quantity: 1,
                            properties: {
                                "_Parent Config ID": configId,
                                "_Clip Sequence": String(clipSequence),
                                "_Item Type": "  ↳ " + accessoryName,
                                "For Clip": configSummary,
                                "_Accessory Name": accessoryName
                            }
                        };
                        items.push(accessoryItem);
                        console.log(`✅ [prepareCartItems] Added accessory "${accessory.type}" with variant ID ${accessoryVariantId}`);
                        console.log("✅ [prepareCartItems] Accessory item:", accessoryItem);
                    } else {
                        console.error(`❌ [prepareCartItems] FAILED: Could not find variant for accessory "${accessory.type}"`);
                        console.log("❌ [prepareCartItems] This accessory will NOT be added to cart!");
                    }
                });
            } else {
                console.log("🔍 [prepareCartItems] No accessories selected");
            }
            console.log("[prepareCartItems] Total items prepared:", items.length);
            console.log("[prepareCartItems] All items:", items);
            if (items.length > 0) {
                const parent = items[0];
                const parentIsClip = /clip/i.test(parent.properties?.["_Item Type"] || "");
                const children = items.slice(1).map(item => {
                    const isLensLine = /prescription lens/i.test(item.properties?.["_Item Type"] || "");
                    return parentIsClip && isLensLine ? {
                        ...item,
                        nestUnderParent: false
                    } : item;
                });
                console.log("[prepareCartItems] 📦 FINAL CART STRUCTURE:");
                console.log("  Parent:", parent.properties?.["_Item Type"] || "Unknown");
                console.log("  Children (" + children.length + "):");
                children.forEach((child, idx) => {
                    console.log(`    ${idx + 1}. ${child.properties?.["_Item Type"] || "Unknown"} (ID: ${child.id})`);
                });
                const hasBridge = children.some(c => c.properties?.["_Item Type"]?.includes("Bridge"));
                const hasMagnet = children.some(c => c.properties?.["_Item Type"]?.includes("Magnet"));
                console.log("[prepareCartItems] 🔍 Hardware check: Bridge=" + hasBridge + ", Magnet=" + hasMagnet);
                if (!hasBridge && this.configuration.bridgeColor) {
                    console.error("[prepareCartItems] ❌ WARNING: Bridge was configured but NOT in children array!");
                }
                if (!hasMagnet && this.configuration.magnetColor) {
                    console.error("[prepareCartItems] ❌ WARNING: Magnet was configured but NOT in children array!");
                }
                console.log("[prepareCartItems] Structured for nested cart lines:", {
                    parent: parent,
                    childrenCount: children.length
                });
                return {
                    parent: parent,
                    children: children
                };
            } else {
                return {
                    parent: null,
                    children: []
                };
            }
        },
        preparePrescriptionOnlyCartItems: async function() {
            console.log("[preparePrescriptionOnlyCartItems] Preparing cart items for prescription-only order");
            const items = [];
            const configurationId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
            const frameHandle = this.configuration.frameProduct;
            const frameVariantId = await this.getFrameVariantId();
            const frameData = window.chemistrie_products.frames[frameHandle];
            const lensType = this.configuration.nativeLensType;
            const lensFeature = this.configuration.nativeLensFeature;
            const lensMaterial = this.configuration.nativeLensMaterial;
            const lensDescription = this.buildPrescriptionLensSummary(lensType, lensFeature, lensMaterial, this.configuration.readerPower);
            const frameItem = {
                id: frameVariantId,
                quantity: 1,
                properties: {
                    "_Configuration ID": configurationId,
                    "_Order Type": "Prescription Only",
                    "_Item Type": "Eyeglasses Frame (Parent)",
                    "_Order Source": this.configuration.orderSource || "Eyeglasses PDP - Prescription Only",
                    "_Frame Choice Key": "new-frame-lenses",
                    "_Frame Product ID": frameHandle,
                    "_Frame Handle": frameHandle,
                    Frame: frameData?.title || frameHandle,
                    "Prescription Lenses": lensDescription,
                    "_Lens Type": lensType || "single-vision",
                    "_Lens Material": lensMaterial || "standard",
                    "_Lens Feature": lensFeature || "standard",
                    ...this.configuration.frameVariantId && {
                        "_Frame Variant ID": String(this.configuration.frameVariantId)
                    },
                    ...this.configuration.frameVariantTitle && {
                        "_Frame Color": this.configuration.frameVariantTitle
                    }
                }
            };
            if (lensType === "readers" && this.configuration.readerPower) {
                frameItem.properties["_Reader Power"] = this.configuration.readerPower;
            }
            const rxOnlyToken = this._getRxTokenForCart();
            if (!frameItem.properties["_Rx Upload Token"] && rxOnlyToken) {
                frameItem.properties["_Rx Upload Token"] = rxOnlyToken;
            }
            items.push(frameItem);
            console.log("[preparePrescriptionOnlyCartItems] Added frame item:", frameItem);
            const lensBreakdown = await this.getNativeLensBreakdown();
            let upgradePrice = 0;
            if (lensType === "single-vision") {
                upgradePrice = lensBreakdown.lensMaterial.price + lensBreakdown.blueLight.price;
            } else if (lensType === "progressive") {
                upgradePrice = lensBreakdown.prescriptionType.price + lensBreakdown.lensMaterial.price + lensBreakdown.blueLight.price;
            } else if (lensType === "readers" || lensType === "non-rx") {
                upgradePrice = lensBreakdown.blueLight.price;
            }
            console.log("[preparePrescriptionOnlyCartItems] Lens upgrade calculation:", {
                lensType: lensType,
                lensFeature: lensFeature,
                lensMaterial: lensMaterial,
                breakdown: lensBreakdown,
                upgradePrice: upgradePrice
            });
            const lensUpgradeDetails = [];
            if (lensType === "progressive" && lensBreakdown.prescriptionType.price > 0) {
                lensUpgradeDetails.push(`Progressive Lenses (+${this.formatPrice(lensBreakdown.prescriptionType.price)})`);
            } else if (lensType === "readers") {
                const readerPower = this.configuration.readerPower;
                lensUpgradeDetails.push(`Reader Lenses${readerPower ? " " + readerPower : ""} (Included)`);
            } else if (lensType === "non-rx") {
                lensUpgradeDetails.push("Non-Rx Lenses (Included)");
            } else {
                lensUpgradeDetails.push("Single Vision Lenses (Included)");
            }
            if (lensFeature === "blue-light" && lensBreakdown.blueLight.price > 0) {
                lensUpgradeDetails.push(`Blue Light filter (+${this.formatPrice(lensBreakdown.blueLight.price)})`);
            }
            if (lensBreakdown.lensMaterial.price > 0) {
                lensUpgradeDetails.push(`${this.getLabLensMaterialLabel(lensMaterial)} (+${this.formatPrice(lensBreakdown.lensMaterial.price)})`);
            }
            if (upgradePrice > 0) {
                const lensUpgradeVariantId = this.getLensUpgradeVariantId(upgradePrice, this.configuration.nativeLensType);
                if (lensUpgradeVariantId) {
                    const lensItem = {
                        id: lensUpgradeVariantId,
                        quantity: 1,
                        properties: {
                            "_Parent Config ID": configurationId,
                            "_Item Type": "  ↳ Prescription Lenses (Child)",
                            _Is_Paid_Upgrade: "true",
                            "For Frame": frameData?.title || frameHandle,
                            "_Upgrade Details": lensUpgradeDetails.join(" + ")
                        }
                    };
                    items.push(lensItem);
                    console.log("[preparePrescriptionOnlyCartItems] Added lens upgrade item (paid):", lensItem);
                } else {
                    console.warn("[preparePrescriptionOnlyCartItems] No variant found for upgrade price:", upgradePrice);
                }
            } else {
                console.log("[preparePrescriptionOnlyCartItems] Single Vision Included - no child item needed (info on parent)");
            }
            console.log("[preparePrescriptionOnlyCartItems] Processing accessories...");
            console.log("[preparePrescriptionOnlyCartItems] Accessories in configuration:", this.configuration.accessories);
            if (this.configuration.accessories && this.configuration.accessories.length > 0) {
                console.log(`[preparePrescriptionOnlyCartItems] Found ${this.configuration.accessories.length} accessories to add`);
                const frameTitle = frameData?.title || frameHandle;
                this.configuration.accessories.forEach((accessory, index) => {
                    console.log(`[preparePrescriptionOnlyCartItems] Processing accessory ${index + 1}:`, accessory);
                    const accessoryVariantId = this.getAccessoryVariantId(accessory.type);
                    if (accessoryVariantId) {
                        const accessoryData = this.accessories[accessory.type];
                        const windowAccessoryData = window.chemistrie_products?.accessories?.[accessory.type];
                        const accessoryName = accessoryData?.name || windowAccessoryData?.title || this.capitalizeWords(accessory.type.replace(/_/g, " "));
                        const accessoryItem = {
                            id: accessoryVariantId,
                            quantity: 1,
                            properties: {
                                "_Parent Config ID": configurationId,
                                "_Item Type": "  ↳ " + accessoryName,
                                "For Frame": frameTitle,
                                "_Accessory Name": accessoryName
                            }
                        };
                        items.push(accessoryItem);
                        console.log(`[preparePrescriptionOnlyCartItems] Added accessory "${accessory.type}" with variant ID ${accessoryVariantId}`);
                    } else {
                        console.error(`[preparePrescriptionOnlyCartItems] FAILED: Could not find variant for accessory "${accessory.type}"`);
                    }
                });
            } else {
                console.log("[preparePrescriptionOnlyCartItems] No accessories selected");
            }
            if (items.length > 0) {
                const parent = items[0];
                const children = items.slice(1);
                console.log("═══════════════════════════════════════════════════════════════");
                console.log("📦 [preparePrescriptionOnlyCartItems] === FINAL CART STRUCTURE ===");
                console.log("📦 [preparePrescriptionOnlyCartItems] Total items:", items.length);
                console.log("📦 [preparePrescriptionOnlyCartItems] Parent:", parent);
                console.log("📦 [preparePrescriptionOnlyCartItems] Children count:", children.length);
                if (children.length > 0) {
                    console.log("📦 [preparePrescriptionOnlyCartItems] Children:", children);
                } else {
                    console.log("📦 [preparePrescriptionOnlyCartItems] No children (Single Vision - no paid upgrades)");
                }
                console.log("═══════════════════════════════════════════════════════════════");
                return {
                    parent: parent,
                    children: children
                };
            } else {
                console.warn("⚠️ [preparePrescriptionOnlyCartItems] No items prepared - this should not happen");
                return {
                    parent: null,
                    children: []
                };
            }
        },
        getClipTypeLabel: function() {
            if (!this.configuration.clipType) return "";
            const clipTypes = {
                sun: "Sun Clip",
                reader: "Reader Clip",
                blueLight: "Blue Light Clip",
                "3d": "3D Clip",
                lightSensitivity: "Light Sensitivity Clip",
                migraine: "Migraine Clip",
                driving: "Night Drive Clip"
            };
            return clipTypes[this.configuration.clipType] || this.configuration.clipType;
        },
        generateConfigId: function() {
            if (!this._configId) {
                this._configId = `CFG-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
            }
            return this._configId;
        },
        getExistingConfigId: async function() {
            try {
                const cartResponse = await fetch("/cart.js", {
                    credentials: "same-origin"
                });
                const cart = await cartResponse.json();
                console.log("[getExistingConfigId] Searching cart for matching frame...");
                const matchingClips = cart.items.filter(item => {
                    const props = item.properties || {};
                    const frameProduct = props["_Frame Product ID"];
                    const frameBrand = props["_Frame Brand"];
                    const frameModel = props["_Frame Model"];
                    if (this.configuration.frameProduct && frameProduct) {
                        const match = frameProduct === this.configuration.frameProduct;
                        console.log("[getExistingConfigId] Variant C check:", {
                            cartFrameProduct: frameProduct,
                            configFrameProduct: this.configuration.frameProduct,
                            match: match
                        });
                        if (match) return true;
                    }
                    if (this.configuration.frameBrand && this.configuration.frameModel) {
                        const match = frameBrand === this.configuration.frameBrand && frameModel === this.configuration.frameModel;
                        console.log("[getExistingConfigId] Variants A/B check:", {
                            cartFrame: `${frameBrand} ${frameModel}`,
                            configFrame: `${this.configuration.frameBrand} ${this.configuration.frameModel}`,
                            match: match
                        });
                        if (match) return true;
                    }
                    return false;
                });
                if (matchingClips.length > 0) {
                    const configId = matchingClips[0].properties["_Configuration ID"] || matchingClips[0].properties["_Parent Config ID"];
                    console.log("[getExistingConfigId] ✅ Found matching clip - Reusing config ID:", configId);
                    console.log("[getExistingConfigId] Matching clip:", {
                        product: matchingClips[0].product_title,
                        variant: matchingClips[0].variant_title,
                        clipNumber: matchingClips[0].properties["_Clip Number"]
                    });
                    return configId;
                }
                console.warn("[getExistingConfigId] ⚠️ No matching clip found in cart - generating new config ID");
                return this.generateConfigId();
            } catch (error) {
                console.error("[getExistingConfigId] ❌ Error fetching cart:", error);
                return this.generateConfigId();
            }
        },
        getFrameChoiceLabel: function() {
            const frameChoice = this.configuration.frameChoice;
            switch (frameChoice) {
              case "own-frame-own-lenses":
                return "Own Frames + Own Lenses";

              case "own-frame-new-lenses":
                return "Own Frames + New Lenses";

              case "new-frame-lenses":
                return "New Frame from Chemistrie";

              default:
                return "Not selected";
            }
        },
        getLensUpgradeVariantId: function(totalPrice, lensType = null) {
            if (!window.chemistrie_products?.lens_upgrades?.variants) {
                console.warn("[getLensUpgradeVariantId] lens_upgrades product not loaded");
                return null;
            }
            const roundedPrice = Math.round(totalPrice / 5) * 5;
            const priceInCents = roundedPrice * 100;
            if (roundedPrice === 0) {
                const variants = window.chemistrie_products.lens_upgrades.variants;
                const skuPatterns = {
                    readers: [ "LENS-READERS-INCLUDED", "READERS-INCLUDED" ],
                    "non-rx": [ "LENS-NONRX-INCLUDED", "NONRX-INCLUDED", "LENS-NON-RX-INCLUDED", "NON-RX-INCLUDED" ],
                    "single-vision": [ "LENS-SV-INCLUDED", "SV-INCLUDED", "SINGLE-VISION-INCLUDED" ]
                };
                if (lensType && skuPatterns[lensType]) {
                    for (const pattern of skuPatterns[lensType]) {
                        const matchingVariant = variants.find(v => v.sku && v.sku.toUpperCase().includes(pattern.toUpperCase()));
                        if (matchingVariant) {
                            console.log(`[getLensUpgradeVariantId] Found $0 variant for ${lensType} by SKU:`, matchingVariant.sku);
                            return matchingVariant.id;
                        }
                    }
                    const titlePatterns = {
                        readers: [ "readers", "reader" ],
                        "non-rx": [ "non-rx", "nonrx", "non rx", "plano" ],
                        "single-vision": [ "single vision", "single-vision", "sv" ]
                    };
                    if (titlePatterns[lensType]) {
                        for (const pattern of titlePatterns[lensType]) {
                            const matchingVariant = variants.find(v => v.title && v.title.toLowerCase().includes(pattern.toLowerCase()) && v.price === 0);
                            if (matchingVariant) {
                                console.log(`[getLensUpgradeVariantId] Found $0 variant for ${lensType} by title:`, matchingVariant.title);
                                return matchingVariant.id;
                            }
                        }
                    }
                }
                const zeroVariant = variants.find(v => v.price === 0);
                if (zeroVariant) {
                    console.log(`[getLensUpgradeVariantId] Using fallback $0 variant:`, zeroVariant.sku || zeroVariant.title);
                    return zeroVariant.id;
                }
                console.log("[getLensUpgradeVariantId] Using hardcoded Single Vision Included variant");
                return 45499590312097;
            }
            const variant = window.chemistrie_products.lens_upgrades.variants.find(v => Math.abs(v.price - priceInCents) < 50);
            if (variant) {
                return variant.id;
            }
            console.warn("[getLensUpgradeVariantId] No variant found for price:", roundedPrice);
            return null;
        },
        getAccessoryVariantId: function(accessoryKey) {
            console.log(`[getAccessoryVariantId] Looking up variant for: "${accessoryKey}"`);
            if (this.accessories && this.accessories[accessoryKey]) {
                const variantId = this.accessories[accessoryKey].variantId;
                if (variantId) {
                    console.log(`[getAccessoryVariantId] Found in this.accessories: ${variantId}`);
                    return variantId;
                }
            }
            if (window.chemistrie_products?.accessories?.[accessoryKey]) {
                const variantId = window.chemistrie_products.accessories[accessoryKey].variantId;
                console.log(`[getAccessoryVariantId] Found in window.chemistrie_products: ${variantId}`);
                return variantId;
            }
            console.warn(`[getAccessoryVariantId] No variant found for: "${accessoryKey}"`);
            console.log("[getAccessoryVariantId] Available keys in this.accessories:", Object.keys(this.accessories || {}));
            console.log("[getAccessoryVariantId] Available keys in window:", Object.keys(window.chemistrie_products?.accessories || {}));
            return null;
        },
        fetchFrameData: async function(frameHandle) {
            if (!frameHandle) {
                console.warn("[fetchFrameData] No frame handle provided");
                return null;
            }
            console.log(`[fetchFrameData] Fetching data for frame: "${frameHandle}"`);
            try {
                const response = await fetch(`/products/${frameHandle}.js`);
                if (!response.ok) {
                    console.error("[fetchFrameData] HTTP error:", response.status, response.statusText);
                    return null;
                }
                const product = await response.json();
                console.log("[fetchFrameData] Raw product data:", product);
                if (!window.chemistrie_products) {
                    window.chemistrie_products = {};
                }
                if (!window.chemistrie_products.frames) {
                    window.chemistrie_products.frames = {};
                }
                window.chemistrie_products.frames[frameHandle] = {
                    id: product.variants[0].id,
                    price: product.price,
                    title: product.title,
                    handle: product.handle,
                    image: product.featured_image
                };
                console.log("[fetchFrameData] ✅ Frame data loaded and stored:", {
                    handle: frameHandle,
                    data: window.chemistrie_products.frames[frameHandle]
                });
                return window.chemistrie_products.frames[frameHandle];
            } catch (error) {
                console.error("[fetchFrameData] ❌ Error fetching frame:", error);
                return null;
            }
        },
        getFrameVariantId: async function() {
            const frameHandle = this.configuration.frameProduct;
            if (!frameHandle) {
                console.warn("[getFrameVariantId] No frameProduct in configuration");
                return null;
            }
            if (this.configuration.frameVariantId) {
                console.log(`[getFrameVariantId] ✅ Using stored variant ID from PDP: ${this.configuration.frameVariantId}`);
                console.log(`[getFrameVariantId] Variant title: ${this.configuration.frameVariantTitle || "N/A"}`);
                return this.configuration.frameVariantId;
            }
            console.log(`[getFrameVariantId] ⚠️ No stored variant ID, fetching from Shopify API (will use first variant)`);
            if (!window.chemistrie_products) {
                window.chemistrie_products = {};
            }
            if (!window.chemistrie_products.frames) {
                window.chemistrie_products.frames = {};
            }
            console.log(`[getFrameVariantId] Looking up frame: "${frameHandle}"`);
            console.log("[getFrameVariantId] Available frames:", Object.keys(window.chemistrie_products.frames));
            let frameData = window.chemistrie_products.frames[frameHandle];
            if (!frameData) {
                console.log("[getFrameVariantId] Frame data not loaded yet, fetching from Shopify API...");
                frameData = await this.fetchFrameData(frameHandle);
                if (!frameData) {
                    console.error(`[getFrameVariantId] ❌ Failed to fetch frame data for: "${frameHandle}"`);
                    return null;
                }
                console.log("[getFrameVariantId] ✅ Frame data fetched successfully");
            }
            if (!frameData.id) {
                console.error(`[getFrameVariantId] Frame "${frameHandle}" has no variant ID`);
                console.log("[getFrameVariantId] Frame data:", frameData);
                return null;
            }
            console.log(`[getFrameVariantId] ✅ Found frame variant for "${frameHandle}":`, {
                id: frameData.id,
                title: frameData.title,
                price: frameData.price
            });
            return frameData.id;
        },
        getCrystalVariantId: function() {
            if (!window.chemistrie_products?.accessories?.crystal?.variants) {
                console.warn("[getCrystalVariantId] crystal product or variants not loaded");
                return null;
            }
            if (!this.configuration.crystalColor) {
                console.warn("[getCrystalVariantId] No crystal color selected");
                return null;
            }
            const variantKey = this.configuration.crystalColor.toLowerCase().replace(/\s+/g, "");
            const variant = window.chemistrie_products.accessories.crystal.variants[variantKey];
            if (!variant || !variant.id) {
                console.warn(`[getCrystalVariantId] Variant not found for color: ${this.configuration.crystalColor} (key: ${variantKey})`);
                return null;
            }
            console.log(`[getCrystalVariantId] Found variant ID ${variant.id} for color: ${this.configuration.crystalColor}`);
            return variant.id;
        },
        getBridgeVariantId: function() {
            if (!window.chemistrie_products?.accessories?.bridge?.variants) {
                console.warn("[getBridgeVariantId] bridge product or variants not loaded");
                return null;
            }
            if (!this.configuration.bridgeColor) {
                console.warn("[getBridgeVariantId] No bridge color selected");
                return null;
            }
            const variantKey = this.configuration.bridgeColor.toLowerCase().replace(/\s+/g, "");
            const variant = window.chemistrie_products.accessories.bridge.variants[variantKey];
            if (!variant || !variant.id) {
                console.warn(`[getBridgeVariantId] Variant not found for finish: ${this.configuration.bridgeColor} (key: ${variantKey})`);
                return null;
            }
            console.log(`[getBridgeVariantId] Found variant ID ${variant.id} for finish: ${this.configuration.bridgeColor}`);
            return variant.id;
        },
        getMagnetVariantId: function() {
            if (!window.chemistrie_products?.accessories?.magnet?.variants) {
                console.warn("[getMagnetVariantId] magnet product or variants not loaded");
                return null;
            }
            if (!this.configuration.magnetColor) {
                console.warn("[getMagnetVariantId] No magnet color selected");
                return null;
            }
            const variantKey = this.configuration.magnetColor.toLowerCase().replace(/\s+/g, "");
            const variant = window.chemistrie_products.accessories.magnet.variants[variantKey];
            if (!variant || !variant.id) {
                console.warn(`[getMagnetVariantId] Variant not found for finish: ${this.configuration.magnetColor} (key: ${variantKey})`);
                return null;
            }
            console.log(`[getMagnetVariantId] Found variant ID ${variant.id} for finish: ${this.configuration.magnetColor}`);
            return variant.id;
        },
        getLensDescription: function() {
            const clipType = this.configuration.clipType;
            switch (clipType) {
              case "sun":
                return `${this.configuration.lensCategory} - ${this.configuration.lensColor}`;

              case "reader":
                return `Reader ${this.configuration.magnification}`;

              case "blueLight":
                return `Blue Light ${this.configuration.magnification}`;

              case "therapeutic":
                const type = this.configuration.therapeuticType;
                const intensity = this.configuration.therapeuticIntensity;
                return intensity ? `${type} ${intensity}` : type;

              case "3d":
                return "3D Cinema";

              case "driving":
                return "Night Drive";

              default:
                return "Unknown";
            }
        },
        buildSecondClipItems: function() {
            console.warn("Second clip item building not yet implemented");
            return [];
        },
        getProductVariantId: function(componentType, config = {}, useDiscount = false) {
            if (!window.ChemistrieVariantMapping) {
                console.error("ChemistrieVariantMapping not loaded - cannot get variant IDs");
                return null;
            }
            const mapping = window.ChemistrieVariantMapping;
            try {
                switch (componentType) {
                  case "lens":
                    return this.getClipLensVariantId(config, useDiscount);

                  case "bridge":
                    return mapping.getBridgeVariantId(config.finish);

                  case "magnet":
                    return mapping.getMagnetVariantId(config.finish);

                  case "crystal":
                    return mapping.getCrystalVariantId(config.type);

                  case "accessory":
                    console.warn(`Accessory product not yet configured: ${config.type}`);
                    return null;

                  default:
                    console.warn(`Unknown component type: ${componentType}`);
                    return null;
                }
            } catch (error) {
                console.error(`Error getting variant ID for ${componentType}:`, error);
                return null;
            }
        },
        getClipLensVariantId: function(config, useDiscount = false) {
            if (!window.chemistrie_products) {
                console.error("Chemistrie product data not loaded");
                return null;
            }
            const clipType = config.clipType || this.configuration.clipType;
            switch (clipType) {
              case "sun":
                return this.findSunClipVariant(config, useDiscount);

              case "reader":
                return this.findReaderClipVariant(config, useDiscount);

              case "blueLight":
                return this.findBlueLightClipVariant(config, useDiscount);

              case "lightSensitivity":
                return this.findLightSensitivityClipVariant(config, useDiscount);

              case "migraine":
                return this.findMigraineClipVariant(useDiscount);

              case "3d":
                return this.find3DClipVariant(useDiscount);

              case "driving":
                return this.findDrivingClipVariant(useDiscount);

              default:
                console.warn(`Unknown clip type: ${clipType}`);
                return null;
            }
        },
        getVariantImageUrl: function(config) {
            const clipType = config.clipType || this.configuration.clipType;
            let products, variant;
            switch (clipType) {
              case "sun":
                {
                    products = window.chemistrie_products?.sun_clips;
                    if (!products?.variants) return null;
                    const category = config.category || this.configuration.lensCategory;
                    const color = config.color || this.configuration.lensColor;
                    const formattedColor = color === "G15" ? "G-15" : this.capitalizeWords(color);
                    let expectedTitle;
                    if (category === "non-polarized") {
                        expectedTitle = `Non Polarized ${formattedColor}`;
                    } else {
                        expectedTitle = `${this.capitalizeWords(category)} ${formattedColor}`;
                    }
                    variant = products.variants.find(v => v.title.toLowerCase() === expectedTitle.toLowerCase());
                    break;
                }

              case "reader":
                products = window.chemistrie_products?.reader_clips;
                variant = products?.variants?.[0];
                break;

              case "blueLight":
                products = window.chemistrie_products?.blue_light_clips;
                variant = products?.variants?.[0];
                break;

              case "lightSensitivity":
                products = window.chemistrie_products?.light_sensitivity_clips;
                if (products?.variants) {
                    const intensity = config.intensity || this.configuration.lightSensitivityIntensity || this.configuration.therapeuticIntensity;
                    variant = intensity ? products.variants.find(v => v.title.toLowerCase().includes(intensity.toLowerCase())) : products.variants[0];
                }
                break;

              case "migraine":
                products = window.chemistrie_products?.migraine_clips;
                variant = products?.variants?.[0];
                break;

              case "3d":
                products = window.chemistrie_products?.clips_3d;
                variant = products?.variants?.[0];
                break;

              case "driving":
                products = window.chemistrie_products?.driving_clips;
                variant = products?.variants?.[0];
                break;

              default:
                return null;
            }
            const imageUrl = variant?.image || null;
            console.log(`[getVariantImageUrl] clipType: ${clipType}, variant: ${variant?.title || "none"}, image: ${imageUrl ? "found" : "null"}`);
            return imageUrl;
        },
        findSunClipVariant: function(config, useDiscount = false) {
            const products = window.chemistrie_products.sun_clips;
            if (!products || !products.variants) {
                console.error("Sun clips product data not available");
                return null;
            }
            const category = config.category || this.configuration.lensCategory;
            const color = config.color || this.configuration.lensColor;
            const formattedColor = color === "G15" ? "G-15" : this.capitalizeWords(color);
            let expectedTitle;
            if (category === "non-polarized") {
                expectedTitle = `Non Polarized ${formattedColor}`;
            } else {
                expectedTitle = `${this.capitalizeWords(category)} ${formattedColor}`;
            }
            console.log(`[Sun Clip Lookup] Category: ${category}, Color: ${color}`);
            console.log(`[Sun Clip Lookup] Searching for: "${expectedTitle}"${useDiscount ? " (DISCOUNTED)" : ""}`);
            const variant = products.variants.find(v => v.title.toLowerCase() === expectedTitle.toLowerCase());
            if (!variant) {
                console.error(`[Sun Clip Lookup] No variant found for: ${expectedTitle}`);
                console.log("[Sun Clip Lookup] Available variants:", products.variants.map(v => v.title));
                return null;
            }
            if (useDiscount && products.discounted_variant_id) {
                console.log(`[Sun Clip Lookup] Using discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            console.log(`[Sun Clip Lookup] Found variant ID: ${variant.id}`);
            return variant.id;
        },
        findReaderClipVariant: function(config, useDiscount = false) {
            const products = window.chemistrie_products.reader_clips;
            if (!products || !products.variants || products.variants.length === 0) {
                console.error("Reader clips product data not available");
                return null;
            }
            if (useDiscount && products.discounted_variant_id) {
                console.log(`[Reader Clip Lookup] Using discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            const variant = products.variants[0];
            console.log(`[Reader Clip Lookup] Found variant ID: ${variant.id} (magnification will be added as property)`);
            return variant.id;
        },
        findBlueLightClipVariant: function(config, useDiscount = false) {
            const products = window.chemistrie_products.blue_light_clips;
            if (!products || !products.variants || products.variants.length === 0) {
                console.error("Blue Light clips product data not available");
                return null;
            }
            if (useDiscount && products.discounted_variant_id) {
                console.log(`[Blue Light Clip Lookup] Using discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            const variant = products.variants[0];
            console.log(`[Blue Light Clip Lookup] Found variant ID: ${variant.id} (magnification will be added as property)`);
            return variant.id;
        },
        findTherapeuticClipVariant: function(config, useDiscount = false) {
            const therapType = config.therapeuticType || this.configuration.therapeuticType;
            const intensity = config.intensity || this.configuration.therapeuticIntensity;
            let products;
            if (therapType === "fl41") {
                products = window.chemistrie_products.fl41_therapeutic_clips;
                if (!products || !products.variants) {
                    console.warn("FL-41 therapeutic clips product not available - falling back to legacy product");
                    products = window.chemistrie_products.therapeutics_clips;
                }
            } else if (therapType === "avulux") {
                products = window.chemistrie_products.avulux_therapeutic_clips;
                if (!products || !products.variants) {
                    console.warn("Avulux therapeutic clips product not available - falling back to legacy product");
                    products = window.chemistrie_products.therapeutics_clips;
                }
            } else {
                products = window.chemistrie_products.therapeutics_clips;
            }
            if (!products || !products.variants) {
                console.error("Therapeutic clips product data not available");
                return null;
            }
            const normalizedType = therapType === "fl41" ? "FL-41" : therapType === "avulux" ? "Avulux" : this.capitalizeWords(therapType);
            const expectedTitle = intensity ? `${normalizedType} ${this.capitalizeWords(intensity)}` : normalizedType;
            const isAvulux = therapType === "avulux";
            const effectiveUseDiscount = useDiscount && !isAvulux;
            console.log(`[Therapeutic Clip Lookup] Product: ${products.handle}, Searching for: "${expectedTitle}"${effectiveUseDiscount ? " (DISCOUNTED)" : ""}${isAvulux && useDiscount ? " (Avulux excluded from discount)" : ""}`);
            if (effectiveUseDiscount && products.discounted_variants) {
                const discountedVariantId = products.discounted_variants[expectedTitle.toLowerCase()];
                if (discountedVariantId) {
                    console.log(`[Therapeutic Clip Lookup] Using discounted variant ID for "${expectedTitle}": ${discountedVariantId}`);
                    return discountedVariantId;
                }
            } else if (effectiveUseDiscount && products.discounted_variant_id) {
                console.log(`[Therapeutic Clip Lookup] Using single discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            const variant = products.variants.find(v => v.title.toLowerCase() === expectedTitle.toLowerCase());
            if (variant) {
                console.log(`[Therapeutic Clip Lookup] Found variant ID: ${variant.id} (price: ${variant.price})`);
                return variant.id;
            }
            console.error(`[Therapeutic Clip Lookup] No variant found for: ${expectedTitle}`);
            console.log("[Therapeutic Clip Lookup] Available variants:", products.variants.map(v => v.title));
            return null;
        },
        find3DClipVariant: function(useDiscount = false) {
            const products = window.chemistrie_products.clips_3d;
            if (!products || !products.variants || products.variants.length === 0) {
                console.error("3D clips product data not available");
                return null;
            }
            if (useDiscount && products.discounted_variant_id) {
                console.log(`[3D Clip Lookup] Using discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            const variant = products.variants[0];
            console.log(`[3D Clip Lookup] Found variant ID: ${variant.id}`);
            return variant.id;
        },
        findDrivingClipVariant: function(useDiscount = false) {
            const products = window.chemistrie_products.driving_clips;
            if (!products || !products.variants || products.variants.length === 0) {
                console.error("Driving clips product data not available");
                return null;
            }
            if (useDiscount && products.discounted_variant_id) {
                console.log(`[Driving Clip Lookup] Using discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            const variant = products.variants[0];
            console.log(`[Driving Clip Lookup] Found variant ID: ${variant.id}`);
            return variant.id;
        },
        findLightSensitivityClipVariant: function(config, useDiscount = false) {
            const products = window.chemistrie_products.light_sensitivity_clips;
            if (!products || !products.variants || products.variants.length === 0) {
                console.error("Light Sensitivity clips product data not available");
                const fallback = window.chemistrie_products.fl41_therapeutic_clips;
                if (fallback && fallback.variants && fallback.variants.length > 0) {
                    console.log("[Light Sensitivity Clip Lookup] Using FL-41 therapeutic fallback");
                    return this.findTherapeuticClipVariant({
                        ...config,
                        therapeuticType: "fl41"
                    }, useDiscount);
                }
                return null;
            }
            const intensity = config.intensity || this.configuration.lightSensitivityIntensity || "Light";
            const expectedTitle = `FL-41 ${this.capitalizeWords(intensity)}`;
            console.log(`[Light Sensitivity Clip Lookup] Searching for: "${expectedTitle}"${useDiscount ? " (DISCOUNTED)" : ""}`);
            if (useDiscount && products.discounted_variant_id) {
                console.log(`[Light Sensitivity Clip Lookup] Using discounted variant ID: ${products.discounted_variant_id}`);
                return products.discounted_variant_id;
            }
            const variant = products.variants.find(v => v.title.toLowerCase() === expectedTitle.toLowerCase());
            if (variant) {
                console.log(`[Light Sensitivity Clip Lookup] Found variant ID: ${variant.id}`);
                return variant.id;
            }
            console.error(`[Light Sensitivity Clip Lookup] No variant found for: ${expectedTitle}`);
            console.log("[Light Sensitivity Clip Lookup] Available variants:", products.variants.map(v => v.title));
            return null;
        },
        findMigraineClipVariant: function(useDiscount = false) {
            const products = window.chemistrie_products.migraine_clips;
            if (!products || !products.variants || products.variants.length === 0) {
                console.error("Migraine clips product data not available");
                const fallback = window.chemistrie_products.avulux_therapeutic_clips;
                if (fallback && fallback.variants && fallback.variants.length > 0) {
                    console.log("[Migraine Clip Lookup] Using Avulux therapeutic fallback");
                    return this.findTherapeuticClipVariant({
                        therapeuticType: "avulux"
                    }, false);
                }
                return null;
            }
            if (useDiscount) {
                console.log("[Migraine Clip Lookup] Discount requested but IGNORED - Migraine excluded from discount");
            }
            const variant = products.variants[0];
            console.log(`[Migraine Clip Lookup] Found variant ID: ${variant.id}`);
            return variant.id;
        },
        capitalizeWords: function(str) {
            if (!str) return "";
            const spaced = str.replace(/([A-Z])/g, " $1").trim();
            return spaced.split(/[-\s]+/).map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
        },
        addItemsToShopifyCart: function(items) {
            console.log("═══════════════════════════════════════════════════════════════");
            console.log("🛒 [addItemsToShopifyCart] === ADDING ITEMS TO CART ===");
            console.log("🛒 [addItemsToShopifyCart] Raw items received:", items);
            console.log("🛒 [addItemsToShopifyCart] Items type:", typeof items);
            console.log("🛒 [addItemsToShopifyCart] Has parent?:", items?.parent ? "YES" : "NO");
            console.log("🛒 [addItemsToShopifyCart] Has children array?:", Array.isArray(items?.children) ? "YES" : "NO");
            console.log("🛒 [addItemsToShopifyCart] Children length:", items?.children?.length || 0);
            console.log("═══════════════════════════════════════════════════════════════");
            if (!window.cartStateManager) {
                console.error("❌ [addItemsToShopifyCart] CartStateManager not available");
                console.log("🔍 [addItemsToShopifyCart] Using fallback direct cart add");
                return fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    credentials: "same-origin",
                    body: JSON.stringify({
                        items: items
                    })
                }).then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                });
            }
            if (items.parent && Array.isArray(items.children)) {
                console.log("✅ [addItemsToShopifyCart] ================================");
                console.log("✅ [addItemsToShopifyCart] Using NESTED cart lines structure");
                console.log("✅ [addItemsToShopifyCart] ================================");
                console.log("✅ [addItemsToShopifyCart] Parent item:", items.parent);
                console.log(`✅ [addItemsToShopifyCart] Children count: ${items.children.length}`);
                if (items.children.length > 0) {
                    items.children.forEach((child, index) => {
                        console.log(`✅ [addItemsToShopifyCart] Child ${index + 1}:`, {
                            variantId: child.id,
                            type: child.properties["_Item Type"],
                            lenses: child.properties["Lenses"] || child.properties["Upgrades"] || "N/A"
                        });
                    });
                } else {
                    console.log("ℹ️ [addItemsToShopifyCart] No children (Single Vision Included - no paid upgrades)");
                }
                console.log("🔍 [addItemsToShopifyCart] Calling CartStateManager.addNested()...");
                return window.cartStateManager.addNested(items.parent, items.children);
            } else {
                console.log("⚠️ [addItemsToShopifyCart] Using STANDARD add (no nesting structure)");
                console.log("⚠️ [addItemsToShopifyCart] Items is NOT {parent, children} format");
                console.log("⚠️ [addItemsToShopifyCart] Items to add:", items);
                return window.cartStateManager.add(items);
            }
        },
        saveState: function() {
            try {
                localStorage.setItem("orderFlowState", JSON.stringify({
                    currentStep: this.currentStep,
                    currentSubStep: this.currentSubStep,
                    isInSubStep: this.isInSubStep,
                    hasCompletedStep1_5: this.hasCompletedStep1_5,
                    hasVisitedStep1_5: this.hasVisitedStep1_5,
                    wasInStep1_5: this.wasInStep1_5,
                    lastStepBeforeTwo: this.lastStepBeforeTwo,
                    step1_5FrameChoice: this.step1_5FrameChoice,
                    originalStep1Header: this.originalStep1Header,
                    currentStep2Substep: this.currentStep2Substep,
                    lastStep2Substep: this.lastStep2Substep,
                    isInStep2Substep: this.isInStep2Substep,
                    previousStepNumber: this.previousStepNumber,
                    currentSubStage: this.currentSubStage,
                    configuration: this.configuration,
                    pricing: this.pricing
                }));
                sessionStorage.setItem("orderFlowEntry", JSON.stringify({
                    isBuilding2ndClip: this.isBuilding2ndClip || false,
                    isReorderMode: this.isReorderMode || false,
                    isFrameReorderMode: this.isFrameReorderMode || false,
                    isOpticalRetailerReorder: this.isOpticalRetailerReorder || false,
                    isRedrillFlow: this.isRedrillFlow || false,
                    redrillVariantId: this.redrillVariantId || null,
                    redrillHandle: this.redrillHandle || null,
                    redrillPrice: this.redrillPrice || 0
                }));
            } catch (e) {
                console.warn("Could not save state to localStorage:", e);
            }
        },
        saveStateDebounced: function(delay = 500) {
            const self = this;
            if (this._saveStateTimeout) {
                clearTimeout(this._saveStateTimeout);
            }
            this._saveStateTimeout = setTimeout(function() {
                self.saveState();
            }, delay);
        },
        loadState: function() {
            try {
                const saved = localStorage.getItem("orderFlowState");
                if (saved) {
                    const state = JSON.parse(saved);
                    this.currentStep = state.currentStep || 1;
                    if (this.currentStep !== 1) {
                        this.currentSubStep = null;
                        this.isInSubStep = false;
                    } else {
                        this.currentSubStep = state.currentSubStep || null;
                        this.isInSubStep = state.isInSubStep || false;
                    }
                    this.hasCompletedStep1_5 = state.hasCompletedStep1_5 || false;
                    this.hasVisitedStep1_5 = state.hasVisitedStep1_5 || false;
                    this.wasInStep1_5 = state.wasInStep1_5 || false;
                    this.lastStepBeforeTwo = state.lastStepBeforeTwo || null;
                    this.step1_5FrameChoice = state.step1_5FrameChoice || null;
                    this.originalStep1Header = state.originalStep1Header || null;
                    this.currentStep2Substep = state.currentStep2Substep || null;
                    this.lastStep2Substep = state.lastStep2Substep || null;
                    this.isInStep2Substep = state.isInStep2Substep || false;
                    this.previousStepNumber = state.previousStepNumber || null;
                    this.currentSubStage = state.currentSubStage || null;
                    this.configuration = {
                        ...this.configuration,
                        ...state.configuration
                    };
                    this.pricing = {
                        ...this.pricing,
                        ...state.pricing
                    };
                    this.configuration.orderSource = null;
                    this.configuration.orderSource = this.deriveOrderSourceFromFrameChoice(this.configuration.frameChoice);
                    this.configuration.isPrescriptionOnlyOrder = false;
                    this.configuration.isFramelessRxOrder = false;
                    this.configuration.originalOrder = null;
                    let entry = null;
                    if (this._entryScopeValid) {
                        try {
                            entry = JSON.parse(sessionStorage.getItem("orderFlowEntry") || "null");
                        } catch (e) {}
                    }
                    entry = entry || {};
                    this.isBuilding2ndClip = entry.isBuilding2ndClip || false;
                    this.isReorderMode = entry.isReorderMode || false;
                    this.isFrameReorderMode = entry.isFrameReorderMode || false;
                    this.isOpticalRetailerReorder = entry.isOpticalRetailerReorder || false;
                    this.isRedrillFlow = entry.isRedrillFlow || false;
                    this.redrillVariantId = entry.redrillVariantId || null;
                    this.redrillHandle = entry.redrillHandle || null;
                    this.redrillPrice = entry.redrillPrice || 0;
                    if (this.isRedrillFlow && !this.redrillPrice) this.redrillPrice = 75;
                    if (this.isOpticalRetailerReorder) {
                        this.configuration.orderSource = "Reorder - Optical Retailer";
                    }
                    if (this.isRedrillFlow) {
                        this.configuration.orderSource = "Redrill - Replacement Magnets";
                    }
                    if (!this.configuration.prescriptionMethod) {
                        if (this.configuration.prescriptionUpload && this.configuration.prescriptionUpload.token) {
                            this.configuration.prescriptionMethod = "upload";
                        } else if (this.configuration.prescription && this.configuration.prescription !== "skip") {
                            this.configuration.prescriptionMethod = "manual";
                        } else if (this.configuration.prescriptionSendLater) {
                            this.configuration.prescriptionMethod = "later";
                        }
                    }
                    setTimeout(() => this.restoreUIState(), 100);
                    return true;
                }
            } catch (e) {
                console.warn("Could not load state from localStorage:", e);
            }
            return false;
        },
        resetConfiguration: function() {
            try {
                localStorage.removeItem("orderFlowState");
            } catch (e) {
                console.warn("Could not clear localStorage:", e);
            }
            try {
                sessionStorage.removeItem("orderFlowEntry");
            } catch (e) {
                console.warn("Could not clear sessionStorage:", e);
            }
            this.pendingClipPreselect = null;
            this.exitClipFocusMode();
            this._configId = null;
            console.log("[Reset] Configuration ID cache cleared");
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, window.location.pathname);
                console.log("[Reset] URL parameters cleared");
            }
            this.configuration = {
                frameChoice: null,
                frameProduct: null,
                useExistingLenses: null,
                nativeLensType: "single-vision",
                nativeLensFeature: "standard",
                nativeLensMaterial: "standard",
                nativeLensOptions: {},
                prescription: null,
                prescriptionSendLater: false,
                prescriptionUpload: null,
                prescriptionMethod: null,
                uploadPd: null,
                rxValuesStaging: null,
                rxCarriedToken: null,
                rxCarriedStatus: null,
                rxCertifiedAt: null,
                termsAcceptedAt: null,
                isPrescriptionOnlyOrder: false,
                orderForSomeoneElse: false,
                patientName: null,
                patientRelationship: null,
                clipType: null,
                clipOption: null,
                lensColor: null,
                bridgeColor: "MatteBlack",
                magnetColor: "Gunmetal",
                crystalColor: null,
                addSecondClip: false,
                secondClip: null,
                accessories: [],
                quantity: 1
            };
            this.pricing = {
                frame: 0,
                nativeLenses: 0,
                clip: 0,
                hardware: 0,
                bridge: 0,
                magnet: 0,
                crystals: 0,
                secondClip: 0,
                accessories: 0,
                total: 0
            };
            this.hideAllSteps();
            const configuratorWrapper = document.getElementById("configuratorWrapper");
            if (configuratorWrapper) {
                configuratorWrapper.style.display = "none";
            }
            document.querySelectorAll(".selection-panel").forEach(panel => {
                panel.style.display = "none";
            });
            const step1SubContent = document.getElementById("step1SubContent");
            if (step1SubContent) {
                step1SubContent.style.display = "none";
                step1SubContent.classList.remove("active");
            }
            if (this.sharedImageLayering) {
                this.sharedImageLayering.clearAllLayers();
            }
            this.removePatientInfoIndicator();
            const orderForSomeoneBtn = document.getElementById("orderForSomeoneElseBtn");
            if (orderForSomeoneBtn) {
                orderForSomeoneBtn.classList.remove("active");
            }
            document.querySelectorAll(".configurator-view .selection-panel.active").forEach(panel => {
                panel.classList.remove("active");
            });
            this.clearAllUISelections();
            this.currentStep = 1;
            this.currentSubStep = null;
            this.isInSubStep = false;
            this.currentStep2Substep = null;
            this.isInStep2Substep = false;
            this.currentSubStage = null;
            this.isInSubStage = false;
            this.isNavigating = false;
            this.hasCompletedStep1_5 = false;
            this.hasVisitedStep1_5 = false;
            this.wasInStep1_5 = false;
            this.lastStepBeforeTwo = null;
            this.step1_5FrameChoice = null;
            this.originalStep1Header = null;
            this.isPrescriptionOnlyFlow = false;
            this.isReorderMode = false;
            this.isFrameReorderMode = false;
            this.isOpticalRetailerReorder = false;
            this.isRedrillFlow = false;
            this.redrillVariantId = null;
            this.redrillHandle = null;
            this.redrillPrice = 0;
            this.isBuilding2ndClip = false;
            this._secondClipStartTime = null;
            const step1El = document.getElementById("step1");
            if (step1El) {
                step1El.style.display = "block";
            }
            this.updateProgressBar();
            this.updateNavigationButtons();
            const navCalculator = document.getElementById("navTotalCalculator");
            const navTotalPrice = document.getElementById("navTotalPrice");
            if (navCalculator) {
                navCalculator.style.display = "none";
            }
            if (navTotalPrice) {
                navTotalPrice.textContent = "$0.00";
            }
            console.log("[Reset] Nav total calculator cleared");
            this.hideAllDetailsPanels();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        showResetModal: function() {
            const modal = document.getElementById("resetConfirmationModal");
            if (modal) {
                modal.style.display = "flex";
                document.body.style.overflow = "hidden";
            }
        },
        hideResetModal: function() {
            const modal = document.getElementById("resetConfirmationModal");
            if (modal) {
                modal.style.display = "none";
                document.body.style.overflow = "";
            }
        },
        validateEmail: function(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        skipSaveAndReset: function() {
            this.hideResetModal();
            this.resetConfiguration();
        },
        initializeResetModalHandlers: function() {
            const modal = document.getElementById("resetConfirmationModal");
            if (!modal) return;
            const skipResetBtn = document.getElementById("skipAndResetBtn");
            const cancelBtn = document.getElementById("cancelResetBtn");
            const closeBtn = document.getElementById("resetModalClose");
            if (skipResetBtn) {
                skipResetBtn.addEventListener("click", () => {
                    this.skipSaveAndReset();
                });
            }
            if (cancelBtn) {
                cancelBtn.addEventListener("click", () => {
                    this.hideResetModal();
                });
            }
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    this.hideResetModal();
                });
            }
            modal.addEventListener("click", e => {
                if (e.target === modal) {
                    this.hideResetModal();
                }
            });
            document.addEventListener("keydown", e => {
                if (e.key === "Escape" && modal.style.display === "flex") {
                    this.hideResetModal();
                }
            });
        },
        showPDInfoModal: function() {
            const modal = document.getElementById("pdInfoModal");
            if (modal) {
                modal.style.display = "flex";
                document.body.style.overflow = "hidden";
            }
        },
        hidePDInfoModal: function() {
            const modal = document.getElementById("pdInfoModal");
            if (modal) {
                modal.style.display = "none";
                document.body.style.overflow = "";
            }
        },
        initializePDInfoModal: function() {
            const modal = document.getElementById("pdInfoModal");
            if (!modal) return;
            const closeBtn = document.getElementById("pdInfoModalClose");
            const pdInfoBtn = document.getElementById("pdInfoBtn");
            const pdInfoBtnReview = document.getElementById("pdInfoBtnReview");
            const pdInfoBtnUpload = document.getElementById("pdInfoBtnUpload");
            if (pdInfoBtn) {
                pdInfoBtn.addEventListener("click", () => {
                    this.showPDInfoModal();
                });
            }
            if (pdInfoBtnReview) {
                pdInfoBtnReview.addEventListener("click", () => {
                    this.showPDInfoModal();
                });
            }
            if (pdInfoBtnUpload) {
                pdInfoBtnUpload.addEventListener("click", () => {
                    this.showPDInfoModal();
                });
            }
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    this.hidePDInfoModal();
                });
            }
            modal.addEventListener("click", e => {
                if (e.target === modal) {
                    this.hidePDInfoModal();
                }
            });
            document.addEventListener("keydown", e => {
                if (e.key === "Escape" && modal.style.display === "flex") {
                    this.hidePDInfoModal();
                }
            });
        },
        showShipInAckModal: function(frameChoice) {
            const modal = document.getElementById("shipInAckModal");
            if (!modal) {
                console.error("[ShipInAck] Modal element not found — allowing navigation");
                this._shipInAckProceed();
                return;
            }
            modal.querySelectorAll(".ship-in-ack-variant").forEach(p => {
                p.style.display = p.dataset.variant === frameChoice ? "" : "none";
            });
            this._showShipInAckPanel("confirm");
            this._shipInAckReturnFocus = document.activeElement;
            modal.style.display = "flex";
            document.body.classList.add("ship-in-ack-open");
            document.documentElement.classList.add("ship-in-ack-open");
            const confirmBtn = document.getElementById("shipInAckConfirm");
            if (confirmBtn) confirmBtn.focus();
            try {
                document.dispatchEvent(new CustomEvent("configurator:ship_in_ack_shown", {
                    detail: {
                        variant: frameChoice
                    }
                }));
            } catch (e) {}
            console.log("[ShipInAck] Gate shown for", frameChoice, "→ target step", this._pendingShipInTarget);
        },
        hideShipInAckModal: function() {
            const modal = document.getElementById("shipInAckModal");
            if (modal) modal.style.display = "none";
            document.body.classList.remove("ship-in-ack-open");
            document.documentElement.classList.remove("ship-in-ack-open");
            if (this._shipInAckReturnFocus && typeof this._shipInAckReturnFocus.focus === "function") {
                this._shipInAckReturnFocus.focus();
            }
            this._shipInAckReturnFocus = null;
        },
        _showShipInAckPanel: function(which) {
            const confirmPanel = document.getElementById("shipInAckConfirmPanel");
            const altPanel = document.getElementById("shipInAckAltPanel");
            if (!confirmPanel || !altPanel) return;
            const showingConfirm = which === "confirm";
            confirmPanel.style.display = showingConfirm ? "flex" : "none";
            altPanel.style.display = showingConfirm ? "none" : "flex";
            const modal = document.getElementById("shipInAckModal");
            if (modal) {
                modal.setAttribute("aria-labelledby", showingConfirm ? "shipInAckTitle" : "shipInAckAltTitle");
            }
            if (modal && modal.style.display === "flex") {
                const focusTarget = document.getElementById(showingConfirm ? "shipInAckConfirm" : "shipInAckBack");
                if (focusTarget) focusTarget.focus();
            }
        },
        _shipInAckProceed: function() {
            this.configuration.shipInAckAt = (new Date).toISOString();
            this.saveState();
            const target = this._pendingShipInTarget;
            this._pendingShipInTarget = null;
            this.hideShipInAckModal();
            if (target) this.goToStep(target);
        },
        initializeShipInAckModal: function() {
            const modal = document.getElementById("shipInAckModal");
            if (!modal) return;
            const self = this;
            const confirmBtn = document.getElementById("shipInAckConfirm");
            const cancelBtn = document.getElementById("shipInAckCancel");
            const closeBtn = document.getElementById("shipInAckClose");
            const altCloseBtn = document.getElementById("shipInAckAltClose");
            const backBtn = document.getElementById("shipInAckBack");
            const chooseCBtn = document.getElementById("shipInAckChooseC");
            const isOpen = () => modal.style.display === "flex";
            const onAlternatives = () => {
                const alt = document.getElementById("shipInAckAltPanel");
                return alt && alt.style.display !== "none";
            };
            const decline = () => {
                if (onAlternatives()) {
                    self._pendingShipInTarget = null;
                    self.hideShipInAckModal();
                    return;
                }
                try {
                    document.dispatchEvent(new CustomEvent("configurator:ship_in_declined"));
                } catch (e) {}
                self._showShipInAckPanel("alternatives");
            };
            if (confirmBtn) confirmBtn.addEventListener("click", () => self._shipInAckProceed());
            if (cancelBtn) cancelBtn.addEventListener("click", decline);
            if (closeBtn) closeBtn.addEventListener("click", decline);
            if (altCloseBtn) altCloseBtn.addEventListener("click", decline);
            if (backBtn) backBtn.addEventListener("click", () => self._showShipInAckPanel("confirm"));
            if (chooseCBtn) {
                chooseCBtn.addEventListener("click", () => {
                    self._pendingShipInTarget = null;
                    self.hideShipInAckModal();
                    self.selectFrameChoice("new-frame-lenses");
                });
            }
            modal.addEventListener("click", e => {
                if (e.target === modal) decline();
            });
            document.addEventListener("keydown", e => {
                if (!isOpen()) return;
                if (e.key === "Escape") {
                    decline();
                    return;
                }
                if (e.key !== "Tab") return;
                const focusable = Array.from(modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(el => el.offsetParent !== null);
                if (focusable.length === 0) return;
                const first = focusable[0];
                const last = focusable[focusable.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            });
        },
        handleReorderSubmit: function(e) {
            e.preventDefault();
            const form = document.getElementById("reorderClipForm");
            const submitBtn = document.getElementById("reorderSubmitBtn");
            const errorContainer = document.getElementById("reorderFormError");
            if (!form || !submitBtn) return;
            if (!form.checkValidity()) {
                form.reportValidity();
                return;
            }
            submitBtn.disabled = true;
            submitBtn.textContent = "Submitting...";
            errorContainer.style.display = "none";
            const name = document.getElementById("reorder-name").value;
            const email = document.getElementById("reorder-email").value;
            const phone = document.getElementById("reorder-phone").value || "Not provided";
            const street = document.getElementById("reorder-street").value;
            const city = document.getElementById("reorder-city").value;
            const state = document.getElementById("reorder-state").value;
            const zip = document.getElementById("reorder-zip").value;
            const frameBrand = document.getElementById("reorder-frame-brand").value;
            const frameModel = document.getElementById("reorder-frame-model").value;
            const clipType = document.getElementById("reorder-clip-type").value;
            const purchaseLocation = document.getElementById("reorder-purchase-location").value;
            const messageBody = `\nCLIP REORDER REQUEST\n====================\n\nCustomer Information:\n- Name: ${name}\n- Email: ${email}\n- Phone: ${phone}\n\nShipping Address:\n${street}\n${city}, ${state} ${zip}\n\nFrame Details:\n- Brand: ${frameBrand}\n- Model: ${frameModel}\n\nPreferred Clip Type: ${clipType}\n\nOriginal Purchase Location: ${purchaseLocation}\n            `.trim();
            document.getElementById("reorder-body").value = messageBody;
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: "reorder_clip_form_submitted",
                    frame_brand: frameBrand,
                    frame_model: frameModel,
                    clip_type: clipType,
                    purchase_location: purchaseLocation
                });
            }
            console.log("[Reorder Modal] Submitting form");
            form.submit();
        },
        checkReorderSuccess: function() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get("contact_posted") === "true") {
                console.log("[Reorder Modal] Detected successful form submission");
                const modal = document.getElementById("reorderClipModal");
                const formContainer = document.getElementById("reorderFormContainer");
                const successContainer = document.getElementById("reorderSuccessContainer");
                if (modal && successContainer) {
                    modal.style.display = "flex";
                    document.body.style.overflow = "hidden";
                    if (formContainer) formContainer.style.display = "none";
                    successContainer.style.display = "block";
                    const cleanUrl = window.location.pathname;
                    window.history.replaceState({}, document.title, cleanUrl);
                }
            }
        },
        showReorderModal: function() {
            const modal = document.getElementById("reorderClipModal");
            if (!modal) return;
            modal.style.display = "flex";
            document.body.style.overflow = "hidden";
            document.body.classList.add("reorder-modal-open");
            setTimeout(() => {
                const firstInput = document.getElementById("reorder-name");
                if (firstInput) firstInput.focus();
            }, 100);
        },
        hideReorderModal: function() {
            const modal = document.getElementById("reorderClipModal");
            if (!modal) return;
            modal.style.display = "none";
            document.body.style.overflow = "";
            document.body.classList.remove("reorder-modal-open");
            this.resetReorderForm();
        },
        resetReorderForm: function() {
            const form = document.getElementById("reorderClipForm");
            const formContainer = document.getElementById("reorderFormContainer");
            const successContainer = document.getElementById("reorderSuccessContainer");
            const errorContainer = document.getElementById("reorderFormError");
            const submitBtn = document.getElementById("reorderSubmitBtn");
            if (form) form.reset();
            if (formContainer) formContainer.style.display = "block";
            if (successContainer) successContainer.style.display = "none";
            if (errorContainer) errorContainer.style.display = "none";
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = "Submit Reorder Request";
            }
        },
        ENABLE_LEGACY_REORDER_FORM: false,
        initializeReorderModal: function() {
            const modal = document.getElementById("reorderClipModal");
            if (!modal) return;
            const openBtn = document.getElementById("openReorderModal");
            const closeBtn = document.getElementById("reorderModalClose");
            const closeSuccessBtn = document.getElementById("reorderCloseSuccessBtn");
            const customizeClipBtn = document.getElementById("reorderCustomizeClipBtn");
            if (openBtn) {
                openBtn.addEventListener("click", () => {
                    this.showReorderModal();
                    console.log("[Reorder Modal] Opened");
                });
            }
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    if (!this.isReorderSubmitting) {
                        this.hideReorderModal();
                    }
                });
            }
            if (closeSuccessBtn) {
                closeSuccessBtn.addEventListener("click", () => {
                    this.hideReorderModal();
                });
            }
            modal.addEventListener("click", e => {
                if (e.target === modal && !this.isReorderSubmitting) {
                    this.hideReorderModal();
                }
            });
            if (customizeClipBtn) {
                customizeClipBtn.addEventListener("click", () => {
                    this.startOpticalRetailerReorder();
                });
            }
            if (this.ENABLE_LEGACY_REORDER_FORM) {
                const submitBtn = document.getElementById("reorderSubmitBtn");
                if (submitBtn) {
                    submitBtn.addEventListener("click", e => this.handleReorderSubmit(e));
                }
            }
            document.addEventListener("keydown", e => {
                if (e.key === "Escape" && modal.style.display === "flex" && !this.isReorderSubmitting) {
                    this.hideReorderModal();
                }
            });
            const autoOpenParams = new URLSearchParams(window.location.search);
            if (autoOpenParams.get("reorder") === "1") {
                this.showReorderModal();
                autoOpenParams.delete("reorder");
                const remaining = autoOpenParams.toString();
                const cleanedUrl = window.location.pathname + (remaining ? "?" + remaining : "");
                window.history.replaceState({}, document.title, cleanedUrl);
            }
            console.log("[Reorder Modal] Event handlers initialized");
        },
        startOpticalRetailerReorder: function(navigate = true) {
            console.log("[Reorder Modal] Starting optical-retailer reorder flow (navigate=" + navigate + ")");
            this.isBuilding2ndClip = true;
            this.isOpticalRetailerReorder = true;
            this.configuration.frameChoice = "own-frame-own-lenses";
            this.configuration.orderSource = "Reorder - Optical Retailer";
            this._clearStaleRxState({
                includeRxData: true
            });
            document.querySelectorAll("#step1 .frame-choice-card").forEach(card => {
                card.classList.remove("selected");
                card.setAttribute("aria-pressed", "false");
            });
            const variantACard = document.querySelector('#step1 [data-choice="own-frame-own-lenses"]');
            if (variantACard) {
                variantACard.classList.add("selected");
                variantACard.setAttribute("aria-pressed", "true");
            }
            if (typeof this.saveState === "function") {
                this.saveState();
            }
            if (!navigate) return;
            this.hideReorderModal();
            this.goToStep(2);
        },
        clearAllUISelections: function() {
            document.querySelectorAll(".choice-card.selected, .lens-card.selected, .clip-card.selected, .option-card.active, .color-option.selected, .mag-option.selected").forEach(el => {
                el.classList.remove("selected", "active");
            });
            document.querySelectorAll("#step1 .frame-choice-card").forEach(card => {
                card.classList.remove("selected", "flipped");
                card.setAttribute("aria-pressed", "false");
                card.setAttribute("aria-expanded", "false");
            });
            document.querySelectorAll(".not-sure-btn").forEach(btn => {
                btn.classList.remove("selected");
            });
            document.querySelectorAll(".details-area").forEach(area => {
                area.classList.remove("active");
                area.innerHTML = "";
            });
            document.querySelectorAll(".main-area").forEach(area => {
                area.classList.remove("has-details");
            });
            document.querySelectorAll(".step-content").forEach(content => {
                content.classList.remove("show-details");
            });
            const colorGrid = document.getElementById("step4LensColorGrid");
            if (colorGrid) colorGrid.innerHTML = "";
            document.querySelectorAll('#orderFlowConfigurator input[type="checkbox"], #orderFlowConfigurator input[type="radio"]').forEach(input => {
                input.checked = false;
            });
            document.querySelectorAll('#step2 input[type="text"], #step2 input[type="number"], #step2 select').forEach(input => {
                input.value = "";
            });
            const inlineRxInputs = [ "odSphereReview", "odCylinderReview", "odAxisReview", "odAddReview", "osSphereReview", "osCylinderReview", "osAxisReview", "osAddReview", "pdReview", "rxNotesReview" ];
            inlineRxInputs.forEach(id => {
                const input = document.getElementById(id);
                if (input) input.value = "";
            });
            document.querySelectorAll(".lens-puck").forEach(puck => {
                puck.classList.remove("selected", "active");
            });
            const secondClipToggle = document.getElementById("secondClipToggle");
            if (secondClipToggle) secondClipToggle.checked = false;
            document.querySelectorAll(".accessory-toggle").forEach(toggle => {
                toggle.checked = false;
            });
            document.querySelectorAll(".rx-method-card").forEach(card => {
                card.classList.remove("selected");
                card.setAttribute("aria-pressed", "false");
            });
            document.querySelectorAll(".rx-method-content").forEach(panel => {
                panel.hidden = true;
            });
            const rxDropzone = document.getElementById("rxDropzone");
            if (rxDropzone) {
                rxDropzone.classList.remove("has-file", "is-uploading", "is-dragover");
                const uploadedRow = rxDropzone.querySelector(".rx-dropzone__uploaded");
                const filenameEl = rxDropzone.querySelector(".rx-dropzone__filename");
                const sizeEl = rxDropzone.querySelector(".rx-dropzone__size");
                if (uploadedRow) uploadedRow.hidden = true;
                if (filenameEl) filenameEl.textContent = "";
                if (sizeEl) sizeEl.textContent = "";
            }
            const rxAckBtn = document.getElementById("rxLaterAcknowledgeBtn");
            if (rxAckBtn) rxAckBtn.classList.remove("acknowledged");
            const rxUploadStatus = document.getElementById("uploadRxStatus");
            if (rxUploadStatus) {
                rxUploadStatus.textContent = "";
                rxUploadStatus.hidden = true;
                rxUploadStatus.classList.remove("error", "success");
            }
            document.querySelectorAll(".rx-cert-checkbox").forEach(function(b) {
                b.checked = false;
            });
            document.querySelectorAll(".rx-cert-row").forEach(function(r) {
                r.classList.remove("rx-cert-pulse");
            });
            document.querySelectorAll(".rx-cert-row__error").forEach(function(e) {
                e.hidden = true;
            });
            const tcCheckboxReset = document.getElementById("tcAcceptCheckbox");
            if (tcCheckboxReset) tcCheckboxReset.checked = false;
            const tcAcceptanceReset = document.getElementById("tcAcceptance");
            if (tcAcceptanceReset) tcAcceptanceReset.classList.remove("tc-pulse");
            const tcErrorReset = document.getElementById("tcAcceptError");
            if (tcErrorReset) tcErrorReset.hidden = true;
        },
        hideAllDetailsPanels: function() {
            document.querySelectorAll(".details-area.active").forEach(panel => {
                panel.classList.remove("active");
                panel.innerHTML = "";
            });
        },
        hideDetailsPanel: function(stepId) {
            const detailsArea = document.getElementById(`${stepId}Details`);
            const mainArea = document.getElementById(`${stepId}Main`);
            const stepContent = document.querySelector(`#${stepId} .step-content`);
            if (detailsArea && detailsArea.classList.contains("active")) {
                detailsArea.classList.remove("active");
                detailsArea.innerHTML = "";
                if (mainArea) {
                    mainArea.classList.remove("has-details");
                }
                if (stepContent) {
                    stepContent.classList.remove("show-details");
                }
            }
        },
        hideAllSteps: function() {
            for (let i = 1; i <= this.totalSteps; i++) {
                const stepEl = document.getElementById(`step${i}`);
                if (stepEl) {
                    stepEl.style.display = "none";
                }
            }
        },
        restoreUIState: function() {
            if (this.configuration.frameChoice) {
                const frameCard = document.querySelector(`#step1 [data-choice="${this.configuration.frameChoice}"]`);
                if (frameCard) {
                    frameCard.classList.add("selected");
                    frameCard.setAttribute("aria-pressed", "true");
                    frameCard.classList.remove("flipped");
                    frameCard.setAttribute("aria-expanded", "false");
                }
            }
            if (this.configuration.nativeLensType) {
                const lensCard = document.querySelector(`#step2 [data-lens-type="${this.configuration.nativeLensType}"]`);
                if (lensCard) {
                    lensCard.classList.add("selected");
                }
            }
            if (this.configuration.prescription === "skip" && this.configuration.prescriptionSkippedInVariantB) {
                const skipBtnB = document.getElementById("skipRxBtnB");
                if (skipBtnB) {
                    skipBtnB.classList.add("selected");
                }
            }
            if (this.configuration.frameDetailsUnknown) {
                const notSureBtns = document.querySelectorAll(".not-sure-btn");
                notSureBtns.forEach(btn => {
                    btn.classList.add("selected");
                });
            }
            if (this.configuration.orderForSomeoneElse && this.configuration.patientName) {
                const orderForSomeoneBtn = document.getElementById("orderForSomeoneElseBtn");
                if (orderForSomeoneBtn) {
                    orderForSomeoneBtn.classList.add("active");
                }
                setTimeout(() => {
                    this.showPatientInfoIndicator(this.configuration.patientName, this.configuration.patientRelationship || "Not specified");
                }, 150);
            }
            if (this.configuration.clipType) {
                let clipCard = document.querySelector(`#step3 [data-clip-type="${this.configuration.clipType}"]`);
                if (!clipCard) {
                    const kebabClipType = this.configuration.clipType.replace(/[A-Z]/g, c => "-" + c.toLowerCase());
                    clipCard = document.querySelector(`#step3 [data-clip-type="${kebabClipType}"]`);
                }
                if (clipCard) {
                    clipCard.classList.add("selected");
                }
            }
            if (this.configuration.clipOption) {
                const clipOption = document.querySelector(`#step4 [data-option="${this.configuration.clipOption}"]`);
                if (clipOption) {
                    clipOption.classList.add("active");
                }
                const magOption = document.querySelector(`#step4MagnificationGrid [data-magnification="${this.configuration.clipOption}"]`);
                if (magOption) {
                    magOption.classList.add("selected");
                }
            }
            if (this.configuration.bridgeColor) {
                const bridgeOption = document.querySelector(`#step5 [data-bridge="${this.configuration.bridgeColor}"]`);
                if (bridgeOption) {
                    bridgeOption.classList.add("selected");
                }
            }
            if (this.configuration.addSecondClip !== null) {
                const choice = this.configuration.addSecondClip ? "yes" : "no";
                const choiceCard = document.querySelector(`#step5 [data-choice="${choice}"]`);
                if (choiceCard) {
                    choiceCard.classList.add("selected");
                    const secondClipConfig = document.getElementById("secondClipConfigurator");
                    if (secondClipConfig) {
                        if (this.configuration.addSecondClip) {
                            secondClipConfig.classList.remove("hidden");
                        } else {
                            secondClipConfig.classList.add("hidden");
                        }
                    }
                }
            }
            this.configuration.accessories.forEach(accessory => {
                const checkbox = document.getElementById(`accessory-${accessory.type}`);
                if (checkbox) {
                    checkbox.checked = true;
                    checkbox.closest(".accessory-card").classList.add("selected");
                }
            });
            this.updateOrderSummary();
            this.updateNavigationButtons();
            this.updateProgressBar();
        },
        MOBILE_SPACER_HEIGHT: 60,
        _measureStickyBar: function() {
            const bar = document.querySelector(".order-flow__progress-section");
            if (!bar || !bar.offsetHeight) return;
            document.documentElement.style.setProperty("--sticky-progress-height-actual", bar.offsetHeight + "px");
            const spacer = document.getElementById("progress-spacer");
            if (spacer) {
                spacer.style.height = (window.innerWidth <= 768 ? this.MOBILE_SPACER_HEIGHT : bar.offsetHeight) + "px";
            }
        },
        _syncMobileFullScreenMode: function(step) {
            const s = typeof step === "number" ? step : this.currentStep;
            document.body.classList.toggle("configurator-active-mobile", s >= 4 && window.innerWidth <= 768);
            this._measureStickyBar();
        },
        setupStickyProgress: function() {
            console.log("[setupStickyProgress] Initializing always-sticky progress bar...");
            const progressSection = document.querySelector(".order-flow__progress-section");
            if (!progressSection) {
                console.warn("[setupStickyProgress] Progress section not found!");
                return;
            }
            const progressCloseBtn = document.getElementById("progress-close-btn");
            const progressResetBtn = document.getElementById("progress-reset-btn");
            progressSection.classList.add("is-sticky");
            document.body.classList.add("progress-bar-sticky");
            if (!document.getElementById("progress-spacer")) {
                const spacer = document.createElement("div");
                spacer.id = "progress-spacer";
                spacer.style.height = progressSection.offsetHeight + "px";
                progressSection.parentNode.insertBefore(spacer, progressSection);
            }
            this._measureStickyBar();
            if (progressCloseBtn) progressCloseBtn.style.display = "block";
            if (progressResetBtn) progressResetBtn.style.display = "block";
            this.closeHandler = () => {
                console.log("[Close Animation] Handler triggered");
                console.log("[Close Animation] GSAP available:", !!window.gsap);
                const orderFlowContainer = document.getElementById("orderFlowConfigurator");
                const progressSection = document.querySelector(".order-flow__progress-section");
                console.log("[Close Animation] Container found:", !!orderFlowContainer);
                console.log("[Close Animation] Progress bar found:", !!progressSection);
                if (window.gsap && orderFlowContainer) {
                    console.log("[Close Animation] Starting slide DOWN animation...");
                    this.saveMinimizedState(true);
                    try {
                        localStorage.setItem("clipConfigurationStep", this.currentStep || "1");
                    } catch (e) {
                        console.warn("[Close Animation] Failed to save step:", e);
                    }
                    gsap.to([ progressSection, orderFlowContainer ], {
                        y: window.innerHeight,
                        opacity: 0,
                        duration: .4,
                        ease: "power2.in",
                        force3D: true,
                        onComplete: () => {
                            console.log("[Close Animation] Slide DOWN completed");
                            window.history.back();
                        }
                    });
                } else {
                    console.warn("[Close Animation] GSAP not available or element not found");
                    this.saveMinimizedState(true);
                    try {
                        localStorage.setItem("clipConfigurationStep", this.currentStep || "1");
                    } catch (e) {
                        console.warn("[Close Animation] Failed to save step:", e);
                    }
                    setTimeout(() => {
                        window.history.back();
                    }, 50);
                }
            };
            this.resetHandler = () => {
                this.showResetModal();
            };
            if (progressCloseBtn) {
                progressCloseBtn.addEventListener("click", this.closeHandler);
            }
            if (progressResetBtn) {
                progressResetBtn.addEventListener("click", this.resetHandler);
            }
            if (!this._barObserver && typeof ResizeObserver === "function") {
                this._barObserver = new ResizeObserver(() => this._measureStickyBar());
                this._barObserver.observe(progressSection);
            }
            if (!this._viewportSyncBound) {
                this._viewportSyncBound = true;
                let viewportSyncTimer = null;
                const onViewportChange = () => {
                    clearTimeout(viewportSyncTimer);
                    viewportSyncTimer = setTimeout(() => {
                        this._syncMobileFullScreenMode();
                    }, 150);
                };
                window.addEventListener("resize", onViewportChange);
                window.addEventListener("orientationchange", onViewportChange);
            }
            this.restoreMinimizedState();
            console.log("[setupStickyProgress] Always-sticky progress bar initialized");
        },
        saveMinimizedState: function(isMinimized) {
            try {
                localStorage.setItem("orderFlowMinimized", isMinimized ? "true" : "false");
                console.log("[saveMinimizedState] State saved:", isMinimized);
            } catch (e) {
                console.warn("[saveMinimizedState] Failed to save state:", e);
            }
        },
        isConfiguratorMinimized: function() {
            try {
                return localStorage.getItem("orderFlowMinimized") === "true";
            } catch (e) {
                console.warn("[isConfiguratorMinimized] Failed to read state:", e);
                return false;
            }
        },
        hasConfigurationInProgress: function() {
            try {
                const configState = localStorage.getItem("clipConfiguration");
                return configState !== null && configState !== "";
            } catch (e) {
                return false;
            }
        },
        restoreMinimizedState: function() {
            const isMinimized = this.isConfiguratorMinimized();
            if (isMinimized) {
                const currentPage = window.location.pathname;
                if (currentPage.includes("/pages/order-flow")) {
                    console.log("[restoreMinimizedState] Detected minimized state on order flow page");
                }
            }
        },
        initializeImageLayering: function() {
            console.log("Redirecting to shared image layering initialization...");
            this.initializeSharedImageLayering();
            this.setupSharedPreviewControls();
            this.loadBaseFrame();
            console.log("Image layering initialized for Step 4");
        },
        setupSharedPreviewControls: function() {
            console.log("Setting up shared preview controls...");
            const self = this;
            const controlsContainer = document.querySelector(".shared-preview-section .preview-controls");
            if (!controlsContainer) {
                console.warn("Shared preview controls container not found");
                return;
            }
            const zoomInBtn = controlsContainer.querySelector(".zoom-in");
            if (zoomInBtn) {
                zoomInBtn.addEventListener("click", function() {
                    if (self.sharedImageLayering && typeof self.sharedImageLayering.zoomIn === "function") {
                        self.sharedImageLayering.zoomIn();
                    }
                });
            }
            const zoomOutBtn = controlsContainer.querySelector(".zoom-out");
            if (zoomOutBtn) {
                zoomOutBtn.addEventListener("click", function() {
                    if (self.sharedImageLayering && typeof self.sharedImageLayering.zoomOut === "function") {
                        self.sharedImageLayering.zoomOut();
                    }
                });
            }
            const resetBtn = controlsContainer.querySelector(".reset-view");
            if (resetBtn) {
                resetBtn.addEventListener("click", function() {
                    if (self.sharedImageLayering && typeof self.sharedImageLayering.resetView === "function") {
                        self.sharedImageLayering.resetView();
                    }
                });
            }
            console.log("Shared preview controls set up successfully");
        },
        setupStep4PreviewControls: function() {
            console.log("Setting up Step 4 preview controls...");
            const self = this;
            setTimeout(function() {
                self.setupPreviewControlsForStep(4);
            }, 100);
        },
        setupPreviewControlsForStep: function(stepNumber) {
            console.log("Setting up preview controls for step:", stepNumber);
            const self = this;
            let imageLayering = null;
            let containerSelector = `#step${stepNumber}`;
            if (stepNumber === 4) {
                imageLayering = this.sharedImageLayering;
            } else if (stepNumber >= 5 && stepNumber <= 7) {
                imageLayering = this.sharedImageLayering;
            }
            if (!imageLayering) {
                var retryKey = "_previewControlRetry_" + stepNumber;
                this[retryKey] = (this[retryKey] || 0) + 1;
                if (this[retryKey] < 3) {
                    console.warn(`Image layering not available for step ${stepNumber}, retry ${this[retryKey]}/3...`);
                    setTimeout(function() {
                        self.setupPreviewControlsForStep(stepNumber);
                    }, 300);
                } else {
                    console.error(`Image layering not available for step ${stepNumber} after 3 retries`);
                    this[retryKey] = 0;
                }
                return;
            }
            this["_previewControlRetry_" + stepNumber] = 0;
            const stepContainer = document.querySelector(containerSelector);
            if (!stepContainer) {
                console.warn(`Step ${stepNumber} container not found`);
                return;
            }
            const zoomInBtn = stepContainer.querySelector(".zoom-in");
            const zoomOutBtn = stepContainer.querySelector(".zoom-out");
            const resetViewBtn = stepContainer.querySelector(".reset-view");
            if (!zoomInBtn || !zoomOutBtn || !resetViewBtn) {
                console.warn(`Preview control buttons not found in Step ${stepNumber}`);
                return;
            }
            const newZoomInBtn = zoomInBtn.cloneNode(true);
            const newZoomOutBtn = zoomOutBtn.cloneNode(true);
            const newResetViewBtn = resetViewBtn.cloneNode(true);
            zoomInBtn.parentNode.replaceChild(newZoomInBtn, zoomInBtn);
            zoomOutBtn.parentNode.replaceChild(newZoomOutBtn, zoomOutBtn);
            resetViewBtn.parentNode.replaceChild(newResetViewBtn, resetViewBtn);
            newZoomInBtn.addEventListener("click", function(e) {
                e.preventDefault();
                console.log(`Step ${stepNumber} zoom in clicked`);
                if (imageLayering && typeof imageLayering.zoomIn === "function") {
                    imageLayering.zoomIn();
                    console.log("Zoom in executed successfully");
                } else {
                    console.error(`Image layering not available for step ${stepNumber}`);
                }
            });
            newZoomOutBtn.addEventListener("click", function(e) {
                e.preventDefault();
                console.log(`Step ${stepNumber} zoom out clicked`);
                if (imageLayering && typeof imageLayering.zoomOut === "function") {
                    imageLayering.zoomOut();
                    console.log("Zoom out executed successfully");
                } else {
                    console.error(`Image layering not available for step ${stepNumber}`);
                }
            });
            newResetViewBtn.addEventListener("click", function(e) {
                e.preventDefault();
                console.log(`Step ${stepNumber} reset view clicked`);
                self.applyStepViewport(stepNumber);
            });
            console.log(`Step ${stepNumber} preview controls set up successfully`);
        },
        applyStepViewport: function(stepNumber) {
            if (stepNumber < 4 || stepNumber > 5) return;
            const imageLayering = this.sharedImageLayering;
            if (!imageLayering) {
                console.warn("Shared image layering not initialized for step", stepNumber);
                return;
            }
            const presetName = this.viewportPresets[stepNumber] || "full";
            console.log(`Applying preset viewport '${presetName}' for step ${stepNumber}`);
            if (imageLayering.setViewport) {
                imageLayering.setViewport(presetName);
            }
        },
        saveCurrentViewport: function() {
            const currentStep = this.currentStep;
            if (currentStep < 4 || currentStep > 5) return;
            const imageLayering = this.sharedImageLayering;
            if (!imageLayering) return;
            if (imageLayering.isAnimating) {
                console.log("Deferring viewport save until animation completes for step", currentStep);
                const self = this;
                imageLayering.animationCallback = function() {
                    console.log("Animation completed, now saving viewport for step", currentStep);
                    self.saveCurrentViewport();
                };
                return;
            }
            const currentState = {
                scale: imageLayering.scale || 1,
                offsetX: imageLayering.offsetX || 0,
                offsetY: imageLayering.offsetY || 0,
                userHasInteracted: imageLayering.userHasInteracted || false
            };
            this.viewportManager.setState(currentStep, currentState);
            if (imageLayering.userHasInteracted) {
                this.viewportManager.markUserInteraction();
            }
            console.log(`Saved viewport state for step ${currentStep}:`, currentState);
        },
        resetStepViewport: function(stepNumber) {
            if (stepNumber < 4 || stepNumber > 5) return;
            this.viewportManager.states[stepNumber] = null;
            this.viewportManager.userHasInteracted = false;
            console.log(`Reset step ${stepNumber} to preset`);
            if (this.viewportManager.currentStep === stepNumber) {
                this.applyStepViewport(stepNumber);
            }
        },
        startViewportMonitoring: function() {
            if (this.viewportMonitorInterval) {
                clearInterval(this.viewportMonitorInterval);
            }
            const self = this;
            this.viewportMonitorInterval = setInterval(function() {
                const currentStep = self.currentStep;
                if (currentStep < 4 || currentStep > 7) return;
                let imageLayering = null;
                if (currentStep === 4 && self.sharedImageLayering) {
                    imageLayering = self.sharedImageLayering;
                } else if (currentStep >= 5 && currentStep <= 7 && self.currentStepLayering) {
                    imageLayering = self.currentStepLayering;
                }
                if (!imageLayering) return;
                if (imageLayering.userHasInteracted) {
                    const currentSavedState = self.viewportManager.getSavedState(currentStep);
                    const actualState = {
                        scale: imageLayering.scale || 1,
                        offsetX: imageLayering.offsetX || 0,
                        offsetY: imageLayering.offsetY || 0,
                        userHasInteracted: true
                    };
                    if (!currentSavedState || actualState.scale !== currentSavedState.scale || actualState.offsetX !== currentSavedState.offsetX || actualState.offsetY !== currentSavedState.offsetY) {
                        self.viewportManager.setState(currentStep, actualState);
                        self.viewportManager.markUserInteraction();
                        console.log(`Auto-saved viewport changes for step ${currentStep}:`, actualState);
                    }
                }
            }, 500);
        },
        stopViewportMonitoring: function() {
            if (this.viewportMonitorInterval) {
                clearInterval(this.viewportMonitorInterval);
                this.viewportMonitorInterval = null;
            }
        },
        loadBaseFrame: function() {
            if (!this.sharedImageLayering) return;
            const frameModel = "Raen-Angle";
            const frameImagePath = `${frameModel}-Frame.png`;
            console.log("Loading base frame:", frameImagePath);
            const assetUrl = this.getAssetUrl(frameImagePath);
            this.sharedImageLayering.loadBaseImage(assetUrl);
        },
        getAssetUrl: function(filename) {
            if (window.assetUrls && window.assetUrls[filename]) {
                return window.assetUrls[filename];
            }
            return filename;
        },
        updateCanvasPreview: function(type, value) {
            if (value === null || value === undefined || value === "null" || value === "") {
                console.log("Skipping canvas update for null/empty value:", type, value);
                return;
            }
            const layering = this.sharedImageLayering;
            if (!layering) {
                console.error("No image layering system initialized");
                return;
            }
            console.log("Updating canvas preview:", type, value);
            const frameModel = "Raen-Angle";
            if (type === "lens") {
                const category = this.configuration.lensCategory || "gradient";
                const capitalizedCategory = category === "3d" ? "3D" : category === "non-polarized" ? "Solid" : category.charAt(0).toUpperCase() + category.slice(1);
                let lensImagePath;
                if (category === "blueLight" || category === "reader" || category === "3d") {
                    lensImagePath = `${frameModel}-Lens-${capitalizedCategory}.png`;
                } else if (category === "driving") {
                    lensImagePath = `${frameModel}-Lens-Driving.png`;
                } else if (category === "fl41" || category === "lightSensitivity") {
                    const lsColor = this.configuration.lightSensitivityColor || value || "FL41-Light";
                    lensImagePath = `${frameModel}-Lens-${lsColor}.png`;
                } else if (category === "migraine") {
                    lensImagePath = `${frameModel}-Lens-Avulux-Light.png`;
                } else {
                    lensImagePath = `${frameModel}-Lens-${capitalizedCategory}-${value}.png`;
                }
                console.log("Updating lens layer:", lensImagePath);
                const assetUrl = this.getAssetUrl(lensImagePath);
                layering.updateLayer("lens", assetUrl, 1);
            } else if (type === "bridge") {
                const bridgeImagePath = `${frameModel}-Bridge-${value}.png`;
                const assetUrl = this.getAssetUrl(bridgeImagePath);
                layering.updateLayer("bridge", assetUrl, 2);
            } else if (type === "magnet") {
                const magnetImagePath = `${frameModel}-Magnet-${value}.png`;
                const assetUrl = this.getAssetUrl(magnetImagePath);
                layering.updateLayer("magnet", assetUrl, 3);
            } else if (type === "crystal") {
                if (value && value !== null) {
                    const crystalImagePath = `${frameModel}-Crystal-${value}.png`;
                    const assetUrl = this.getAssetUrl(crystalImagePath);
                    layering.updateLayer("crystal", assetUrl, 4);
                }
            }
            console.log("Calling render on canvas...");
            layering.render();
            console.log("Canvas render complete");
        },
        getColorValue: function(colorName) {
            const colorMap = {
                VioletRose: "linear-gradient(135deg, #8B5A96, #D4668A)",
                VioletGrey: "linear-gradient(135deg, #8B5A96, #7A7A7A)",
                Rouge: "linear-gradient(135deg, #8B0000, #DC143C)",
                MediumBrown: "linear-gradient(135deg, #CD853F, #F4A460)",
                DarkGrey: "linear-gradient(135deg, #2F2F2F, #696969)",
                DarkBrown: "linear-gradient(135deg, #654321, #8B4513)",
                CrimsonGrey: "linear-gradient(135deg, #DC143C, #808080)",
                Amber: "linear-gradient(135deg, #FFBF00, #FF8C00)",
                SkyBlue: "linear-gradient(135deg, #87CEEB, #4682B4)",
                Silver: "linear-gradient(135deg, #C0C0C0, #808080)",
                Orange: "linear-gradient(135deg, #FFA500, #FF8C00)",
                Morado: "linear-gradient(135deg, #8B008B, #9370DB)",
                Green: "linear-gradient(135deg, #32CD32, #228B22)",
                Gold: "linear-gradient(135deg, #FFD700, #DAA520)",
                Caliente: "linear-gradient(135deg, #FF4500, #DC143C)",
                Blue: "linear-gradient(135deg, #4169E1, #0000CD)",
                Yellow: "#FFD700",
                Grey: "#808080",
                Rose: "#FF69B4",
                G15: "#4F7942",
                Brown: "#8B4513",
                Bronze: "#CD7F32"
            };
            return colorMap[colorName] || "#cccccc";
        },
        formatColorName: function(colorValue) {
            if (!colorValue) return "";
            return colorValue.replace(/([A-Z])/g, " $1").trim();
        }
    };
    window.diagnosticAccessories = function() {
        console.log("=== 🔍 ACCESSORY DIAGNOSTIC REPORT ===");
        console.log("\n1️⃣ PRODUCT DATA CHECK:");
        console.log("window.chemistrie_products exists:", !!window.chemistrie_products);
        console.log("window.chemistrie_products.accessories exists:", !!window.chemistrie_products?.accessories);
        if (window.chemistrie_products?.accessories) {
            console.log("✅ Accessory types available:", Object.keys(window.chemistrie_products.accessories));
            Object.entries(window.chemistrie_products.accessories).forEach(([key, value]) => {
                console.log(`   - ${key}:`, {
                    name: value.name,
                    variantId: value.variantId,
                    price: value.price
                });
            });
        } else {
            console.error("❌ CRITICAL: Accessory product data NOT loaded!");
        }
        console.log("\n2️⃣ CONFIGURATOR STATE:");
        if (window.orderFlowConfigurator) {
            console.log("✅ Configurator initialized");
            console.log("Current step:", window.orderFlowConfigurator.currentStep);
            console.log("Accessories in configuration:", window.orderFlowConfigurator.configuration.accessories);
        } else {
            console.error("❌ Configurator not initialized");
        }
        console.log("\n3️⃣ DOM ELEMENTS:");
        const toggles = document.querySelectorAll("#reviewAccessories .accessory-toggle");
        console.log("Accessory toggles found:", toggles.length);
        toggles.forEach((toggle, index) => {
            console.log(`   Toggle ${index + 1}:`, {
                type: toggle.dataset.accessory,
                checked: toggle.checked,
                id: toggle.id
            });
        });
        console.log("\n4️⃣ VARIANT LOOKUP TEST:");
        if (window.orderFlowConfigurator) {
            const testTypes = [ "case", "cleaning", "cleaning_kit", "insurance" ];
            testTypes.forEach(type => {
                const variantId = window.orderFlowConfigurator.getAccessoryVariantId(type);
                console.log(`   ${type}:`, variantId ? `✅ ${variantId}` : "❌ NOT FOUND");
            });
        }
        console.log("\n5️⃣ CART PREPARATION TEST:");
        if (window.orderFlowConfigurator && window.orderFlowConfigurator.configuration.accessories.length > 0) {
            console.log("Simulating cart item preparation...");
            window.orderFlowConfigurator.prepareCartItems();
        } else {
            console.log("No accessories selected - toggle some accessories in Step 5 first");
        }
        console.log("\n=== END DIAGNOSTIC REPORT ===");
        console.log("💡 TIP: Select accessories in Step 5, then run diagnosticAccessories() again");
    };
    function initializeWhenReady() {
        if (document.getElementById("orderFlowConfigurator") && window.SunClipImageLayering) {
            window.orderFlowConfigurator = new window.OrderFlowConfigurator;
            addPageEntranceAnimation();
        } else if (document.getElementById("orderFlowConfigurator")) {
            setTimeout(initializeWhenReady, 50);
        }
    }
    function addPageEntranceAnimation() {
        try {
            const isReturning = localStorage.getItem("orderFlowMinimized") === "true";
            const hasConfig = localStorage.getItem("clipConfiguration") !== null;
            const referrer = document.referrer;
            const shouldAnimate = isReturning || hasConfig && referrer && !referrer.includes("/pages/order-flow");
            if (shouldAnimate && typeof gsap !== "undefined") {
                console.log("[Entrance Animation] User returning to configurator - adding slide UP animation");
                console.log("[Entrance Animation] isReturning:", isReturning, "hasConfig:", hasConfig);
                const container = document.getElementById("orderFlowConfigurator");
                const progressBar = document.querySelector(".order-flow__progress-section");
                if (container && progressBar) {
                    gsap.set([ container, progressBar ], {
                        y: window.innerHeight,
                        opacity: 0
                    });
                    gsap.to([ container, progressBar ], {
                        y: 0,
                        opacity: 1,
                        duration: .4,
                        ease: "power2.out",
                        force3D: true,
                        clearProps: "transform,opacity",
                        onComplete: () => {
                            console.log("[Entrance Animation] Slide UP completed");
                            if (localStorage.getItem("orderFlowMinimized") === "true") {
                                localStorage.setItem("orderFlowMinimized", "false");
                                console.log("[Entrance Animation] Cleared minimized flag");
                            }
                        }
                    });
                }
            }
        } catch (e) {
            console.warn("[Entrance Animation] Error:", e);
        }
    }
    document.addEventListener("DOMContentLoaded", initializeWhenReady);
})();